import { defineMessages } from "react-intl.macro";

const Messages = defineMessages({
  traffic_light_tab: {
    id: "traffic_light_tab",
    defaultMessage: "Traffic Light",
  },
  traffic_light_config_title: {
    id: "traffic_light_config_title",
    defaultMessage: "Adult Traffic Light Configuration",
  },
  traffic_light_config_help: {
    id: "traffic_light_config_help",
    defaultMessage:
      "Configure the nightly adherence scoring, efficacy flags, escalation, and annual review rules. Saving creates a new configuration version.",
  },
  traffic_light_config_version: {
    id: "traffic_light_config_version",
    defaultMessage: "Current version: {version}",
  },
  traffic_light_adherence_scoring: {
    id: "traffic_light_adherence_scoring",
    defaultMessage: "Adherence scoring",
  },
  traffic_light_adherence_scoring_help: {
    id: "traffic_light_adherence_scoring_help",
    defaultMessage:
      "Set the rolling window and thresholds used to calculate each patient's traffic light tier.",
  },
  traffic_light_window_length: {
    id: "traffic_light_window_length",
    defaultMessage: "Scoring window (nights)",
  },
  traffic_light_usage_threshold: {
    id: "traffic_light_usage_threshold",
    defaultMessage: "Nightly usage threshold (hours)",
  },
  traffic_light_green_min: {
    id: "traffic_light_green_min",
    defaultMessage: "Green tier minimum",
  },
  traffic_light_orange_min: {
    id: "traffic_light_orange_min",
    defaultMessage: "Orange tier minimum",
  },
  traffic_light_no_data_period: {
    id: "traffic_light_no_data_period",
    defaultMessage: "No-data period (days)",
  },
  traffic_light_hysteresis_runs: {
    id: "traffic_light_hysteresis_runs",
    defaultMessage: "Runs required to confirm a tier change",
  },
  traffic_light_baseline_nights: {
    id: "traffic_light_baseline_nights",
    defaultMessage: "Minimum baseline nights",
  },
  traffic_light_efficacy: {
    id: "traffic_light_efficacy",
    defaultMessage: "Efficacy flags",
  },
  traffic_light_efficacy_help: {
    id: "traffic_light_efficacy_help",
    defaultMessage:
      "Configure the thresholds that identify therapy efficacy concerns.",
  },
  traffic_light_efficacy_enabled: {
    id: "traffic_light_efficacy_enabled",
    defaultMessage: "Enable efficacy flags",
  },
  traffic_light_leak_threshold: {
    id: "traffic_light_leak_threshold",
    defaultMessage: "Leak threshold",
  },
  traffic_light_ahi_threshold: {
    id: "traffic_light_ahi_threshold",
    defaultMessage: "AHI threshold",
  },
  traffic_light_cai_threshold: {
    id: "traffic_light_cai_threshold",
    defaultMessage: "CAI threshold",
  },
  traffic_light_consecutive_days: {
    id: "traffic_light_consecutive_days",
    defaultMessage: "Consecutive days",
  },
  traffic_light_red_escalation: {
    id: "traffic_light_red_escalation",
    defaultMessage: "Red tier escalation",
  },
  traffic_light_red_escalation_help: {
    id: "traffic_light_red_escalation_help",
    defaultMessage:
      "Set the follow-up attempt limit and the period in which escalation is measured.",
  },
  traffic_light_escalation_attempts: {
    id: "traffic_light_escalation_attempts",
    defaultMessage: "Escalation attempts",
  },
  traffic_light_escalation_window: {
    id: "traffic_light_escalation_window",
    defaultMessage: "Escalation window (days)",
  },
  traffic_light_annual_review: {
    id: "traffic_light_annual_review",
    defaultMessage: "Annual review",
  },
  traffic_light_annual_review_rule: {
    id: "traffic_light_annual_review_rule",
    defaultMessage: "Annual review rule",
  },
  traffic_light_percentage_help: {
    id: "traffic_light_percentage_help",
    defaultMessage: "Enter percentages as decimals, for example 0.70 for 70%.",
  },
  traffic_light_required: {
    id: "traffic_light_required",
    defaultMessage: "This field is required.",
  },
  traffic_light_positive_integer: {
    id: "traffic_light_positive_integer",
    defaultMessage: "Enter a whole number greater than zero.",
  },
  traffic_light_non_negative_number: {
    id: "traffic_light_non_negative_number",
    defaultMessage: "Enter a number of zero or greater.",
  },
  traffic_light_percentage_range: {
    id: "traffic_light_percentage_range",
    defaultMessage: "Enter a value between 0 and 1.",
  },
  traffic_light_orange_below_green: {
    id: "traffic_light_orange_below_green",
    defaultMessage: "Orange minimum must be lower than green minimum.",
  },
  traffic_light_load_error: {
    id: "traffic_light_load_error",
    defaultMessage: "The Traffic Light configuration could not be loaded.",
  },
  traffic_light_update_success: {
    id: "traffic_light_update_success",
    defaultMessage: "Traffic Light configuration has been updated.",
  },
  traffic_light_update_error: {
    id: "traffic_light_update_error",
    defaultMessage: "The Traffic Light configuration could not be updated.",
  },
  submitting: {
    id: "submitting",
    defaultMessage: "Submitting...",
  },
  change_pwd_to_cont: {
    id: "change_pwd_to_cont",
    defaultMessage: "Please change your password to continue",
  },
  cp_updated_pt: {
    id: "cp_updated_pt",
    defaultMessage: "Care Plan has been updated for the Patient.",
  },
  invalidate_sessions_conf: {
    id: "invalidate_sessions_conf",
    defaultMessage: "All session have been invalidated.",
  },
  invalidate_sessions_warn: {
    id: "invalidate_sessions_warn",
    defaultMessage:
      "Are you certain that you want to invalidate all sessions for this user? Please note that this action will log the user out from all the devices they have previously logged in to.",
  },
  invalidate_sessions: {
    id: "invalidate_sessions",
    defaultMessage: "Invalidate Sessions",
  },
  signup_alternative: {
    id: "signup_alternative",
    defaultMessage:
      "Alternatively, you can use a different email or phone number to create a new account.",
  },
  forgot_pwd_su: {
    id: "forgot_pwd_su",
    defaultMessage:
      "If you've forgotten your password, you can reset it by following the steps from <forgot>here</forgot>.",
  },
  forgot_userId: {
    id: "forgot_userId",
    defaultMessage:
      "In case you have forgotten, the username for the account is: {loginUserId}",
  },
  wait_account: {
    id: "wait_account",
    defaultMessage: "Wait...You already have an account",
  },
  started_surveys: {
    id: "started_surveys",
    defaultMessage: "Started Surveys",
  },
  pdf_downloaded: {
    id: "pdf_downloaded",
    defaultMessage:
      "PDF has been downloaded. Please check Downloads on your device.",
  },
  pdf_downloading: {
    id: "pdf_downloading",
    defaultMessage: "PDF is downloading...",
  },
  hide_profile: {
    id: "hide_profile",
    defaultMessage: "Hide Profile",
  },
  configure_crit: {
    id: "configure_crit",
    defaultMessage: "Configure Criteria",
  },
  exclude_pts_match: {
    id: "exclude_pts_match",
    defaultMessage: "Exclude patients matching",
  },
  visible_bw: {
    id: "visible_bw",
    defaultMessage: "Visible Between (Optional)",
  },
  completed_surveys: {
    id: "completed_surveys",
    defaultMessage: "Completed Surveys",
  },
  incomplete_surveys: {
    id: "incomplete_surveys",
    defaultMessage: "Incomplete Surveys",
  },
  survey_created: {
    id: "survey_create",
    defaultMessage: "Survey Created Successfuly",
  },
  survey_created_failed: {
    id: "survey_created_failed",
    defaultMessage: "Survey Creation Failed",
  },
  no_events: {
    id: "no_events",
    defaultMessage: "There are no events in this range.",
  },
  appt_link_error: {
    id: "appt_link_error",
    defaultMessage: "Please set name and template for all links.",
  },
  schedule_for: { id: "schedule_for", defaultMessage: "Schedule for: {name}" },
  text_update: { id: "text_update", defaultMessage: "Text update" },
  audio_recording: { id: "audio_recording", defaultMessage: "Audio recording" },
  videos: { id: "videos", defaultMessage: "Videos" },
  vids_thumbs_error: {
    id: "vids_thumbs_error",
    defaultMessage:
      "Different number of videos and thumbnails - Videos ({noOfFiles}) Thumbs ({noOfThumbs})",
  },
  current_files: { id: "current_files", defaultMessage: "Current Files" },
  pl_att_files_w_type: {
    id: "pl_att_files_w_type",
    defaultMessage: "Please attach {subType} file(s).",
  },
  content: { id: "content", defaultMessage: "Content" },
  media_type: { id: "media_type", defaultMessage: "Media type" },
  upload_progress: { id: "upload_progress", defaultMessage: "Upload progress" },
  error: { id: "error", defaultMessage: "Error" },
  before_mins: {
    id: "before_mins",
    defaultMessage: "Before Minutes: {reminderBeforeMinutes}",
  },
  send_days_before: {
    id: "send_days_before",
    defaultMessage:
      "Send {fixedNoOfDaysBefore} days before at {fixedTimeToSend}",
  },
  appt_templ_comments_tt: {
    id: "appt_templ_comments_tt",
    defaultMessage:
      "Comments will also be used as event description on the calendar.",
  },
  appt_templ_desc_tt: {
    id: "appt_templ_desc_tt",
    defaultMessage:
      "Appointment description will be shown as event name on the calendar.",
  },
  incl_video_call: {
    id: "incl_video_call",
    defaultMessage: "Include Video Calling?",
  },
  appt_templ_name_tt: {
    id: "appt_templ_name_tt",
    defaultMessage:
      "Identifies an Appointment template. It's not used in the appointment data.",
  },
  url: { id: "url", defaultMessage: "URL" },
  link_name: { id: "link_name", defaultMessage: "Link Name" },
  se_date_reqd: {
    id: "se_date_reqd",
    defaultMessage: "Start and End Date are required",
  },
  comments_w_c: { id: "comments_w_c", defaultMessage: "Comments: {comments}" },
  deleted_pp: {
    id: "deleted_pp",
    defaultMessage: "This is a deleted/inactivated patient profile.",
  },
  cal_assignee: { id: "cal_assignee", defaultMessage: "Assignee" },
  cal_schedules: {
    id: "cal_schedules",
    defaultMessage: "Schedules",
  },
  complete: {
    id: "complete",
    defaultMessage: "Complete",
  },
  consolidated_report_uc: {
    id: "consolidated_report_uc",
    defaultMessage: "CONSOLIDATED REPORT",
  },
  weekly_login_activity: {
    id: "weekly_login_activity",
    defaultMessage: "Weekly Login Activity",
  },
  monthly_login_activity: {
    id: "monthly_login_activity",
    defaultMessage: "Monthly Login Activity",
  },
  xNoteAdded: {
    id: "xNoteAdded",
    defaultMessage: "Note has been added to the other facility.",
  },
  acct_ready: {
    id: "acct_ready",
    defaultMessage: "Your account on myPatientSpace is ready! {loginUserId}",
  },
  username_dot_er: {
    id: "username_dot_er",
    defaultMessage: "Username can not have more than one period(.).",
  },
  username_len_er: {
    id: "username_len_er",
    defaultMessage: "Username should have at least 5 characters.",
  },
  username_emp_er: {
    id: "username_emp_er",
    defaultMessage: "Username can not be empty.",
  },
  username_sp_er: {
    id: "username_sp_er",
    defaultMessage: "Username can not have spaces.",
  },
  terms_pp_w_link: {
    id: "terms_pp_w_link",
    defaultMessage:
      "I have read and accept the <terms>terms & conditions</terms> and <pp>privacy policy</pp> for {name}.",
  },
  cp_library: { id: "cp_library", defaultMessage: "Copy Library - {name}" },
  delete_library: { id: "delete_library", defaultMessage: "Delete Library" },
  draft: { id: "draft", defaultMessage: "Draft" },
  pl_select_temp_sch: {
    id: "pl_select_temp_sch",
    defaultMessage: "Please select a template and a schedule",
  },
  pl_select_link: {
    id: "pl_select_link",
    defaultMessage: "Please select a link",
  },
  pl_select_slots: {
    id: "pl_select_slots",
    defaultMessage: "Please select slot(s)",
  },
  on_text: { id: "on_text", defaultMessage: "on" },
  six_weeks_years_pp: {
    id: "six_weeks_years_pp",
    defaultMessage:
      "6 Weeks, 6 Months, 1 Year, 2 Years and 5 Years Pre and Post",
  },
  lt_week: { id: "lt_week", defaultMessage: "< A Week" },
  lt_two_weeks: { id: "lt_two_weeks", defaultMessage: "< 2 Weeks" },
  lt_month: { id: "lt_month", defaultMessage: "< 1 Month" },
  lt_two_months: { id: "lt_two_months", defaultMessage: "< 2 Months" },
  gt_two_months: { id: "gt_two_months", defaultMessage: "> Two Months" },
  pre_post: { id: "pre_post", defaultMessage: "Pre and Post" },
  pre: { id: "pre", defaultMessage: "Pre" },
  post: { id: "post", defaultMessage: "Post" },
  created_by_on: {
    id: "created_by_on",
    defaultMessage: "Created by {name} on {date}",
  },
  new_password: { id: "new_password", defaultMessage: "New Password" },
  reenter_new_pwd: {
    id: "reenter_new_pwd",
    defaultMessage: "Re-enter New Password",
  },
  set_new_password: {
    id: "set_new_password",
    defaultMessage: "Please set new password.",
  },
  confirm_new_pwd_err: {
    id: "confirm_new_pwd_err",
    defaultMessage: "Confirm password does not match with the new password",
  },
  set_confirm_password: {
    id: "set_confirm_password",
    defaultMessage: "Please set confirm new password",
  },
  set_auto_creds: {
    id: "set_auto_creds",
    defaultMessage: "Set Auto Credentials",
  },
  set_creds_manually: {
    id: "set_creds_manually",
    defaultMessage: "Set Credentials Manually",
  },
  sal_ms: { id: "sal_ms", defaultMessage: "Ms" },
  sal_miss: { id: "sal_miss", defaultMessage: "Miss" },
  sal_mrs: { id: "sal_mrs", defaultMessage: "Mrs" },
  sal_mr: { id: "sal_mr", defaultMessage: "Mr" },
  sal_master: { id: "sal_master", defaultMessage: "Master" },
  sal_fr: { id: "sal_fr", defaultMessage: "Father (Fr)" },
  sal_rev: { id: "sal_rev", defaultMessage: "Reverend (Rev)" },
  sal_dr: { id: "sal_dr", defaultMessage: "Doctor (Dr)" },
  sal_atty: { id: "sal_atty", defaultMessage: "Attorney (Atty)" },
  sal_honorable: { id: "sal_honorable", defaultMessage: "Honorable" },
  sal_professor: { id: "sal_professor", defaultMessage: "Professor" },
  sal_president: { id: "sal_president", defaultMessage: "President" },
  sal_vice_president: {
    id: "sal_vice_president",
    defaultMessage: "Vice President",
  },
  sal_governor: { id: "sal_governor", defaultMessage: "Governor" },
  sal_officer: { id: "sal_officer", defaultMessage: "Officer" },

  phone_or_email: {
    id: "phone_or_email",
    defaultMessage: "Phone number or Email",
  },
  credentials_reset_act: {
    id: "credentials_reset_act",
    defaultMessage: "Patient has been activated and credentials have been set.",
  },
  activate_patient: {
    id: "activate_patient",
    defaultMessage: "Activate Patient",
  },
  activate: {
    id: "activate",
    defaultMessage: "Activate",
  },
  free_slots_to_cont: {
    id: "free_slots_to_cont",
    defaultMessage: "free slots (green) to continue booking",
  },
  select_dt_time_for_appt: {
    id: "select_dt_time_for_appt",
    defaultMessage: "Please select date and time for the appointment",
  },
  send_link_message_to_all_q: {
    id: "send_link_message_to_all_q",
    defaultMessage:
      "Are you sure you want to send the link message to all participants?",
  },
  please_provide_msgs: {
    id: " please_provide_msgs",
    defaultMessage: "Please provide messages.",
  },
  send_to_all_parts: {
    id: "send_to_all_parts",
    defaultMessage: "Send to all participants",
  },
  enter_msg_with_link: {
    id: "enter_msg_with_link",
    defaultMessage: "Enter a message with the LINK",
  },
  appts_created_w_desc: {
    id: "appts_created_w_desc",
    defaultMessage: "The following appointments have been created for {desc}.",
  },
  class: { id: "class", defaultMessage: "Class" },
  join: { id: "join", defaultMessage: "Join" },
  class_on: { id: "class_on", defaultMessage: "Class on" },
  select_class_w_green: {
    id: "select_class_w_green",
    defaultMessage: "Select a class (green) to join.",
  },
  ph_for_appt: {
    id: "ph_for_appt",
    defaultMessage: "Please enter your Phone number for the appointment.",
  },
  appt_conf_w_details: {
    id: "appt_conf_w_details",
    defaultMessage: "We have sent you an email with the appointment details.",
  },
  with_w_col: { id: "with_w_col", defaultMessage: "with:" },
  please_sl_staff: {
    id: "please_sl_staff",
    defaultMessage: "Please select a staff",
  },
  select_slot_w_green: {
    id: "select_slot_w_green",
    defaultMessage: "Select a free slot (green) to continue booking",
  },
  appt_w_staff: {
    id: "appt_w_staff",
    defaultMessage: "{dateTime} with {staffName}",
  },
  join_class_on: {
    id: "join_class_on",
    defaultMessage: "You are about to join class {description} on:",
  },
  joined_class_text: {
    id: " joined_class_text",
    defaultMessage:
      "You have joined class {description} on {slot} with {staffName}.",
  },
  class_conf: {
    id: "class_conf",
    defaultMessage:
      "We have sent you an email with the class details. Thank you for using myPatientSpace.",
  },
  cancel_booking: { id: "cancel_booking", defaultMessage: "Cancel Booking" },
  scheduled_for: { id: "scheduled_for", defaultMessage: "scheduled for" },
  alt_sel_link_here: {
    id: "alt_sel_link_here",
    defaultMessage: "Alternatively, select one of the links below",
  },
  survey_filter_patients_by: {
    id: "survey_filter_patients_by",
    defaultMessage: "Filter patients by",
  },
  booking_recommended_title: {
    id: "booking_recommended_title",
    defaultMessage: "Recommended: book from a published schedule",
  },
  booking_recommended_why: {
    id: "booking_recommended_why",
    defaultMessage: "These keep the schedule and the appointment template together, so the patient appears on the right schedule and gets that schedule's reminders.",
  },
  booking_other_title: {
    id: "booking_other_title",
    defaultMessage: "Other: choose any template, then any schedule",
  },
  booking_other_note: {
    id: "booking_other_note",
    defaultMessage: "The patient will appear on whichever schedule you pick in the next step.",
  },
  with_text: { id: "with_text", defaultMessage: "with" },
  scheduling_appt_for: {
    id: "scheduling_appt_for",
    defaultMessage: "Scheduling an Appointment for:",
  },
  select_add_patient: {
    id: "select_add_patient",
    defaultMessage: "Please select or add a patient",
  },
  or_w_hyphen: { id: "or_w_hyphen", defaultMessage: "- or -" },
  new_adhoc_pt_for_appt: {
    id: "new_adhoc_pt_for_appt",
    defaultMessage: "New Ad-hoc Patient for Appointment",
  },
  contact_dets: { id: "contact_dets", defaultMessage: "Contact Details" },
  new_contact_dets: {
    id: "new_contact_dets",
    defaultMessage: "New contact details",
  },
  how_to_contact_me: {
    id: "how_to_contact_me",
    defaultMessage: "How to Contact Me",
  },
  contact_in_app: {
    id: "contact_in_app",
    defaultMessage: "Contact details registered in the app",
  },
  close_current_appt: {
    id: "close_current_appt",
    defaultMessage: "Close the current appointment?",
  },
  published_links: { id: "published_links", defaultMessage: "Published Links" },
  appt_temp_sch: {
    id: "appt_temp_sch",
    defaultMessage: "Templates and Schedules",
  },
  sel_appt_temp_sch: {
    id: "sel_appt_temp_sch",
    defaultMessage: "Select Appointment Template and Schedule",
  },
  series_cancelled: {
    id: "series_cancelled",
    defaultMessage: "All Appointments in the series have been cancelled.",
  },
  no_upcoming_appts: {
    id: "no_upcoming_appts",
    defaultMessage: "There are no upcoming appointments.",
  },
  appt_series_w_desc: {
    id: "appt_series_w_desc",
    defaultMessage: "Appointment Series for {description}, {patientName}",
  },
  view_appt: { id: "view_appt", defaultMessage: "View Appointment" },
  cancel_appt_series: {
    id: "cancel_appt_series",
    defaultMessage: "Cancel Appointment Series",
  },
  to_cancel_appt_series: {
    id: "to_cancel_appt_series",
    defaultMessage: "Are you sure you want to cancel the appointment series?",
  },
  screening_result: {
    id: "screening_result",
    defaultMessage: "Screening Result",
  },
  join_video_call: { id: "join_video_call", defaultMessage: "Join Video Call" },
  video_call_title: {
    id: "video_call_title",
    defaultMessage: "Start your video call",
  },
  send_appt_link: {
    id: "send_appt_link",
    defaultMessage: "Send Appointment Link",
  },
  book_again: { id: "book_again", defaultMessage: "Book Again" },
  free_sp_one: { id: "free_sp_one", defaultMessage: "1 free space available" },
  free_sp_count: {
    id: "free_sp_count",
    defaultMessage: "{count} free spaces available",
  },
  appt_ba_help: {
    id: "appt_ba_help",
    defaultMessage:
      "Starts creating a new appointment using details from this appointment but for different slots selected.",
  },
  appt_reb_help: {
    id: "appt_reb_help",
    defaultMessage:
      "Mark this appointment fulfilled and starts creating the new appointment.",
  },
  view_series: { id: "view_series", defaultMessage: "View Series" },
  pts_upcoming_appts: {
    id: "pts_upcoming_appts",
    defaultMessage: "Patient's Upcoming Appointments",
  },
  select_slots_sch: {
    id: "select_slots_sch",
    defaultMessage: "Select slots from the schedule",
  },
  or_enter_dt: { id: "or_enter_dt", defaultMessage: "Or Enter Date & Time" },
  you_are_here: { id: "you_are_here", defaultMessage: "You are here!" },
  upcoming_appointments: {
    id: "upcoming_appointments",
    defaultMessage: "Upcoming Appointments",
  },
  no_upcoming_appointments: {
    id: "no_upcoming_appointments",
    defaultMessage: "You have no upcoming appointments.",
  },
  click_here_view_all_appointments: {
    id: "click_here_view_all_appointments",
    defaultMessage: "Click {link} to view all appointments.",
  },
  here: {
    id: "here",
    defaultMessage: "here",
  },
  calendar_view: {
    id: "calendar_view",
    defaultMessage: "Calendar View",
  },
  daily: { id: "daily", defaultMessage: "Daily" },
  weekly: { id: "weekly", defaultMessage: "Weekly" },
  monthly: { id: "monthly", defaultMessage: "Monthly" },
  end_date: { id: "end_date", defaultMessage: "End Date" },
  every: { id: "every", defaultMessage: "Every" },
  recurringq: { id: "recurringq", defaultMessage: "Recurring?" },
  recurring_err: {
    id: "recurring_err",
    defaultMessage: "Repeat, Every, and End Date are required",
  },
  use_at_as_appt_st: {
    id: "use_at_as_appt_st",
    defaultMessage: "Use Arrival Time As Appointment Start Time?",
  },
  arrive_before_im: {
    id: "arrive_before_im",
    defaultMessage: "Arrive Before (in Minutes)",
  },
  slot_ct_error: {
    id: "slot_ct_error",
    defaultMessage: "Please create at least one slot",
  },
  hour: { id: "hour", defaultMessage: "Hour" },
  min: { id: "min", defaultMessage: "Min" },
  responses_w_label: {
    id: "responses_w_label",
    defaultMessage: "Responses - {label}",
  },
  ref_range_count: {
    id: "ref_range_count",
    defaultMessage: "Reference Range Count",
  },
  response_rate_by_tw: {
    id: "response_rate_by_tw",
    defaultMessage: "Response Rate By Time Window",
  },
  prev: {
    id: "prev",
    defaultMessage: "Prev",
  },
  send_to_patient: { id: "send_to_patient", defaultMessage: "Send To Patient" },
  one_doc: { id: "one_doc", defaultMessage: "1 Document" },
  docs_w_count: { id: "docs_w_count", defaultMessage: "{count} Documents" },
  doc_w_name: {
    id: "doc_w_name",
    defaultMessage: "Document - {name}",
  },
  doc_del_conf: {
    id: "doc_del_conf",
    defaultMessage:
      "Are you sure you want to delete the document {name}? It will be permanently deleted from the system and can not be reverted.",
  },
  send_doc_pt: {
    id: "send_doc_pt",
    defaultMessage: "Send Document to Patient",
  },
  edit_document: { id: "edit_document", defaultMessage: "Edit Document" },
  delete_document: { id: "delete_document", defaultMessage: "Delete Document" },
  filter_by_topic: { id: "filter_by_topic", defaultMessage: "Filter By Topic" },
  all_fields_reqd: {
    id: "all_fields_reqd",
    defaultMessage: "Please provide values for all fields.",
  },
  invite_ptsq: {
    id: "invite_ptsq",
    defaultMessage: "Invite Patients?",
  },
  invite_susq: {
    id: "invite_susq",
    defaultMessage: "Invite Service Users?",
  },
  care_team: { id: "care_team", defaultMessage: "Care Team" },
  import_patients: { id: "import_patients", defaultMessage: "Import Patients" },
  import_service_users: {
    id: "import_service_users",
    defaultMessage: "Import Service Users",
  },
  patients_w_count: {
    id: "patients_w_count",
    defaultMessage: "{count} Patients",
  },
  one_patient: { id: "one_patient", defaultMessage: "1 Patient" },
  one_service_user: {
    id: "one_service_user",
    defaultMessage: "1 Service User",
  },
  service_users_w_count: {
    id: "service_users_w_count",
    defaultMessage: "{count} Service Users",
  },
  dau: { id: "dau", defaultMessage: "Daily (DAU)" },
  wau: { id: "wau", defaultMessage: "Weekly (WAU)" },
  mau: { id: "mau", defaultMessage: "Monthly (MAU)" },
  user_activity: {
    id: "user_activity",
    defaultMessage: "User Activity",
  },
  discontinued: {
    id: "discontinued",
    defaultMessage: "Discontinued",
  },
  clone_template: {
    id: "clone_template",
    defaultMessage: "Clone Template",
  },
  one_app_reasons: {
    id: "one_app_reasons",
    defaultMessage: "Please select one of the reasons if applicable",
  },
  archive_confirm: {
    id: "archive_confirm",
    defaultMessage: "Archive Patient: Please Confirm",
  },
  invitation_expired: {
    id: "invitation_expired",
    defaultMessage: "Invitation Expired",
  },
  deleted_uc: { id: "deleted_uc", defaultMessage: "DELETED" },
  invited: { id: "invited", defaultMessage: "Invited" },
  added: { id: "added", defaultMessage: "Added" },
  dropout: { id: "dropout", defaultMessage: "Dropout" },
  sure_send_messages_to: {
    id: "sure_send_messages_to",
    defaultMessage:
      "Are you sure you want to send the messages to {noOfPatients} patients?",
  },
  charge_items_uc: {
    id: "charge_items_uc",
    defaultMessage: "PURCHASE HISTORY",
  },
  color: {
    id: "color",
    defaultMessage: "Color",
  },
  date_of_consent: { id: "date_of_consent", defaultMessage: "Date Of Consent" },
  appt_desc_w_date: {
    id: "appt_desc_w_date",
    defaultMessage: "{description} on {date}",
  },
  dp_consent: {
    id: "dp_consent",
    defaultMessage: "See Data Processing Consent",
  },
  configure: { id: "configure", defaultMessage: "Configure" },
  wc_activate: {
    id: "wc_activate",
    defaultMessage:
      "Welcome back! You have just joined {facilityName}. You already have an account with myPatientSpace. Your account is pending activation. Please activate your account by clicking on the link that has been sent to your email/phone.",
  },
  decide_appt_time_later: {
    id: "decide_appt_time_later",
    defaultMessage: "Decide Appointment Time Later",
  },
  staff_added_ct: {
    id: "staff_added_ct",
    defaultMessage:
      "Staff has been added and a care team created for the staff. Please check Doctor Teams tab.",
  },
  no_teams: {
    id: "no_teams",
    defaultMessage: "There are no teams at the moment.",
  },
  doctor_teams: {
    id: "doctor_teams",
    defaultMessage: "Doctor Teams",
  },
  support_teams: {
    id: "support_teams",
    defaultMessage: "Support Teams",
  },
  a_create_doc_team: {
    id: "a_create_doc_team",
    defaultMessage: "Also create a team for this doctor?",
  },
  doctor_visibility: {
    id: "doctor_visibility",
    defaultMessage: "Apply restricted patient visibility",
  },
  referral_date: {
    id: "referral_date",
    defaultMessage: "Date Referred",
  },
  enroll_date: {
    id: "enroll_date",
    defaultMessage: "Date Enrolled",
  },
  first_insulin: {
    id: "first_insulin",
    defaultMessage: "First Time Insulin",
  },
  weight: {
    id: "weight",
    defaultMessage: "Weight",
  },
  hba1c: {
    id: "hba1c",
    defaultMessage: "HbA1c",
  },
  blood_glucose: {
    id: "blood_glucose",
    defaultMessage: "Blood Glucose",
  },
  preferred_language: {
    id: "preferred_language",
    defaultMessage: "Preferred Language",
  },
  diabetes_type: {
    id: "diabetes_type",
    defaultMessage: "Diabetes Type",
  },
  can_pt_book: {
    id: "can_pt_book",
    defaultMessage: "Allow Self Booking By Patients?",
  },
  appts_created: {
    id: "appts_created",
    defaultMessage: "Appointments have been created.",
  },
  reschedule_appt_g: {
    id: "reschedule_appt_g",
    defaultMessage: "Reschedule Appointment - General",
  },
  slots_per_appt: {
    id: "slots_per_appt",
    defaultMessage: "Slots Per Appointment",
  },
  rebook_appointment: {
    id: "rebook_appointment",
    defaultMessage: "Rebook Appointment",
  },
  appointment_on_d: {
    id: "appointment_on_d",
    defaultMessage: "Appointment on {dateTime}",
  },
  edit_details: {
    id: "edit_details",
    defaultMessage: "Edit Details",
  },
  rebook: {
    id: "rebook",
    defaultMessage: "Rebook",
  },
  reschedule_appointment: {
    id: "reschedule_appointment",
    defaultMessage: "Reschedule Appointment",
  },
  reschedule: {
    id: "reschedule",
    defaultMessage: "Reschedule",
  },
  change_appt_time: {
    id: "change_appt_time",
    defaultMessage: "Change Appointment Time",
  },
  current_appt_time: {
    id: "current_appt_time",
    defaultMessage: "Current Appointment Time",
  },
  new_appt_time: {
    id: "new_appt_time",
    defaultMessage: "New Appointment Time",
  },
  correct_anss: { id: "correct_anss", defaultMessage: "Correct Answers:" },
  correct_ans: { id: "correct_ans", defaultMessage: "Correct Answer:" },
  correct: { id: "correct", defaultMessage: "Correct" },
  incorrect: { id: "incorrect", defaultMessage: "Incorrect" },
  ca_na_reqd: {
    id: "ca_na_reqd",
    defaultMessage: "Current assignee and new assignee are required",
  },
  req_acc: { id: "req_acc", defaultMessage: "Both Requested and Accepted" },
  enter_valid_date: {
    id: "enter_valid_date",
    defaultMessage: "Enter a valid date",
  },
  completed_sm: { id: "completed_sm", defaultMessage: "completed" },
  xOfy: { id: "xOfy", defaultMessage: "{completed} of {required}" },
  org_deleted: {
    id: "org_deleted",
    defaultMessage: "Organization has been deleted.",
  },
  error_org_delete: {
    id: "error_org_delete",
    defaultMessage: "Error deleting the organization.",
  },
  delete_org_warning: {
    id: "delete_org_warning",
    defaultMessage:
      "Are you sure you want to delete organization {orgName}? This can not be reverted.",
  },
  delete_org: {
    id: "delete_org",
    defaultMessage: "Delete Organization",
  },
  organizations: { id: "organizations", defaultMessage: "Organizations" },
  this_is_you: { id: "this_is_you", defaultMessage: "This is You!" },
  reset_password: { id: "reset_password", defaultMessage: "Reset Password" },
  role_reqd: { id: "role_reqd", defaultMessage: "Role is Required" },
  add_new_staff: { id: "add_new_staff", defaultMessage: "Add New Staff" },
  staff_restored: {
    id: "staff_restored",
    defaultMessage: "Staff has been restored.",
  },
  password_reset_w_name: {
    id: "password_reset_w_name",
    defaultMessage:
      "Password has been reset for {name}. An Email/SMS will be sent with the new credentials",
  },
  tasks_by_topics_w_count: {
    id: "tasks_by_topics_w_count",
    defaultMessage: "Tasks By Topics - {count}",
  },
  tasks_by_templates_w_count: {
    id: "tasks_by_templates_w_count",
    defaultMessage: "Tasks By Templates - {count}",
  },
  override_role_privileges: {
    id: "override_role_privileges",
    defaultMessage: "Override Role Privileges",
  },
  role_privileges_msg: {
    id: "role_privileges_msg",
    defaultMessage:
      "If you have selected a Role above, selection here would override the privileges from it.",
  },
  allow_channel_publishing: {
    id: "allow_channel_publishing",
    defaultMessage: "Allow Channel Publishing?",
  },
  external_api: { id: "external_api", defaultMessage: "External API" },
  external_id: { id: "external_id", defaultMessage: "External Id" },
  role: { id: "role", defaultMessage: "Role" },
  super_user_q: { id: "super_user_q", defaultMessage: "Super User?" },
  publisher_staff_q: {
    id: "publisher_staff_q",
    defaultMessage: "Publisher Staff?",
  },
  privileges: { id: "privileges", defaultMessage: "Privileges" },
  default_visibility_afs: {
    id: "default_visibility_afs",
    defaultMessage: "Default Visibility On Created Artifacts",
  },
  attributes_filter_pt: {
    id: "attributes_filter_pt",
    defaultMessage: "Attributes to Filter Patient",
  },
  pt_detail_attributes: {
    id: "pt_detail_attributes",
    defaultMessage: "Accessible Patient Detail Attributes",
  },
  staff_no_usage: {
    id: "staff_no_usage",
    defaultMessage: "No usage data found for this staff.",
  },
  want_delete_name: {
    id: "want_delete_name",
    defaultMessage: "Do you want to delete {name}?",
  },
  want_remove_name: {
    id: "want_remove_name",
    defaultMessage: "Do you want to remove {name} from Organization?",
  },
  confirm_deleting_type: {
    id: "confirm_deleting_type",
    defaultMessage: "Confirm Deleting {type}",
  },
  confirm_removing_type: {
    id: "confirm_removing_type",
    defaultMessage: "Confirm Removing {type}",
  },
  rp_w_name: { id: "rp_w_name", defaultMessage: "Reset Password - {name}" },
  include_inactive_staff: {
    id: "include_inactive_staff",
    defaultMessage: "Include Inactive Staff",
  },
  total_staff: { id: "total_staff", defaultMessage: "{total} Staff" },
  no_type_added: {
    id: "no_type_added",
    defaultMessage: "No {type} added yet.",
  },
  edit_org: { id: "edit_org", defaultMessage: "Edit Organization" },
  org_ct_info: {
    id: "org_ct_info",
    defaultMessage:
      "There is a default care team created for this organization. You can add/remove more care teams based on requirements.",
  },
  city_town: { id: "city_town", defaultMessage: "City/Town" },
  update: { id: "update", defaultMessage: "Update" },
  logo: { id: "logo", defaultMessage: "Logo" },
  contact_info: { id: "contact_info", defaultMessage: "Contact Info" },
  org_created: {
    id: "org_created",
    defaultMessage: "Organization has been created.",
  },
  org_create_err: {
    id: "org_create_err",
    defaultMessage: "Error creating the organization.",
  },
  create_org: { id: "create_org", defaultMessage: "Create an Organization" },
  no_orgs: {
    id: "no_orgs",
    defaultMessage: "There are no organizations at the moment.",
  },
  staff_no_orgs: {
    id: "staff_no_orgs",
    defaultMessage: "You are not part of any organizations at the moment.",
  },
  error_removing_staff: {
    id: "error_removing_staff",
    defaultMessage: "Error removing the staff from the organization.",
  },
  staff_removed_org: {
    id: "staff_removed_org",
    defaultMessage: "Staff has been removed from the Organization.",
  },
  add_existing_staff: {
    id: "add_existing_staff",
    defaultMessage: "Add Existing Staff",
  },
  sure_to_reset_creds_staff: {
    id: "sure_to_reset_creds_staff",
    defaultMessage:
      "Are you sure you want to reset the password for the staff?",
  },
  reset_creds_warning_msg_staff: {
    id: "reset_creds_warning_msg_staff",
    defaultMessage:
      "Clicking on the submit button will reset the password for the staff",
  },
  staff_added: { id: "staff_added", defaultMessage: "Staff has been added." },
  error_adding_staff: {
    id: "error_adding_staff",
    defaultMessage: "Error adding the staff to the organization.",
  },
  org_updated: {
    id: "org_updated",
    defaultMessage: "Organization has been updated.",
  },
  error_org_update: {
    id: "error_org_update",
    defaultMessage: "Error updating the organization.",
  },
  staff_saved: {
    id: "staff_saved",
    defaultMessage: "Staff details have been updated.",
  },
  nav_patients: { id: "nav_patients", defaultMessage: "Patients" },
  terms_privacy_for: { id: "terms_privacy_for", defaultMessage: "for {text}" },
  st_hm_treatment: { id: "st_hm_treatment", defaultMessage: "Treatment" },
  last: { id: "last", defaultMessage: "Last" },
  first: { id: "first", defaultMessage: "First" },
  others: { id: "others", defaultMessage: "Others" },
  submit_assessments_w_name_mrn: {
    id: "submit_assessments_w_name_mrn",
    defaultMessage: "Submit Assessments for {patientName}. MRN: {mrn}",
  },
  patients_added: { id: "patients_added", defaultMessage: "Patients Added" },
  patients_onboarded: {
    id: "patients_onboarded",
    defaultMessage: "Patients Onboarded",
  },
  active_monthly_avg: {
    id: "active_monthly_avg",
    defaultMessage: "Active Monthly (Avg)",
  },
  hi_w_name: { id: "hi_w_name", defaultMessage: "Hi, {name}!" },
  summary_today: {
    id: "summary_today",
    defaultMessage: "Here is your summary for today",
  },
  view_patients: { id: "view_patients", defaultMessage: "View Patients" },
  info_res: {
    id: "info_res",
    defaultMessage: "Information and Other Resources",
  },
  home: { id: "home", defaultMessage: "Home" },
  staff_ip_config_error: {
    id: "staff_ip_config_error",
    defaultMessage:
      "Information Panel for Staff is not configured. Please contact your system administrator.",
  },
  mfa_adv_1: {
    id: "mfa_adv_1",
    defaultMessage:
      "Two-factor authentication adds an extra layer of security to your account. We strongly recommend enabling it.",
  },
  mfa_adv_2: {
    id: "mfa_adv_2",
    defaultMessage:
      "Disabling two-factor authentication will reduce your account security. We recommend keeping it enabled.",
  },
  opt_in_mfa: { id: "opt_in_mfa", defaultMessage: "Enable 2FA" },
  opt_out_mfa: { id: "opt_out_mfa", defaultMessage: "Disable 2FA" },
  setup_2fa: { id: "setup_2fa", defaultMessage: "Setup 2FA" },
  mfa_enter_otp: {
    id: "mfa_enter_otp",
    defaultMessage: "Enter OTP that has been sent to your Email/Phone.",
  },
  otp: { id: "otp", defaultMessage: "OTP" },
  mfa_opt_in_msg: {
    id: "mfa_opt_in_msg",
    defaultMessage:
      "Well done! You have taken a very best step to secure your account. From now on, you will be asked to enter a OTP everytime you login to myPatientSpace.",
  },
  mfa_opt_out_msg: {
    id: "mfa_opt_out_msg",
    defaultMessage:
      "We have registered your preference. You can setup 2FA any time from your profile. You can access your profile by clicking on your icon/picture at the top right corner.",
  },
  mfa_select_def_msg: {
    id: "mfa_select_def_msg",
    defaultMessage: "Do you want to opt for SMS/Email based 2FA OTP for login?",
  },
  mfa_opt_out: { id: "mfa_opt_out", defaultMessage: "No, Opt Out" },
  mfa_opt_in: { id: "mfa_opt_in", defaultMessage: "Yes, Opt In" },
  two_step_verification: {
    id: "two_step_verification",
    defaultMessage: "2-Step Verification",
  },
  resend_code: { id: "resend_code", defaultMessage: "Resend code" },
  resend_code_in: {
    id: "resend_code_in",
    defaultMessage: "Resend code in {seconds}s",
  },
  verify: { id: "verify", defaultMessage: "Verify" },
  space_changed: {
    id: "space_changed",
    defaultMessage: "Space has been changed. Please login to access it.",
  },
  is_eq: { id: "is_eq", defaultMessage: "is equal to" },
  is_bw: { id: "is_bw", defaultMessage: "is between" },
  is_lt: { id: "is_lt", defaultMessage: "is less than" },
  is_lte: { id: "is_lte", defaultMessage: "is less than or equal to" },
  is_gt: { id: "is_gt", defaultMessage: "is greater than" },
  is_gte: { id: "is_gte", defaultMessage: "is greater than or equal to" },
  is_et: { id: "is_et", defaultMessage: "is empty" },
  is_not_et: { id: "is_not_et", defaultMessage: "is not empty" },
  is_neq: { id: "is_neq", defaultMessage: "does not equal" },
  is_in: { id: "is_in", defaultMessage: "includes" },
  is_nin: { id: "is_nin", defaultMessage: "does not include" },
  is_nin: { id: "is_nin", defaultMessage: "does not include" },
  notes_for_staff: { id: "notes_for_staff", defaultMessage: "Notes for Staff" },
  messages_to_patients: {
    id: "messages_to_patients",
    defaultMessage: "Messages and Updates to Patients",
  },
  summary_uc: { id: "summary_uc", defaultMessage: "SUMMARY" },
  sure_to_reopen_appt: {
    id: "sure_to_reopen_appt",
    defaultMessage: "Are you sure you want to reopen the appointment?",
  },
  next_mrn: { id: "next_mrn", defaultMessage: "Next MRN" },
  screening_warning: {
    id: "screening_warning",
    defaultMessage:
      "This screening is meant to be performed within {value} hours of the appointment time.",
  },
  call_status: { id: "call_status", defaultMessage: "Call Status" },
  resubmit: { id: "resubmit", defaultMessage: "Resubmit" },
  cancel_resubmit: { id: "cancel_resubmit", defaultMessage: "Cancel Resubmit" },
  covid_screening: {
    id: "covid_screening",
    defaultMessage: "Screening",
  },
  date_time: { id: "date_time", defaultMessage: "Date/Time" },
  save_close: { id: "save_close", defaultMessage: "Save & Close" },
  appt_screening_res: {
    id: "appt_screening_res",
    defaultMessage: "Appointment Screening Result",
  },
  submit_participants: {
    id: "submit_participants",
    defaultMessage: "Submit Participants",
  },
  clinic_sts_risk: { id: "clinic_sts_risk", defaultMessage: "Done - Risk" },
  clinic_sts_ok: { id: "clinic_sts_ok", defaultMessage: "Done - OK" },
  clinic_sts_nr: { id: "clinic_sts_nr", defaultMessage: "Not Reachable" },
  clinic_sts_na: { id: "clinic_sts_na", defaultMessage: "Not Available" },
  clinic_sts_np: { id: "clinic_sts_np", defaultMessage: "No Phone" },
  clinic_sts_resch: {
    id: "clinic_sts_resch",
    defaultMessage: "Already rescheduled on PAS",
  },
  clinic_sts_lm: { id: "clinic_sts_lm", defaultMessage: "Left Message" },
  clinic_sts_noans: { id: "clinic_sts_noans", defaultMessage: "No Answer" },
  clinic_sts_pt_reqc: {
    id: "clinic_sts_pt_reqc",
    defaultMessage: "Patient Req. Cancel",
  },
  clinic_sts_pt_ca: {
    id: "clinic_sts_pt_ca",
    defaultMessage: "Patient Prev. Cancelled",
  },
  clinic_sts_pending: { id: "clinic_sts_pending", defaultMessage: "Pending" },
  scheduled: { id: "scheduled", defaultMessage: "Scheduled" },
  no: { id: "no", defaultMessage: "No" },
  asap_uc: { id: "asap_uc", defaultMessage: "ASAP" },
  urgent_uc: { id: "urgent_uc", defaultMessage: "URGENT" },
  normal_uc: { id: "normal_uc", defaultMessage: "NORMAL" },
  low_uc: { id: "low_uc", defaultMessage: "LOW" },
  stat_uc: { id: "stat_uc", defaultMessage: "STAT" },
  requested_uc: { id: "requested_uc", defaultMessage: "REQUESTED" },
  accepted_uc: { id: "accepted_uc", defaultMessage: "ACCEPTED" },
  completed_uc: { id: "completed_uc", defaultMessage: "COMPLETED" },
  current_password: {
    id: "current_password",
    defaultMessage: "Current Password",
  },
  set_current_password: {
    id: "set_current_password.",
    defaultMessage: "Please set current password.",
  },
  pwd_changed: {
    id: "pwd_changed",
    defaultMessage: "Password has been changed.",
  },
  change_password: { id: "change_password", defaultMessage: "Change Password" },
  requested: { id: "requested", defaultMessage: "Requested" },
  accepted: { id: "accepted", defaultMessage: "Accepted" },
  count: { id: "count", defaultMessage: "Count" },
  assignee_tasks_due: {
    id: "assignee_tasks_due",
    defaultMessage: "Assignee and Tasks Due",
  },
  assignee_task_status: {
    id: "assignee_task_status",
    defaultMessage: "Assignee and Task Status",
  },
  signup_conf_thank_u: {
    id: "signup_conf_thank_u",
    defaultMessage:
      "Thank you for signing up with myPatientSpace. Please check your email or SMS and click on the link to complete the Signup process.",
  },
  signup_conf_app: {
    id: "signup_conf_app",
    defaultMessage:
      "You can close this window and return to myPatientSpace by tapping DONE on top right",
  },
  signup_conf_ins: {
    id: "signup_conf_ins",
    defaultMessage:
      "Please download the application on your mobile device. After installing the app, Sign In using your username and password.",
  },
  signup_conf_ins_download: {
    id: "signup_conf_ins_download",
    defaultMessage:
      "If not already installed, please <download>download</download> the application on your device. After installing the app, Sign In using your username and password.",
  },
  signup_conf_success: {
    id: "signup_conf_success",
    defaultMessage: "Your account has been created successfully!",
  },
  signup_conf_new_ins: {
    id: "signup_conf_new_ins",
    defaultMessage:
      "You can download the app on your mobile device or access it directly from your browser.",
  },
  signup_conf_download_btn: {
    id: "signup_conf_download_btn",
    defaultMessage: "Download App",
  },
  signup_conf_access_btn: {
    id: "signup_conf_access_btn",
    defaultMessage: "Access App",
  },
  user_activated_success: {
    id: "user_activated_success",
    defaultMessage: "User activated successfully!",
  },
  send_message_to: {
    id: "send_message_to",
    defaultMessage: "Send Message to {name}",
  },
  no_info_panel: {
    id: "no_info_panel",
    defaultMessage: "Info panel is not configured",
  },
  uploaded_files: { id: "uploaded_files", defaultMessage: "Uploaded Files" },
  assets_desc: {
    id: "assets_desc",
    defaultMessage:
      "Once file is uploaded to public CDN, you can use the mentioned URL as the image source. Accepts jpg, jpeg, png, gif, mp3, mp4, avi, aac",
  },

  appt_booked_for_slot: {
    id: "appt_booked_for_slot",
    defaultMessage: "An appointment has been booked for {slot}",
  },
  sent_appt_email: {
    id: "sent_appt_email",
    defaultMessage: "We have sent you an email with the appointment details.",
  },
  book_now: { id: "book_now", defaultMessage: "Book Now" },
  book_appt_w_name: {
    id: "book_appt_w_name",
    defaultMessage: "Book Appointment - {name}",
  },
  review_booking: { id: "review_booking", defaultMessage: "Review Booking" },
  select_a_staff: {
    id: "select_a_staff",
    defaultMessage: "Please select a staff",
  },
  select_green_slot: {
    id: "select_green_slot",
    defaultMessage: "Select a free slot (green) to continue booking",
  },
  select_green_slot_w_count: {
    id: "select_green_slot_w_count",
    defaultMessage: "Select {count} free slots (green) to continue booking",
  },
  with: { id: "with", defaultMessage: "with" },

  select_or_add_pt: {
    id: "select_or_add_pt",
    defaultMessage: "Please select or add a patient",
  },
  for_patient: { id: "for_patient", defaultMessage: "for: {patientName}" },
  new_ad_hoc_patient: {
    id: "new_ad_hoc_patient",
    defaultMessage: "New Ad-hoc Patient for Appointment",
  },
  contact_details: { id: "contact_details", defaultMessage: "Contact Details" },
  contact_details_in_app: {
    id: "contact_details_in_app",
    defaultMessage: "Contact details registered in the app",
  },
  new_contact_details: {
    id: "new_contact_details",
    defaultMessage: "New contact details",
  },

  no_n_slots: {
    id: "no_n_slots",
    defaultMessage: "{noOfSlots} consecutive free slots are not available.",
  },
  share: { id: "share", defaultMessage: "Share" },
  select_a_schedule_view_class: {
    id: "select_a_schedule_view_class",
    defaultMessage: "Select a schedule to view the classes/rooms",
  },
  select_schedule: { id: "select_schedule", defaultMessage: "Select Schedule" },
  logins: { id: "logins", defaultMessage: "Logins" },
  survey_submission: {
    id: "survey_submission",
    defaultMessage: "Survey Submission",
  },
  no_joints_affected: {
    id: "no_joints_affected",
    defaultMessage: "No joints swollen or tender",
  },
  humanoid_no_positions: {
    id: "humanoid_no_positions",
    defaultMessage:
      "You have not selected any positions in the humanoid image.",
  },
  score_w_score: { id: "score_w_score", defaultMessage: "Score: {score}" },
  question_not_answered: {
    id: "question_not_answered.",
    defaultMessage: "This question was not answered.",
  },
  total_value_w_score: {
    id: "total_value_w_score",
    defaultMessage: "Total Score: {totalScore}",
  },
  total_value_w_value: {
    id: "total_value_w_value",
    defaultMessage: "Total Value: {totalValue}",
  },
  field_mandatory: {
    id: "field_mandatory",
    defaultMessage: "This field is mandatory",
  },
  father: { id: "father", defaultMessage: "Father" },
  mother: { id: "mother", defaultMessage: "Mother" },
  wife: { id: "wife", defaultMessage: "Wife" },
  husband: { id: "husband", defaultMessage: "Husband" },
  daughter: { id: "daughter", defaultMessage: "Daughter" },
  son: { id: "son", defaultMessage: "Son" },
  brother: { id: "brother", defaultMessage: "Brother" },
  sister: { id: "sister", defaultMessage: "Sister" },
  friend: { id: "friend", defaultMessage: "Friend" },
  room: { id: "room", defaultMessage: "Room" },
  floor: { id: "floor", defaultMessage: "Floor" },
  address_line_1: { id: "address_line_1", defaultMessage: "Address Line 1" },
  address_line_2: { id: "address_line_2", defaultMessage: "Address Line 2" },
  city: { id: "city", defaultMessage: "City" },
  district: { id: "district", defaultMessage: "District" },
  state: { id: "state", defaultMessage: "State" },
  postal_code: { id: "postal_code", defaultMessage: "Postal code" },
  bio: { id: "bio", defaultMessage: "Bio" },
  gender_optional: {
    id: "gender_optional",
    defaultMessage: "Gender (Optional)",
  },
  set_gender: { id: "set_gender.", defaultMessage: "Please set gender." },
  set_dob: { id: "set_dob", defaultMessage: "Please set Birth date." },
  dob_optional: {
    id: "dob_optional",
    defaultMessage: "Birth date (Optional)",
  },
  task_priority_w: {
    id: "task_priority_w",
    defaultMessage: "Task Priority: {priority}",
  },
  task_status_w: {
    id: "task_status_w",
    defaultMessage: "Task Status: {status}",
  },
  not_set: { id: "not_set", defaultMessage: "Not Set" },
  prefix_optional: {
    id: "prefix_optional",
    defaultMessage: "Prefix (Optional)",
  },
  prefix: {
    id: "prefix",
    defaultMessage: "Prefix",
  },
  first_name: { id: "first_name", defaultMessage: "First Name" },
  set_given_name: {
    id: "set_given_name",
    defaultMessage: "Please set a given name",
  },
  last_name: { id: "last_name", defaultMessage: "Last Name" },
  set_last_name: {
    id: "set_last_name",
    defaultMessage: "Please set a last name.",
  },
  phone_optional: { id: "phone_optional", defaultMessage: "Phone (Optional)" },
  phone_email_optional: {
    id: "phone_email_optional",
    defaultMessage: "Phone (Phone or email optional)",
  },
  email_optional: { id: "email_optional", defaultMessage: "Email (Optional)" },
  sponsors_heading: { id: "sponsors_heading", defaultMessage: "Sponsors" },
  good_morning: { id: "good_morning", defaultMessage: "Good Morning" },
  good_afternoon: { id: "good_afternoon", defaultMessage: "Good Afternoon" },
  good_evening: { id: "good_evening", defaultMessage: "Good Evening" },
  good_night: { id: "good_night", defaultMessage: "Good Night" },
  todays_tasks: { id: "todays_tasks", defaultMessage: "Today's Tasks" },
  go_to_tasks: { id: "go_to_tasks", defaultMessage: "Go to Tasks" },
  assessments_tasks_of: { id: "assessments_tasks_of", defaultMessage: "of" },
  assessments_tasks_see_details: {
    id: "assessments_tasks_see_details",
    defaultMessage: "See details",
  },
  assessments_tasks_total_score: {
    id: "assessments_tasks_total_score",
    defaultMessage: "Tot. Score",
  },
  assessments_tasks_assessments_title: {
    id: "assessments_tasks_assessments_title",
    defaultMessage: "Assessments",
  },
  class1_med_device: {
    id: "class1_med_device",
    defaultMessage: "myPatientSpace is a Class 1 Medical Device",
  },
  new_room: { id: "new_room", defaultMessage: "New Room" },
  new_class: { id: "new_class", defaultMessage: "New Class" },
  add_p_error1: {
    id: "add_p_error1",
    defaultMessage: "Please fill in valid values for all mandatory fields.",
  },
  add_p_error2: {
    id: "add_p_error2",
    defaultMessage: "Email or Phone number is mandatory.",
  },
  add_p_error3: {
    id: "add_p_error3",
    defaultMessage: "Email and Confirm Email should be the same.",
  },
  add_p_error4: {
    id: "add_p_error4",
    defaultMessage: "Phone and Confirm Phone should be the same.",
  },
  add_p_error5: {
    id: "add_p_error5",
    defaultMessage: "GP Email and Confirm Email should be the same.",
  },
  add_p_config_error: {
    id: "add_p_config_error",
    defaultMessage:
      "Add Patient page is not configured for the selected patient type. Please contact administrator.",
  },
  no_invite: { id: "no_invite", defaultMessage: "Don't send invite?" },
  msg_no_onboarding_steps: {
    id: "msg_no_onboarding_steps",
    defaultMessage:
      "If you set username and password invited person will be activated automatically, without any onboarding steps.",
  },
  set_text: { id: "set_text", defaultMessage: "Set" },
  set_un_pwd_wc: {
    id: "set_un_pwd_wc",
    defaultMessage: "SET USERNAME & PASSWORD",
  },
  pt_text: { id: "pt_text", defaultMessage: "Patient Type: {text}" },
  add_pt_type_helper: {
    id: "add_pt_type_helper",
    defaultMessage: "This will change and reset the form given below.",
  },
  print: { id: "print", defaultMessage: "Print" },
  report_duration: { id: "report_duration", defaultMessage: "Report Duration" },
  last_one_month: { id: "last_one_month", defaultMessage: "Last One Month" },
  last_two_months: { id: "last_two_months", defaultMessage: "Last Two Months" },
  last_three_months: {
    id: "last_three_months",
    defaultMessage: "Last Three Months",
  },
  last_six_months: { id: "last_six_months", defaultMessage: "Last Six Months" },
  last_year: { id: "last_year", defaultMessage: "Last Year" },
  search: { id: "search", defaultMessage: "Search" },
  navigate: { id: "navigate", defaultMessage: "Navigate" },
  globalSearch: { id: "globalSearch", defaultMessage: "Search (min 3 chars)" },
  search_patients: { id: "search_patients", defaultMessage: "Search patients" },
  search_sections_content: {
    id: "search_sections_content",
    defaultMessage: "Search sections or contents...",
  },
  showing_results_for: {
    id: "showing_results_for",
    defaultMessage: "Showing results for:",
  },
  select_patient_for: {
    id: "select_patient_for",
    defaultMessage: "Select Patient for",
  },
  back_to: { id: "back_to", defaultMessage: "Back to" },
  previous_page: { id: "previous_page", defaultMessage: "previous page" },
  clear: { id: "clear", defaultMessage: "Clear" },
  care_plans: { id: "care_plans", defaultMessage: "Care Plans" },
  link: { id: "link", defaultMessage: "Link" },
  view_template: { id: "view_template", defaultMessage: "View Template" },
  view_schedule: { id: "view_schedule", defaultMessage: "View Schedule" },
  no_pub_schedules: {
    id: "no_pub_schedules",
    defaultMessage: "There are no published schedules available",
  },
  book: { id: "book", defaultMessage: "Book" },
  group_cr: { id: "group_cr", defaultMessage: "Group Classes/Rooms" },
  published_schedules: {
    id: "published_schedules",
    defaultMessage: "Published Schedules",
  },
  share_link: { id: "share_link", defaultMessage: "Share Link" },
  new_ad_hoc_booking: {
    id: "new_ad_hoc_booking",
    defaultMessage: "New Ad-hoc Booking",
  },
  csv_file: { id: "csv_file", defaultMessage: "CSV file" },
  view_pub_sch: {
    id: "view_pub_sch",
    defaultMessage: "View Published Schedules",
  },
  upcoming_events: { id: "upcoming_events", defaultMessage: "Upcoming Events" },
  view_all: { id: "view_all", defaultMessage: "View All" },
  view_details: { id: "view_details", defaultMessage: "View Details" },

  pt_sch_info: {
    id: "pt_sch_info",
    defaultMessage:
      "This Patient type will be assigned to all the patients who are added as part of clinic uploads that use this schedule.",
  },
  sch_invite_pts: {
    id: "sch_invite_pts",
    defaultMessage: "Invite/Re-Invite Patients Uploaded?",
  },
  sch_type: { id: "sch_type", defaultMessage: "Schedule Type" },
  one_one_sch: { id: "one_one_sch", defaultMessage: "One-to-One Schedules" },
  group_class: { id: "group_class", defaultMessage: "Group Class" },
  group_classes: { id: "group_classes", defaultMessage: "Group Classes" },
  conf_rooms: { id: "conf_rooms", defaultMessage: "Conference Rooms" },
  ce_placeholder: {
    id: "ce_placeholder",
    defaultMessage:
      "Type your text content here. Select text to apply formatting.",
  },
  hours_in_adv: { id: "hours_in_adv", defaultMessage: "Hours in advance" },
  booking_weekend: {
    id: "booking_weekend",
    defaultMessage: "Allow Booking On Weekend",
  },
  location_lib: {
    id: "location_lib",
    defaultMessage: "Location Helper Library",
  },
  require_consent: {
    id: "require_consent",
    defaultMessage: "Require explicit consent?",
  },
  consent_text: { id: "consent_text", defaultMessage: "Consent Text" },
  needs_action: { id: "needs_action", defaultMessage: "Needs Action?" },
  ct_for_appts: {
    id: "ct_for_appts",
    defaultMessage: "Care Team For Appointments",
  },
  emails_clo_notif: {
    id: "emails_clo_notif",
    defaultMessage: "Emails for Closure Notification",
  },
  comms_emails: { id: "", defaultMessage: "Comma separated emails" },
  view_inp_slots: {
    id: "view_inp_slots",
    defaultMessage: "View In-progress Slots",
  },
  picked_n_slots: {
    id: "picked_n_slots",
    defaultMessage: "Picked {count} Slots",
  },
  one_space: { id: "one_space", defaultMessage: "1 free space" },
  count_free_spaces: {
    id: "count_free_spaces",
    defaultMessage: "{count} free spaces",
  },
  one_slot: { id: "one_slot", defaultMessage: "1 Slot" },
  count_slots: { id: "count_slots", defaultMessage: "{count} Slots" },

  edit_sch_w_name: { id: "done", defaultMessage: "Edit Schedule - {name}" },
  create_slots_w_name: {
    id: "create_slots_w_name",
    defaultMessage: "Create Slots  - {name}",
  },
  create_gc_w_name: {
    id: "create_gc_w_name",
    defaultMessage: "Create Group Classes  - {name}",
  },
  delete_sch_w_name: {
    id: "delete_sch_w_name",
    defaultMessage: "Delete Schedule - {name}",
  },
  create_links_w_name: {
    id: "create_links_w_name",
    defaultMessage: "Create Links - {name}",
  },
  delete_slots_w_name: {
    id: "delete_slots_w_name",
    defaultMessage: "Delete Slots  - {name}",
  },
  slots_warning: {
    id: "slots_warning",
    defaultMessage:
      "Please set slot duration in the schedule info to be able to create slots.",
  },
  create_links: { id: "create_links", defaultMessage: "Create Links" },
  change_schedule_info: {
    id: "change_schedule_info",
    defaultMessage: "Change Schedule Info",
  },
  create_slots: { id: "create_slots", defaultMessage: "Create Slots" },
  copy_link: { id: "copy_link", defaultMessage: "Copy Link" },
  custom_data: { id: "custom_data", defaultMessage: "Custom Data" },
  temp_msg_cancel_pt: {
    id: "temp_msg_cancel_pt",
    defaultMessage: "Cancel Appointment - Patient",
  },
  temp_msg_cancel_staff: {
    id: "temp_msg_cancel_staff",
    defaultMessage: "Cancel Appointment - Staff",
  },
  general: { id: "general", defaultMessage: "General" },
  reschedule_appt_pt: {
    id: "reschedule_appt_pt",
    defaultMessage: "Reschedule Appointment - Patient",
  },
  reschedule_appt_staff: {
    id: "reschedule_appt_staff",
    defaultMessage: "Reschedule Appointment - Staff",
  },
  congratulations: {
    id: "congratulations",
    defaultMessage: "Congratulations!",
  },
  setup_success: {
    id: "setup_success",
    defaultMessage: "You have successfully setup your account.",
  },
  username_is: {
    id: "username_is",
    defaultMessage: "Your username is: <bold>{userName}</bold>",
  },

  download_install: {
    id: "download_install",
    defaultMessage: "Download & Install the app on your mobile device.",
  },
  signin_w_un_pwd1: {
    id: "signin_w_un_pwd1",
    defaultMessage:
      "Sign-in with username: {userName}, and the password you just setup.",
  },
  signin_w_un_pwd2: {
    id: "signin_w_un_pwd2",
    defaultMessage: "Sign-in with your username and the password.",
  },
  ty_service: {
    id: "ty_service",
    defaultMessage: "Thank you for using this service.",
  },
  step_2_creds: {
    id: "step_2_creds",
    defaultMessage: "Step 2 of 3: Your Credentials",
  },
  error_un_pwd: {
    id: "error_un_pwd",
    defaultMessage: "Error with username and password set.",
  },
  received_as: { id: "received_as", defaultMessage: "Received As" },
  enter_to_ai: {
    id: "enter_to_ai",
    defaultMessage: "Enter the following details to accept invitation.",
  },
  enter_e_p: {
    id: "enter_e_p",
    defaultMessage:
      "Enter your email or phone with country code to accept invitation.",
  },
  enter_email_inv: {
    id: "enter_email_inv",
    defaultMessage: "Enter your email to accept invitation.",
  },
  enter_cc_ph: {
    id: "enter_cc_ph",
    defaultMessage:
      "Select country and enter your phone number to accept invitation.",
  },
  invited_to_join_w_fn: {
    id: "invited_to_join_w_fn",
    defaultMessage:
      "You’ve been invited to join {facilityName} on myPatientSpace",
  },
  invited_to_join: {
    id: "invited_to_join",
    defaultMessage: "You’ve been invited to join myPatientSpace",
  },
  step_1_accept: {
    id: "step_1_accept",
    defaultMessage: "Step 1 of 3: Accept Invitation",
  },
  install: { id: "install", defaultMessage: "Install" },
  install_pwa: { id: "install_pwa", defaultMessage: "Install PWA" },
  register: { id: "register", defaultMessage: "Register" },
  mps_acct_setup_for: {
    id: "mps_acct_setup_for",
    defaultMessage: "myPatientSpace Account Setup for {facilityName}",
  },
  mps_acct_setup: {
    id: "mps_acct_setup",
    defaultMessage: "myPatientSpace Account Setup",
  },
  view_patient: { id: "view_patient", defaultMessage: "View Patient" },
  pt_screening_appt: {
    id: "pt_screening_appt",
    defaultMessage: "Patient Screening - Appointment",
  },
  no_appointments: { id: "no_appointments", defaultMessage: "No Appointments" },
  screening: {
    id: "screening",
    defaultMessage: "Screening",
  },
  contact: {
    id: "contact",
    defaultMessage: "Contact",
  },
  mrn: { id: "mrn", defaultMessage: "MRN" },
  time: { id: "time", defaultMessage: "Time" },
  screened_ok: { id: "screened_ok", defaultMessage: "Screened - OK" },
  screened_risk: { id: "screened_risk", defaultMessage: "Screened - Risk" },
  screening_pending: {
    id: "screening_pending",
    defaultMessage: "Screening Pending",
  },
  ok: { id: "ok", defaultMessage: "Ok" },
  risk: { id: "risk", defaultMessage: "Risk" },
  screened_by_staff: {
    id: "screened_by_staff",
    defaultMessage: "Screened By Staff",
  },
  self_screen: { id: "self_screen", defaultMessage: "Self Screen" },
  screened: { id: "screened", defaultMessage: "Screened" },
  view_report: { id: "view_report", defaultMessage: "View Report" },
  assigned_to_w_col: {
    id: "assigned_to_w_col",
    defaultMessage: "Assigned to:",
  },
  consultant_w_col: {
    id: "consultant_w_col",
    defaultMessage: "Consultant:",
  },
  call_action_req: {
    id: "call_action_req",
    defaultMessage: "Call Action Required",
  },
  speciality_w_col: { id: "speciality_w_col", defaultMessage: "Speciality:" },
  call_patients: { id: "call_patients", defaultMessage: "Call Patients" },
  report: { id: "report", defaultMessage: "Report" },
  valid_json_file: {
    id: "valid_json_file",
    defaultMessage: "Please set a valid file with proper JSON content.",
  },
  file: { id: "file", defaultMessage: "File" },
  change_file: { id: "change_file", defaultMessage: "Change File" },
  drop_file_here: { id: "drop_file_here", defaultMessage: "Drop file here" },
  choose_or_drag_file: {
    id: "choose_or_drag_file",
    defaultMessage: "Choose file or drag and drop",
  },
  document_file_type_mismatch: {
    id: "document_file_type_mismatch",
    defaultMessage: "This file does not match the selected document type. Choose a matching file or change the document type.",
  },
  click_or_drag: {
    id: "click_or_drag",
    defaultMessage: "Click to browse or drag a file here",
  },
  enter_document_name: {
    id: "enter_document_name",
    defaultMessage: "Enter document name",
  },
  library_w_count: {
    id: "library_w_count",
    defaultMessage: "Library ({count})",
  },
  topics_w_count: {
    id: "topics_w_count",
    defaultMessage: "Topics ({count})",
  },
  topic: { id: "topic", defaultMessage: "Topic" },
  file_type: { id: "file_type", defaultMessage: "File Type" },
  featured_content: {
    id: "featured_content",
    defaultMessage: "Featured Content",
  },
  sort_order: { id: "sort_order", defaultMessage: "Sort Order" },
  created: { id: "created", defaultMessage: "Created" },
  modified: { id: "modified", defaultMessage: "Modified" },
  actions: { id: "actions", defaultMessage: "Actions" },
  appointment: { id: "appointment", defaultMessage: "Appointment" },
  open: { id: "open", defaultMessage: "Open" },
  cal_more: { id: "cal_more", defaultMessage: "+{total} more" },
  template_param_ht: {
    id: "template_param_ht",
    defaultMessage: "Set status text and add templateParams using '_'",
  },
  start_time: { id: "start_time", defaultMessage: "Start Time" },
  end_time: { id: "end_time", defaultMessage: "End Time" },
  select_care_team: {
    id: "select_care_team",
    defaultMessage: "Select Care Team",
  },
  select_care_teams: {
    id: "select_care_teams",
    defaultMessage: "Select Care Teams",
  },
  submit_survey_q: {
    id: "submit_survey_q",
    defaultMessage: "Confirm Submission",
  },
  sure_submit_survey: {
    id: "sure_submit_survey",
    defaultMessage: "Ready to submit your responses?",
  },
  review_your_answers: {
    id: "review_your_answers",
    defaultMessage: "Review your answers below, then submit.",
  },
  submit_assessment: {
    id: "submit_assessment",
    defaultMessage: "Submit Assessment",
  },
  value_bw_1and6: {
    id: "value_bw_1and6",
    defaultMessage: "Please enter a value between 1 and 6.",
  },
  value_bw_100and800: {
    id: "value_bw_100and800",
    defaultMessage: "Please enter a value between 100 and 800.",
  },
  answer_mandatory_qs: {
    id: "answer_mandatory_qs",
    defaultMessage: "Valid Answer is required for all mandatory questions.",
  },
  gc_error: {
    id: "gc_error",
    defaultMessage:
      "No of Patients exceeds the maximum number of allowed patients for this class",
  },
  set_valid_participants: {
    id: "set_valid_participants",
    defaultMessage: "Please set valid participants.",
  },
  facility_admin: { id: "facility_admin", defaultMessage: "Facility Admin" },
  arrival_time: { id: "arrival_time", defaultMessage: "Arrival Time" },
  max_part_allowed: {
    id: "max_part_allowed",
    defaultMessage: "Maximum Number of Patient Participants Allowed",
  },
  include_video_call: {
    id: "include_video_call",
    defaultMessage: "Include Video Call?",
  },
  data: { id: "data", defaultMessage: "Data" },
  comments_info: {
    id: "comments_info",
    defaultMessage:
      "Comments will also be used as event description on the calendar.",
  },
  advanced_options: {
    id: "advanced_options",
    defaultMessage: "Advanced Options",
  },
  gc_appointment: {
    id: "gc_appointment",
    defaultMessage: "Group Class Appointment",
  },
  gc_info: {
    id: "gc_info",
    defaultMessage:
      "Group Class Group call appointment has been created. You can share the below link with your admin.",
  },
  no_schedule: { id: "no_schedule", defaultMessage: "No Schedule" },
  enter_valid_number: {
    id: "enter_valid_number",
    defaultMessage: "Please enter a valid number",
  },
  free_slots_info: {
    id: "free_slots_info",
    defaultMessage:
      "This needs {count} consecutive free slots. When you select the first slot, it will automatically select other slots based on availability.",
  },
  selected_slot: {
    id: "selected_slot",
    defaultMessage: "Selected Slot: {slot}",
  },
  select_a_schedule: {
    id: "select_a_schedule",
    defaultMessage: "Please select a schedule",
  },
  select_a_slot: {
    id: "select_a_slot",
    defaultMessage: "Please select a slot",
  },
  select_free_slot: {
    id: "select_free_slot",
    defaultMessage: "Please select a free slot",
  },
  new_booking_for: {
    id: "new_booking_for",
    defaultMessage: "New Booking for {name}",
  },
  select_a_template: {
    id: "select_a_template",
    defaultMessage: "Please select a template",
  },
  one_free_space: { id: "one_f_space", defaultMessage: " | 1 free space" },
  n_free_spaces: {
    id: "n_free_spaces",
    defaultMessage: " | {count} free spaces",
  },
  slot: { id: "slot", defaultMessage: "Slot" },
  default_text: { id: "default_text", defaultMessage: "default" },
  assign_cp_conf: {
    id: "assign_cp_conf",
    defaultMessage: "Are you sure you want to {op} the care plan?",
  },
  archive_warning: {
    id: "archive_warning",
    defaultMessage:
      "WARNING: Archiving Patient Data cannot be undone.  None of this patient’s data will be visible to staff in ANY listing view.  Patient will no longer be able to use the myPatientSpace App or on the Web (they will be logged out).  This action is irreversible, and we urge extreme caution, recovery will NOT be possible.",
  },
  sure_to_archive: {
    id: "sure_to_archive",
    defaultMessage:
      "FINAL WARNING:  This action is irreversible.  Are you sure? Press Confirm to continue to Archive all patient data.",
  },
  yes_deactivate: { id: "yes_deactivate", defaultMessage: "Yes, De-Activate" },
  archive_patient: {
    id: "archive_patient",
    defaultMessage: "Archive Patient Data?",
  },
  assessment_deleted: {
    id: "assessment_deleted",
    defaultMessage: "Assessment has been deleted.",
  },
  delete_assessment: {
    id: "delete_assessment",
    defaultMessage: "Delete Assessment",
  },
  to_delete_sr: {
    id: "to_delete_sr",
    defaultMessage:
      "Are you sure you want to delete the assessment? It will be permanently deleted from the system and can not be reverted.",
  },
  reopen_task: {
    id: "reopen_task",
    defaultMessage: "Reopen Task?",
  },
  view_complete_space: {
    id: "view_complete_space",
    defaultMessage: "View Complete Space",
  },
  view_profile: {
    id: "view_profile",
    defaultMessage: "View Profile",
  },
  consolidated_report: {
    id: "consolidated_report",
    defaultMessage: "Consolidated Report",
  },
  send_message: {
    id: "send_message",
    defaultMessage: "Send Message",
  },
  username_already_taken: {
    id: "username_already_taken",
    defaultMessage: "Mentioned Username is already taken.",
  },
  set_valid_un: {
    id: "set_valid_un",
    defaultMessage: "Please set valid Username.",
  },
  email_phone_are: {
    id: "email_phone_are",
    defaultMessage: "Your Email address and Phone number are",
  },
  email_is: { id: "email_is", defaultMessage: "Your Email address is" },
  phone_no_is: { id: "phone_no_is", defaultMessage: "Your Phone number is" },
  email_ph_associated_already: {
    id: "email_ph_associated_already",
    defaultMessage:
      "{prefix} already associated with an account. You can <login>login</login> to your existing account or continue to submit your details to add as another space under the existing account.",
  },
  con_ph_no: { id: "con_ph_no", defaultMessage: "Confirm Phone Number" },
  login_creds: { id: "login_creds", defaultMessage: "Login Credentials" },
  set_un_pwd: {
    id: "set_un_pwd",
    defaultMessage: "Set your Login Username and Password",
  },
  email_or_phone: {
    id: "email_or_phone",
    defaultMessage: "Please enter email or mobile phone number.",
  },

  confirm_email: { id: "confirm_email", defaultMessage: "Confirm Email" },
  country: { id: "country", defaultMessage: "Country" },
  confirm_email_req: {
    id: "confirm_email_req",
    defaultMessage: "Confirm Email is required.",
  },
  confirm_phone_req: {
    id: "confirm_phone_req",
    defaultMessage: "Confirm Phone is required.",
  },
  should_past_date: {
    id: "should_past_date",
    defaultMessage: "{field} should be a past date",
  },
  should_future_date: {
    id: "should_future_date",
    defaultMessage: "{field} should be a future date",
  },
  date_bw: {
    id: "date_bw",
    defaultMessage: "Enter a date between {fromDate} and {toDate}",
  },
  number_bw: {
    id: "number_bw",
    defaultMessage: "Provide a valid number that is between {from} and {to}",
  },
  provide_valid_email: {
    id: "provide_valid_email",
    defaultMessage: "Please provide a valid email",
  },
  provide_valid_phone: {
    id: "provide_valid_phone",
    defaultMessage: "Please provide a valid phone with country code",
  },
  un_taken: {
    id: "un_taken",
    defaultMessage: "This Username is already taken.",
  },
  with_an_acount_alr: {
    id: "with_an_acount_alr",
    defaultMessage: "This {field} is already associated with an account.",
  },
  not_valid_field: {
    id: "not_valid_field",
    defaultMessage: "This {field} is not valid",
  },
  field_used: {
    id: "field_used",
    defaultMessage: "This {field} is already used.",
  },
  wc_back_associated: {
    id: "wc_back_associated",
    defaultMessage:
      "Welcome back! You have just joined {facilityName}. You already have an account with myPatientSpace associated with {emailAndPhone}.",
  },
  click_if_dnk_pwd: {
    id: "click_if_dnk_pwd",
    defaultMessage: "If you don't remember the password, click",
  },

  var_is_required: {
    id: "var_is_required",
    defaultMessage: "{title} is required.",
  },
  phone_number_cc: { id: "phone_number_cc", defaultMessage: "Phone Number" },
  privacy_policy_cc: {
    id: "privacy_policy_cc",
    defaultMessage: "Privacy Policy",
  },
  terms_conds_cc: {
    id: "terms_conds_cc",
    defaultMessage: "Terms and Conditions",
  },
  mps_terms_conds: {
    id: "mps_terms_conds",
    defaultMessage: "myPatientSpace Terms and Conditions",
  },

  verification_failed: {
    id: "verification_failed",
    defaultMessage: "Verification Failed",
  },
  for_text: { id: "for_text", defaultMessage: "for" },
  and: { id: "and", defaultMessage: "and" },
  have_read_accept: {
    id: "have_read_accept",
    defaultMessage: "I have read and accept the",
  },
  terms_conds: { id: "terms_conds", defaultMessage: "terms & conditions" },
  privacy_policy: { id: "privacy_policy", defaultMessage: "privacy policy" },
  creating_acc: { id: "creating_acc", defaultMessage: "creating this account" },
  keyword: { id: "keyword", defaultMessage: "Keyword" },
  country_code: { id: "country_code", defaultMessage: "Country code" },
  set_valid_id: { id: "set_valid_id", defaultMessage: "Please set valid ID." },
  id_uc: { id: "id_uc", defaultMessage: "ID" },
  send_instructions_reset_pwd: {
    id: "send_instructions_reset_pwd",
    defaultMessage:
      "Please enter your registered {contact}. We will send you instructions to reset your password.",
  },
  forgot_password_wo_q: {
    id: "forgot_password_wo_q",
    defaultMessage: "Forgot password",
  },

  reassign_tasks: { id: "reassign_tasks", defaultMessage: "Reassign Tasks" },
  current_assignee: {
    id: "current_assignee",
    defaultMessage: "Current Assignee",
  },
  tasks_reassigned: {
    id: "tasks_reassigned",
    defaultMessage: "{count} Tasks have been reassigned.",
  },
  new_assignee: { id: "new_assignee", defaultMessage: "New Assignee" },
  add_cancelled: { id: "add_cancelled", defaultMessage: "Add Cancelled?" },
  cancelled_only: {
    id: "cancelled_only",
    defaultMessage: "Cancelled Only",
  },
  free_slots: { id: "free_slots", defaultMessage: "Free Slots" },
  both: { id: "both", defaultMessage: "Both" },
  schedules: {
    id: "schedules",
    defaultMessage: "Schedules",
  },
  active_staff: {
    id: "active_staff",
    defaultMessage: "Active Staff",
  },
  inactive_staff: {
    id: "inactive_staff",
    defaultMessage: "Inactive Staff",
  },
  gender: {
    id: "gender",
    defaultMessage: "Gender",
  },
  staff_age: {
    id: "staff_age",
    defaultMessage: "Staff Age",
  },
  no_results_found: {
    id: "no_results_found",
    defaultMessage: "No results found",
  },
  unknown: { id: "unknown", defaultMessage: "Unknown" },
  no_data_found: { id: "no_data_found", defaultMessage: "No data found." },
  invitation_status: {
    id: "invitation_status",
    defaultMessage: "Invitation Status",
  },
  age: { id: "age", defaultMessage: "Age" },
  daily_login_activity: {
    id: "daily_login_activity",
    defaultMessage: "Daily Login Activity",
  },
  active_today: { id: "active_today", defaultMessage: "Active Today" },
  ios_android_pct: {
    id: "ios_android_pct",
    defaultMessage: "iOS/Android (Pct.)",
  },
  new_high: { id: "new_high", defaultMessage: "  New High!" },
  no_of_staff: { id: "no_of_staff", defaultMessage: "No of Staff" },
  no_of_patients: { id: "no_of_patients", defaultMessage: "No of Patients" },

  month: { id: "month", defaultMessage: "Month" },
  week: { id: "week", defaultMessage: "Week" },
  work_week: { id: "work_week", defaultMessage: "Work Week" },
  day: { id: "day", defaultMessage: "Day" },
  agenda: { id: "agenda", defaultMessage: "Agenda" },
  patient_not_active_yet: {
    id: "patient_not_active_yet",
    defaultMessage: "Patient is not active yet.",
  },
  private_q: { id: "private_q", defaultMessage: "Private?" },
  select_template: {
    id: "select_template",
    defaultMessage: "Select from template",
  },
  copy_to_staff_notes: {
    id: "copy_to_staff_notes",
    defaultMessage: "Copy to Staff Notes",
  },
  task_focus: { id: "task_focus", defaultMessage: "Task Focus" },
  show_private_tasks: {
    id: "show_private_tasks",
    defaultMessage: "Show Only Private Tasks?",
  },
  by_sender: { id: "by_sender", defaultMessage: "by {senderName}" },
  select_pre_canned: {
    id: "select_pre_canned",
    defaultMessage: "Select a pre-canned message",
  },
  add_message_to_interaction: {
    id: "add_message_to_interaction",
    defaultMessage: "Add Message Content to Patient Interaction?",
  },
  tomorrow: { id: "tomorrow", defaultMessage: "Tomorrow" },
  days_7: { id: "days_7", defaultMessage: "Last 7 Days" },
  next7days: { id: "next7days", defaultMessage: "Next 7 Days" },
  days_10: { id: "days_10", defaultMessage: "Last 10 Days" },
  next10days: { id: "next10days", defaultMessage: "Next 10 Days" },
  month_1: { id: "month_1", defaultMessage: "Last 30 Days" },
  next1month: { id: "next1month", defaultMessage: "Next 30 Days" },
  date_range: { id: "date_range", defaultMessage: "Date Range" },
  drp_last_7_days: { id: "drp_last_7_days", defaultMessage: "Last 7 Days" },
  drp_last_30_days: { id: "drp_last_30_days", defaultMessage: "Last 30 Days" },
  drp_this_month: { id: "drp_this_month", defaultMessage: "This Month" },
  drp_last_month: { id: "drp_last_month", defaultMessage: "Last Month" },
  drp_last_3_months: {
    id: "drp_last_3_months",
    defaultMessage: "Last 3 Months",
  },
  drp_last_6_months: {
    id: "drp_last_6_months",
    defaultMessage: "Last 6 Months",
  },
  drp_last_year: { id: "drp_last_year", defaultMessage: "Last Year" },
  drp_last_2_years: { id: "drp_last_2_years", defaultMessage: "Last 2 Years" },
  drp_last_3_years: { id: "drp_last_3_years", defaultMessage: "Last 3 Years" },
  drp_past: { id: "drp_past", defaultMessage: "Past" },
  drp_future: { id: "drp_future", defaultMessage: "Future" },
  drp_next_7_days: { id: "drp_next_7_days", defaultMessage: "Next 7 Days" },
  drp_next_30_days: { id: "drp_next_30_days", defaultMessage: "Next 30 Days" },
  drp_next_month: { id: "drp_next_month", defaultMessage: "Next Month" },
  drp_next_3_months: {
    id: "drp_next_3_months",
    defaultMessage: "Next 3 Months",
  },
  drp_next_6_months: {
    id: "drp_next_6_months",
    defaultMessage: "Next 6 Months",
  },
  drp_next_year: { id: "drp_next_year", defaultMessage: "Next Year" },
  drp_next_2_years: { id: "drp_next_2_years", defaultMessage: "Next 2 Years" },
  drp_next_3_years: { id: "drp_next_3_years", defaultMessage: "Next 3 Years" },
  drp_select_date_range: {
    id: "drp_select_date_range",
    defaultMessage: "Select Date Range",
  },
  drp_from_date: { id: "drp_from_date", defaultMessage: "From {date}" },
  drp_to_date: { id: "drp_to_date", defaultMessage: "To {date}" },
  drp_date_range_display: {
    id: "drp_date_range_display",
    defaultMessage: "{fromDate} - {toDate}",
  },
  drp_from_label: { id: "drp_from_label", defaultMessage: "From" },
  drp_to_label: { id: "drp_to_label", defaultMessage: "To" },
  drp_aria_date_range_picker: {
    id: "drp_aria_date_range_picker",
    defaultMessage: "Date range picker",
  },
  drp_max_range_exceeded: {
    id: "drp_max_range_exceeded",
    defaultMessage: "Max {days} days",
  },
  prev_data: { id: "prev_data", defaultMessage: "Prev Data" },
  next_data: { id: "next_data", defaultMessage: "Next Data" },
  created_on: { id: "created_on", defaultMessage: "Created Date" },
  created_on_newest_first: {
    id: "created_on_newest_first",
    defaultMessage: "Created Date (Newest first)",
  },
  created_on_oldest_first: {
    id: "created_on_oldest_first",
    defaultMessage: "Created Date (Oldest first)",
  },
  modified_on_newest_first: {
    id: "modified_on_newest_first",
    defaultMessage: "Modified Date (Newest first)",
  },
  modified_on_oldest_first: {
    id: "modified_on_oldest_first",
    defaultMessage: "Modified Date (Oldest first)",
  },
  name_a_z: { id: "name_a_z", defaultMessage: "Name (A to Z)" },
  name_z_a: { id: "name_z_a", defaultMessage: "Name (Z to A)" },
  title_a_z: { id: "title_a_z", defaultMessage: "Title (A to Z)" },
  title_z_a: { id: "title_z_a", defaultMessage: "Title (Z to A)" },

  accepted_date: { id: "accepted_date", defaultMessage: "Accepted Date" },
  completed_date: { id: "completed_date", defaultMessage: "Completed Date" },
  date_range_em: {
    id: "date_range_em",
    defaultMessage: "Date Range should be less than or equal to thirty days.",
  },
  no_data_available: {
    id: "no_data_available",
    defaultMessage: "No data available",
  },
  done: { id: "done", defaultMessage: "Done" },
  n_days_on_treatment: {
    id: "n_days_on_treatment",
    defaultMessage: "Days on treatment: {dayNumberInTreatment}",
  },
  n_days_to_treatment: {
    id: "n_days_to_treatment",
    defaultMessage: "{dayNumberInTreatment} days to Treatment",
  },
  n_days_to_procedure: {
    id: "n_days_to_procedure",
    defaultMessage: "{dayNumberInTreatment} days to Procedure",
  },

  send_update_to: {
    id: "send_update_to",
    defaultMessage: "You are about to send status update to ",
  },
  add_notes_yourself: {
    id: "add_notes_yourself",
    defaultMessage: "You are about to add notes for yourself for ",
  },
  add_staff_notes: {
    id: "add_staff_notes",
    defaultMessage: "You are about to add your notes under Staff Notes for ",
  },
  status_messages: { id: "status_messages", defaultMessage: "Status Messages" },
  hide_messages_activation: {
    id: "hide_messages_activation",
    defaultMessage: "Hide Messages After Patient Activation",
  },
  patient_type_w_value: {
    id: "patient_type_w_value",
    defaultMessage: "Patient Type: {patientType}",
  },
  speciality: { id: "speciality", defaultMessage: "Speciality" },
  clinic_name: { id: "clinic_name", defaultMessage: "Clinic Name" },
  caller: { id: "caller", defaultMessage: "Caller" },
  date_from_to: { id: "date_from_to", defaultMessage: "Date (From and To)" },

  profile: { id: "profile", defaultMessage: "Profile" },
  change_space: { id: "change_space", defaultMessage: "Change Space" },
  logout: { id: "logout", defaultMessage: "Logout" },
  confirm_to_go_ahead: {
    id: "confirm_to_go_ahead",
    defaultMessage: "Please confirm to go ahead.",
  },
  v_name_space: {
    id: "v_name_space",
    defaultMessage: "{name}'s Space.",
  },
  message_visible_to: {
    id: "message_visible_to",
    defaultMessage: "This message will be visible to {label}",
  },
  clinic_report_schedule: {
    id: "clinic_report_schedule",
    defaultMessage: "Clinic Report - {scheduleTitle}",
  },
  clinics_upload_report: {
    id: "clinics_upload_report",
    defaultMessage: "Clinics Upload Report",
  },
  upload_appointments: {
    id: "upload_appointments",
    defaultMessage: "Upload Appointments",
  },
  upload: { id: "upload", defaultMessage: "Upload" },
  clinic_lc: { id: "clinic_lc", defaultMessage: "clinic" },
  clinics_lc: { id: "clinics_lc", defaultMessage: "clinics" },
  change_to_grid_view: {
    id: "change_to_grid_view",
    defaultMessage: "Change to Grid View",
  },
  change_to_list_view: {
    id: "change_to_list_view",
    defaultMessage: "Change to List View",
  },
  import_results: { id: "import_results", defaultMessage: "Import Results" },
  v_all_clinic_reports: {
    id: "v_all_clinic_reports",
    defaultMessage: "View All Clinic Reports",
  },
  clinic_upload_results: {
    id: "clinic_upload_results",
    defaultMessage: "Clinic Upload Results",
  },
  no_clinics_found: {
    id: "no_clinics_found",
    defaultMessage:
      "No clinics scheduled. Try a different date range in the filter.",
  },

  password_reset_failed: {
    id: "password_reset_failed",
    defaultMessage: "Request for password reset has failed. Please try again.",
  },

  check_your_sms_email: {
    id: "check_your_sms_email",
    defaultMessage:
      "Please check your SMS and/or Email. We have sent you the steps to reset your password.",
  },

  forgot_password_confirmation: {
    id: "forgot_password_confirmation",
    defaultMessage:
      "If {contact} is registered with myPatientSpace, we've sent password reset instructions. Please check your email (including spam folder) and/or SMS.",
  },

  return_to_login: {
    id: "return_to_login",
    defaultMessage: "Return to login",
  },

  verify_contact_details: {
    id: "verify_contact_details",
    defaultMessage: "Verify Your Contact Details",
  },
  modify_your_contact_details: {
    id: "modify_your_contact_details",
    defaultMessage:
      "Do you need to update your contact details? Here’s what we currently have on our system. One of either email or phone is required.",
  },
  set_phone_email: {
    id: "set_phone_email",
    defaultMessage: "Please set a valid phone number or email.",
  },
  set_valid_phone: {
    id: "set_valid_phone",
    defaultMessage: "Please set a valid phone number with country code.",
  },
  confirm_phone: { id: "confirm_phone", defaultMessage: "Confirm Phone" },
  same_confirm_phone: {
    id: "same_confirm_phone",
    defaultMessage: "Phone and Confirm phone should be the same.",
  },
  e_mail: { id: "e_mail", defaultMessage: "E-mail" },
  phone_cc: { id: "phone_cc", defaultMessage: "Phone" },
  set_valid_email: {
    id: "set_valid_email",
    defaultMessage: "Please set a valid email.",
  },
  confirm_e_mail: { id: "confirm_e_mail", defaultMessage: "Confirm E-mail" },
  same_confirm_email: {
    id: "same_confirm_email",
    defaultMessage: "Email and Confirm Email should be the same.",
  },
  verify_update: { id: "verify_update", defaultMessage: "Verify and Update" },

  embedded_videos: {
    id: "embedded_videos",
    defaultMessage: "Sorry, your browser doesn't support embedded videos.",
  },
  lets_get_started: {
    id: "lets_get_started",
    defaultMessage: "Let's Get Started",
  },

  e_p_confirmed: {
    id: "e_p_confirmed",
    defaultMessage: "Congratulations! Your {linkType} has been confirmed.",
  },
  download_app: {
    id: "download_app",
    defaultMessage:
      "Please download the application on your mobile device. After installing the app, Sign In using your username and password.",
  },
  sign_in_uc: { id: "sign_in_uc", defaultMessage: "SIGN IN" },

  already_accepted_invitation: {
    id: "already_accepted_invitation",
    defaultMessage:
      "You have already accepted the invitation and your account is active.",
  },
  link_reset_password: {
    id: "link_reset_password",
    defaultMessage:
      "Have you forgotten your username and password? No problem, we will send you a link to reset password, to your",
  },
  phone: { id: "phone", defaultMessage: "Phone" },
  email_address: { id: "email_address", defaultMessage: "email address" },
  phone_number: { id: "phone_number", defaultMessage: "phone number" },
  already_activated: {
    id: "already_activated",
    defaultMessage:
      "You are seeing this page because you attempted to Activate your Account from an email or SMS. It appears you may have done this already at least once. If so, your account is active. Now, you just need to",
  },
  download: {
    id: "download",
    defaultMessage: "download",
  },
  already_activated_download_suffix: {
    id: "already_activated_download_suffix",
    defaultMessage:
      "the myPatientSpace App, and login using the credentials you setup.",
  },
  can_reset_pwd: {
    id: "can_reset_pwd",
    defaultMessage:
      "If you don't remember your username or password, you can reset your password",
  },
  send_you_username: {
    id: "send_you_username",
    defaultMessage:
      ", by entering the email or phone number you used when signing up (we will send you your username).",
  },

  reach_us_on: {
    id: "reach_us_on",
    defaultMessage: "Please reach out to us on",
  },
  or: { id: "or", defaultMessage: "or" },
  problems_signing_up: {
    id: "problems_signing_up",
    defaultMessage: "if you continue to have problems signing up.",
  },
  contact_for_invitation: {
    id: "contact_for_invitation",
    defaultMessage:
      "if you continue to have problems signing up, or contact your provider to request a new invitation.",
  },

  dont_rem_pwd: {
    id: "dont_rem_pwd",
    defaultMessage: "If you don't remember the username or password, click",
  },
  to_reset: { id: "to_reset", defaultMessage: "to reset." },
  here: { id: "here", defaultMessage: "here" },

  wc_download_app: {
    id: "wc_download_app",
    defaultMessage:
      "Welcome back! You have just joined {facilityName}. You already have an account with myPatientSpace. Please download and login on the app.",
  },

  set_your_credentials: {
    id: "set_your_credentials",
    defaultMessage: "Set Your Credentials",
  },
  set_username_password: {
    id: "set_username_password",
    defaultMessage: "Set username and password for your account.",
  },
  user_name: { id: "user_name", defaultMessage: "Username" },
  user_name_ht: {
    id: "user_name_ht",
    defaultMessage:
      "Either valid email or only letters, numbers, underline, and one period are allowed",
  },
  email_as_username: {
    id: "email_as_username",
    defaultMessage: "Use my email as username",
  },
  set_username: { id: "set_username", defaultMessage: "Please set username." },
  password: { id: "password", defaultMessage: "Password" },
  password_ht: {
    id: "password_ht",
    defaultMessage:
      "Password should contain at least one lower case letter, one upper case letter, one digit, and a minimum of 8 characters.",
  },
  set_valid_password: {
    id: "set_valid_password",
    defaultMessage: "Please set valid password.",
  },
  confirm_password: {
    id: "confirm_password",
    defaultMessage: "Confirm Password",
  },
  passwords_mustbe_same: {
    id: "passwords_mustbe_same",
    defaultMessage: "Confirm password must be same as password.",
  },
  create_account: { id: "create_account", defaultMessage: "Create Account" },
  accept_tc: { id: "accept_tc", defaultMessage: "Accept Terms and Conditions" },

  confirm_identity: {
    id: "confirm_identity",
    defaultMessage: "Confirm Identity",
  },
  to_accept_your_invitation: {
    id: "to_accept_your_invitation",
    defaultMessage:
      "To accept your invitation, please confirm your identity by providing the following information.",
  },
  accept_pp_tc: {
    id: "accept_pp_tc",
    defaultMessage: "Please accept privacy policy and terms and conditions.",
  },
  to_sign_up_service: {
    id: "to_sign_up_service",
    defaultMessage:
      "To Sign Up to {appName} service, please enter the following details to confirm your identity.",
  },
  note: {
    id: "note",
    defaultMessage: "Note:",
  },
  contact_if_no_details: {
    id: "contact_if_no_details",
    defaultMessage:
      "If you don't have these details, please contact {facilityName} to get them.",
  },

  accept_invite: {
    id: "accept_invite",
    defaultMessage: "Accept Invite",
  },

  contact_support_at: {
    id: "contact_support_at",
    defaultMessage:
      "If you're having trouble with setting up your account, please contact support at:",
  },

  account_setup: {
    id: "account_setup",
    defaultMessage: "Account Setup",
  },

  account_setup_for: {
    id: "account_setup_for",
    defaultMessage: "Account Setup for {facilityName}",
  },

  please_contact: {
    id: "please_contact",
    defaultMessage:
      "If you believe you've entered the code correctly but are seeing an error, please contact",
  },

  region: {
    id: "region",
    defaultMessage: "Region",
  },

  myPatientSpace_support: {
    id: "myPatientSpace_support",
    defaultMessage: "myPatientSpace Support",
  },

  invite_you_received: {
    id: "invite_you_received",
    defaultMessage:
      "If you've been sent an invite that you received via Email or SMS text, please click the link there and follow on-screen instructions to setup your account.",
  },

  contact_the_organization: {
    id: "contact_the_organization",
    defaultMessage:
      "Contact the Organization or Healthcare Provider who invited you if you do not have this information. The code would have been provided to you at the hospital, or on a printed leaflet.",
  },

  continue: {
    id: "continue",
    defaultMessage: "Continue",
  },

  hospital_code: {
    id: "hospital_code",
    defaultMessage: "Hospital Code",
  },

  invalid_code: {
    id: "invalid_code",
    defaultMessage: "Invalid Code. Please try again.",
  },

  start_entering_code: {
    id: "start__entering_code",
    defaultMessage:
      "To use you need to create an account. Start by entering the Code given by your Health Care Provider.",
  },

  invite_only: {
    id: "invite_only",
    defaultMessage: "This Service is Invite-Only",
  },

  invalid_link: {
    id: "invalid_link",
    defaultMessage: "Invalid link or facility code",
  },

  login_to_account: {
    id: "login_to_account",
    defaultMessage: "Login to your Account",
  },

  error_logging_in: {
    id: "error_logging_in",
    defaultMessage:
      "Error logging in. Please provide correct Username and Password.",
  },

  forgot_password: {
    id: "forgot_password",
    defaultMessage: "Forgot password?",
  },

  welcome_back: {
    id: "welcome_back",
    defaultMessage:
      "Welcome back! You have just joined {facilityName}. You already have an account with myPatientSpace. Please login to access your account.",
  },

  caps_lock_on: {
    id: "caps_lock_on",
    defaultMessage: "Caps Lock On",
  },

  login: {
    id: "login",
    defaultMessage: "Login",
  },

  view_search_filters: {
    id: "view_search_filters",
    defaultMessage: "View Search Filters",
  },
  hide_search_filters: {
    id: "hide_search_filters",
    defaultMessage: "Hide Search Filters",
  },
  save_search: { id: "save_search", defaultMessage: "Save Search" },
  saved_search: { id: "saved_search", defaultMessage: "Saved Search" },
  delete_saved_search: {
    id: "delete_saved_search",
    defaultMessage: "Delete Saved Search",
  },
  update_saved_search: {
    id: "update_saved_search",
    defaultMessage: "Update Saved Search",
  },
  edit_saved_search: {
    id: "edit_saved_search",
    defaultMessage: "Edit Saved Search",
  },
  onboarded: { id: "onboarded", defaultMessage: "Onboarded" },
  my_watchlist: { id: "my_watchlist", defaultMessage: "My Watchlist" },
  pending_invitation: {
    id: "pending_invitation",
    defaultMessage: "Pending Invitation",
  },
  active_internal: { id: "active_internal", defaultMessage: "Active Internal" },
  rip_inactive: { id: "rip_inactive", defaultMessage: "RIP Inactive" },
  start_now: { id: "start_now", defaultMessage: "Start Now" },
  schedule_call: { id: "schedule_call", defaultMessage: "Schedule Call" },
  new_message: {
    id: "new_message",
    defaultMessage: "New Message",
  },
  see_more: { id: "see_more", defaultMessage: "See more" },
  see_message: { id: "see_message", defaultMessage: "See Message" },
  booking: {
    id: "booking",
    defaultMessage: "Booking",
  },

  appt_no_of_slots_per_appt: {
    id: "appt_no_of_slots_per_appt",
    defaultMessage: "No Of Slots Per Appointment",
  },
  short_no_of_slots_per_appt: {
    id: "short_no_of_slots_per_appt",
    defaultMessage: "Slots/Appt",
  },
  appt_messages_configured: {
    id: "appt_messages_configured",
    defaultMessage: "Messages",
  },
  appt_color_code: {
    id: "appt_color_code",
    defaultMessage: "Color Code",
  },
  export_data: {
    id: "export_data",
    defaultMessage: "Export Data",
  },

  select_export_fields: {
    id: "select_export_fields",
    defaultMessage: "Select Export Fields",
  },

  exporting_data: {
    id: "exporting_data",
    defaultMessage: "Exporting Data",
  },

  clinic_export_fields_hint: {
    id: "clinic_export_fields_hint",
    defaultMessage:
      "Choose the columns to include in the CSV. Tick \"Writing space\" to add a blank column beside a field for handwritten notes.",
  },

  clinic_export_writing_space: {
    id: "clinic_export_writing_space",
    defaultMessage: "Writing space",
  },

  clinic_export_selected_count: {
    id: "clinic_export_selected_count",
    defaultMessage: "{selected} of {total} columns selected",
  },

  clinic_export_all_fields: {
    id: "clinic_export_all_fields",
    defaultMessage: "Export all columns",
  },
  content_library: {
    id: "content_library",
    defaultMessage: "Content Library",
  },

  team_calendars: {
    id: "team_calendars",
    defaultMessage: "Team Calendars",
  },

  my_calendar: {
    id: "my_calendar",
    defaultMessage: "Calendar",
  },

  new_booking: {
    id: "new_booking",
    defaultMessage: "New Booking",
  },

  manage_schedules: {
    id: "manage_schedules",
    defaultMessage: "Manage Schedules",
  },

  my_clinics: {
    id: "my_clinics",
    defaultMessage: "My Clinics",
  },

  fa_template_copied: {
    id: "fa_template_copied",
    defaultMessage: "Appointment Template has been copied.",
  },
  instructions: {
    id: "instructions",
    defaultMessage: "Instructions",
  },

  clinic_report_sent: {
    id: "clinic_report_sent",
    defaultMessage: "Report has been sent to the recipients.",
  },

  import_library_item: {
    id: "import_library_item",
    defaultMessage: "Import Library Item",
  },

  add_dosage: {
    id: "add_dosage",
    defaultMessage: "Add Dosage",
  },

  edit_dosage: {
    id: "edit_dosage",
    defaultMessage: "Edit Dosage",
  },

  delete_dosage: {
    id: "delete_dosage",
    defaultMessage: "Delete Dosage",
  },

  to_delete_dosage: {
    id: "to_delete_dosage",
    defaultMessage: "Are you sure you want to delete the Dosage?",
  },

  to_delete_medication: {
    id: "to_delete_medication",
    defaultMessage:
      "Are you sure you want to delete the medication? It will be permanently deleted from the system and can not be reverted.",
  },

  to_delete_treatment: {
    id: "to_delete_treatment",
    defaultMessage:
      "Are you sure you want to delete the treatment? It will be permanently deleted from the system and can not be reverted.",
  },

  medication_added: {
    id: "medication_added",
    defaultMessage: "Medication has been added",
  },

  medication_deleted: {
    id: "medication_deleted",
    defaultMessage: "Medication has been deleted",
  },

  medication_updated: {
    id: "medication_updated",
    defaultMessage: "Medication has been updated",
  },

  medications_uc: {
    id: "medications_uc",
    defaultMessage: "MEDICATIONS",
  },

  diet_uc: {
    id: "diet_uc",
    defaultMessage: "DIET",
  },

  diet_tab: {
    id: "diet_tab",
    defaultMessage: "Diet",
  },

  food_journal: {
    id: "food_journal",
    defaultMessage: "Food Journal",
  },

  calories: {
    id: "calories",
    defaultMessage: "Calories",
  },

  protein: {
    id: "protein",
    defaultMessage: "Protein",
  },

  carbs: {
    id: "carbs",
    defaultMessage: "Carbs",
  },

  fat: {
    id: "fat",
    defaultMessage: "Fat",
  },

  serving_size: {
    id: "serving_size",
    defaultMessage: "Serving Size",
  },

  nutri_score: {
    id: "nutri_score",
    defaultMessage: "NutriScore",
  },

  no_diet_entries: {
    id: "no_diet_entries",
    defaultMessage: "No diet entries found",
  },

  saturated_fat: {
    id: "saturated_fat",
    defaultMessage: "Saturated Fat",
  },

  fiber: {
    id: "fiber",
    defaultMessage: "Fiber",
  },

  sugar: {
    id: "sugar",
    defaultMessage: "Sugar",
  },

  sodium: {
    id: "sodium",
    defaultMessage: "Sodium",
  },

  cholesterol: {
    id: "cholesterol",
    defaultMessage: "Cholesterol",
  },

  log_meal: {
    id: "log_meal",
    defaultMessage: "Log Meal",
  },
  upload_photo: {
    id: "upload_photo",
    defaultMessage: "Upload Photo",
  },
  photo_instructions: {
    id: "photo_instructions",
    defaultMessage: "Take a photo of your meal or choose from your gallery",
  },
  select_dishes: {
    id: "select_dishes",
    defaultMessage: "Select Dishes",
  },
  set_portions: {
    id: "set_portions",
    defaultMessage: "Set Portions",
  },
  review_and_save: {
    id: "review_and_save",
    defaultMessage: "Review & Save",
  },
  add_item_not_detected: {
    id: "add_item_not_detected",
    defaultMessage: "Add item not detected",
  },
  search_dishes: {
    id: "search_dishes",
    defaultMessage: "Search dishes",
  },
  grams: {
    id: "grams",
    defaultMessage: "grams",
  },
  saving_entry: {
    id: "saving_entry",
    defaultMessage: "Saving entry...",
  },
  entry_saved: {
    id: "entry_saved",
    defaultMessage: "Entry saved successfully",
  },
  analysing_photo: {
    id: "analysing_photo",
    defaultMessage: "Analysing your meal...",
  },
  load_more: {
    id: "load_more",
    defaultMessage: "Load More",
  },
  error_loading_data: {
    id: "error_loading_data",
    defaultMessage: "Error loading data",
  },

  retry: {
    id: "retry",
    defaultMessage: "Retry",
  },

  cal: {
    id: "cal",
    defaultMessage: "cal",
  },

  totals: {
    id: "totals",
    defaultMessage: "Totals",
  },

  g_serving: {
    id: "g_serving",
    defaultMessage: "{grams}g serving",
  },

  add_item_manually: {
    id: "add_item_manually",
    defaultMessage: "Add item manually...",
  },

  manual_item: {
    id: "manual_item",
    defaultMessage: "manual",
  },

  unsaved_changes_confirm: {
    id: "unsaved_changes_confirm",
    defaultMessage: "You have unsaved changes. Are you sure you want to close?",
  },

  save_failed: {
    id: "save_failed",
    defaultMessage: "Failed to save. Please try again.",
  },

  add_medication: {
    id: "add_medication",
    defaultMessage: "Add Medication",
  },

  delete_medication: {
    id: "delete_medication",
    defaultMessage: "Delete Medication",
  },

  edit_medication: {
    id: "edit_medication",
    defaultMessage: "Edit Medication",
  },

  medications: {
    id: "medications",
    defaultMessage: "Medications",
  },

  medication: {
    id: "medication",
    defaultMessage: "Medication",
  },

  form_medication: {
    id: "form_medication",
    defaultMessage: "Form of Medication",
  },
  survey_topics: {
    id: "survey_topics",
    defaultMessage: "Survey Topics",
  },

  task_topics: {
    id: "task_topics",
    defaultMessage: "Task Topics",
  },

  content_type: {
    id: "content_type",
    defaultMessage: "Content Type",
  },
  appointment_reopened: {
    id: "appointment_reopened",
    defaultMessage: "Appointment has been reopened.",
  },

  reopen_appointment: {
    id: "reopen_appointment",
    defaultMessage: "Reopen Appointment",
  },

  clear_care_plan_history: {
    id: "clear_care_plan_history",
    defaultMessage: "Clear Care Plan History",
  },

  care_plan_history_cleared: {
    id: "care_plan_history_cleared",
    defaultMessage: "Care Plan history has been cleared.",
  },

  sure_to_clear_cp_history: {
    id: "sure_to_clear_cp_history",
    defaultMessage: "Are you sure you want to clear the care plan history?",
  },

  task_sent: {
    id: "task_sent",
    defaultMessage:
      "Thank you. Your request has been received and will be processed shortly.",
  },

  edit_profile: {
    id: "edit_profile",
    defaultMessage: "Edit Profile",
  },

  clinic: {
    id: "clinic",
    defaultMessage: "Clinic",
  },

  survey_imported: {
    id: "survey_imported",
    defaultMessage: "Survey has been imported.",
  },

  could_not_import_survey: {
    id: "could_not_import_survey",
    defaultMessage:
      "Could not import the survey. Please check the file for valid JSON and try again.",
  },

  rule_deleted: {
    id: "rule_deleted",
    defaultMessage: "Rule Map has been deleted.",
  },

  information: {
    id: "information",
    defaultMessage: "Information",
  },

  sort_order_in_use: {
    id: "sort_order_in_use",
    defaultMessage: "Sort order is already in use.",
  },

  fa_cancel_reminders_config: {
    id: "fa_cancel_reminders_config",
    defaultMessage: "Cancellation Messages Configuration",
  },

  fa_reschedule_reminders_config: {
    id: "fa_reschedule_reminders_config",
    defaultMessage: "Reschedule Messages Configuration",
  },

  phno_mandatory_4_patients: {
    id: "phno_mandatory_4_patients",
    defaultMessage: "Phone Number Mandatory for Patients?",
  },

  participants_updated: {
    id: "participants_updated",
    defaultMessage: "Participants have been updated.",
  },

  noAuditsAvailable: {
    id: "no_audits_available",
    defaultMessage: "No audits available.",
  },

  audit_logs: {
    id: "audit_logs",
    defaultMessage: "Audit Logs",
  },

  adhoc_new_patient: {
    id: "adhoc_new_patient",
    defaultMessage: "Add Ad-hoc Patient for Appointment",
  },

  no_patients_for_keyword: {
    id: "no_patients_for_keyword",
    defaultMessage: "No matching patients found for the given keyword.",
  },

  notify_all_in_channel: {
    id: "notify_all_in_channel",
    defaultMessage: "Notify All in the Channel?",
  },

  channel_updated: {
    id: "channel_updated",
    defaultMessage: "Channel has been Updated.",
  },

  optional: {
    id: "optional",
    defaultMessage: "(Optional)",
  },

  appt_notif_sent: {
    id: "appt_notif_sent",
    defaultMessage: "Link has been sent to all participants.",
  },

  new_schedule: {
    id: "new_schedule",
    defaultMessage: "New Schedule",
  },

  link_shared: {
    id: "link_shared",
    defaultMessage: "Link has been shared.",
  },

  rule_created: {
    id: "rule_created",
    defaultMessage: "Rule has been created",
  },
  rule_edited: {
    id: "rule_edited",
    defaultMessage: "Rule has been edited",
  },
  rule_banner_try_new: {
    id: "rule_banner_try_new",
    defaultMessage: "Try our new rules editor!",
  },
  rule_banner_description: {
    id: "rule_banner_description",
    defaultMessage: "Modern, intuitive, and easier to use",
  },
  rule_banner_switch_button: {
    id: "rule_banner_switch_button",
    defaultMessage: "Switch to Modern Editor",
  },
  rule_classic_editor_label: {
    id: "rule_classic_editor_label",
    defaultMessage: "Classic Editor",
  },
  automations: {
    id: "automations",
    defaultMessage: "Automations",
  },
  automations_subtitle: {
    id: "automations_subtitle",
    defaultMessage: "View automated rules and execution history",
  },
  automations_no_rules: {
    id: "automations_no_rules",
    defaultMessage: "No automations configured for your patient types",
  },
  automations_view_config: {
    id: "automations_view_config",
    defaultMessage: "View",
  },
  automations_view_logs: {
    id: "automations_view_logs",
    defaultMessage: "View Logs",
  },
  automations_rule_config: {
    id: "automations_rule_config",
    defaultMessage: "Rule Configuration",
  },
  automations_execution_logs: {
    id: "automations_execution_logs",
    defaultMessage: "Execution Logs",
  },
  rule_modern_title: {
    id: "rule_modern_title",
    defaultMessage: "Rule Configuration",
  },
  rule_modern_badge: {
    id: "rule_modern_badge",
    defaultMessage: "Modern Editor",
  },
  rule_modern_switch_classic: {
    id: "rule_modern_switch_classic",
    defaultMessage: "Switch to Classic Editor",
  },
  rule_modern_setup: {
    id: "rule_modern_setup",
    defaultMessage: "Rule Setup",
  },
  rule_form_title: {
    id: "rule_form_title",
    defaultMessage: "Rule Name",
  },
  rule_form_enable_rule: {
    id: "rule_form_enable_rule",
    defaultMessage: "Enable this rule",
  },
  rule_form_trigger_once: {
    id: "rule_form_trigger_once",
    defaultMessage: "Trigger only once per patient",
  },
  rule_form_multiple_reset: {
    id: "rule_form_multiple_reset",
    defaultMessage: "Multiple reset triggers",
  },
  rule_modern_conditions: {
    id: "rule_modern_conditions",
    defaultMessage: "When these conditions are met",
  },
  rule_form_operator_between: {
    id: "rule_form_operator_between",
    defaultMessage: "Operator Between Attributes",
  },
  rule_operator_and: {
    id: "rule_operator_and",
    defaultMessage: "And",
  },
  rule_operator_or: {
    id: "rule_operator_or",
    defaultMessage: "Or",
  },
  rule_modern_actions: {
    id: "rule_modern_actions",
    defaultMessage: "Then take these actions",
  },
  rule_modern_actions_placeholder: {
    id: "rule_modern_actions_placeholder",
    defaultMessage:
      "Actions configuration will be implemented in the next phase",
  },
  rule_form_submit: {
    id: "rule_form_submit",
    defaultMessage: "Save Rule",
  },
  channel_add_error: {
    id: "channel_add_error",
    defaultMessage:
      "Error while creating channel {name}. Please try again later",
  },

  create_channel: {
    id: "create_channel",
    defaultMessage: "Create Channel",
  },

  channels: {
    id: "channels",
    defaultMessage: "Channels",
  },

  not_taken_assignments: {
    id: "not_taken_assignments",
    defaultMessage: "You have not taken any assignments yet",
  },

  pt_not_taken_assignments: {
    id: "pt_not_taken_assignments",
    defaultMessage: "This patient has not taken any assessments yet.",
  },

  // m: {
  //   id: "",
  //   defaultMessage: ""
  // },

  patient_interactions: {
    id: "patient_interactions",
    defaultMessage: "Patient Interactions",
  },

  select_patient: {
    id: "select_patient",
    defaultMessage: "Select Patient",
  },
  select_service_user: {
    id: "select_service_user",
    defaultMessage: "Select Service User",
  },
  self: {
    id: "self",
    defaultMessage: "Self",
  },

  care_teams: {
    id: "care_teams",
    defaultMessage: "Care Teams",
  },

  copied_appt_sch: {
    id: "copied_appt_sch",
    defaultMessage:
      "Appointment Schedule URL has been copied to the clipboard.",
  },
  appt_schedule_w_name: {
    id: "appt_schedule_w_name",
    defaultMessage: "Appointment Schedule - {name}",
  },

  copied: {
    id: "copied",
    defaultMessage: "Copied!",
  },

  copied_cp: {
    id: "copied_cp",
    defaultMessage: "Copied to clipboard.",
  },

  copied_cp_safari: {
    id: "copied_cp_safari",
    defaultMessage: "Copied to clipboard, please paste into Safari browser.",
  },

  patients_imported: {
    id: "patients_imported",
    defaultMessage: "Patients have been imported.",
  },

  staff_imported: {
    id: "staff_imported",
    defaultMessage: "Staff have been imported.",
  },

  import_text: {
    id: "import_text",
    defaultMessage: "Import",
  },

  external_auth: {
    id: "external_auth",
    defaultMessage: "External Auth",
  },

  entra_id_group_mappings: {
    id: "entra_id_group_mappings",
    defaultMessage: "Entra ID Group Mappings",
  },

  manage_external_auth: {
    id: "manage_external_auth",
    defaultMessage: "Manage External Authentication",
  },

  confirm_appointment: {
    id: "confirm_appointment",
    defaultMessage: "Confirm Appointment",
  },
  vc_appointment_confirmation: {
    id: "vc_appointment_confirmation",
    defaultMessage: "Scheduling Video Call with {patientName} for:",
  },
  vc_patient_error: {
    id: "vc_patient_error",
    defaultMessage:
      "Video call is available only for patients who has set up their myPatientSpace account.",
  },

  vc_appt_created: {
    id: "vc_appt_created",
    defaultMessage:
      "Created video call appointment with {patientName} for {dateTime}",
  },

  appt_created_w_name: {
    id: "appt_created_w_name",
    defaultMessage: "Created appointment with {patientName} for {dateTime}",
  },

  edit_contact: {
    id: "edit_contact",
    defaultMessage: "Edit Contact",
  },

  contact_updated: {
    id: "contact_updated",
    defaultMessage: " Contact has been updated",
  },

  contact_added: {
    id: "contact_added",
    defaultMessage: "Contact has been added",
  },

  contact_add_failed: {
    id: "contact_add_failed",
    defaultMessage: "Unable to add contact. Please try again later.",
  },

  contact_removed: {
    id: "contact_removed",
    defaultMessage: "Contact has been removed.",
  },

  remove_contact: {
    id: "remove_contact",
    defaultMessage: "Remove Contact",
  },

  add_contact: {
    id: "add_contact",
    defaultMessage: "Add Contact",
  },

  no_contacts: {
    id: "no_contacts",
    defaultMessage: "No Contacts",
  },

  placeholder_created: {
    id: "placeholder_created",
    defaultMessage: "Placeholder has been created",
  },
  create_placeholder_failed: {
    id: "create_placeholder_failed",
    defaultMessage: "Placeholder creation failed.",
  },

  video_call: {
    id: "video_call",
    defaultMessage: "Video Call",
  },
  video_call_minimize: {
    id: "video_call_minimize",
    defaultMessage: "Minimize video call",
  },
  video_call_expand: {
    id: "video_call_expand",
    defaultMessage: "Expand video call",
  },
  video_call_close: {
    id: "video_call_close",
    defaultMessage: "Close video call",
  },
  video_call_invite_placeholder: {
    id: "video_call_invite_placeholder",
    defaultMessage:
      "(Optional) Send a brief message to {name} with your invite to join the call",
  },
  video_call_notifying: {
    id: "video_call_notifying",
    defaultMessage: "Notifying {name}…",
  },
  video_call_notified: {
    id: "video_call_notified",
    defaultMessage: "{name} has been notified",
  },
  video_call_waiting_join: {
    id: "video_call_waiting_join",
    defaultMessage: "Waiting for them to join…",
  },
  video_call_auto_end_hint: {
    id: "video_call_auto_end_hint",
    defaultMessage: "The call ends automatically if they don’t join",
  },
  video_call_end_now: {
    id: "video_call_end_now",
    defaultMessage: "End Now",
  },
  video_call_ended: {
    id: "video_call_ended",
    defaultMessage: "Call ended",
  },
  video_call_try_enhanced_connection: {
    id: "video_call_try_enhanced_connection",
    defaultMessage: "Try enhanced connection",
  },
  video_call_connection_trouble: {
    id: "video_call_connection_trouble",
    defaultMessage: "Trouble hearing or seeing each other?",
  },
  video_call_enhanced_connection_hint: {
    id: "video_call_enhanced_connection_hint",
    defaultMessage:
      "Restarts the call on a network path that works better on restricted hospital networks. The patient gets a new invite.",
  },
  video_call_generating_summary: {
    id: "video_call_generating_summary",
    defaultMessage: "Generating call summary…",
  },
  video_call_summary_opens_hint: {
    id: "video_call_summary_opens_hint",
    defaultMessage: "The summary will open here for review when it’s ready",
  },
  video_call_summary_unavailable: {
    id: "video_call_summary_unavailable",
    defaultMessage: "Call summary unavailable",
  },
  video_call_summary_title: {
    id: "video_call_summary_title",
    defaultMessage: "Video Call Summary",
  },
  video_call_summary_ai_pill: {
    id: "video_call_summary_ai_pill",
    defaultMessage: "AI generated — approve before saving",
  },
  video_call_save_to_notes: {
    id: "video_call_save_to_notes",
    defaultMessage: "Save to Notes",
  },
  video_call_summary_saved: {
    id: "video_call_summary_saved",
    defaultMessage: "Call summary saved to notes",
  },
  video_call_summary_save_failed: {
    id: "video_call_summary_save_failed",
    defaultMessage: "Could not save the call summary",
  },
  video_call_connected: {
    id: "video_call_connected",
    defaultMessage: "Connected",
  },
  video_call_transcribing: {
    id: "video_call_transcribing",
    defaultMessage: "Transcribing",
  },
  video_call_mini_hint: {
    id: "video_call_mini_hint",
    defaultMessage: "Starts right here in a mini video window",
  },
  video_call_mini_info: {
    id: "video_call_mini_info",
    defaultMessage:
      "Instant calls open in a mini viewer — you can keep working while on the call",
  },
  video_call_start_now_sub: {
    id: "video_call_start_now_sub",
    defaultMessage: "Opens a mini viewer so you can keep working",
  },
  video_call_schedule_sub: {
    id: "video_call_schedule_sub",
    defaultMessage: "Pick a date and time and notify the patient",
  },
  video_call_before_you_start: {
    id: "video_call_before_you_start",
    defaultMessage: "Before you start",
  },
  video_call_start_call: {
    id: "video_call_start_call",
    defaultMessage: "Start call",
  },
  video_call_notify_bullet: {
    id: "video_call_notify_bullet",
    defaultMessage: "Scheduled calls send a notification to the patient",
  },
  video_call_camera_bullet: {
    id: "video_call_camera_bullet",
    defaultMessage:
      "You and the patient both need a working camera and microphone",
  },

  tasks_stats_status: {
    id: "tasks_stats_status",
    defaultMessage: "Status - {status}",
  },

  tasks_stats_priority: {
    id: "tasks_stats_priority",
    defaultMessage: "Priority - {priority}",
  },

  tasks_stats_topic: {
    id: "tasks_stats_topic",
    defaultMessage: "Topic - {topic}",
  },

  tasks_stats_template: {
    id: "tasks_stats_template",
    defaultMessage: "Template - {template}",
  },

  tasks_for_name: {
    id: "tasks_for_name",
    defaultMessage: "{label} tasks for {user}",
  },

  add_status: {
    id: "add_status",
    defaultMessage: "Add Status",
  },

  my_status: {
    id: "my_status",
    defaultMessage: "My Status",
  },

  special_notes_updated: {
    id: "special_notes_updated",
    defaultMessage: "Notes has been updated",
  },

  add_survey: {
    id: "add_survey",
    defaultMessage: "Add Survey",
  },

  profile_updated: {
    id: "profile_updated",
    defaultMessage: "Profile has been updated.",
  },

  learning_style: {
    id: "learning_style",
    defaultMessage: "Learning Style",
  },

  pref_locale_updated: {
    id: "pref_locale_updated",
    defaultMessage:
      // "Preferred Locale has been updated. Please log out and log back in for the new locale to take effect."
      "Preferred Locale has been updated.",
  },

  content_preview: {
    id: "content_preview",
    defaultMessage: "Content Preview",
  },

  file_upload: {
    id: "file_upload",
    defaultMessage: "File Upload",
  },

  preview: {
    id: "preview",
    defaultMessage: "Preview",
  },

  html: {
    id: "html",
    defaultMessage: "HTML",
  },

  rich_text: {
    id: "rich_text",
    defaultMessage: "Rich Text",
  },

  type_content_here: {
    id: "type_content_here",
    defaultMessage: "Type content here.",
  },

  category: {
    id: "category",
    defaultMessage: "Category",
  },
  availability: {
    id: "availability",
    defaultMessage: "Availability",
  },
  public: {
    id: "public",
    defaultMessage: "Public",
  },
  private: {
    id: "private",
    defaultMessage: "Private",
  },
  all_members: {
    id: "all_members",
    defaultMessage: "All - All members in the Patient's space",
  },
  staff_ct_members: {
    id: "staff_ct_members",
    defaultMessage: "Staff",
  },
  patient_only: {
    id: "patient_only",
    defaultMessage: "Patient - Only for Patient",
  },
  patient_members: {
    id: "patient_members",
    defaultMessage: "Patient and Members",
  },
  status_all_roles: {
    id: "status_all_roles",
    defaultMessage: "All (Staff/Doctor, Patient and Family)",
  },
  status_all_roles_wo_family: {
    id: "status_all_roles_wo_family",
    defaultMessage: "All (Staff/Doctor and Patient)",
  },
  status_all_roles_service_user: {
    id: "status_all_roles_service_user",
    defaultMessage: "All (Staff/Doctor, Service User and Family)",
  },
  status_all_roles_service_user_wo_family: {
    id: "status_all_roles_service_user_wo_family",
    defaultMessage: "All (Staff/Doctor and Service User)",
  },
  basic_text_update: {
    id: "basic_text_update",
    defaultMessage: "Basic Text update",
  },
  ideal_quick_notes: {
    id: "ideal_quick_notes",
    defaultMessage: "Ideal for quick notes",
  },
  pre_canned_messages: {
    id: "pre_canned_messages",
    defaultMessage: "Pre-canned messages",
  },
  welcome_texts_other: {
    id: "welcome_texts_other",
    defaultMessage: "Welcome texts, reminder & other",
  },
  images: {
    id: "images",
    defaultMessage: "Images",
  },
  notes_with_images: {
    id: "notes_with_images",
    defaultMessage: "Ideal for notes with images",
  },
  notes_with_audio_file: {
    id: "notes_with_audio_file",
    defaultMessage: "Ideal for notes with an audio file",
  },
  notes_with_video: {
    id: "notes_with_video",
    defaultMessage: "Ideal for notes with a video",
  },
  notes_with_pdf: {
    id: "notes_with_pdf",
    defaultMessage: "Ideal for documents",
  },
  library_surveys: {
    id: "library_surveys",
    defaultMessage: "Library of surveys",
  },
  content_library_items: {
    id: "content_library_items",
    defaultMessage: "Content Library Items",
  },
  consent_documents: {
    id: "consent_documents",
    defaultMessage: "Consent Documents",
  },
  task_templates: {
    id: "task_templates",
    defaultMessage: "Templates for creating Task",
  },
  audio: {
    id: "audio",
    defaultMessage: "Audio",
  },
  audio_track_label: {
    id: "audio_track_label",
    defaultMessage: "Audio {number}",
  },
  audio_playback_speed: {
    id: "audio_playback_speed",
    defaultMessage: "Playback speed",
  },
  audio_more_options: {
    id: "audio_more_options",
    defaultMessage: "More options",
  },
  generate_translations: {
    id: "generate_translations",
    defaultMessage: "Generate Translations",
  },
  generate_translations_confirm: {
    id: "generate_translations_confirm",
    defaultMessage:
      "Generate translations for all content in this patient type? This can take some time.",
  },
  generate_translations_started: {
    id: "generate_translations_started",
    defaultMessage: "Translation generation has started.",
  },
  generate_translations_failed: {
    id: "generate_translations_failed",
    defaultMessage: "Translation generation failed. Please try again.",
  },
  video: {
    id: "video",
    defaultMessage: "Video",
  },
  library_item: {
    id: "library_item",
    defaultMessage: "Library Item",
  },

  existing_files: {
    id: "existing_files",
    defaultMessage: "Existing Files",
  },

  set_files: {
    id: "set_files",
    defaultMessage: "Please set files",
  },

  set_status_text: {
    id: "set_status_text",
    defaultMessage: "Set status text and add templateParams using '_'",
  },

  set_template_text: {
    id: "set_template_text",
    defaultMessage: "Please set template text (minimum 4 chars)",
  },
  save_template: {
    id: "save_template",
    defaultMessage: "Save template",
  },

  attach_type_files: {
    id: "attach_type_files",
    defaultMessage: "Please attach {messageType} file(s).",
  },

  what_to_say: {
    id: "what_to_say",
    defaultMessage: "What would you like to say to {name}?",
  },

  template: {
    id: "template",
    defaultMessage: "Template",
  },

  new_template: {
    id: "new_template",
    defaultMessage: "New Template",
  },

  edit_template: {
    id: "edit_template",
    defaultMessage: "Edit Template",
  },
  tabs_reordered: {
    id: "tabs_reordered",
    defaultMessage: "Patient view tabs have been reordered and saved.",
  },
  survey_deleted: {
    id: "survey_deleted",
    defaultMessage: "Survey has been deleted.",
  },
  delete_survey: {
    id: "delete_survey",
    defaultMessage: "Delete Survey",
  },
  hard_delete_survey_msg: {
    id: "hard_delete_survey_msg",
    defaultMessage:
      "Are you sure you want to delete survey {survey}? It will be permanently deleted from the system and can not be reverted.",
  },
  delete_survey_msg: {
    id: "delete_survey_msg",
    defaultMessage:
      "Are you sure you want to delete survey {survey}? This can not be reverted.",
  },
  delete_template: {
    id: "delete_template",
    defaultMessage: "Delete Template - {template}",
  },
  delete_s_template_msg: {
    id: "delete_s_template_msg",
    defaultMessage:
      "Are you sure you want to delete template {title}? This can not be reverted.",
  },
  hard_delete_s_template_msg: {
    id: "hard_s_delete_template_msg",
    defaultMessage:
      "Are you sure you want to delete template {title}? It will be permanently deleted from the system and can not be reverted.",
  },
  s_template_created: {
    id: "s_template_created",
    defaultMessage: "Status Template has been created.",
  },
  s_template_create_error: {
    id: "s_template_create_error",
    defaultMessage: "Error while creating the template. {message}",
  },
  s_template_updated: {
    id: "s_template_updated",
    defaultMessage: "Status Template has been updated.",
  },
  s_template_update_err: {
    id: "s_template_update_err",
    defaultMessage:
      "Error while updating the template. Please try again later.",
  },
  attributes_saved: {
    id: "attributes_saved",
    defaultMessage:
      "Attribute changes have been saved. Please submit it to save in the backend.",
  },
  survey_submitted: {
    id: "survey_submitted",
    defaultMessage: "Survey answers have been submitted.",
  },
  s_template_ret_error: {
    id: "s_template_ret_error",
    defaultMessage:
      "Error while retrieving the template. Please try again later.",
  },
  care_plan_not_exist: {
    id: "care_plan_not_exist",
    defaultMessage: "Care Plan that you have chosen does not exist.",
  },
  care_plan_assigned: {
    id: "care_plan_assigned",
    defaultMessage: "Care Plan has been assigned.",
  },
  sure_to_complete: {
    id: "sure_to_complete",
    defaultMessage: "Are you sure you want to complete the care plan?",
  },
  error_assigning_cp: {
    id: "error_assigning_cp",
    defaultMessage:
      "Error while assigning the Care Plan. Please try again later.",
  },
  req_complete_cp: {
    id: "req_complete_cp",
    defaultMessage: "Request to complete Care Plan has been triggered.",
  },

  view_mode: {
    id: "view_mode",
    defaultMessage: "View Mode",
  },
  trigger_mode: {
    id: "trigger_mode",
    defaultMessage: "Trigger Mode",
  },

  cp_triggered: {
    id: "cp_triggered",
    defaultMessage: "Care Plan has been triggered for the mentioned date.",
  },

  both_reqd: {
    id: "both_reqd",
    defaultMessage: "Both the fields are required",
  },

  refresh: {
    id: "refresh",
    defaultMessage: "Refresh",
  },
  view_answers: {
    id: "view_answers",
    defaultMessage: "View Answers",
  },

  no_assigned_care_plans: {
    id: "no_assigned_care_plans",
    defaultMessage: "You have not been assigned any care plans yet.",
  },
  milestone_with_title: {
    id: "milestone_with_title",
    defaultMessage: "Milestone - {title}",
  },

  report_last_generated_at: {
    id: "report_last_generated_at",
    defaultMessage: "Report last generated at: {date}.",
  },

  day_of_treatment: {
    id: "day_of_treatment",
    defaultMessage: "Day {dayNumberInTreatment} of {treatmentDuration}",
  },

  assign_care_plan: {
    id: "assign_care_plan",
    defaultMessage: "Assign a Care Plan",
  },
  open_test_mode: {
    id: "open_test_mode",
    defaultMessage: "Open Test Mode",
  },
  preview_care_plan: {
    id: "preview_care_plan",
    defaultMessage: "Preview Care Plan",
  },
  care_plan_simulator: {
    id: "care_plan_simulator",
    defaultMessage: "Care Plan Simulator (beta)",
  },
  care_plan_preview_description: {
    id: "care_plan_preview_description",
    defaultMessage: "See what this care plan looks like on a future date",
  },
  trigger_warning: {
    id: "trigger_warning",
    defaultMessage:
      "This triggers the care plan engine and has real side effects.",
  },
  custom_date: {
    id: "custom_date",
    defaultMessage: "Custom Date",
  },
  day_number: {
    id: "day_number",
    defaultMessage: "Day {day}",
  },
  day_x_of_y: {
    id: "day_x_of_y",
    defaultMessage: "Day {current} of {total}",
  },
  tasks_completed_of_due: {
    id: "tasks_completed_of_due",
    defaultMessage: "{completed} of {total} due tasks completed",
  },
  adherence: {
    id: "adherence",
    defaultMessage: "Adherence",
  },
  no_actions_scheduled: {
    id: "no_actions_scheduled",
    defaultMessage: "No actions scheduled for this day",
  },
  not_started: {
    id: "not_started",
    defaultMessage: "Not Started",
  },
  fired: {
    id: "fired",
    defaultMessage: "Fired",
  },
  complete_care_plan: {
    id: "complete_care_plan",
    defaultMessage: "Complete Care Plan",
  },

  download_as_csv: {
    id: "download_as_csv",
    defaultMessage: "Download as CSV",
  },

  change_care_plan: {
    id: "change_care_plan",
    defaultMessage: "Change Care Plan",
  },
  milestones: {
    id: "milestones",
    defaultMessage: "Milestones",
  },
  care_plan_test_mode: {
    id: "care_plan_test_mode",
    defaultMessage: "Care Plan Test Mode",
  },
  edit_assigned_care_plan: {
    id: "edit_assigned_care_plan",
    defaultMessage: "Edit Assigned Care Plan",
  },

  sh_survey_details: {
    id: "sh_survey_details",
    defaultMessage: "Survey Details",
  },
  new_uc: {
    id: "new_uc",
    defaultMessage: "NEW",
  },
  no_pending_tasks: {
    id: "no_pending_tasks",
    defaultMessage: "No pending tasks for today. See more.",
  },
  sh_complete: {
    id: "sh_complete",
    defaultMessage: "Complete",
  },
  survey_pending: { id: "survey_pending", defaultMessage: "SURVEY: PENDING" },
  survey_completed: {
    id: "survey_completed",
    defaultMessage: "SURVEY: COMPLETED",
  },
  article: { id: "article", defaultMessage: "ARTICLE" },

  consent_pending: {
    id: "consent_pending",
    defaultMessage: "CONSENT: PENDING",
  },

  consent_completed: {
    id: "consent_completed",
    defaultMessage: "CONSENT: COMPLETED",
  },

  sh_appointment_type_md: {
    id: "sh_appointment_type_md",
    defaultMessage: "Appointment Type Master Data",
  },
  sh_appointment_location_md: {
    id: "sh_appointment_location_md",
    defaultMessage: "Appointment Schedule Location Master Data",
  },
  sh_appointment_vc_template: {
    id: "sh_appointment_vc_template",
    defaultMessage: "Appointment Template for Video calls",
  },
  fa_location: {
    id: "fa_location",
    defaultMessage: "Location",
  },
  sh_confirmation_messages: {
    id: "sh_confirmation_messages",
    defaultMessage: "Confirmation Messages",
  },
  sh_reminders_config: {
    id: "sh_reminders_config",
    defaultMessage: "Reminders Configuration",
  },
  sh_reminder_config_edit: {
    id: "sh_reminder_config_edit",
    defaultMessage: "Edit Reminder Configuration",
  },
  sh_delete: {
    id: "sh_delete",
    defaultMessage: "Delete",
  },
  sh_before_hours: {
    id: "sh_before_hours",
    defaultMessage: "Before Hours/Mins",
  },
  sh_email_sub: {
    id: "sh_email_sub",
    defaultMessage: "Email Subject",
  },
  sh_email_content: {
    id: "sh_email_content",
    defaultMessage: "Email Content",
  },
  sh_sms_content: {
    id: "sh_sms_content",
    defaultMessage: "SMS Content",
  },
  sh_status_message: {
    id: "sh_status_message",
    defaultMessage: "Status Message",
  },
  sh_submit: {
    id: "sh_submit",
    defaultMessage: "Submit",
  },
  sh_participants: {
    id: "sh_participants",
    defaultMessage: "Participants",
  },
  sh_type: {
    id: "sh_type",
    defaultMessage: "Type",
  },
  sh_master_data: {
    id: "sh_master_data",
    defaultMessage: "Master Data",
  },
  sh_master_data_key: {
    id: "sh_master_data_key",
    defaultMessage: "Master Data Key",
  },
  sh_master_data_value: {
    id: "sh_master_data_value",
    defaultMessage: "Master Data Value",
  },
  sh_staff: {
    id: "sh_staff",
    defaultMessage: "Staff",
  },
  sh_remove: {
    id: "sh_remove",
    defaultMessage: "Remove",
  },
  sh_add_participant: {
    id: "sh_add_participant",
    defaultMessage: "Add Participant",
  },
  sh_reminder_config: {
    id: "sh_reminder_config",
    defaultMessage: "Reminder Configuration",
  },
  sh_users: {
    id: "sh_users",
    defaultMessage: "Users",
  },
  sh_all_users: {
    id: "sh_all_users",
    defaultMessage: "All Users",
  },
  sh_all_patients: {
    id: "sh_all_patients",
    defaultMessage: "All Patients",
  },
  sh_selected_patients: {
    id: "sh_selected_patients",
    defaultMessage: "Selected Patients",
  },
  sh_search_patients: {
    id: "sh_search_patients",
    defaultMessage: "Patients From Search",
  },
  sh_set_campaign_mode: {
    id: "sh_set_campaign_mode",
    defaultMessage: "Please set campaign mode",
  },
  sh_set_sms_content: {
    id: "sh_set_sms_content",
    defaultMessage:
      "Please set sms content that does not exceed 160 characters.",
  },
  sh_set_subject: {
    id: "sh_set_subject",
    defaultMessage: "Please set subject",
  },
  sh_set_email_content: {
    id: "sh_set_email_content",
    defaultMessage: "Please set email content",
  },
  sh_send_messages_to: {
    id: "sh_send_messages_to",
    defaultMessage: "Send Messages To",
  },
  sh_50_patients: {
    id: "sh_50_patients",
    defaultMessage: "Maximum of 50 Patients",
  },
  sh_view: {
    id: "sh_view",
    defaultMessage: "View",
  },
  sh_patient_ids: {
    id: "sh_patient_ids",
    defaultMessage: "Patient Ids",
  },
  sh_set_patient_ids: {
    id: "sh_set_patient_ids",
    defaultMessage: "Please set patient Ids",
  },
  sh_set_number_of_patients: {
    id: "sh_set_number_of_patients",
    defaultMessage: "Please set Number of patients",
  },
  sh_set_one_of_message: {
    id: "sh_set_one_of_message",
    defaultMessage: "At least one the following messages is required",
  },
  sh_set_email_subject: {
    id: "sh_set_email_subject",
    defaultMessage: "Please set email subject",
  },
  sh_send_messages: {
    id: "sh_send_messages",
    defaultMessage: "Send Messages",
  },
  sh_sure_send_messages: {
    id: "sh_sure_send_messages",
    defaultMessage: "Are you sure you want to send the messages?",
  },
  patient: {
    id: "patient",
    defaultMessage: "Patient",
  },
  add: {
    id: "add",
    defaultMessage: "Add",
  },
  hide: {
    id: "hide",
    defaultMessage: "Hide",
  },
  addNewPatient: {
    id: "add_new_patient",
    defaultMessage: "Add New Patient",
  },
  change: {
    id: "change",
    defaultMessage: "Change",
  },
  select: {
    id: "select",
    defaultMessage: "Select",
  },
  addPatient: {
    id: "add_patient",
    defaultMessage: "Add Patient",
  },
  patientType: {
    id: "patient_type",
    defaultMessage: "Patient Type",
  },
  setPatientType: {
    id: "set_patient_type",
    defaultMessage: "Please set patient type.",
  },
  consultant: {
    id: "consultant",
    defaultMessage: "Consultant",
  },
  set_consultant: {
    id: "set_consultant",
    defaultMessage: "Please set consultant.",
  },
  procedure: {
    id: "procedure",
    defaultMessage: "Procedure",
  },
  treatment: {
    id: "treatment",
    defaultMessage: "Treatment",
  },
  clinic_diagnosis: {
    id: "clinic_diagnosis",
    defaultMessage: "Diagnosis",
  },
  procedureDate: {
    id: "procedure_date",
    defaultMessage: "Procedure Date",
  },
  treatment_date: {
    id: "treatment_date",
    defaultMessage: "Treatment Date",
  },

  procedure_date_w_date: {
    id: "procedure_date_w_date",
    defaultMessage: "Procedure Date: {procedureDate}",
  },

  sure_to_deactivate_profile_w_name: {
    id: "sure_to_deactivate_profile_w_name",
    defaultMessage:
      "Are you sure you want to de-activate Patient profile {name}?",
  },

  sure_to_deactivate_profile: {
    id: "sure_to_deactivate_profile",
    defaultMessage: "Are you sure you want to de-activate Patient profile?",
  },

  sure_to_restore_profile_w_name: {
    id: "sure_to_restore_profile_w_name",
    defaultMessage: "Are you sure you want to restore Patient profile {name}?",
  },

  sure_to_restore_profile: {
    id: "sure_to_restore_profile",
    defaultMessage: "Are you sure you want to restore Patient profile?",
  },

  restore_patient: {
    id: "restore_patient",
    defaultMessage: "Restore Patient",
  },

  submit: {
    id: "submit",
    defaultMessage: "Submit",
  },
  reset: {
    id: "reset",
    defaultMessage: "Reset",
  },
  filters: {
    id: "filters",
    defaultMessage: "Filters",
  },
  hideAdvanced: {
    id: "hide_advanced",
    defaultMessage: "Hide Advanced",
  },
  sortBy: {
    id: "sort_by",
    defaultMessage: "Sort By",
  },
  patients: {
    id: "patients",
    defaultMessage: "Patients",
  },
  advanced: {
    id: "advanced",
    defaultMessage: "Advanced",
  },
  agedDebt: {
    id: "aged_debt",
    defaultMessage: "Aged Debt",
  },
  watchlist: {
    id: "watchlist",
    defaultMessage: "Watchlist",
  },
  recent: {
    id: "recent",
    defaultMessage: "Recent",
  },
  removeFromWatchlist: {
    id: "remove_from_watchlist",
    defaultMessage: "Remove from watchlist",
  },
  addToWatchlist: {
    id: "add_to_watchlist",
    defaultMessage: "Add to watchlist",
  },
  create_new_task: {
    id: "create_new_task",
    defaultMessage: "Create Task",
  },
  submit_assessments: {
    id: "submit_assessments",
    defaultMessage: "Submit Assessments",
  },
  statuses_uc: {
    id: "statuses_uc",
    defaultMessage: "UPDATES",
  },
  reset_credentials: {
    id: "reset_credentials",
    defaultMessage: "Reset Credentials",
  },

  send_sms: {
    id: "send_sms",
    defaultMessage: "Send SMS",
  },

  send_email: {
    id: "send_email",
    defaultMessage: "Send Email",
  },

  reorder_tabs: {
    id: "reorder_tabs",
    defaultMessage: "Reorder Tabs",
  },

  de_activate_patient: {
    id: "de_activate_patient",
    defaultMessage: "De-Activate Patient",
  },

  not_viewed_by_patient: {
    id: "not_viewed_by_patient",
    defaultMessage: "Not Viewed By Patient",
  },

  staff_notes_uc: {
    id: "staff_notes_uc",
    defaultMessage: "NOTES",
  },

  patient_interactions_uc: {
    id: "patient_interactions_uc",
    defaultMessage: "COMMS",
  },

  care_plan_uc: {
    id: "care_plan_uc",
    defaultMessage: "CARE PLAN",
  },
  assessments_uc: {
    id: "assessments_uc",
    defaultMessage: "ASSESSMENTS",
  },
  tasks_uc: {
    id: "tasks_uc",
    defaultMessage: "TASKS",
  },
  appointments_uc: {
    id: "appointments_uc",
    defaultMessage: "APPTS.",
  },
  usage_uc: {
    id: "usage_uc",
    defaultMessage: "USAGE",
  },
  audit_logs_uc: {
    id: "audit_logs_uc",
    defaultMessage: "AUDITS",
  },
  resendInvite: {
    id: "resend_invite",
    defaultMessage: "Resend Invite",
  },
  sendInvite: {
    id: "send_invite",
    defaultMessage: "Send Invite",
  },
  restore: {
    id: "restore",
    defaultMessage: "Restore",
  },
  noPatients: {
    id: "no_patients",
    defaultMessage: "No patients.",
  },
  compactView: {
    id: "compact_view",
    defaultMessage: "Compact",
  },
  mobilePhoneNumber: {
    id: "mobile_phone_number",
    defaultMessage: "Mobile Phone Number",
  },
  noLogs: {
    id: "no_logs",
    defaultMessage: "No logs available",
  },
  changeLogs: {
    id: "change_logs",
    defaultMessage: "Change Logs",
  },
  accessLogs: {
    id: "access_logs",
    defaultMessage: "Access Logs",
  },
  viewOlderEntries: {
    id: "view_older_entries",
    defaultMessage: "View older entries",
  },
  title: {
    id: "title",
    defaultMessage: "Title",
  },
  setTitle: {
    id: "setTitle",
    defaultMessage: "Please set title",
  },
  details: {
    id: "details",
    defaultMessage: "Details",
  },
  setDetails: {
    id: "set_details",
    defaultMessage: "Please set details",
  },
  visibility: {
    id: "visibility",
    defaultMessage: "Visibility",
  },
  notify_patient_q: {
    id: "notify_patient_q",
    defaultMessage: "Notify Patient?",
  },
  dont_send_push_notification: {
    id: "dont_send_push_notification",
    defaultMessage: "Don't send push notification",
  },
  notify_patient_desc: {
    id: "notify_patient_desc",
    defaultMessage: "Send a notification to the patient about this document",
  },
  documentType: {
    id: "document_type",
    defaultMessage: "Document Type",
  },
  pdf: {
    id: "pdf",
    defaultMessage: "PDF",
  },
  image: {
    id: "image",
    defaultMessage: "Image",
  },
  documents: {
    id: "documents",
    defaultMessage: "Documents",
  },
  setDocuments: {
    id: "set_documents",
    defaultMessage: "Please set documents",
  },
  topics: {
    id: "topics",
    defaultMessage: "Topics",
  },
  addDocument: {
    id: "add_document",
    defaultMessage: "Add Document",
  },
  description: {
    id: "description",
    defaultMessage: "Description",
  },
  noDocsFound: {
    id: "no_docs_found",
    defaultMessage: "No documents have been found for this patient",
  },
  markAsRIP: {
    id: "mark_as_rip",
    defaultMessage: "Mark as RIP",
  },
  cancel: {
    id: "cancel",
    defaultMessage: "Cancel",
  },
  yes: {
    id: "yes",
    defaultMessage: "Yes",
  },
  delete: {
    id: "delete",
    defaultMessage: "Delete",
  },
  noRecAssessments: {
    id: "no_rec_assessments",
    defaultMessage: "No recent assessments",
  },
  assessments: {
    id: "assessments",
    defaultMessage: "Assessments",
  },
  select_assessment_type: {
    id: "select_assessment_type",
    defaultMessage: "Assessment Name",
  },
  filter_by_date: {
    id: "filter_by_date",
    defaultMessage: "Filter by Date",
  },
  view: {
    id: "view",
    defaultMessage: "View",
  },
  send: {
    id: "send",
    defaultMessage: "Send",
  },
  sms: {
    id: "sms",
    defaultMessage: "SMS",
  },
  email: {
    id: "email",
    defaultMessage: "Email",
  },
  credentials: {
    id: "credentials",
    defaultMessage: "Credentials",
  },
  model: {
    id: "model",
    defaultMessage: "Model",
  },
  photos: {
    id: "photos",
    label: "Photos",
  },
  noDevsFound: {
    id: "no_devs_found",
    defaultMessage: "No devices have been found for this patient",
  },
  viewCompleteProfile: {
    id: "view_complete_profile",
    defaultMessage: "View Complete Profile",
  },
  save: {
    id: "save",
    defaultMessage: "Save",
  },
  saving: {
    id: "saving",
    defaultMessage: "Saving...",
  },
  saveChanges: {
    id: "save_changes",
    defaultMessage: "Save Changes",
  },
  dragDrop: {
    id: "drag_drop",
    defaultMessage: "Drag and drop to reorder the tabs",
  },
  yetToImpl: {
    id: "yet_to_impl",
    defaultMessage: "Yet to be implemented",
  },
  loginUserId: {
    id: "login_user_id",
    defaultMessage: "Login User Id",
  },
  setLoginUserId: {
    id: "set_login_user_id",
    defaultMessage: "Please set User Id",
  },
  sureToResetCreds: {
    id: "sure_to_reset_creds",
    defaultMessage:
      "Are you sure you want to reset the credentials for the patient?",
  },
  resetCredsWarningMsg: {
    id: "reset_creds_warning_msg",
    defaultMessage:
      "Clicking on the submit button will reset the credentials for the patient",
  },
  todayTasks: {
    id: "today_tasks",
    defaultMessage: "Today's Tasks",
  },
  viewTasks: {
    id: "view_tasks",
    defaultMessage: "View Tasks",
  },
  activities: {
    id: "activities",
    defaultMessage: "Activities",
  },
  name: {
    id: "name",
    defaultMessage: "Name",
  },
  relation: {
    id: "relation",
    defaultMessage: "Relation",
  },
  address: {
    id: "address",
    defaultMessage: "Address",
  },
  showAll: {
    id: "show_all",
    defaultMessage: "Show All",
  },
  editTaskData: {
    id: "edit_task_data",
    defaultMessage: "Edit Task Data",
  },
  editPatientProfile: {
    id: "edit_patient_profile",
    defaultMessage: "Edit Profile",
  },
  rip: {
    id: "rip",
    defaultMessage: "Deceased",
  },
  birthDate: {
    id: "birth_date",
    defaultMessage: "Birth Date",
  },
  notAvailable: {
    id: "not_available",
    defaultMessage: "Not Available",
  },
  lastActiveOn: {
    id: "last_active_on",
    defaultMessage: "Last Active On",
  },
  loginUserName: {
    id: "login_user_name",
    defaultMessage: "Login Username",
  },
  patientId: {
    id: "patient_id",
    defaultMessage: "Patient ID",
  },
  dob: {
    id: "dob",
    defaultMessage: "DOB",
  },
  fromDate: { id: "from_date", defaultMessage: "From Date" },
  toDate: { id: "to_date", defaultMessage: "To Date" },
  serialNumber: { id: "serial_number", defaultMessage: "Serial Number" },
  mode: { id: "mode", defaultMessage: "Mode" },
  statistics: { id: "statistics", defaultMessage: "Statistics" },
  usage: { id: "usage", defaultMessage: "Usage" },
  maskOnDates: { id: "mask_on_dates", defaultMessage: "Mask On Dates" },
  maskOffDates: { id: "mask_off_dates", defaultMessage: "Mask Off Dates" },
  leak: { id: "leak", defaultMessage: "Leak" },
  tgtIPAP: { id: "tgtIPAP", defaultMessage: "tgtIPAP" },
  spo: { id: "spo", defaultMessage: "SPO" },
  events: { id: "events", defaultMessage: "Events" },
  detailedReport: {
    id: "detailed_report",
    defaultMessage: "Detailed Report",
  },
  fetchDetailedReport: {
    id: "fetch_detailed_report",
    defaultMessage: "Fetch Detailed Report",
  },
  therapyComplianceReport: {
    id: "therapy_compliance_report",
    defaultMessage: "Therapy Compliance Report",
  },
  fetchTherapyComplianceReport: {
    id: "fetch_therapy_compliance_report",
    defaultMessage: "Fetch Therapy Compliance Report",
  },
  showConsolidatedReport: {
    id: "show_consolidated_report",
    defaultMessage: "Show Consolidated Report",
  },
  surveyDateAndScores: {
    id: "survey_date_and_scores",
    defaultMessage: "Assessment Date and Scores",
  },
  no_assessments_found: {
    id: "no_assessments_found",
    defaultMessage: "No Assessments Found",
  },
  no_assessments_description: {
    id: "no_assessments_description",
    defaultMessage:
      "There are no assessments matching your selected criteria. Try adjusting your filters or date range.",
  },
  recentScore: { id: "recent_score", defaultMessage: "Recent Score" },
  answer: { id: "Ans", defaultMessage: "Answer" },
  na: { id: "na", defaultMessage: "NA" },
  totalScore: { id: "total_score", defaultMessage: "Total Score" },
  daywiseChartFor: {
    id: "day_wise_chart_for",
    defaultMessage: "Day wise Chart for",
  },
  answers: { id: "answers", defaultMessage: "Answers" },
  submissionDate: {
    id: "submission_date",
    defaultMessage: "Submission Date",
  },
  dateSurveyTaken: {
    id: "date_survey_taken",
    defaultMessage: "Date when the assessment was taken:",
  },
  surveyCompletedBy: {
    id: "survey_completed_by",
    defaultMessage: "Completed by:",
  },
  surveyScore: { id: "survey_score", defaultMessage: "Assessment Score" },
  survey_value: { id: "survey_value", defaultMessage: "Assessment Value" },
  survey_sleep_score: {
    id: "survey_sleep_score",
    defaultMessage: "Sleep Score",
  },
  survey_total_score: {
    id: "survey_total_score",
    defaultMessage: "Total Score",
  },
  survey_no_data: {
    id: "survey_no_data",
    defaultMessage: "No survey data available",
  },
  survey_show_details: {
    id: "survey_show_details",
    defaultMessage: "Show details",
  },
  survey_hide_details: {
    id: "survey_hide_details",
    defaultMessage: "Hide details",
  },
  score: { id: "score", defaultMessage: "Score" },
  value: { id: "value", defaultMessage: "Value" },
  avgScoresQuestionsPeriod: {
    id: "avg_scores_qs_period",
    defaultMessage: "Average Scores Across Questions and Response Period",
  },
  timeWindow: { id: "time_window", defaultMessage: "Time Window" },
  completed: { id: "completed", defaultMessage: "Completed" },
  alert_schedules_no_data: {
    id: "alert_schedules_no_data",
    defaultMessage: "No schedules data available",
  },
  inComplete: { id: "in_complete", defaultMessage: "Not completed" },
  started: { id: "started", defaultMessage: "Started" },
  overallResponseRate: {
    id: "overall_response_rate",
    defaultMessage: "Overall response rate",
  },
  availableOptions: {
    id: "available_options",
    defaultMessage: "Available Options",
  },
  selectSurveyToView: {
    id: "select_survey_to_view",
    defaultMessage: "Please select a Survey to view the data",
  },
  survey: { id: "survey", defaultMessage: "Survey" },
  surveyQuestions: {
    id: "survey_questions",
    defaultMessage: "Survey Questions",
  },
  tasksByAssignee: {
    id: "tasks_by_assignee",
    defaultMessage: "Tasks By Assignee",
  },
  tasksByPriority: {
    id: "tasks_by_priority",
    defaultMessage: "Tasks By Priority",
  },
  tasksByStatus: {
    id: "tasks_by_status",
    defaultMessage: "Tasks By Status",
  },
  tasksByTopics: {
    id: "tasks_by_topics",
    defaultMessage: "Tasks By Topics",
  },
  tasksByTemplates: {
    id: "tasks_by_templates",
    defaultMessage: "Tasks By Templates",
  },
  date: { id: "date", defaultMessage: "Date" },
  taskTemplate: { id: "task_template", defaultMessage: "Task Template" },
  taskAssignee: { id: "task_assignee", defaultMessage: "Task Assignee" },
  taskCreatedBy: {
    id: "task_created_by",
    defaultMessage: "Task Created By",
  },
  tasks_count: { id: "tasks_count", defaultMessage: "{count} Tasks" },
  tasks: { id: "tasks", defaultMessage: "Tasks" },
  my_tasks: { id: "my_tasks", defaultMessage: "My Tasks" },
  team_tasks: { id: "team_tasks", defaultMessage: "Team Tasks" },
  tasks_by_me: {
    id: "tasks_by_me",
    defaultMessage: "Tasks Created By Me",
  },
  tasks_completed_by_me: {
    id: "tasks_completed_by_me",
    defaultMessage: "Tasks Completed By Me",
  },
  all_completed_tasks: {
    id: "all_completed_tasks",
    defaultMessage: "All Completed Tasks",
  },
  appointments: {
    id: "appointments",
    defaultMessage: "Appointments",
  },
  template_messages: {
    id: "template_messages",
    defaultMessage: "Template Messages",
  },
  dashboard: {
    id: "dashboard",
    defaultMessage: "Dashboard",
  },
  filter: { id: "filter", defaultMessage: "Filter" },
  close: { id: "close", defaultMessage: "Close" },
  surveys: { id: "surveys", defaultMessage: "Surveys" },
  staff: { id: "staff", defaultMessage: "Staff" },
  patientReport: {
    id: "patient_report",
    defaultMessage: "Patient Report",
  },
  setRelation: {
    id: "please_set_relation",
    defaultMessage: "Please set relation",
  },
  remove: { id: "remove", defaultMessage: "Remove" },
  noMembersYet: { id: "no_members_yet", defaultMessage: "No members yet" },
  addMember: { id: "add_member", defaultMessage: "Add Member" },
  removeMember: { id: "remove_member", defaultMessage: "Remove Member" },
  confirmRemoveAppointmentDay: {
    id: "confirm_remove_appointment_day",
    defaultMessage: "Are you sure you want to remove this appointment day?",
  },
  confirm_remove_cycle: {
    id: "confirm_remove_cycle",
    defaultMessage:
      "Are you sure you want to remove this cycle? This action cannot be undone.",
  },
  remove_cycle: {
    id: "remove_cycle",
    defaultMessage: "Remove Cycle",
  },
  cannot_remove_last_cycle: {
    id: "cannot_remove_last_cycle",
    defaultMessage: "Cannot remove the only cycle in the regimen",
  },
  confirm: { id: "confirm", defaultMessage: "Confirm" },
  myNotes: { id: "my_notes", defaultMessage: "Private" },
  expanded: { id: "expanded", defaultMessage: "Expanded" },
  addNotes: { id: "add_notes", defaultMessage: "+ New" },
  sendNewStatus: {
    id: "send_new_status",
    defaultMessage: "Send New Status",
  },
  noNotesYet: {
    id: "no_notes_yet",
    defaultMessage: "You don't have any notes yet.",
  },
  noStaffNotes: {
    id: "no_staff_notes",
    defaultMessage: "No staff notes yet for this patient.",
  },
  no_patient_interactions: {
    id: "no_patient_interactions",
    defaultMessage: "There are no patient interactions.",
  },
  deleteStaffNote: {
    id: "delete_staff_note",
    defaultMessage: "Delete Staff Note",
  },
  deleteStatusMessage: {
    id: "delete_status_message",
    defaultMessage: "Delete Status Message",
  },
  noStatuses: {
    id: "no_statuses",
    defaultMessage: "No updates yet for this patient.",
  },
  no_statuses_channel: {
    id: "no_statuses_channel",
    defaultMessage: "No updates yet for this channel.",
  },
  today: { id: "today", defaultMessage: "Today" },
  yesterday: { id: "yesterday", defaultMessage: "Yesterday" },
  edit: { id: "edit", defaultMessage: "Edit" },
  carePlanDetails: {
    id: "care_plan_details",
    defaultMessage: "Care Plan Details",
  },
  consentDocumentDetails: {
    id: "consent_document_details",
    defaultMessage: "Consent Document Details",
  },
  status: { id: "status", defaultMessage: "Status" },
  device: { id: "device", defaultMessage: "DEVICE" },
  deviceDetails: {
    id: "device_details",
    defaultMessage: "Device Details",
  },
  position: { id: "position", defaultMessage: "POSITION (Lat/Lng)" },
  surveyAnswers: {
    id: "survey_answers",
    defaultMessage: "Survey Answers",
  },
  taskCreatedAvailable: {
    id: "task_created_available",
    defaultMessage:
      "A Task has been created and its available in the tasks page.",
  },
  typeOfEntry: { id: "type_of_entry", defaultMessage: "Message Type" },
  chooseUpdateType: {
    id: "choose_update_type",
    defaultMessage: "Please choose update type",
  },
  videoThumbnails: {
    id: "video_thumbnails",
    defaultMessage: "Video Thumbnails",
  },
  setThumbnails: {
    id: "set_thumbnails",
    defaultMessage: "Please Set Thumbnails",
  },
  setThumbnailsE: {
    id: "set_thumbnails_e",
    defaultMessage: "Please set thumbnails for all video files",
  },
  availableTemplates: {
    id: "available_templates",
    defaultMessage: "Available Templates",
  },
  chooseTemplate: {
    id: "choose_template",
    defaultMessage: "Please Choose Template",
  },
  chooseSurvey: { id: "choose_survey", defaultMessage: "Choose a survey" },
  pleaseChooseSurvey: {
    id: "please_choose_survey",
    defaultMessage: "Please Choose Survey",
  },
  library: { id: "library", defaultMessage: "Library" },
  pleaseSetLibrary: {
    id: "please_set_liLbrary",
    defaultMessage: "Please Set Library",
  },
  consentDocument: {
    id: "consent_document",
    defaultMessage: "Consent Document",
  },
  setConsentDocument: {
    id: "set_consent_document",
    defaultMessage: "Please Set Consent Document",
  },
  setTaskTemplate: {
    id: "set_task_template",
    defaultMessage: "Please Set Task Template",
  },
  text: { id: "text", defaultMessage: "Text" },
  external: { id: "external", defaultMessage: "External" },
  missing_renditions: {
    id: "missing_renditions",
    defaultMessage: "Missing renditions",
  },
  more_filters: {
    id: "more_filters",
    defaultMessage: "More filters",
  },
  audio_narration: { id: "audio_narration", defaultMessage: "Audio Narration" },
  prepare_script: { id: "prepare_script", defaultMessage: "Prepare script" },
  preparing_ellipsis: {
    id: "preparing_ellipsis",
    defaultMessage: "Preparing...",
  },
  no_script_yet: { id: "no_script_yet", defaultMessage: "No script yet" },
  audio_narration_empty_help: {
    id: "audio_narration_empty_help",
    defaultMessage:
      "Pull the article body, strip URLs and reviewer credits, then turn it into spoken narration.",
  },
  audio_narration_save_first: {
    id: "audio_narration_save_first",
    defaultMessage: "Save the library item first to enable script preparation.",
  },
  preparing_script_title: {
    id: "preparing_script_title",
    defaultMessage: "Preparing script...",
  },
  preparing_script_help: {
    id: "preparing_script_help",
    defaultMessage:
      "Reading the article body and cleaning it up for narration.",
  },
  notes_from_script_preparation: {
    id: "notes_from_script_preparation",
    defaultMessage: "Notes from script preparation",
  },
  script: { id: "script", defaultMessage: "Script" },
  reprepare_from_article: {
    id: "reprepare_from_article",
    defaultMessage: "Re-prepare from article",
  },
  repreparing_ellipsis: {
    id: "repreparing_ellipsis",
    defaultMessage: "Re-preparing...",
  },
  insert_pause: { id: "insert_pause", defaultMessage: "Insert pause" },
  pause_toolbar_hint: {
    id: "pause_toolbar_hint",
    defaultMessage: "Max 3s · use sparingly",
  },
  soft_pause: { id: "soft_pause", defaultMessage: "Soft pause" },
  short_pause: { id: "short_pause", defaultMessage: "Short pause" },
  soft_pause_tooltip: {
    id: "soft_pause_tooltip",
    defaultMessage: "Ellipsis — gentle hesitation between phrases",
  },
  short_pause_tooltip: {
    id: "short_pause_tooltip",
    defaultMessage: "Em dash — short pause inside a sentence",
  },
  pause_seconds: {
    id: "pause_seconds",
    defaultMessage: "{seconds}s pause",
  },
  pause_seconds_tooltip: {
    id: "pause_seconds_tooltip",
    defaultMessage: "Insert an explicit {seconds} second pause",
  },
  pause_seconds_tooltip_max: {
    id: "pause_seconds_tooltip_max",
    defaultMessage: "Insert an explicit 3 second pause (maximum)",
  },
  script_placeholder: {
    id: "script_placeholder",
    defaultMessage: "Review and edit the narration script here.",
  },
  generate_audio: { id: "generate_audio", defaultMessage: "Generate audio" },
  generating_ellipsis: {
    id: "generating_ellipsis",
    defaultMessage: "Generating...",
  },
  start_over: { id: "start_over", defaultMessage: "Start over" },
  audio_ready: { id: "audio_ready", defaultMessage: "Audio ready" },
  save_to_renditions: {
    id: "save_to_renditions",
    defaultMessage: "Save to renditions",
  },
  discard: { id: "discard", defaultMessage: "Discard" },
  toast_save_library_before_audio: {
    id: "toast_save_library_before_audio",
    defaultMessage: "Save the library item before preparing audio.",
  },
  toast_could_not_prepare_script: {
    id: "toast_could_not_prepare_script",
    defaultMessage: "Could not prepare the audio script.",
  },
  toast_prepare_script_first: {
    id: "toast_prepare_script_first",
    defaultMessage: "Please prepare or enter an audio script first.",
  },
  toast_could_not_generate_audio: {
    id: "toast_could_not_generate_audio",
    defaultMessage: "Could not generate audio from the reviewed script.",
  },
  toast_audio_added_to_renditions: {
    id: "toast_audio_added_to_renditions",
    defaultMessage:
      "Generated audio added to renditions. Save the library item to publish it.",
  },
  setTextContent: {
    id: "please_set_text_content",
    defaultMessage: "Please Set Text Content",
  },
  optionalTitle: {
    id: "optional_title",
    defaultMessage: "Title (Optional)",
  },
  media: { id: "media", defaultMessage: "Media" },
  artifactType: { id: "artifact_type", defaultMessage: "Artifact Type" },
  sendUpdate: { id: "send_update", defaultMessage: "Send Update" },
  selectCD: { id: "select_cd", defaultMessage: "Select Consent Document" },
  selectTaskTemplate: {
    id: "select_task_template",
    defaultMessage: "Select Task Template",
  },
  newTask: { id: "new_task", defaultMessage: "New Task" },
  task: { id: "task", defaultMessage: "Task" },
  back: { id: "back", defaultMessage: "Back" },
  create: { id: "create", defaultMessage: "Create" },
  choosePatient: {
    id: "choose_patient",
    defaultMessage: "Choose Patient",
  },
  chooseServiceUser: {
    id: "choose_service_user",
    defaultMessage: "Choose Service User",
  },
  relatedTo: { id: "related_to", defaultMessage: "Related to" },
  setPatient: { id: "set_patient", defaultMessage: "Please set Patient" },
  chooseTaskType: {
    id: "choose_task_type",
    defaultMessage: "Choose Task Type",
  },
  adHocTask: { id: "ad_hoc_task", defaultMessage: "Ad Hoc Task" },
  next: { id: "next", defaultMessage: "Next" },
  assignee: { id: "assignee", defaultMessage: "Assignee" },
  pending: { id: "pending", defaultMessage: "Pending" },
  dueOn: { id: "due_on", defaultMessage: "Due On" },
  createdBy: { id: "created_by", defaultMessage: "Created By" },
  modifiedBy: { id: "edited_by", defaultMessage: "Edited By" },
  reassign: { id: "reassign", defaultMessage: "Reassign" },
  my_care_team: { id: "my_care_team", defaultMessage: "My Care Team" },
  all_care_teams: { id: "all_care_teams", defaultMessage: "All Care Teams" },
  all_staff: { id: "all_staff", defaultMessage: "All Staff" },
  search_assignees: { id: "search_assignees", defaultMessage: "Search..." },
  taskFor: { id: "task_for", defaultMessage: "Task For" },
  accept: { id: "accept", defaultMessage: "Accept" },
  assignToMe: { id: "assign_to_me", defaultMessage: "Assign To Me" },
  acceptNComplete: {
    id: "accept_complete",
    defaultMessage: "Accept & Complete",
  },
  markComplete: { id: "mark_complete", defaultMessage: "Mark Complete" },
  taskCompleteReopen: {
    id: "task_complete_reopen",
    defaultMessage: "Task Complete. Reopen?",
  },
  requester: { id: "requester", defaultMessage: "Requester" },
  taskNotes: { id: "task_notes", defaultMessage: "Task Notes" },
  attachments: { id: "attachments", defaultMessage: "Attachments" },
  taskDetails: { id: "task_details", defaultMessage: "Task Details" },
  taskAuditDetails: {
    id: "task_audit_details",
    defaultMessage: "Task Audit Details",
  },
  setTaskTitle: {
    id: "please_set_task_title",
    defaultMessage: "Please Set Task Title",
  },
  setTaskDescription: {
    id: "please_set_task_description",
    defaultMessage: "Please Set Task Description",
  },
  existingAttachments: {
    id: "existing_attachments",
    defaultMessage: "Existing Attachments",
  },
  attachmentsImages: {
    id: "attachments_images",
    defaultMessage: "Attachments (Images)",
  },
  pleaseSetAssignee: {
    id: "please_set_assignee",
    defaultMessage: "Please Set Assignee",
  },
  dueDate: { id: "due_date", defaultMessage: "Due Date" },
  taskPriority: { id: "task_priority", defaultMessage: "Task Priority" },
  asap: { id: "asap", defaultMessage: "ASAP" },
  urgent: { id: "urgent", defaultMessage: "Urgent" },
  normal: { id: "normal", defaultMessage: "Normal" },
  low: { id: "low", defaultMessage: "Low" },
  stat: { id: "stat", defaultMessage: "Stat" },
  noTasksAvailable: {
    id: "no_tasks_available",
    defaultMessage: "No Tasks Available.",
  },
  noTasksFound: {
    id: "no_tasks_found",
    defaultMessage: "No tasks have been found for the given criteria",
  },
  priority: { id: "priority", defaultMessage: "Priority" },
  pLastName: { id: "p_last_name", defaultMessage: "Patient Last Name" },
  pFirstName: { id: "p_first_name", defaultMessage: "Patient First Name" },
  aLastName: { id: "alast_name", defaultMessage: "Assignee Last Name" },
  aFirstName: { id: "afirst_name", defaultMessage: "Assignee First Name" },
  aCareTeam: { id: "acare_team", defaultMessage: "Assignee Care Team" },
  taskTitle: { id: "task_title", defaultMessage: "Task Title" },
  asc: { id: "asc", defaultMessage: "Asc" },
  desc: { id: "desc", defaultMessage: "Desc" },
  allDue: { id: "all_due", defaultMessage: "All Due" },
  allDue_filter_required: {
    id: "allDue_filter_required",
    defaultMessage:
      "Please select at least one other filter when using 'All Due'",
  },
  dueToday: { id: "due_today", defaultMessage: "Due Today" },
  overdue: { id: "overdue", defaultMessage: "Overdue" },
  upcoming: { id: "Upcoming", defaultMessage: "Upcoming" },
  all: { id: "all", defaultMessage: "All" },
  gotPatientConsent: {
    id: "got_patient_consent",
    defaultMessage:
      "Have you got the patient's consent to add this family member",
  },
  relationToPatient: {
    id: "relation_to_patient",
    defaultMessage: "Relation to the Patient",
  },
  checkIfConsentFromPatient: {
    id: "check_if_consent_from_patient",
    defaultMessage:
      "Please check this if you have got consent from the patient",
  },
  toDeleteStaffNote: {
    id: "to_delete_staff_note",
    defaultMessage:
      "Are you sure you want to delete the staff note? It will be permanently deleted from the system and can not be reverted.",
  },
  toDeleteStatus: {
    id: "to_delete_status",
    defaultMessage:
      "Are you sure you want to delete the status message? It will be permanently deleted from the system and can not be reverted.",
  },
  sureToRemove: {
    id: "sure_to_remove",
    defaultMessage: "Are you sure you want to remove",
  },
  admin: {
    id: "admin",
    defaultMessage: "Admin",
  },
  noMembers: {
    id: "no_members",
    defaultMessage: "No members yet",
  },
  newStaffNote: {
    id: "new_staff_note",
    defaultMessage: "New Staff Note",
  },
  newNote: {
    id: "new_note",
    defaultMessage: "New Note",
  },
  notes: {
    id: "notes",
    defaultMessage: "Notes",
  },
  smartNotes: {
    id: "smart_notes",
    defaultMessage: "Smart Notes",
  },
  smartDocuments: {
    id: "smart_documents",
    defaultMessage: "Smart Documents",
  },
  save_edits: {
    id: "save_edits",
    defaultMessage: "Save Edits",
  },
  in_progress: {
    id: "in_progress",
    defaultMessage: "In Progress",
  },
  no_drafts: {
    id: "no_drafts",
    defaultMessage: "No documents in progress",
  },
  one_draft: {
    id: "one_draft",
    defaultMessage: "1 document in progress",
  },
  drafts_count: {
    id: "drafts_count",
    defaultMessage: "{count} documents in progress",
  },
  last_modified_short: {
    id: "last_modified_short",
    defaultMessage: "Last modified",
  },
  last_modified_on: {
    id: "last_modified_on",
    defaultMessage: "Last modified on",
  },
  by: {
    id: "by",
    defaultMessage: "By",
  },
  document_saved: {
    id: "document_saved",
    defaultMessage: "Document saved",
  },
  last_modified: {
    id: "last_modified",
    defaultMessage: "Last modified {date} by {name}",
  },
  confirm_delete_draft: {
    id: "confirm_delete_draft",
    defaultMessage: "Delete this draft?",
  },
  staffNotes: {
    id: "staff_notes",
    defaultMessage: "Staff Notes",
  },
  newStatusMsg: {
    id: "new_status_msg",
    defaultMessage: "New status message",
  },

  confirmStaffNote: {
    id: "confirm_staff_note",
    defaultMessage: "Confirm adding Staff Note",
  },
  confirmNote: {
    id: "confirm_note",
    defaultMessage: "Confirm adding Note",
  },
  confirmStatus: {
    id: "confirm_status",
    defaultMessage: "Confirm Sending Message",
  },
  confirmUpdateStaffNoteQ: {
    id: "confirm_staff_note_q",
    defaultMessage: "Are you sure you want to update the Staff Note",
  },
  confirmUpdateNoteQ: {
    id: "confirm_note_q",
    defaultMessage: "Are you sure you want to update the Note",
  },
  confirmUpdateStatusQ: {
    id: "confirm_status_q",
    defaultMessage: "Are you sure you want to update the status message",
  },
  confirmUpdateStaffNote: {
    id: "confirm_upd_staff_note",
    defaultMessage: "Confirm updating Staff Note",
  },
  confirmUpdateStatus: {
    id: "confirm_upd_status",
    defaultMessage: "Confirm updating Status",
  },
  confirmUpdateNote: {
    id: "confirm_upd_note",
    defaultMessage: "Confirm updating Note",
  },
  by: {
    id: "by",
    defaultMessage: "by",
  },
  selectLibrary: {
    id: "select_library",
    defaultMessage: "Select Library",
  },
  selectConsentDocument: {
    id: "select_consent_document",
    defaultMessage: "Select Consent Document",
  },
  lastUpdatedOn: {
    id: "last_updated_on",
    defaultMessage: "Last Updated On",
  },
  assignedTo: {
    id: "assigned_to",
    defaultMessage: "Assigned to",
  },
  none: {
    id: "none",
    defaultMessage: "NONE",
  },
  reopen: {
    id: "reopen",
    defaultMessage: "Reopen",
  },
  reopenTask: {
    id: "reopenTask",
    defaultMessage: "Reopen Task",
  },
  sureToReopen: {
    id: "sure_to_reopen",
    defaultMessage: "Are you sure you want to reopen the task?",
  },
  reassignTask: {
    id: "reassign_task",
    defaultMessage: "Reassign Task",
  },
  editTask: {
    id: "edit_task",
    defaultMessage: "Edit Task",
  },
  taskAuditLogs: {
    id: "task_audit_logs",
    defaultMessage: "Task Audit Logs",
  },
  taskData: {
    id: "task_data",
    defaultMessage: "Task Data",
  },

  taskAccepted: {
    id: "task_accepted",
    defaultMessage: "Task has been accepted.",
  },
  taskAssigned: {
    id: "task_assigned",
    defaultMessage: "Task has been assigned to you.",
  },
  taskReassigned: {
    id: "task_reassigned",
    defaultMessage: "Task has been reassigned.",
  },
  taskMarkedComplete: {
    id: "task_marked_complete",
    defaultMessage: "Task has been marked complete.",
  },
  taskMandatoryFieldsMissing: {
    id: "task_mandatory_fields_missing",
    defaultMessage:
      "Complete the mandatory fields before you close this task: {fields}",
  },
  taskReopened: {
    id: "task_reopened",
    defaultMessage: "Task has been reopened.",
  },
  taskUpdated: {
    id: "task_updated",
    defaultMessage: "Task details have been updated.",
  },
  patientProfileDeactivated: {
    id: "patient_profile_deactivated",
    defaultMessage: "Patient profile has been de-activated.",
  },
  patientDeactivationProblems: {
    id: "patient_deactivation_problems",
    defaultMessage:
      "There were problems in de-activating the patient profile. Please try again later.",
  },
  patientRestored: {
    id: "patient_restored",
    defaultMessage: "Patient has been restored.",
  },
  patientRestorationProblems: {
    id: "patient_restoration_problems",
    defaultMessage:
      "There were problems in restoring the patient profile. Please try again later.",
  },
  natLoadPatient: {
    id: "nat_load_patient",
    defaultMessage: "Not able to load patient details. Please try again.",
  },
  inviteResent: {
    id: "invite_resent",
    defaultMessage: "Invite has been resent.",
  },
  credentialsReset: {
    id: "credentials_reset",
    defaultMessage: "Patient credentials have been reset.",
  },
  removedFromList: {
    id: "removed_from_list",
    defaultMessage: "Patient has been removed from your list.",
  },
  addedToList: {
    id: "added_to_list",
    defaultMessage: "Patient has been added to your list",
  },
  taskCreated: {
    id: "task_created",
    defaultMessage: "Task has been created",
  },
  memberRemoved: {
    id: "member_removed",
    defaultMessage: "Member has been removed",
  },
  memberAdded: {
    id: "member_added",
    defaultMessage: "Member has been added",
  },
  staffNotesUpdated: {
    id: "staff_notes_updated",
    defaultMessage: "Staff Note has been updated.",
  },
  noteUpdated: {
    id: "note_updated",
    defaultMessage: "Note has been updated.",
  },
  statusMessageUpdated: {
    id: "status_message_updated",
    defaultMessage: "Status Message has been updated.",
  },
  staffNotedDeleted: {
    id: "staff_noted_deleted",
    defaultMessage: "Staff Note has been deleted.",
  },
  statusMessageDeleted: {
    id: "status_message_deleted",
    defaultMessage: "Status Message has been deleted.",
  },
  profileUpdated: {
    id: "profileUpdated",
    defaultMessage: "Profile data has been updated.",
  },
  updateAttributeIntegerError: {
    id: "updateAttributeIntegerError",
    defaultMessage: "Entry Not valid (expected an Integer)",
  },
  document: {
    id: "document",
    defaultMessage: "Document",
  },
  documentAdded: {
    id: "document_added",
    defaultMessage: "Document has been added.",
  },
  documentDeleted: {
    id: "document_deleted",
    defaultMessage: "Document has been deleted.",
  },
  document_edited: {
    id: "document_edited",
    defaultMessage: "Document has been edited.",
  },
  fileUploadError: {
    defaultMessage:
      "There was a problem with file upload. Request might have timed out due to file size and slow network.",
    id: "file_upload_error",
  },
  upload_timed_out: {
    id: "upload_timed_out",
    defaultMessage: "Upload timed out. Please try again.",
  },
  patientAdded: {
    id: "patient_added",
    defaultMessage: "Patient {name} has been added.",
  },
  patientAddError: {
    id: "patient_add_error",
    defaultMessage: "Error while adding patient {name}. Please try again later",
  },
  staffNoteAdded: {
    id: "staff_note_added",
    defaultMessage: "Staff Note has been added.",
  },
  noteAdded: {
    id: "note_added",
    defaultMessage: "Your note has been added.",
  },
  statusAdded: {
    id: "status_added",
    defaultMessage: "Status message has been sent.",
  },
  addMemberError: {
    id: "add_member_error",
    defaultMessage: "Could not add member. Please try again.",
  },
  editStatusMessage: {
    id: "edit_status_message",
    defaultMessage: "Edit Status Message",
  },
  editStaffNote: {
    id: "edit_staff_note",
    defaultMessage: "Edit Staff Note",
  },
  editNote: {
    id: "edit_note",
    defaultMessage: "Edit Note",
  },
  createAppointment: {
    id: "create_appointment",
    defaultMessage: "New Booking",
  },
  ch_appointment_template: {
    id: "ch_appointment_template",
    defaultMessage: "Choose Appointment Template",
  },
  ch_appt_schedule: {
    id: "ch_appt_schedule",
    defaultMessage: "Choose Appointment Schedule",
  },
  appointment_slot: {
    id: "appointment_slot",
    defaultMessage: "Choose Appointment Slot",
  },
  appointment_details: {
    id: "appointment_details",
    defaultMessage: "Appointment Details",
  },

  patient_name: {
    id: "patient_name",
    defaultMessage: "Patient Name",
  },
  appointment_type: {
    id: "appointment_type",
    defaultMessage: "Appointment Type",
  },
  appointment_time: {
    id: "appointment_time",
    defaultMessage: "Appointment Time",
  },
  set_appointment_time: {
    id: "set_appointment_time",
    defaultMessage: "Please set valid Appointment date and time",
  },
  participants: {
    id: "participants",
    defaultMessage: "Participants",
  },
  appointment_desc: {
    id: "appointment_desc",
    defaultMessage: "Appointment Description",
  },
  set_appointment_desc: {
    id: "set_appointment_desc",
    defaultMessage: "Please set Appointment description",
  },
  comments: {
    id: "comments",
    defaultMessage: "Comments",
  },
  patient_instructions: {
    id: "patient_instructions",
    defaultMessage: "Patient Instructions",
  },

  medium: {
    id: "medium",
    defaultMessage: "Medium",
  },
  high: {
    id: "high",
    defaultMessage: "High",
  },
  appt_created: {
    id: "appt_created",
    defaultMessage: "Appointment has been created.",
  },
  slot_not_free: {
    id: "slot_not_free",
    defaultMessage: "Please select a free slot.",
  },
  changePatient: {
    id: "change_patient",
    defaultMessage: "Change Patient",
  },
  selectExistingPatient: {
    id: "select_existing_patient",
    defaultMessage: "Select Existing Patient",
  },
  create_without_schedule: {
    id: "create_without_schedule",
    defaultMessage: "Create Without Schedule",
  },
  view_schedules: {
    id: "view_schedules",
    defaultMessage: "View All Schedules",
  },
  no_template: {
    id: "no_template",
    defaultMessage: "No Template",
  },
  sendMessages: { id: "send_messages", defaultMessage: "Send Messages" },
  proposed: { id: "proposed", defaultMessage: "Proposed" },
  booked: { id: "booked", defaultMessage: "Booked" },
  fulfilled: { id: "fulfilled", defaultMessage: "Fulfilled" },
  cancelled: { id: "cancelled", defaultMessage: "Cancelled" },
  no_show: { id: "no_show", defaultMessage: "No Show" },
  rebooked: { id: "rebooked", defaultMessage: "Re-Booked" },
  appointment_status: {
    id: "appointment_status",
    defaultMessage: "Appointment Status",
  },
  appointmentUpdated: {
    id: "appointment_updated",
    defaultMessage: "Appointment has been updated.",
  },
  editAppointment: {
    id: "edit_appointment",
    defaultMessage: "Edit Appointment",
  },
  cancel_appointment: {
    id: "cancel_appointment",
    defaultMessage: "Cancel Appointment",
  },
  appointmentCancelled: {
    id: "appointment_cancelled",
    defaultMessage: "Appointment has been cancelled.",
  },
  toCancelAppointment: {
    id: "to_cancel_appointment",
    defaultMessage: "Are you sure you want to cancel the appointment?",
  },
  fa_patient: {
    id: "fa_patient",
    defaultMessage: "Patient",
  },
  fa_change: {
    id: "fa_change",
    defaultMessage: "Change",
  },
  fa_name: {
    id: "fa_name",
    defaultMessage: "Name",
  },
  fa_set_name: {
    id: "fa_set_name",
    defaultMessage: "Please set name",
  },
  fa_title: {
    id: "fa_title",
    defaultMessage: "Title",
  },
  fa_comments: {
    id: "fa_comments",
    defaultMessage: "Comments",
  },
  fa_setTitle: {
    id: "fa_setTitle",
    defaultMessage: "Please set title",
  },
  fa_description: {
    id: "fa_Description",
    defaultMessage: "Description",
  },
  fa_set_description: {
    id: "fa_set_description",
    defaultMessage: "Please set description",
  },
  fa_status_message: {
    id: "fa_status_message",
    defaultMessage: "Status Message",
  },
  fa_type: {
    id: "fa_type",
    defaultMessage: "Type",
  },
  fa_set_type: {
    id: "fa_set_type",
    defaultMessage: "Please set type",
  },
  fa_set_status: {
    id: "fa_set_status",
    defaultMessage: "Please set status message",
  },
  fa_survey: {
    id: "fa_survey",
    defaultMessage: "Survey",
  },
  fa_set_survey: {
    id: "fa_set_survey",
    defaultMessage: "Please set survey",
  },
  fa_status_template: {
    id: "fa_status_template",
    defaultMessage: "Status Template",
  },
  fa_set_status_template: {
    id: "fa_set_status_template",
    defaultMessage: "Please set status template",
  },
  fa_library: {
    id: "fa_library",
    defaultMessage: "Library",
  },
  fa_set_library: {
    id: "fa_set_library",
    defaultMessage: "Please set library",
  },
  fa_care_plan: {
    id: "fa_care_plan",
    defaultMessage: "Care Plan",
  },
  fa_set_care_plan: {
    id: "fa_set_care_plan",
    defaultMessage: "Please set care plan",
  },
  fa_ui_attribute: {
    id: "fa_ui_attribute",
    defaultMessage: "UI Attribute",
  },
  fa_set_ui_attribute: {
    id: "fa_set_ui_attribute",
    defaultMessage: "Please set UI attribute.",
  },
  fa_consent_document: {
    id: "fa_consent_document",
    defaultMessage: "Consent Document",
  },
  fa_set_consent_document: {
    id: "fa_set_consent_document",
    defaultMessage: "Please set consent document",
  },
  fa_task_template: {
    id: "fa_task_template",
    defaultMessage: "Task Template",
  },
  fa_set_task_template: {
    id: "fa_set_task_template",
    defaultMessage: "Please set task template",
  },
  fa_send_as_status: {
    id: "fa_send_as_status",
    defaultMessage: "Send As Status Message",
  },
  fa_select_survey: {
    id: "fa_select_survey",
    defaultMessage: "Select Survey",
  },
  fa_select_library: {
    id: "fa_select_library",
    defaultMessage: "Select Library",
  },
  fa_select_care_plan: {
    id: "fa_select_care_plan",
    defaultMessage: "Select Care Plan",
  },
  fa_select_consent: {
    id: "fa_select_consent",
    defaultMessage: "Select Consent Document",
  },
  fa_select_task: {
    id: "fa_select_task",
    defaultMessage: "Select Task",
  },
  fa_select_task_template: {
    id: "fa_select_task_template",
    defaultMessage: "Select Task Template",
  },
  fa_not_able_to_find: {
    id: "fa_not_able_to_find",
    defaultMessage: "Not able to find what you are looking for?",
  },
  fa_create_library: {
    id: "fa_create_library",
    defaultMessage: "Create a Library",
  },
  fa_instead: {
    id: "fa_instead",
    defaultMessage: "instead",
  },
  fa_create: {
    id: "fa_create",
    defaultMessage: "Create",
  },
  fa_appointment_schedule: {
    id: "fa_appointment_schedule",
    defaultMessage: "Appointment Schedule",
  },
  fa_new_appointment_schedule: {
    id: "fa_new_appointment_schedule",
    defaultMessage: "New Appointment Schedule",
  },
  fa_appointment_schedules: {
    id: "fa_appointment_schedules",
    defaultMessage: "Appointment Schedules",
  },
  fa_appointment_templates: {
    id: "fa_appointment_templates",
    defaultMessage: "Appointment Templates",
  },
  fa_patient_type: {
    id: "fa_patient_type",
    defaultMessage: "Patient Type",
  },
  fa_new_schedule: {
    id: "fa_new_schedule",
    defaultMessage: "New Schedule",
  },

  fa_set_participants: {
    id: "fa_set_participants",
    defaultMessage: "Please set participants",
  },

  fa_staff: {
    id: "fa_staff",
    defaultMessage: "Staff",
  },

  fa_remove: {
    id: "fa_remove",
    defaultMessage: "Remove",
  },
  fa_duration: {
    id: "fa_duration",
    defaultMessage: "Duration",
  },
  fa_set_duration: {
    id: "fa_set_duration",
    defaultMessage: "Please set duration",
  },
  fa_from: {
    id: "fa_from",
    defaultMessage: "From",
  },
  fa_to: {
    id: "fa_to",
    defaultMessage: "To",
  },
  fa_slot_interval: {
    id: "fa_slot_interval",
    defaultMessage: "Slot Duration",
  },
  fa_schedule: {
    id: "fa_schedule",
    defaultMessage: "Schedule",
  },
  fa_set_slot_interval: {
    id: "fa_set_slot_interval",
    defaultMessage: "Please set Slot Duration",
  },
  fa_appointment_slots: {
    id: "fa_appointment_slots",
    defaultMessage: "Appointment Slots",
  },
  fa_status: {
    id: "fa_status",
    defaultMessage: "Status",
  },
  fa_submit: {
    id: "fa_submit",
    defaultMessage: "Submit",
  },
  fa_schedule_created: {
    id: "fa_schedule_created",
    defaultMessage: "Appointment Schedule has been created.",
  },
  fa_schedule_edited: {
    id: "fa_schedule_edited",
    defaultMessage: "Appointment Schedule has been edited.",
  },
  fa_slot_updated: {
    id: "fa_slot_updated",
    defaultMessage: "Slot has been updated.",
  },
  fa_slot_deleted: {
    id: "fa_slot_deleted",
    defaultMessage: "Slot has been deleted.",
  },
  fa_delete_slot: {
    id: "fa_delete_slot",
    defaultMessage: "Delete Slot",
  },
  fa_delete_slots: {
    id: "fa_delete_slots",
    defaultMessage: "Delete Slots",
  },
  fa_delete_slots_message: {
    id: "fa_delete_slots_message",
    defaultMessage:
      "Are you sure you want to delete the slots? When no participants given, it will delete all the slots for the given date range.",
  },
  fa_delete_slot_message: {
    id: "fa_delete_slot_message",
    defaultMessage: "Are you sure you want to delete the Slot?",
  },
  fa_create_slots: {
    id: "fa_create_slots",
    defaultMessage: "Create Slots",
  },
  fa_repeat: {
    id: "fa_repeat",
    defaultMessage: "Repeat",
  },
  fa_set_from_to_date: {
    id: "fa_set_from_to_date",
    defaultMessage: "Please set from and to date",
  },
  fa_set_day_repeat: {
    id: "fa_set_day_repeat",
    defaultMessage: "Please set the day",
  },
  fa_edit_slot: {
    id: "fa_edit_slot",
    defaultMessage: "Edit Slot",
  },
  mins: {
    id: "mins",
    defaultMessage: "Mins",
  },
  fa_slot_interval_15: {
    id: "fa_slot_interval_15",
    defaultMessage: "15 Mins",
  },
  fa_slot_interval_20: {
    id: "fa_slot_interval_20",
    defaultMessage: "20 Mins",
  },
  fa_slot_interval_30: {
    id: "fa_slot_interval_30",
    defaultMessage: "30 Mins",
  },
  fa_slot_interval_45: {
    id: "fa_slot_interval_45",
    defaultMessage: "45 Mins",
  },
  fa_slot_interval_60: {
    id: "fa_slot_interval_60",
    defaultMessage: "1 Hour",
  },
  fa_slot_interval_90: {
    id: "fa_slot_interval_90",
    defaultMessage: "1 Hour and 30 Mins",
  },
  fa_slot_interval_120: {
    id: "fa_slot_interval_120",
    defaultMessage: "2 Hours",
  },
  fa_slot_interval_150: {
    id: "fa_slot_interval_150",
    defaultMessage: "2 Hours and 30 Mins",
  },
  fa_slot_interval_180: {
    id: "fa_slot_interval_180",
    defaultMessage: "3 Hours",
  },
  fa_slot_repeat_all: {
    id: "fa_slot_repeat_all",
    defaultMessage: "All Days",
  },
  fa_slot_repeat_week: {
    id: "fa_slot_repeat_week",
    defaultMessage: "Every Monday, Tuesday, Wednesday, Thursday and Friday",
  },
  fa_slot_repeat_mwf: {
    id: "fa_slot_repeat_mwf",
    defaultMessage: "Every Monday, Wednesday and Friday",
  },
  fa_slot_repeat_twt: {
    id: "fa_slot_repeat_twt",
    defaultMessage: "Every Tuesday, Wednesday and Thursday",
  },
  fa_slot_repeat_tt: {
    id: "fa_slot_repeat_tt",
    defaultMessage: "Every Tuesday and Thursday",
  },
  fa_slot_repeat_mon: {
    id: "fa_slot_repeat_mon",
    defaultMessage: "Every Monday",
  },
  fa_slot_repeat_tue: {
    id: "fa_slot_repeat_tue",
    defaultMessage: "Every Tuesday",
  },
  fa_slot_repeat_wed: {
    id: "fa_slot_repeat_wed",
    defaultMessage: "Every Wednesday",
  },
  fa_slot_repeat_thu: {
    id: "fa_slot_repeat_thu",
    defaultMessage: "Every Thursday",
  },
  fa_slot_repeat_fri: {
    id: "fa_slot_repeat_fri",
    defaultMessage: "Every Friday",
  },
  fa_slot_repeat_sat: {
    id: "fa_slot_repeat_sat",
    defaultMessage: "Every Saturday",
  },
  fa_slot_repeat_sun: {
    id: "fa_slot_repeat_sun",
    defaultMessage: "Every Sunday",
  },
  fa_slot_status_busy: {
    id: "fa_slot_status_busy",
    defaultMessage: "Busy",
  },
  fa_slot_status_free: {
    id: "fa_slot_status_free",
    defaultMessage: "Free",
  },
  fa_slot_status_busyua: {
    id: "fa_slot_status_busyua",
    defaultMessage: "Busy Unavailable",
  },
  fa_slot_status_busytt: {
    id: "fa_slot_status_busytt",
    defaultMessage: "Busy Tentative",
  },

  fa_slot_status_busy_reserved: {
    id: "fa_slot_status_busy_reserved",
    defaultMessage: "Busy (Reserved)",
  },

  fa_slot_status_error: {
    id: "fa_slot_status_error",
    defaultMessage: "Entered In Error",
  },
  fa_appt_template: {
    id: "fa_appt_template",
    defaultMessage: "Appointment Template",
  },
  fa_edit_appt_template: {
    id: "fa_edit_appt_template",
    defaultMessage: "Edit Appointment Template",
  },
  fa_new_appt_template: {
    id: "fa_new_appt_template",
    defaultMessage: "New Appointment Template",
  },
  fa_template_created: {
    id: "fa_template_created",
    defaultMessage: "Appointment Template has been created.",
  },
  fa_template_edited: {
    id: "fa_template_edited",
    defaultMessage: "Appointment Template has been edited.",
  },

  fa_appointment_desc: {
    id: "fa_appointment_desc",
    defaultMessage: "Appointment Description",
  },

  fa_patient_instructions: {
    id: "fa_patient_instructions",
    defaultMessage: "Patient Instructions",
  },
  fa_low: {
    id: "fa_low",
    defaultMessage: "Low",
  },
  fa_medium: {
    id: "fa_medium",
    defaultMessage: "Medium",
  },
  fa_high: {
    id: "fa_high",
    defaultMessage: "High",
  },
  fa_priority: { id: "fa_priority", defaultMessage: "Priority" },
  fa_patient_types: {
    id: "fa_patient_types",
    defaultMessage: "Patient Types",
  },
  fa_appointment_type: {
    id: "fa_appointment_type",
    defaultMessage: "Appointment Type",
  },
  fa_visibility: {
    id: "fa_visibility",
    defaultMessage: "Visibility",
  },
  fa_confirmation_email_sub: {
    id: "fa_confirmation_email_sub",
    defaultMessage: "Confirmation Email Subject",
  },
  fa_confirmation_email_content: {
    id: "fa_confirmation_email_content",
    defaultMessage: "Confirmation Email Content",
  },
  fa_confirmation_sms_content: {
    id: "fa_confirmation_sms_content",
    defaultMessage: "Confirmation SMS Content",
  },

  fa_confirmation_messages: {
    id: "fa_confirmation_messages",
    defaultMessage: " Confirmation Messages",
  },
  fa_reminders_config: {
    id: "fa_reminders_config",
    defaultMessage: "Reminders Configuration",
  },
  fa_slots_created: {
    id: "fa_slots_created",
    defaultMessage: "Slots have been created.",
  },
  fa_edit: {
    id: "fa_edit",
    defaultMessage: "Edit",
  },
  fa_template_deleted: {
    id: "fa_template_deleted",
    defaultMessage: "Template has been deleted.",
  },
  fa_delete_template_error: {
    id: "fa_delete_template_error",
    defaultMessage:
      "Error while deleting the template. Please try again later.",
  },

  fa_delete_template: {
    id: "fa_delete_template",
    defaultMessage: "Delete Template",
  },
  to_delete_template: {
    id: "to_delete_template",
    defaultMessage:
      "Are you sure you want to delete the appointment template? It will be permanently deleted from the system and can not be reverted.",
  },
  fa_delete_schedule: {
    id: "fa_delete_schedule",
    defaultMessage: "Delete Schedule",
  },
  fa_delete_schedule_message: {
    id: "fa_delete_schedule_message",
    defaultMessage: "Are you sure you wan to delete the Schedule?",
  },
  fa_schedule_deleted: {
    id: "fa_schedule_deleted",
    defaultMessage: "Appointment Schedule has been deleted.",
  },
  active: {
    id: "active",
    defaultMessage: "Active",
  },
  active_uc: {
    id: "active_uc",
    defaultMessage: "ACTIVE",
  },
  inactive: {
    id: "inactive",
    defaultMessage: "Inactive",
  },
  set_appointment_description: {
    id: "set_appointment_description",
    defaultMessage: "Please set Appointment description",
  },
  set_appointment_type: {
    id: "set_appointment_type",
    defaultMessage: "Please set Appointment type",
  },
  invitation_expired_uc: {
    id: "invitation_expired_uc",
    defaultMessage: "INVITATION EXPIRED",
  },
  active__internal_uc: {
    id: "active__internal_uc",
    defaultMessage: "ACTIVE INTERNAL",
  },
  pending_invitation_uc: {
    id: "pending_invitation_uc",
    defaultMessage: "PENDING INVITATION",
  },
  invite_sent_date: {
    id: "invite_sent_date",
    defaultMessage: "Sent on {date}",
  },
  mrn_w_value: {
    id: "mrn_w_value",
    defaultMessage: "MRN: {mrnNumber}",
  },
  attention_required_uc: {
    id: "attention_required_uc",
    defaultMessage: "ATTENTION REQUIRED",
  },
  monitor_uc: {
    id: "monitor_uc",
    defaultMessage: "MONITOR",
  },
  on_track_uc: {
    id: "on_track_uc",
    defaultMessage: "ON TRACK",
  },
  multi_group_column: {
    id: "multi_group_column",
    defaultMessage: " Multi Group Column",
  },
  multi_group_value_column: {
    id: "multi_group_value_column",
    defaultMessage: " Multi Group Value Column",
  },
  small: {
    id: "small",
    defaultMessage: "Small",
  },
  standard: {
    id: "standard",
    defaultMessage: "Standard",
  },
  use_free_text: {
    id: "use_free_text",
    defaultMessage: "Use freetext",
  },
  medication_name: {
    id: "medication_name",
    defaultMessage: "Drug Name",
  },
  medication_type: {
    id: "medication_type",
    defaultMessage: "Route",
  },
  show_descriptions: {
    id: "show_descriptions",
    defaultMessage: "Show descriptions",
  },
  last_result: {
    id: "last_result",
    defaultMessage: "Last result",
  },
  patient_updated: {
    id: "patient_updated",
    defaultMessage: "Patient has been updated.",
  },
  invalid_number: {
    id: "invalid_number",
    defaultMessage: "This field must be a number.",
  },
  invalid_integer_number: {
    id: "invalid_integer_number",
    defaultMessage: "This field must be a integer number.",
  },
  monitoring_data: {
    id: "monitoring_data",
    defaultMessage: "Monitoring Data",
  },
  required_field: {
    id: "required_field",
    defaultMessage: "This field is required.",
  },
  comorbidity_deleted: {
    id: "comorbidity_deleted",
    defaultMessage: "Comorbidity has been deleted.",
  },
  comorbidities_updated: {
    id: "comorbidities_updated",
    defaultMessage: "Comorbidities has been updated.",
  },
  comorbidities_w_count: {
    id: "comorbidities_w_count",
    defaultMessage: "{count} Comorbidities",
  },
  task_status: {
    id: "task_status",
    defaultMessage: "Task status",
  },
  open_uc: {
    id: "open_uc",
    defaultMessage: "OPEN",
  },
  search_name: {
    id: "search_name",
    defaultMessage: "Search name",
  },
  valid_answer: {
    id: "valid_answer",
    defaultMessage: "Please enter a valid answer for ",
  },
  choose_option: {
    id: "choose_option",
    defaultMessage: "Choose an option",
  },
  allow_reply: {
    id: "allow_reply",
    defaultMessage: "Allow Reply?",
  },
  show_favourites: {
    id: "show_favourites",
    defaultMessage: "Show Favourites",
  },
  hide_favourites: {
    id: "hide_favourites",
    defaultMessage: "Hide Favourites",
  },
  enableAI: {
    id: "enable_ai",
    defaultMessage: "Enable AI",
  },
  comorbidity: {
    id: "comorbidity",
    defaultMessage: "Comorbidity",
  },
  severity: {
    id: "severity",
    defaultMessage: "Severity",
  },
  impact: {
    id: "impact",
    defaultMessage: "Impact",
  },
  other_values: {
    id: "other_values",
    defaultMessage: "Other values",
  },
  show_in_dashboard: {
    id: "show_in_dashboard",
    defaultMessage: "Show in Dahboard",
  },
  thanks_external_submission: {
    id: "thanks_external_submission",
    defaultMessage: "Thank you for your submission, you may close this window",
  },
  show_on_humanoid: {
    id: "show_on_humanoid",
    defaultMessage: "Show on humanoid",
  },
  other_diseases: {
    id: "other_diseases",
    defaultMessage: "Other Diseases",
  },
  create_automated_task: {
    id: "create_automated_task",
    defaultMessage: "Create New Automated Task",
  },
  notes_data: {
    id: "notes_data",
    defaultMessage: "Notes/Data",
  },
  words: {
    id: "words",
    defaultMessage: "Words",
  },
  lines: {
    id: "lines",
    defaultMessage: "Lines",
  },
  limit_reached: {
    id: "limit_reached",
    defaultMessage: "Limit Reached",
  },
  episode: {
    id: "episode",
    defaultMessage: "Episode",
  },
  assessment_already_completed: {
    id: "assessment_already_completed",
    defaultMessage: "You have already completed this assessment.",
  },
  review_completed_assessment: {
    id: "review_completed_assessment",
    defaultMessage: "Review completed assessment.",
  },
  latest: {
    id: "latest",
    defaultMessage: "Latest",
  },
  highest: {
    id: "highest",
    defaultMessage: "Highest",
  },
  admission: {
    id: "admission",
    defaultMessage: "Admission",
  },
  discharge: {
    id: "discharge",
    defaultMessage: "Discharge",
  },
  length_of_stay: {
    id: "length_of_stay",
    defaultMessage: "Length Of Stay",
  },
  interactions: {
    id: "interactions",
    defaultMessage: "Interactions",
  },
  episode_deleted: {
    id: "episode_deleted",
    defaultMessage: "Episode has been deleted.",
  },
  episode_updated: {
    id: "episode_updated",
    defaultMessage: "Episode has been updated.",
  },
  admission_date: {
    id: "admission_date",
    defaultMessage: "Admission Date",
  },
  discharge_date: {
    id: "discharge_date",
    defaultMessage: "Discharge Date",
  },
  hospitalisation_reason: {
    id: "hospitalisation_reason",
    defaultMessage: "Hospitalisation Reason",
  },
  hospitalisation_description: {
    id: "hospitalisation_description",
    defaultMessage: "Hospitalisation Description",
  },
  hospitalisation_outcome: {
    id: "hospitalisation_outcome",
    defaultMessage: "Hospitalisation Outcome",
  },
  reason: {
    id: "reason",
    defaultMessage: "Reason",
  },
  outcome: {
    id: "outcome",
    defaultMessage: "Outcome",
  },
  episode_delete_confirm: {
    id: "episode_delete_confirm",
    defaultMessage: "Are you sure you want to delete this episode?",
  },
  add_treatment: {
    id: "add_treatment",
    defaultMessage: "Add Treatment",
  },
  delete_treatment: {
    id: "delete_treatment",
    defaultMessage: "Delete Treatment",
  },
  edit_treatment: {
    id: "edit_treatment",
    defaultMessage: "Edit Treatment",
  },
  not_live_chat: {
    id: "not_live_chat",
    defaultMessage: "Not a live chat",
  },
  enter_message: {
    id: "enter_message",
    defaultMessage: "Enter message",
  },
  new_messages: {
    id: "new_messages",
    defaultMessage: "New messages",
  },
  adherence_report: {
    id: "adherence_report",
    defaultMessage: "Adherence Report",
  },
  hse_adherence_report: {
    id: "hse_adherence_report",
    defaultMessage: "HSE Adherence",
  },
  hosp_no: {
    id: "hosp_no",
    defaultMessage: "Hosp No.",
  },
  no_days_on_treatment: {
    id: "no_days_on_treatment",
    defaultMessage: "#Days On Treatment",
  },
  traffic_light_category: {
    id: "traffic_light_category",
    defaultMessage: "Traffic Light Category",
  },
  no_contacts_with_patients: {
    id: "no_contacts_with_patients",
    defaultMessage: "#Times Contacted",
  },
  last_contact_attempt_date: {
    id: "last_contact_attempt_date",
    defaultMessage: "Last Contact Attempted",
  },
  hospital: {
    id: "hospital",
    defaultMessage: "Hospital",
  },
  episodes_of_care: {
    id: "episodes-of-care",
    defaultMessage: "EPISODES OF CARE",
  },
  no_episodes_of_care: {
    id: "no_episodes_of_care",
    defaultMessage: "No Episodes of Care",
  },
  choose_option: {
    id: "choose_option",
    defaultMessage: "Choose an option",
  },
  allow_reply: {
    id: "allow_reply",
    defaultMessage: "Allow Reply?",
  },
  reported: {
    id: "reported",
    defaultMessage: "Reported:",
  },
  test_name: {
    id: "test_name",
    defaultMessage: "Test Name",
  },
  result: {
    id: "result",
    defaultMessage: "Result",
  },
  unit: {
    id: "unit",
    defaultMessage: "Unit",
  },
  reference: {
    id: "reference",
    defaultMessage: "Reference",
  },
  comment: {
    id: "comment",
    defaultMessage: "Comment",
  },
  import_medications: {
    id: "import_medications",
    defaultMessage: "Import Medications",
  },
  import_surveys: {
    id: "import_surveys",
    defaultMessage: "Import Surveys",
  },
  video_call_options: {
    id: "video_call_options",
    defaultMessage: "Start now or schedule for later?",
  },
  video_call_now: {
    id: "video_call_now",
    defaultMessage: "Start video call now?",
  },
  chart: {
    id: "chart",
    dafaultMessage: "Chart",
  },
  last_result: {
    id: "last_result",
    defaultMessage: "Last Result",
  },
  no_matching_items: {
    id: "no_matching_items",
    defaultMessage: "No matching items in profile",
  },
  done_please_refresh: {
    id: "done_please_refresh",
    defaultMessage:
      "Submitted successfully. Please refresh the page to see the changes.",
  },
  password_has_been_reset: {
    id: "password_has_been_reset",
    defaultMessage:
      "Your password has been reset. Please use the new password to login.",
  },
  mark_stopped: {
    id: "mark_stopped",
    defaultMessage: "Mark Stopped",
  },
  mark_active: {
    id: "mark_active",
    defaultMessage: "Mark Active",
  },
  male: {
    id: "male",
    defaultMessage: "MALE",
  },
  female: {
    id: "female",
    defaultMessage: "FEMALE",
  },
  other: {
    id: "other",
    defaultMessage: "OTHER",
  },
  my_patients: {
    id: "my_patients",
    defaultMessage: "My Patients",
  },
  no_gp_email: {
    id: "no_gp_email",
    defaultMessage: "No GP Email present for patient",
  },
  no_gp_phone: {
    id: "no_gp_phone",
    defaultMessage: "No GP Phone number present for patient",
  },
  mark_as_complete: {
    id: "mark_as_complete",
    defaultMessage: "Mark as complete",
  },
  use_previous_inputs_warning: {
    id: "use_previous_inputs_warning",
    defaultMessage:
      "Loaded previous submission responses. Please verify and change as needed.",
  },
  period: {
    id: "period",
    defaultMessage: "Period",
  },
  organization_restrict_visibility: {
    id: "organization_restrict_visibility",
    defaultMessage:
      "Restrict patient visibility to individual doctors (or their teams) within this organization",
  },
  start: {
    id: "start",
    defaultMessage: "Start",
  },
  end: {
    id: "end",
    defaultMessage: "End",
  },
  use_the_form_below: {
    id: "use_the_form_below",
    defaultMessage: "Use the form below",
  },
  hide_edit_mode: {
    id: "hide_edit_mode",
    defaultMessage: "Hide Edit Mode",
  },
  show_edit_mode: {
    id: "show_edit_mode",
    defaultMessage: "Show Edit Mode",
  },
  stopped: {
    id: "stopped",
    defaultMessage: "STOPPED",
  },
  no_pending_actions: {
    id: "no_pending_actions",
    defaultMessage: "No pending actions.",
  },
  please_set_medication: {
    id: "please_set_medication",
    defaultMessage: "Please set medication",
  },
  treatment_added: {
    id: "treatment_added",
    defaultMessage: "Treatment has been added",
  },
  treatment_deleted: {
    id: "treatment_deleted",
    defaultMessage: "Treatment has been deleted",
  },
  treatment_updated: {
    id: "treatment_updated",
    defaultMessage: "Treatment has been updated",
  },
  actions_uc: {
    id: "actions_uc",
    defaultMessage: "ACTIONS",
  },
  feet: {
    id: "feet",
    defaultMessage: "Feet",
  },
  noResponse: {
    id: "noResponse",
    defaultMessage: "NO RESPONSE",
  },
  book_same_day_reoccurance: {
    id: "book_same_day_reoccurance",
    defaultMessage: "Book Same Day [Recurrence]",
  },
  reschedule_series: {
    id: "reschedule_series",
    defaultMessage: "Reschedule Series",
  },
  search_profile: {
    id: "search_profile",
    defaultMessage: "Search Profile",
  },
  grid_view: {
    id: "grid_view",
    defaultMessage: "Grid",
  },
  hide_uc: {
    id: "hide_uc",
    defaultMessage: "HIDE",
  },
  show_uc: {
    id: "show_uc",
    defaultMessage: "SHOW",
  },
  processing_please_wait: {
    id: "processing_please_wait",
    defaultMessage:
      "Processing your request to export survey {survey}. This may take some time. Please wait",
  },
  export_survey: {
    id: "export_survey",
    defaultMessage:
      "Survey Exported. CSV will be available for download in 'Documents'",
  },
  group_by_day: {
    id: "group_by_day",
    defaultMessage: "Group by day",
  },
  empty_survey_response: {
    id: "empty_survey_response",
    defaultMessage: "No Data available for the selected period",
  },
  full_day_view: {
    id: "full_day_view",
    defaultMessage: "Full Day View",
  },
  update_staff: {
    id: "update_staff",
    defaultMessage: "Update Staff",
  },
  notify_staff: {
    id: "notify_staff",
    defaultMessage: "Notify Staff",
  },
  update_driver: {
    id: "update_driver",
    defaultMessage: "Update Driver",
  },
  notify_driver: {
    id: "notify_driver",
    defaultMessage: "Notify Driver",
  },
  staff_notified: {
    id: "staff_notified",
    defaultMessage: "The staff has been notified.",
  },
  staff_updated: {
    id: "staff_updated",
    defaultMessage: "Staff participants have been updated.",
  },
  auto_ai_translate_warning: {
    id: "auto_ai_translate_warning",
    defaultMessage: "Answers to this survey may have been translated using AI.",
  },
  response_translated_ai: {
    id: "response_translated_ai",
    defaultMessage: "Response translated by AI.",
  },
  previous_value: {
    id: "previous_value",
    defaultMessage: "Previous value",
  },
  new_value: {
    id: "new_value",
    defaultMessage: "New value",
  },
  author: {
    id: "author",
    defaultMessage: "Author",
  },
  show_table: {
    id: "show_table",
    defaultMessage: "Show Table",
  },
  show_chart: {
    id: "show_chart",
    defaultMessage: "Show Chart",
  },
  history: {
    id: "history",
    defaultMessage: "History",
  },
  activities_to_be_completed: {
    id: "activities_to_be_completed",
    defaultMessage: "Activities to be completed by the patient",
  },
  auto_translated: {
    id: "auto_translated",
    defaultMessage: "This field has been auto translated.",
  },
  overview_uc: {
    id: "overview_uc",
    defaultMessage: "OVERVIEW",
  },
  goals_uc: {
    id: "goals_uc",
    defaultMessage: "GOALS",
  },
  smart_goal: {
    id: "smart_goal",
    defaultMessage: "SMART Goal",
  },
  goal_name: {
    id: "goal_name",
    defaultMessage: "Goal Name",
  },
  goal_template: {
    id: "goal_template",
    defaultMessage: "Create goal from template?",
  },
  goal_data: {
    id: "goal_data",
    defaultMessage: "Goal Data",
  },
  gas_goal: {
    id: "gas_goal",
    defaultMessage: "GAS Goal",
  },
  baseline: {
    id: "baseline",
    defaultMessage: "Baseline",
  },
  gas_importance: {
    id: "gas_importance",
    defaultMessage: "Importance",
  },
  gas_difficulty: {
    id: "gas_difficulty",
    defaultMessage: "Difficulty",
  },
  gas_baseline_achieved: {
    id: "gas_baseline_achieved",
    defaultMessage: "Baseline Achieved?",
  },
  gas_variance: {
    id: "gas_variance",
    defaultMessage: "Variance",
  },
  goal_status: {
    id: "goal_status",
    defaultMessage: "Goal Status",
  },
  goal_category: {
    id: "goal_category",
    defaultMessage: "Goal Category",
  },
  achievement_status: {
    id: "achievement_status",
    defaultMessage: "Goal Achievement Status",
  },
  status_reason: {
    id: "status_reason",
    defaultMessage: "Status Reason",
  },
  goal_priority: {
    id: "goal_priority",
    defaultMessage: "Goal Priority",
  },
  intervention_level_support: {
    id: "intervention_level_support",
    defaultMessage: "Level of Support",
  },
  intervention_type: {
    id: "intervention_type",
    defaultMessage: "Intervention Type",
  },
  intervention_status: {
    id: "intervention_status",
    defaultMessage: "Status",
  },
  enter_goal_name: {
    id: "enter_goal_name",
    defaultMessage: "Enter goal name",
  },
  enter_status_reason: {
    id: "enter_status_reason",
    defaultMessage: "Enter status reason",
  },
  select_option: {
    id: "select_option",
    defaultMessage: "Select...",
  },
  add_new_goal: {
    id: "add_new_goal",
    defaultMessage: "Add New Goal",
  },
  all_goals: {
    id: "all_goals",
    defaultMessage: "All",
  },
  completed_goals: {
    id: "completed_goals",
    defaultMessage: "Completed",
  },
  no_goals_available: {
    id: "no_goals_available",
    defaultMessage: "No goals available.",
  },
  new_goal: {
    id: "new_goal",
    defaultMessage: "New Goal",
  },
  new_sub_goal: {
    id: "new_sub_goal",
    defaultMessage: "New Sub Goal",
  },
  delete_goal: {
    id: "delete_goal",
    defaultMessage: "Delete Goal",
  },
  delete_goal_confirmation: {
    id: "delete_goal_confirmation",
    defaultMessage: "Are you sure you want to delete this goal?",
  },
  interventions: {
    id: "interventions",
    defaultMessage: "Interventions",
  },
  no_goal_data: {
    id: "no_goal_data",
    defaultMessage: "No goal data available.",
  },
  subgoals: {
    id: "subgoals",
    defaultMessage: "Subgoals",
  },
  subgoal: {
    id: "subgoal",
    defaultMessage: "Subgoal",
  },
  no_subgoals: {
    id: "no_subgoals",
    defaultMessage: "No subgoals available.",
  },
  progress: {
    id: "progress",
    defaultMessage: "Progress",
  },
  targets: {
    id: "targets",
    defaultMessage: "Desired Outcome(s):",
  },
  due_dates: {
    id: "due_dates",
    defaultMessage: "Due Date(s):",
  },
  gas_score: {
    id: "gas_score",
    defaultMessage: "GAS Score",
  },
  notes: {
    id: "notes",
    defaultMessage: "Notes",
  },
  no_notes: {
    id: "no_notes",
    defaultMessage: "No notes available.",
  },
  hide_details: {
    id: "hide_details",
    defaultMessage: "Hide Details",
  },
  short_term_goal: {
    id: "short_term_goal",
    defaultMessage: "Short Term Goal",
  },
  edit_goal: {
    id: "edit_goal",
    defaultMessage: "Edit Goal",
  },
  target: {
    id: "target",
    defaultMessage: "Desired Outcome",
  },
  add_target: {
    id: "add_target",
    defaultMessage: "Add Desired Outcome",
  },
  smart_goal_detail: {
    id: "smart_goal_detail",
    defaultMessage: "SMART Goal",
  },
  target_detail: {
    id: "target_detail",
    defaultMessage: "Detail",
  },
  target_measure: {
    id: "target_measure",
    defaultMessage: "Measure",
  },
  level_of_support: {
    id: "level_of_support",
    defaultMessage: "Level of Support",
  },
  target_status: {
    id: "target_status",
    defaultMessage: "Status",
  },
  target_category: {
    id: "target_category",
    defaultMessage: "Category",
  },
  target_achievement_status: {
    id: "target_achievement_status",
    defaultMessage: "Achievement Status",
  },
  target_status_reason: {
    id: "target_status_reason",
    defaultMessage: "Status Reason",
  },
  target_priority: {
    id: "target_priority",
    defaultMessage: "Priority",
  },
  target_intervention_level_support: {
    id: "target_intervention_level_support",
    defaultMessage: "Level of Support",
  },
  target_intervention_type: {
    id: "target_intervention_type",
    defaultMessage: "Intervention Type",
  },
  target_intervention_status: {
    id: "target_intervention_status",
    defaultMessage: "Status",
  },
  target_name: {
    id: "target_name",
    defaultMessage: "Desired Outcome Name",
  },
  target_description: {
    id: "target_description",
    defaultMessage: "Desired Outcome Description",
  },
  target_description_required: {
    id: "target_description_required",
    defaultMessage: "Desired Outcome description is required",
  },
  target_measure_required: {
    id: "target_measure_required",
    defaultMessage: "Desired Outcome measure is required",
  },
  target_status_required: {
    id: "target_status_required",
    defaultMessage: "Desired Outcome status is required",
  },
  target_category_required: {
    id: "target_category_required",
    defaultMessage: "Desired Outcome category is required",
  },
  target_achievement_status_required: {
    id: "target_achievement_status_required",
    defaultMessage: "Desired Outcome achievement status is required",
  },
  target_status_reason_required: {
    id: "target_status_reason_required",
    defaultMessage: "Desired Outcome status reason is required",
  },
  target_priority_required: {
    id: "target_priority_required",
    defaultMessage: "Desired Outcome priority is required",
  },
  target_intervention_level_support_required: {
    id: "target_intervention_level_support_required",
    defaultMessage: "Desired Outcome level of support is required",
  },
  target_intervention_type_required: {
    id: "target_intervention_type_required",
    defaultMessage: "Desired Outcome intervention type is required",
  },
  target_intervention_status_required: {
    id: "target_intervention_status_required",
    defaultMessage: "Desired Outcome status is required",
  },
  target_detail_required: {
    id: "target_detail_required",
    defaultMessage: "Desired Outcome detail is required",
  },
  target_date_required: {
    id: "target_date_required",
    defaultMessage: "Desired Outcome date is required",
  },
  target_date: {
    id: "target_date",
    defaultMessage: "Desired Outcome Date",
  },
  enter_target_details: {
    id: "enter_target_details",
    defaultMessage: "Enter Desired Outcome details",
  },
  enter_target_measure: {
    id: "enter_target_measure",
    defaultMessage: "Enter Desired Outcome measure",
  },
  enter_target_date: {
    id: "enter_target_date",
    defaultMessage: "Enter Desired Outcome date",
  },
  add_note: {
    id: "add_note",
    defaultMessage: "Add Note",
  },
  enter_note: {
    id: "enter_note",
    defaultMessage: "Enter note...",
  },
  additional_information: {
    id: "additional_information",
    defaultMessage: "Additional Information",
  },
  careplan_overview: {
    id: "careplan_overview",
    defaultMessage: "Care Plan Overview",
  },
  careplan_progress: {
    id: "careplan_progress",
    defaultMessage: "Care Plan Progress",
  },
  timeline: {
    id: "timeline",
    defaultMessage: "Timeline",
  },
  gas_baseline: {
    id: "gas_baseline",
    defaultMessage: "GAS Baseline score",
  },
  gas_outcome: {
    id: "gas_outcome",
    defaultMessage: "GAS Outcome score",
  },
  download_careplan_pdf: {
    id: "download_careplan_pdf",
    defaultMessage: "Download Goals PDF",
  },
  no_activities: {
    id: "no_activities",
    defaultMessage: "No activities.",
  },
  today_activities: {
    id: "today_activities",
    defaultMessage: "Today Activities",
  },
  past_activities: {
    id: "past_activities",
    defaultMessage: "Past Activities",
  },
  future_activities: {
    id: "future_activities",
    defaultMessage: "Future Activities",
  },
  past: { id: "past", defaultMessage: "Past" },
  future: { id: "future", defaultMessage: "Future" },
  overview: { id: "overview", defaultMessage: "Overview" },
  goals: { id: "goals", defaultMessage: "Goals" },
  goal_name_required: {
    id: "goal_name_required",
    defaultMessage: "Goal name is required",
  },
  goal_description_required: {
    id: "goal_description_required",
    defaultMessage: "Goal description is required",
  },
  goal_save_failed: {
    id: "goal_save_failed",
    defaultMessage: "The goal was not saved. Please try again.",
  },
  goal_completed_before_start: {
    id: "goal_completed_before_start",
    defaultMessage: "The completed date cannot be before the start date.",
  },
  add_strategy: {
    id: "add_strategy",
    defaultMessage: "Add Strategy",
  },
  strategy: {
    id: "strategy",
    defaultMessage: "Strategy",
  },
  strategy_number: {
    id: "strategy_number",
    defaultMessage: "Strategy {number}",
  },
  no_interventions: {
    id: "no_interventions",
    defaultMessage: "No interventions available.",
  },
  no_strategies: {
    id: "no_strategies",
    defaultMessage: "No strategies available.",
  },
  strategies: {
    id: "strategies",
    defaultMessage: "Strategies",
  },
  response_translated_ai: {
    id: "response_translated_ai",
    defaultMessage: "Response translated by AI.",
  },
  processing_please_wait: {
    id: "processing_please_wait",
    defaultMessage:
      "Processing your request to export survey {survey}. This may take some time. Please wait",
  },
  export_survey: {
    id: "export_survey",
    defaultMessage:
      "Survey Exported. CSV will be available for download in 'Documents'",
  },
  goal_created: {
    id: "goal_created",
    defaultMessage: "Goal has been created.",
  },
  goal_updated: {
    id: "goal_updated",
    defaultMessage: "Goal has been updated.",
  },
  subgoal_updated: {
    id: "subgoal_updated",
    defaultMessage: "Subgoal has been updated.",
  },
  subgoal_created: {
    id: "subgoal_created",
    defaultMessage: "Subgoal has been created.",
  },
  service_user: {
    id: "service_user",
    defaultMessage: "Service User",
  },
  service_users: {
    id: "service_users",
    defaultMessage: "Service Users",
  },
  one_service_user: {
    id: "one_service_user",
    defaultMessage: "1 Service User",
  },
  service_users_w_count: {
    id: "service_users_w_count",
    defaultMessage: "{count} Service Users",
  },
  noServiceUsers: {
    id: "noServiceUsers",
    defaultMessage: "No Service Users",
  },
  service_user_updated: {
    id: "service_user_updated",
    defaultMessage: "Service User has been updated.",
  },
  messages_to_service_user: {
    id: "messages_to_service_user",
    defaultMessage: "Messages and Updates to Service User",
  },
  service_users_added: {
    id: "service_users_added",
    defaultMessage: "Service Users added",
  },
  service_users_onboarded: {
    id: "service_users_onboarded",
    defaultMessage: "Service Users onboarded",
  },
  view_service_users: {
    id: "view_service_users",
    defaultMessage: "View Service Users",
  },
  add_service_user: {
    id: "add_service_user",
    defaultMessage: "Add Service User",
  },
  no_of_service_users: {
    id: "no_of_service_users",
    defaultMessage: "No of Service Users",
  },
  service_user_report: {
    id: "service_user_report",
    defaultMessage: "Service User Report",
  },
  service_user_name: {
    id: "service_user_name",
    defaultMessage: "Service User Name",
  },
  service_user_members: {
    id: "service_user_members",
    defaultMessage: "Service User and Members",
  },
  message_to_patient: {
    id: "message_to_patient",
    defaultMessage: " Message to the Patient (Optional)",
  },
  message_to_service_user: {
    id: "message_to_service_user",
    defaultMessage: " Message to the Service User (Optional)",
  },
  show_details: {
    id: "show_details",
    defaultMessage: "Show Details",
  },
  quick_actions: {
    id: "quick_actions",
    defaultMessage: "Quick Actions",
  },
  contact_careplan: {
    id: "contact_careplan",
    defaultMessage: "Contact your primary care physician within 24 hours",
  },
  monitor_symptoms: {
    id: "monitor_symptoms",
    defaultMessage: "Monitor your symptoms closely",
  },
  medical_attention: {
    id: "medical_attention",
    defaultMessage: "Seek immediate medical attention if symptoms worsen",
  },
  recommendations: {
    id: "recommendations",
    defaultMessage: "Recommendations",
  },
  emergency_contact: {
    id: "emergency_contact",
    defaultMessage: "Emergency Contact",
  },
  go_to_recommendations: {
    id: "go_to_recommendations",
    defaultMessage: "Go to your personalized recommendations",
  },
  i_understand: {
    id: "i_understand",
    defaultMessage: "I Understand",
  },
  thank_you: {
    id: "thank_you",
    defaultMessage: "Thank You",
  },
  important_notice: {
    id: "important_notice",
    defaultMessage: "Important Notice",
  },
  device_withings_title: {
    id: "device_withings_title",
    defaultMessage: "Withings",
  },
  device_withings_description: {
    id: "device_withings_description",
    defaultMessage: "An account on Withings is required.",
  },
  device_fitbit_title: {
    id: "device_fitbit_title",
    defaultMessage: "FitBit",
  },
  device_fitbit_description: {
    id: "device_fitbit_description",
    defaultMessage: "An account on FitBit is required.",
  },
  device_dexcom_title: {
    id: "device_dexcom_title",
    defaultMessage: "Dexcom",
  },
  device_dexcom_description: {
    id: "device_dexcom_description",
    defaultMessage: "An account on Dexcom is required.",
  },
  device_omron_title: {
    id: "device_omron_title",
    defaultMessage: "Omron",
  },
  device_omron_description: {
    id: "device_omron_description",
    defaultMessage: "For Bluetooth-enabled Omron devices.",
  },
  device_ihealth_title: {
    id: "device_ihealth_title",
    defaultMessage: "iHealth",
  },
  device_ihealth_description: {
    id: "device_ihealth_description",
    defaultMessage: "An account on iHealth is required.",
  },
  device_corsano_title: {
    id: "device_corsano_title",
    defaultMessage: "Corsano",
  },
  device_corsano_description: {
    id: "device_corsano_description",
    defaultMessage: "For Bluetooth-enabled Corsano Bracelet band.",
  },
  my_devices: {
    id: "my_devices",
    defaultMessage: "My Devices",
  },
  no_devices_connected: {
    id: "no_devices_connected",
    defaultMessage: "No devices connected",
  },
  connect_health_devices: {
    id: "connect_health_devices",
    defaultMessage: "Connect your health devices to start monitoring",
  },
  devices: {
    id: "devices",
    defaultMessage: "Devices",
  },
  "devices.page_subtitle": {
    id: "devices.page_subtitle",
    defaultMessage: "Manage your connected health devices",
  },
  info_panel: {
    id: "info_panel",
    defaultMessage: "Information",
  },
  "info_panel.page_subtitle": {
    id: "info_panel.page_subtitle",
    defaultMessage: "Access helpful resources and information",
  },
  hide_all_content_titles: {
    id: "hide_all_content_titles",
    defaultMessage: "Hide All Content Titles",
  },
  "assessments.page_subtitle": {
    id: "assessments.page_subtitle",
    defaultMessage: "View and complete your health assessments",
  },
  "appointments.page_subtitle": {
    id: "appointments.page_subtitle",
    defaultMessage: "Manage your upcoming appointments",
  },
  "profile.page_subtitle": {
    id: "profile.page_subtitle",
    defaultMessage: "View and update your personal information",
  },
  "care_plan.page_subtitle": {
    id: "care_plan.page_subtitle",
    defaultMessage: "Follow your personalized care plan",
  },
  "documents.page_subtitle": {
    id: "documents.page_subtitle",
    defaultMessage: "Access your medical documents and files",
  },
  "home.page_subtitle": {
    id: "home.page_subtitle",
    defaultMessage: "Your health dashboard and overview",
  },
  "tasks.page_subtitle": {
    id: "tasks.page_subtitle",
    defaultMessage: "View and manage your health tasks",
  },
  "progress.page_subtitle": {
    id: "progress.page_subtitle",
    defaultMessage: "Track your health progress and goals",
  },
  "medications.page_subtitle": {
    id: "medications.page_subtitle",
    defaultMessage: "Manage your medications and prescriptions",
  },
  import_patient_survey_results: {
    id: "import_patient_survey_results",
    defaultMessage: "Import Patient Survey Results",
  },
  import_service_user_survey_results: {
    id: "import_service_user_survey_results",
    defaultMessage: "Import Service User Survey Results",
  },
  import_patient_medications: {
    id: "import_patient_medications",
    defaultMessage: "Import Patient Medications",
  },
  import_service_user_medications: {
    id: "import_service_user_medications",
    defaultMessage: "Import Service User Medications",
  },
  patient_actions: {
    id: "patient_actions",
    defaultMessage: "Patient Actions",
  },
  service_user_actions: {
    id: "service_user_actions",
    defaultMessage: "Service User Actions",
  },
  active_patient: {
    id: "active_patient",
    defaultMessage: "Active Patient",
  },
  active_service_user: {
    id: "active_service_user",
    defaultMessage: "Active Service User",
  },
  please_set_treatment: {
    id: "please_set_treatment",
    defaultMessage: "Please set a treatment",
  },
  no_medications: {
    id: "no_medications",
    defaultMessage: "No Medications to display",
  },
  no_treatments: {
    id: "no_treatments",
    defaultMessage: "No Treatments to display",
  },
  select_assistant: {
    id: "select_assistant",
    defaultMessage: "Select an Assistant",
  },
  loading_assistants: {
    id: "loading_assistants",
    defaultMessage: "Loading assistants...",
  },
  no_assistants_available: {
    id: "no_assistants_available",
    defaultMessage: "No assistants available.",
  },
  contact_admin_configure_assistants: {
    id: "contact_admin_configure_assistants",
    defaultMessage: "Contact your administrator to configure assistants.",
  },
  ai_summary_uc: {
    id: "ai_summary_uc",
    defaultMessage: "AI SUMMARY",
  },
  ai_generated_content_disclaimer: {
    id: "ai_generated_content_disclaimer",
    defaultMessage:
      "This document contains AI-generated content. AI can make mistakes - please double-check responses.",
  },

  deleteDocument: {
    id: "delete_document",
    defaultMessage: "Delete Document",
  },
  confirmDeleteDocument: {
    id: "confirm_delete_document",
    defaultMessage: "Are you sure you want to delete this document?",
  },
  errorLoadingDocuments: {
    id: "error_loading_documents",
    defaultMessage: "Failed to load documents",
  },
  errorDeletingDocument: {
    id: "error_deleting_document",
    defaultMessage: "Failed to delete document",
  },
  documentUpdated: {
    id: "document_updated",
    defaultMessage: "Document updated successfully",
  },
  errorSavingDocument: {
    id: "error_saving_document",
    defaultMessage: "Failed to save document",
  },
  auto_play_responses: {
    id: "auto_play_responses",
    defaultMessage: "Auto-play responses",
  },
  disable_auto_play_voice: {
    id: "disable_auto_play_voice",
    defaultMessage: "Disable auto-play of voice responses",
  },
  enable_auto_play_voice: {
    id: "enable_auto_play_voice",
    defaultMessage: "Enable auto-play of voice responses",
  },
  toggle_auto_play_voice: {
    id: "toggle_auto_play_voice",
    defaultMessage: "Toggle auto-play of voice responses",
  },
  document_generated_success: {
    id: "document_generated_success",
    defaultMessage: "Document generated successfully. Click to view and edit.",
  },
  download_pdf: {
    id: "download_pdf",
    defaultMessage: "Download PDF",
  },
  generating_pdf: {
    id: "generating_pdf",
    defaultMessage: "Generating...",
  },
  generating_notes_summary: {
    id: "generating_notes_summary",
    defaultMessage: "Generating notes summary...",
  },
  smart_document_generating_reading: {
    id: "smart_document_generating_reading",
    defaultMessage: "Reading patient context...",
  },
  smart_document_generating_drafting: {
    id: "smart_document_generating_drafting",
    defaultMessage: "Drafting your document...",
  },
  smart_document_generating_finalizing: {
    id: "smart_document_generating_finalizing",
    defaultMessage: "Adding the finishing touches...",
  },
  loading_events: {
    id: "loading_events",
    defaultMessage: "Loading events...",
  },
  unknown_patient: {
    id: "unknown_patient",
    defaultMessage: "Unknown Patient",
  },
  booked_by: {
    id: "booked_by",
    defaultMessage: "Booked by",
  },
  current_month: {
    id: "current_month",
    defaultMessage: "Current Month",
  },
  current_week: {
    id: "current_week",
    defaultMessage: "Current Week",
  },
  download_agenda_pdf: {
    id: "download_agenda_pdf",
    defaultMessage: "Download Agenda PDF",
  },
  recurring_appointment: {
    id: "recurring_appointment",
    defaultMessage: "Recurring",
  },
  recurring_appointment_title: {
    id: "recurring_appointment_title",
    defaultMessage: "Recurring appointment",
  },
  save_to_patient_documents: {
    id: "save_to_patient_documents",
    defaultMessage: "Save to Patient Documents",
  },
  finalize_document_disclaimer: {
    id: "finalize_document_disclaimer",
    defaultMessage:
      "This document will be finalised and saved to patient documents. It will be removed from In Progress and will no longer be available for editing.",
  },
  confirm_finalize: {
    id: "confirm_finalize",
    defaultMessage: "Confirm & Save",
  },
  version_history: {
    id: "version_history",
    defaultMessage: "Version History",
  },
  version_number: {
    id: "version_number",
    defaultMessage: "Version {number}",
  },
  restore_version: {
    id: "restore_version",
    defaultMessage: "Restore",
  },
  restore_version_confirm: {
    id: "restore_version_confirm",
    defaultMessage:
      "Restore this version? Current content will be saved as a new version.",
  },
  version_restored: {
    id: "version_restored",
    defaultMessage: "Version restored",
  },
  no_versions: {
    id: "no_versions",
    defaultMessage: "No previous versions",
  },
  current_version: {
    id: "current_version",
    defaultMessage: "Current",
  },
  attributes: {
    id: "attributes",
    defaultMessage: "Attributes",
  },
  open_document: {
    id: "open_document",
    defaultMessage: "Open Document",
  },
  reactivate: {
    id: "reactivate",
    defaultMessage: "Reactivate",
  },
  hello_greeting: {
    id: "hello_greeting",
    defaultMessage: "Hello, {name}",
  },
  welcome_care_companion: {
    id: "welcome_care_companion",
    defaultMessage: "Welcome to your Care Companion",
  },
  care_journey_intro: {
    id: "care_journey_intro",
    defaultMessage:
      "We're here to support you throughout your care journey with personalized resources, tracking tools, and guidance every step of the way.",
  },
  inbox_updates: {
    id: "inbox_updates",
    defaultMessage: "Inbox & Updates",
  },
  inbox_updates_desc: {
    id: "inbox_updates_desc",
    defaultMessage:
      "Check your latest messages and updates from your care team.",
  },
  my_daily_tasks: {
    id: "my_daily_tasks",
    defaultMessage: "My Daily Tasks",
  },
  daily_tasks_desc: {
    id: "daily_tasks_desc",
    defaultMessage:
      "Review and complete today's activities to stay on track with your care.",
  },
  service_requests: {
    id: "service_requests",
    defaultMessage: "Service Requests",
  },
  service_requests_desc: {
    id: "service_requests_desc",
    defaultMessage:
      "Track your open requests, service updates, and responses from the support team.",
  },
  my_appointments: {
    id: "my_appointments",
    defaultMessage: "My Appointments",
  },
  appointments_desc: {
    id: "appointments_desc",
    defaultMessage:
      "View upcoming appointments, test dates, and medical visits.",
  },
  my_care_journey: {
    id: "my_care_journey",
    defaultMessage: "My Care Journey",
  },
  care_journey_desc: {
    id: "care_journey_desc",
    defaultMessage:
      "Follow your care milestones, achievements and next steps all in one place.",
  },
  learn_explore: {
    id: "learn_explore",
    defaultMessage: "Learn & Explore",
  },
  learn_explore_desc: {
    id: "learn_explore_desc",
    defaultMessage:
      "Access trusted health resources, lifestyle tips, and educational content tailored for you.",
  },
  my_updates: {
    id: "my_updates",
    defaultMessage: "My Updates",
  },
  stay_up_to_date: {
    id: "stay_up_to_date",
    defaultMessage: "Stay up to date with your health journey",
  },
  total_updates: {
    id: "total_updates",
    defaultMessage: "Total Updates",
  },
  unread: {
    id: "unread",
    defaultMessage: "Unread",
  },
  filter_by_type: {
    id: "filter_by_type",
    defaultMessage: "Filter by Type",
  },
  all_updates: {
    id: "all_updates",
    defaultMessage: "All Updates",
  },
  education: {
    id: "education",
    defaultMessage: "Education",
  },
  surveys: {
    id: "surveys",
    defaultMessage: "Surveys",
  },
  messages: {
    id: "messages",
    defaultMessage: "Messages",
  },
  consent: {
    id: "consent",
    defaultMessage: "Consent",
  },
  completed_consent: {
    id: "completed_consent",
    defaultMessage: "Completed Consent",
  },
  completed_surveys_filter: {
    id: "completed_surveys_filter",
    defaultMessage: "Completed Surveys",
  },
  new_agent_chat: {
    id: "new_agent_chat",
    defaultMessage: "New Agent Chat",
  },
  loading_updates: {
    id: "loading_updates",
    defaultMessage: "Loading your updates...",
  },
  loading_more_updates: {
    id: "loading_more_updates",
    defaultMessage: "Loading more updates...",
  },
  load_more_items: {
    id: "load_more_items",
    defaultMessage: "Load More (30 items)",
  },
  loading: {
    id: "loading",
    defaultMessage: "Loading...",
  },
  all_caught_up: {
    id: "all_caught_up",
    defaultMessage: "You're all caught up!",
  },
  no_updates_yet: {
    id: "no_updates_yet",
    defaultMessage: "No updates yet",
  },
  updates_will_appear: {
    id: "updates_will_appear",
    defaultMessage:
      "When you receive updates about your health journey, they'll appear here.",
  },
  start_conversation: {
    id: "start_conversation",
    defaultMessage: "Start a Conversation",
  },
  update_details: {
    id: "update_details",
    defaultMessage: "Update Details",
  },
  january: {
    id: "january",
    defaultMessage: "January",
  },
  february: {
    id: "february",
    defaultMessage: "February",
  },
  march: {
    id: "march",
    defaultMessage: "March",
  },
  april: {
    id: "april",
    defaultMessage: "April",
  },
  may: {
    id: "may",
    defaultMessage: "May",
  },
  june: {
    id: "june",
    defaultMessage: "June",
  },
  july: {
    id: "july",
    defaultMessage: "July",
  },
  august: {
    id: "august",
    defaultMessage: "August",
  },
  september: {
    id: "september",
    defaultMessage: "September",
  },
  october: {
    id: "october",
    defaultMessage: "October",
  },
  november: {
    id: "november",
    defaultMessage: "November",
  },
  december: {
    id: "december",
    defaultMessage: "December",
  },
  care_team: {
    id: "care_team",
    defaultMessage: "Care Team",
  },
  system: {
    id: "system",
    defaultMessage: "System",
  },
  health_assistant: {
    id: "health_assistant",
    defaultMessage: "Health Assistant",
  },
  health_system: {
    id: "health_system",
    defaultMessage: "Health System",
  },
  day: {
    id: "day",
    defaultMessage: "day",
  },
  days: {
    id: "days",
    defaultMessage: "days",
  },
  hour: {
    id: "hour",
    defaultMessage: "hour",
  },
  hours: {
    id: "hours",
    defaultMessage: "hours",
  },
  minute: {
    id: "minute",
    defaultMessage: "minute",
  },
  minutes: {
    id: "minutes",
    defaultMessage: "minutes",
  },
  ago: {
    id: "ago",
    defaultMessage: "ago",
  },
  just_now: {
    id: "just_now",
    defaultMessage: "Just now",
  },
  chat: {
    id: "chat",
    defaultMessage: "Chat",
  },
  mps_chatbot: {
    id: "mps_chatbot",
    defaultMessage: "Chatbot",
  },
  appointments: {
    id: "appointments",
    defaultMessage: "Appointments",
  },
  reminders: {
    id: "reminders",
    defaultMessage: "Reminders",
  },
  no_updates_to_display: {
    id: "no_updates_to_display",
    defaultMessage: "No updates to display",
  },
  timeline_will_appear: {
    id: "timeline_will_appear",
    defaultMessage: "Your timeline will appear here when updates are available",
  },
  showing: {
    id: "showing",
    defaultMessage: "Showing:",
  },
  items: {
    id: "items",
    defaultMessage: "items",
  },
  clear_filter: {
    id: "clear_filter",
    defaultMessage: "Clear filter",
  },
  from: {
    id: "from",
    defaultMessage: "from",
  },
  more_updates_available: {
    id: "more_updates_available",
    defaultMessage: "More updates available",
  },
  no_updates_match_filter: {
    id: "no_updates_match_filter",
    defaultMessage: "No updates match your filter",
  },
  try_different_filter: {
    id: "try_different_filter",
    defaultMessage:
      "Try selecting a different type or use the filter dropdown to show all updates",
  },
  close_modal: {
    id: "close_modal",
    defaultMessage: "Close modal",
  },
  sections: {
    id: "sections",
    defaultMessage: "Sections",
  },
  empty_section: {
    id: "empty_section",
    defaultMessage: "Empty section.",
  },
  item: {
    id: "item",
    defaultMessage: "item",
  },
  articles: {
    id: "articles",
    defaultMessage: "articles",
  },
  article_lower: {
    id: "article_lower",
    defaultMessage: "article",
  },
  section: {
    id: "section",
    defaultMessage: "section",
  },
  cancel_edit: {
    id: "cancel_edit",
    defaultMessage: "Cancel edit",
  },
  format: {
    id: "format",
    defaultMessage: "Format:",
  },
  table: {
    id: "table",
    defaultMessage: "Table",
  },
  updates: {
    id: "updates",
    defaultMessage: "Updates",
  },
  assistants: {
    id: "assistants",
    defaultMessage: "Assistants",
  },
  todays_activities: {
    id: "todays_activities",
    defaultMessage: "Today's Activities",
  },
  todays_activities_loading: {
    id: "todays_activities_loading",
    defaultMessage: "Loading activities...",
  },
  todays_activities_load_failed: {
    id: "todays_activities_load_failed",
    defaultMessage: "Failed to load activities",
  },
  todays_activities_task_count_singular: {
    id: "todays_activities_task_count_singular",
    defaultMessage: "{count} task due today",
  },
  todays_activities_task_count_plural: {
    id: "todays_activities_task_count_plural",
    defaultMessage: "{count} tasks due today",
  },
  todays_activities_pending_completed: {
    id: "todays_activities_pending_completed",
    defaultMessage: "{pending} pending · {completed} completed",
  },
  todays_activities_no_tasks_title: {
    id: "todays_activities_no_tasks_title",
    defaultMessage: "No activities today",
  },
  todays_activities_no_tasks_description: {
    id: "todays_activities_no_tasks_description",
    defaultMessage:
      "You have no tasks due today. Great job staying on top of things!",
  },
  // Pending Tasks Carousel Widget Messages
  pending_tasks_carousel_title: {
    id: "pending_tasks_carousel_title",
    defaultMessage: "Your Pending Tasks for Today",
  },
  tasks_pending_count: {
    id: "tasks_pending_count",
    defaultMessage: "{completed}/{total} pending",
  },
  all_done: {
    id: "all_done",
    defaultMessage: "All Done!",
  },
  task_completion_progress: {
    id: "task_completion_progress",
    defaultMessage: "{completed} of {total}",
  },
  // Recommendations Carousel Widget Messages
  recommendations_carousel_title: {
    id: "recommendations_carousel_title",
    defaultMessage: "Recommendations",
  },
  recommendations_carousel_empty: {
    id: "recommendations_carousel_empty",
    defaultMessage:
      "No recommendations available. Check your information library.",
  },
  // Updates Widget Messages
  recent_updates: {
    id: "recent_updates",
    defaultMessage: "Recent Updates",
  },
  updates_count: {
    id: "updates_count",
    defaultMessage: "{count} updates",
  },
  unread_count: {
    id: "unread_count",
    defaultMessage: "{count} unread",
  },
  read: {
    id: "read",
    defaultMessage: "Read",
  },
  view_all_more: {
    id: "view_all_more",
    defaultMessage: "View All ({count} more)",
  },
  show_less: {
    id: "show_less",
    defaultMessage: "Show Less",
  },
  no_updates_available: {
    id: "no_updates_available",
    defaultMessage: "No updates available",
  },
  no_updates_description: {
    id: "no_updates_description",
    defaultMessage: "You're all caught up! New updates will appear here.",
  },
  new_badge: {
    id: "new_badge",
    defaultMessage: "New",
  },
  read_badge: {
    id: "read_badge",
    defaultMessage: "Read",
  },
  update_from: {
    id: "update_from",
    defaultMessage: "from",
  },
  unread_update: {
    id: "unread_update",
    defaultMessage: "Unread update",
  },
  read_update: {
    id: "read_update",
    defaultMessage: "Read update",
  },
  time_minutes_ago: {
    id: "time_minutes_ago",
    defaultMessage: "{minutes} minutes ago",
  },
  time_hours_ago: {
    id: "time_hours_ago",
    defaultMessage: "{hours} hours ago",
  },
  time_days_ago: {
    id: "time_days_ago",
    defaultMessage: "{days} days ago",
  },
  update_title_fallback: {
    id: "update_title_fallback",
    defaultMessage: "No title",
  },
  unable_to_load_updates: {
    id: "unable_to_load_updates",
    defaultMessage: "Unable to load updates",
  },
  unable_to_display_updates: {
    id: "unable_to_display_updates",
    defaultMessage: "Unable to display updates",
  },
  view_all_updates: {
    id: "view_all_updates",
    defaultMessage: "View all updates",
  },
  show_fewer_updates: {
    id: "show_fewer_updates",
    defaultMessage: "Show fewer updates",
  },
  show_all_updates: {
    id: "show_all_updates",
    defaultMessage: "Show all {count} updates",
  },
  updates_count_aria: {
    id: "updates_count_aria",
    defaultMessage: "{count} updates",
  },
  // Appointments Widget Messages
  error_loading_data: {
    id: "error_loading_data",
    defaultMessage: "Error loading data. Please try again.",
  },
  no_appointments_found: {
    id: "no_appointments_found",
    defaultMessage: "No appointments found",
  },
  no_appointments_period: {
    id: "no_appointments_period",
    defaultMessage: "No appointments scheduled for this period.",
  },
  appointment_count_single: {
    id: "appointment_count_single",
    defaultMessage: "{count} appointment",
  },
  appointment_count_plural: {
    id: "appointment_count_plural",
    defaultMessage: "{count} appointments",
  },
  appointment_date_time: {
    id: "appointment_date_time",
    defaultMessage: "Date & Time",
  },
  duration_minutes: {
    id: "duration_minutes",
    defaultMessage: "{minutes} minutes",
  },
  join_meeting: {
    id: "join_meeting",
    defaultMessage: "Join Meeting",
  },
  pwa_install_title: {
    id: "pwa_install_title",
    defaultMessage: "Install myPatientSpace",
  },
  pwa_install_description: {
    id: "pwa_install_description",
    defaultMessage: "Install our app for a better experience.",
  },
  pwa_open_app_title: {
    id: "pwa_open_app_title",
    defaultMessage: "Open myPatientSpace App",
  },
  pwa_open_app_description: {
    id: "pwa_open_app_description",
    defaultMessage:
      "You have the app installed! Open it for a better experience.",
  },
  pwa_button_install: {
    id: "pwa_button_install",
    defaultMessage: "Install",
  },
  pwa_button_later: {
    id: "pwa_button_later",
    defaultMessage: "Later",
  },
  pwa_button_got_it: {
    id: "pwa_button_got_it",
    defaultMessage: "Got it",
  },
  pwa_button_dont_show: {
    id: "pwa_button_dont_show",
    defaultMessage: "Don't show again",
  },
  terms_and_conditions: {
    id: "terms_and_conditions",
    defaultMessage: "Terms & Conditions",
  },
  privacy_policies: {
    id: "privacy_policies",
    defaultMessage: "Privacy Policies",
  },
  about_mps: {
    id: "about_mps",
    defaultMessage: "About MPS",
  },
  not_specified: {
    id: "not_specified",
    defaultMessage: "Not specified",
  },
  invalid_date: {
    id: "invalid_date",
    defaultMessage: "Invalid Date",
  },
  care_plan_report: {
    id: "care_plan_report",
    defaultMessage: "Care Plan Report",
  },
  care_plan_report_preview: {
    id: "care_plan_report_preview",
    defaultMessage: "Care Plan Report Preview",
  },
  failed_to_load_care_plan: {
    id: "failed_to_load_care_plan",
    defaultMessage: "Failed to load care plan goals. Please try again.",
  },
  untitled: {
    id: "untitled",
    defaultMessage: "Untitled",
  },
  untitled_goal: {
    id: "untitled_goal",
    defaultMessage: "Untitled Goal",
  },
  goal_number: {
    id: "goal_number",
    defaultMessage: "Goal {number}",
  },
  subgoal_number: {
    id: "subgoal_number",
    defaultMessage: "Subgoal {number}",
  },
  generated_on: {
    id: "generated_on",
    defaultMessage: "Generated on {date}",
  },
  patient_name_not_available: {
    id: "patient_name_not_available",
    defaultMessage: "Patient Name Not Available",
  },
  care_plan_title_not_available: {
    id: "care_plan_title_not_available",
    defaultMessage: "Care Plan Title Not Available",
  },
  care_plan_label: {
    id: "care_plan_label",
    defaultMessage: "Care plan:",
  },
  organization_logo: {
    id: "organization_logo",
    defaultMessage: "Organization Logo",
  },
  try_again: {
    id: "try_again",
    defaultMessage: "Try Again",
  },

  // Patient Updates Page
  "updates.page_title": {
    id: "updates.page_title",
    defaultMessage: "Your health journey updates",
  },
  "updates.page_subtitle": {
    id: "updates.page_subtitle",
    defaultMessage: "Your health journey updates",
  },
  "updates.type.text": {
    id: "updates.type.text",
    defaultMessage: "Text Message",
  },
  "updates.type.image": {
    id: "updates.type.image",
    defaultMessage: "Image",
  },
  "updates.type.video": {
    id: "updates.type.video",
    defaultMessage: "Video",
  },
  "updates.type.audio": {
    id: "updates.type.audio",
    defaultMessage: "Audio",
  },
  "updates.type.study": {
    id: "updates.type.study",
    defaultMessage: "Study Material",
  },
  "updates.type.appointment": {
    id: "updates.type.appointment",
    defaultMessage: "Appointment",
  },
  "updates.type.pdf": {
    id: "updates.type.pdf",
    defaultMessage: "PDF Document",
  },
  "updates.type.consent": {
    id: "updates.type.consent",
    defaultMessage: "Consent Form",
  },
  "updates.type.questionnaire": {
    id: "updates.type.questionnaire",
    defaultMessage: "Questionnaire",
  },
  "updates.new": {
    id: "updates.new",
    defaultMessage: "New",
  },
  "updates.urgent": {
    id: "updates.urgent",
    defaultMessage: "Urgent",
  },
  "updates.signed": {
    id: "updates.signed",
    defaultMessage: "Signed",
  },
  "updates.answered": {
    id: "updates.answered",
    defaultMessage: "Answered",
  },
  "updates.mark_as_read": {
    id: "updates.mark_as_read",
    defaultMessage: "Mark as read",
  },
  "updates.see_full_content": {
    id: "updates.see_full_content",
    defaultMessage: "See full content",
  },
  "updates.view_fullscreen": {
    id: "updates.view_fullscreen",
    defaultMessage: "View Full Screen",
  },
  "updates.watch": {
    id: "updates.watch",
    defaultMessage: "Watch Video",
  },
  "updates.access_material": {
    id: "updates.access_material",
    defaultMessage: "Access Material",
  },
  "updates.doctor": {
    id: "updates.doctor",
    defaultMessage: "Doctor",
  },
  "updates.date": {
    id: "updates.date",
    defaultMessage: "Date",
  },
  "updates.time": {
    id: "updates.time",
    defaultMessage: "Time",
  },
  "updates.participants": {
    id: "updates.participants",
    defaultMessage: "Participants",
  },
  "updates.join_call": {
    id: "updates.join_call",
    defaultMessage: "Join Video Call",
  },
  "updates.pages": {
    id: "updates.pages",
    defaultMessage: "{count} pages",
  },
  "updates.download_pdf": {
    id: "updates.download_pdf",
    defaultMessage: "Download PDF",
  },
  "updates.sign_electronically": {
    id: "updates.sign_electronically",
    defaultMessage: "Sign Electronically",
  },
  "updates.signed_on": {
    id: "updates.signed_on",
    defaultMessage: "Signed on {date}",
  },
  "updates.download_signed": {
    id: "updates.download_signed",
    defaultMessage: "Download Signed Copy",
  },
  "updates.submit": {
    id: "updates.submit",
    defaultMessage: "Submit",
  },
  "updates.questionnaire_completed": {
    id: "updates.questionnaire_completed",
    defaultMessage: "Thank you! Your questionnaire has been submitted.",
  },
  "updates.likes": {
    id: "updates.likes",
    defaultMessage: "Likes",
  },
  "updates.filter.all": {
    id: "updates.filter.all",
    defaultMessage: "All",
  },
  "updates.filter.read": {
    id: "updates.filter.read",
    defaultMessage: "Read",
  },
  "updates.filter.unread": {
    id: "updates.filter.unread",
    defaultMessage: "Unread",
  },
  "updates.filter.favourites": {
    id: "updates.filter.favourites",
    defaultMessage: "Favourites",
  },
  "updates.comments": {
    id: "updates.comments",
    defaultMessage: "Comments",
  },
  "updates.post": {
    id: "updates.post",
    defaultMessage: "Post",
  },
  "updates.you": {
    id: "updates.you",
    defaultMessage: "You",
  },
  "updates.time.just_now": {
    id: "updates.time.just_now",
    defaultMessage: "Just now",
  },
  "updates.time.hour_ago": {
    id: "updates.time.hour_ago",
    defaultMessage: "hour ago",
  },
  "updates.time.hours_ago": {
    id: "updates.time.hours_ago",
    defaultMessage: "hours ago",
  },
  "updates.time.day_ago": {
    id: "updates.time.day_ago",
    defaultMessage: "day ago",
  },
  "updates.time.days_ago": {
    id: "updates.time.days_ago",
    defaultMessage: "days ago",
  },
  "updates.text.welcome": {
    id: "updates.text.welcome",
    defaultMessage: "Welcome to Your Care Journey",
  },
  "updates.text.welcome_desc": {
    id: "updates.text.welcome_desc",
    defaultMessage:
      "We're here to support you every step of the way. Don't hesitate to reach out if you have any questions.",
  },
  "updates.image.exercise": {
    id: "updates.image.exercise",
    defaultMessage: "Daily Exercise Routine",
  },
  "updates.video.therapy": {
    id: "updates.video.therapy",
    defaultMessage: "Physical Therapy Session Guide",
  },
  "updates.audio.meditation": {
    id: "updates.audio.meditation",
    defaultMessage: "Guided Meditation for Wellness",
  },
  "updates.study.diabetes": {
    id: "updates.study.diabetes",
    defaultMessage: "Understanding Your Condition",
  },
  "updates.study.diabetes_desc": {
    id: "updates.study.diabetes_desc",
    defaultMessage:
      "Educational materials to help you manage your health effectively.",
  },
  "updates.appointment.upcoming": {
    id: "updates.appointment.upcoming",
    defaultMessage: "Upcoming Video Consultation",
  },
  "updates.pdf.results": {
    id: "updates.pdf.results",
    defaultMessage: "Your Latest Lab Results",
  },
  "updates.consent.surgery": {
    id: "updates.consent.surgery",
    defaultMessage: "Surgical Procedure Consent Form",
  },
  "updates.consent.surgery_preview": {
    id: "updates.consent.surgery_preview",
    defaultMessage:
      "Please review and sign this consent form for your upcoming procedure. Your signature confirms that you understand the procedure, risks, and benefits.",
  },
  "updates.questionnaire.satisfaction": {
    id: "updates.questionnaire.satisfaction",
    defaultMessage: "Patient Satisfaction Survey",
  },
  "updates.questionnaire.q1": {
    id: "updates.questionnaire.q1",
    defaultMessage: "How satisfied are you with your care?",
  },
  "updates.questionnaire.q2": {
    id: "updates.questionnaire.q2",
    defaultMessage: "Would you recommend our services?",
  },
  "updates.questionnaire.q3": {
    id: "updates.questionnaire.q3",
    defaultMessage: "Please share any additional feedback:",
  },
  "updates.questionnaire.opt1": {
    id: "updates.questionnaire.opt1",
    defaultMessage: "Yes, definitely",
  },
  "updates.questionnaire.opt2": {
    id: "updates.questionnaire.opt2",
    defaultMessage: "Maybe",
  },
  "updates.questionnaire.opt3": {
    id: "updates.questionnaire.opt3",
    defaultMessage: "No",
  },
  download_main_title: {
    id: "download_main_title",
    defaultMessage: "Download myPatientSpace",
  },
  try_new_version: {
    id: "try_new_version",
    defaultMessage: "Try the new myPatientSpace",
  },
  mypatientspace_app: {
    id: "mypatientspace_app",
    defaultMessage: "myPatientSpace App",
  },
  download_subtitle: {
    id: "download_subtitle",
    defaultMessage: "Choose your platform and get started with our app",
  },
  download_ios_title: {
    id: "download_ios_title",
    defaultMessage: "iOS App",
  },
  download_ios_description: {
    id: "download_ios_description",
    defaultMessage:
      "For patients only - Download from the Apple App Store for iPhone and iPad",
  },
  download_android_title: {
    id: "download_android_title",
    defaultMessage: "Android App",
  },
  download_android_description: {
    id: "download_android_description",
    defaultMessage:
      "For patients only - Get it on Google Play for Android phones and tablets",
  },
  download_pwa_title: {
    id: "download_pwa_title",
    defaultMessage: "Web App (PWA)",
  },
  download_pwa_description: {
    id: "download_pwa_description",
    defaultMessage: "Use directly in your browser or install as a desktop app",
  },
  download_scan_qr: {
    id: "download_scan_qr",
    defaultMessage: "Scan QR code with your device",
  },
  download_scan_or_click_qr: {
    id: "download_scan_or_click_qr",
    defaultMessage: "Scan or click to open on browser",
  },
  download_use_browser_link: {
    id: "download_use_browser_link",
    defaultMessage: "Use this link in your browser",
  },
  download_open_link: {
    id: "download_open_link",
    defaultMessage: "Open Download Link",
  },
  download_footer_text: {
    id: "download_footer_text",
    defaultMessage:
      "Available on all your devices for seamless healthcare management",
  },
  download_app_installed: {
    id: "download_app_installed",
    defaultMessage: "App Installed",
  },
  download_installing: {
    id: "download_installing",
    defaultMessage: "Installing...",
  },
  download_install_now: {
    id: "download_install_now",
    defaultMessage: "Install Now",
  },
  download_open_app_store: {
    id: "download_open_app_store",
    defaultMessage: "Open in App Store",
  },
  download_open_google_play: {
    id: "download_open_google_play",
    defaultMessage: "Open in Google Play",
  },
  download_opening: {
    id: "download_opening",
    defaultMessage: "Opening...",
  },
  download_open_app: {
    id: "download_open_app",
    defaultMessage: "Open App",
  },
  download_open_pwa_app: {
    id: "download_open_pwa_app",
    defaultMessage: "Open PWA App",
  },
  download_link_copied: {
    id: "download_link_copied",
    defaultMessage: "Link Copied!",
  },
  download_copy_link: {
    id: "download_copy_link",
    defaultMessage: "Copy Link",
  },
  download_how_to_install: {
    id: "download_how_to_install",
    defaultMessage: "How to install?",
  },
  download_already_installed: {
    id: "download_already_installed",
    defaultMessage: "App Already Installed",
  },
  download_already_installed_desc: {
    id: "download_already_installed_desc",
    defaultMessage:
      "You're already running the app! Enjoy seamless access to your healthcare.",
  },
  download_install_success: {
    id: "download_install_success",
    defaultMessage: "App installed successfully!",
  },
  go_to_login: {
    id: "go_to_login",
    defaultMessage: "Go to login",
  },
  download_install_error: {
    id: "download_install_error",
    defaultMessage: "Installation failed. Please try again.",
  },
  download_other_platforms: {
    id: "download_other_platforms",
    defaultMessage: "Other Platforms",
  },
  download_ios_instruction_1: {
    id: "download_ios_instruction_1",
    defaultMessage: "Tap the link above to open the App Store",
  },
  download_ios_instruction_2: {
    id: "download_ios_instruction_2",
    defaultMessage: "Tap 'Get' or the download icon to install",
  },
  download_ios_instruction_3: {
    id: "download_ios_instruction_3",
    defaultMessage: "Open the app from your home screen and log in",
  },
  download_android_instruction_1: {
    id: "download_android_instruction_1",
    defaultMessage: "Tap the link above to open Google Play Store",
  },
  download_android_instruction_2: {
    id: "download_android_instruction_2",
    defaultMessage: "Tap 'Install' to download and install the app",
  },
  download_android_instruction_3: {
    id: "download_android_instruction_3",
    defaultMessage: "Open the app from your app drawer and log in",
  },
  download_pwa_instruction_1: {
    id: "download_pwa_instruction_1",
    defaultMessage:
      "Click the 'Install' button above or look for the install icon in your browser",
  },
  download_pwa_instruction_2: {
    id: "download_pwa_instruction_2",
    defaultMessage: "Confirm the installation when prompted by your browser",
  },
  download_pwa_instruction_3: {
    id: "download_pwa_instruction_3",
    defaultMessage: "Access the app from your desktop or applications menu",
  },
  download_pwa_ios_instruction_1: {
    id: "download_pwa_ios_instruction_1",
    defaultMessage: "Tap the Share button at the bottom of Safari",
  },
  download_pwa_ios_instruction_2: {
    id: "download_pwa_ios_instruction_2",
    defaultMessage: "Scroll down and tap 'Add to Home Screen'",
  },
  download_pwa_ios_instruction_3: {
    id: "download_pwa_ios_instruction_3",
    defaultMessage: "Tap 'Add' in the top right corner",
  },
  download_pwa_ios_instruction_4: {
    id: "download_pwa_ios_instruction_4",
    defaultMessage: "Open the app from your home screen and log in",
  },
  download_pwa_chrome_instruction_1: {
    id: "download_pwa_chrome_instruction_1",
    defaultMessage:
      "Click the install icon in the address bar (or the three dots menu)",
  },
  download_pwa_chrome_instruction_2: {
    id: "download_pwa_chrome_instruction_2",
    defaultMessage: "Click 'Install' in the popup dialog",
  },
  download_pwa_chrome_instruction_3: {
    id: "download_pwa_chrome_instruction_3",
    defaultMessage: "The app will open in its own window",
  },
  download_pwa_chrome_instruction_4: {
    id: "download_pwa_chrome_instruction_4",
    defaultMessage: "Access the app from your desktop or applications menu",
  },
  schedule_every_day: {
    id: "schedule_every_day",
    defaultMessage: "Every day",
  },
  schedule_time_not_set: {
    id: "schedule_time_not_set",
    defaultMessage: "Time not set",
  },
  schedule_no_days_selected: {
    id: "schedule_no_days_selected",
    defaultMessage: "No days selected",
  },
  alert_disabled: {
    id: "alert_disabled",
    defaultMessage: "Disabled",
  },
  alert_enabled: {
    id: "alert_enabled",
    defaultMessage: "Enabled",
  },
  alert_fall_rate: {
    id: "alert_fall_rate",
    defaultMessage: "Fall Rate",
  },
  alert_high_glucose: {
    id: "alert_high_glucose",
    defaultMessage: "High Glucose",
  },
  alert_low_glucose: {
    id: "alert_low_glucose",
    defaultMessage: "Low Glucose",
  },
  alert_no_readings: {
    id: "alert_no_readings",
    defaultMessage: "No Readings",
  },
  alert_out_of_range: {
    id: "alert_out_of_range",
    defaultMessage: "Out of Range",
  },
  alert_output: {
    id: "alert_output",
    defaultMessage: "Output:",
  },
  alert_rise_rate: {
    id: "alert_rise_rate",
    defaultMessage: "Rise Rate",
  },
  alert_schedules_configuration: {
    id: "alert_schedules_configuration",
    defaultMessage: "Alert Schedules Configuration",
  },
  alert_settings: {
    id: "alert_settings",
    defaultMessage: "Alert Settings",
  },
  alert_snooze: {
    id: "alert_snooze",
    defaultMessage: "Snooze:",
  },
  alert_sound_mode_default: {
    id: "alert_sound_mode_default",
    defaultMessage: "Default",
  },
  alert_sound_mode_sound: {
    id: "alert_sound_mode_sound",
    defaultMessage: "Sound",
  },
  alert_sound_mode_vibrate: {
    id: "alert_sound_mode_vibrate",
    defaultMessage: "Vibrate",
  },
  alert_trigger: {
    id: "alert_trigger",
    defaultMessage: "Trigger:",
  },
  alert_urgent_low: {
    id: "alert_urgent_low",
    defaultMessage: "Urgent Low",
  },
  alert_urgent_low_soon: {
    id: "alert_urgent_low_soon",
    defaultMessage: "Urgent Low Soon",
  },
  alert_value: {
    id: "alert_value",
    defaultMessage: "Value:",
  },
  audio_current_time: {
    id: "audio_current_time",
    defaultMessage: "Current time",
  },
  audio_download: {
    id: "audio_download",
    defaultMessage: "Download audio",
  },
  audio_download_completed: {
    id: "audio_download_completed",
    defaultMessage: "Download completed!",
  },
  audio_download_error: {
    id: "audio_download_error",
    defaultMessage: "Audio download failed. Please try again.",
  },
  audio_download_file: {
    id: "audio_download_file",
    defaultMessage: "Download audio file",
  },
  audio_download_success: {
    id: "audio_download_success",
    defaultMessage: "Audio downloaded successfully!",
  },
  audio_load_error: {
    id: "audio_load_error",
    defaultMessage: "Failed to load audio file. Please try again.",
  },
  audio_mute: {
    id: "audio_mute",
    defaultMessage: "Mute audio",
  },
  audio_pause: {
    id: "audio_pause",
    defaultMessage: "Pause audio",
  },
  audio_play: {
    id: "audio_play",
    defaultMessage: "Play audio",
  },
  audio_play_error: {
    id: "audio_play_error",
    defaultMessage: "Unable to play audio. Please check your connection.",
  },
  audio_play_item: {
    id: "audio_play_item",
    defaultMessage: "Play {title}",
  },
  audio_player_up_next: {
    id: "audio_player_up_next",
    defaultMessage: "Up Next",
  },
  audio_progress: {
    id: "audio_progress",
    defaultMessage: "Audio progress",
  },
  audio_seek_error: {
    id: "audio_seek_error",
    defaultMessage: "Unable to seek audio position.",
  },
  audio_total_duration: {
    id: "audio_total_duration",
    defaultMessage: "Total duration",
  },
  audio_unmute: {
    id: "audio_unmute",
    defaultMessage: "Unmute audio",
  },
  audio_volume_control: {
    id: "audio_volume_control",
    defaultMessage: "Volume control",
  },
  audio_no_content: {
    id: "audio_no_content",
    defaultMessage: "No audio content available",
  },
  content_empty_state_title: {
    id: "content_empty_state_title",
    defaultMessage: "No Content Available",
  },
  content_empty_state_description: {
    id: "content_empty_state_description",
    defaultMessage: "Add some content to see it displayed here",
  },
  card_slider_go_to_slide: {
    id: "card_slider_go_to_slide",
    defaultMessage: "Go to slide {slideNumber} of {totalSlides}",
  },
  card_slider_next: {
    id: "card_slider_next",
    defaultMessage: "Next slide",
  },
  card_slider_previous: {
    id: "card_slider_previous",
    defaultMessage: "Previous slide",
  },
  card_slider_unknown_type: {
    id: "card_slider_unknown_type",
    defaultMessage: "Unknown",
  },
  card_slider_untitled: {
    id: "card_slider_untitled",
    defaultMessage: "Untitled",
  },
  carousel_current_slide: {
    id: "carousel_current_slide",
    defaultMessage: "Slide {currentSlide} of {totalSlides}: {title}",
  },
  carousel_error_description: {
    id: "carousel_error_description",
    defaultMessage:
      "There was an error loading the carousel. Please try refreshing the page.",
  },
  carousel_error_retry: {
    id: "carousel_error_retry",
    defaultMessage: "Try Again",
  },
  carousel_error_title: {
    id: "carousel_error_title",
    defaultMessage: "Unable to display carousel content",
  },
  carousel_image_unavailable: {
    id: "carousel_image_unavailable",
    defaultMessage: "Image unavailable",
  },
  carousel_modal_close: {
    id: "carousel_modal_close",
    defaultMessage: "Close modal",
  },
  carousel_modal_next: {
    id: "carousel_modal_next",
    defaultMessage: "Next image",
  },
  carousel_modal_previous: {
    id: "carousel_modal_previous",
    defaultMessage: "Previous image",
  },
  carousel_modal_zoom_in: {
    id: "carousel_modal_zoom_in",
    defaultMessage: "Zoom in",
  },
  carousel_modal_zoom_out: {
    id: "carousel_modal_zoom_out",
    defaultMessage: "Zoom out",
  },
  carousel_modal_zoom_reset: {
    id: "carousel_modal_zoom_reset",
    defaultMessage: "Reset zoom",
  },
  carousel_next: {
    id: "carousel_next",
    defaultMessage: "Next slide",
  },
  carousel_previous: {
    id: "carousel_previous",
    defaultMessage: "Previous slide",
  },
  carousel_region_label: {
    id: "carousel_region_label",
    defaultMessage: "Image carousel",
  },
  carousel_slide_label: {
    id: "carousel_slide_label",
    defaultMessage: "Slide {slideNumber}",
  },
  chart_widget_area_chart: {
    id: "chart_widget_area_chart",
    defaultMessage: "Area Chart",
  },
  chart_widget_average: {
    id: "chart_widget_average",
    defaultMessage: "Average",
  },
  chart_widget_bar_chart: {
    id: "chart_widget_bar_chart",
    defaultMessage: "Bar Chart",
  },
  chart_widget_chart_type_controls: {
    id: "chart_widget_chart_type_controls",
    defaultMessage: "Chart type controls",
  },
  chart_widget_current: {
    id: "chart_widget_current",
    defaultMessage: "Current",
  },
  chart_widget_data_labels: {
    id: "chart_widget_data_labels",
    defaultMessage: "Data Labels",
  },
  chart_widget_data_points: {
    id: "chart_widget_data_points",
    defaultMessage: "Data Points",
  },
  chart_widget_day_friday: {
    id: "chart_widget_day_friday",
    defaultMessage: "Fri",
  },
  task_template_disabled_on_days: {
    id: "task_template_disabled_on_days",
    defaultMessage: "Disabled On Days",
  },
  chart_widget_day_monday: {
    id: "chart_widget_day_monday",
    defaultMessage: "Mon",
  },
  chart_widget_day_saturday: {
    id: "chart_widget_day_saturday",
    defaultMessage: "Sat",
  },
  chart_widget_day_sunday: {
    id: "chart_widget_day_sunday",
    defaultMessage: "Sun",
  },
  chart_widget_day_thursday: {
    id: "chart_widget_day_thursday",
    defaultMessage: "Thu",
  },
  chart_widget_day_tuesday: {
    id: "chart_widget_day_tuesday",
    defaultMessage: "Tue",
  },
  chart_widget_day_wednesday: {
    id: "chart_widget_day_wednesday",
    defaultMessage: "Wed",
  },
  chart_widget_enable_export: {
    id: "chart_widget_enable_export",
    defaultMessage: "Enable Export",
  },
  chart_widget_enable_zoom: {
    id: "chart_widget_enable_zoom",
    defaultMessage: "Enable Zoom",
  },
  chart_widget_gradient: {
    id: "chart_widget_gradient",
    defaultMessage: "Gradient",
  },
  chart_widget_line_chart: {
    id: "chart_widget_line_chart",
    defaultMessage: "Line Chart",
  },
  chart_widget_no_data: {
    id: "chart_widget_no_data",
    defaultMessage: "No data provided to display.",
  },
  chart_widget_pie_chart: {
    id: "chart_widget_pie_chart",
    defaultMessage: "Pie Chart",
  },
  chart_widget_select_metric: {
    id: "chart_widget_select_metric",
    defaultMessage: "Select metric to display",
  },
  chart_widget_smooth_curves: {
    id: "chart_widget_smooth_curves",
    defaultMessage: "Smooth Curves",
  },
  chart_widget_solid: {
    id: "chart_widget_solid",
    defaultMessage: "Solid",
  },
  chart_widget_sparkline: {
    id: "chart_widget_sparkline",
    defaultMessage: "Sparkline",
  },
  chart_widget_switch_to_area: {
    id: "chart_widget_switch_to_area",
    defaultMessage: "Switch to area chart",
  },
  chart_widget_switch_to_bar: {
    id: "chart_widget_switch_to_bar",
    defaultMessage: "Switch to bar chart",
  },
  chart_widget_switch_to_line: {
    id: "chart_widget_switch_to_line",
    defaultMessage: "Switch to line chart",
  },
  chart_widget_switch_to_pie: {
    id: "chart_widget_switch_to_pie",
    defaultMessage: "Switch to pie chart",
  },
  chart_widget_time_range_1year: {
    id: "chart_widget_time_range_1year",
    defaultMessage: "Last Year",
  },
  chart_widget_time_range_24hours: {
    id: "chart_widget_time_range_24hours",
    defaultMessage: "Last 24 Hours",
  },
  chart_widget_time_range_30days: {
    id: "chart_widget_time_range_30days",
    defaultMessage: "Last 30 Days",
  },
  chart_widget_time_range_7days: {
    id: "chart_widget_time_range_7days",
    defaultMessage: "Last 7 Days",
  },
  chart_widget_time_range_90days: {
    id: "chart_widget_time_range_90days",
    defaultMessage: "Last 3 Months",
  },
  chart_widget_toggle_data_labels: {
    id: "chart_widget_toggle_data_labels",
    defaultMessage: "Toggle data labels",
  },
  chart_widget_toggle_data_points: {
    id: "chart_widget_toggle_data_points",
    defaultMessage: "Toggle data points",
  },
  chart_widget_toggle_export: {
    id: "chart_widget_toggle_export",
    defaultMessage: "Toggle export",
  },
  chart_widget_toggle_fill: {
    id: "chart_widget_toggle_fill",
    defaultMessage: "Toggle fill mode",
  },
  chart_widget_toggle_smooth_curves: {
    id: "chart_widget_toggle_smooth_curves",
    defaultMessage: "Toggle smooth curves",
  },
  chart_widget_toggle_sparkline: {
    id: "chart_widget_toggle_sparkline",
    defaultMessage: "Toggle sparkline mode",
  },
  chart_widget_toggle_zoom: {
    id: "chart_widget_toggle_zoom",
    defaultMessage: "Toggle zoom",
  },
  chart_widget_trend: {
    id: "chart_widget_trend",
    defaultMessage: "Trend",
  },
  chart_widget_untitled: {
    id: "chart_widget_untitled",
    defaultMessage: "Untitled",
  },
  date_recorded: {
    id: "date_recorded",
    defaultMessage: "Date Recorded: {date}",
  },
  no_alert_settings_configured: {
    id: "no_alert_settings_configured",
    defaultMessage: "No alert settings configured",
  },
  on_hold: {
    id: "on_hold",
    defaultMessage: "On Hold",
  },
  override_active_until: {
    id: "override_active_until",
    defaultMessage: "Override active until {date}",
  },
  show_less: {
    id: "show_less",
    defaultMessage: "Show less",
  },
  show_more: {
    id: "show_more",
    defaultMessage: "Show more",
  },
  video_aborted_error: {
    id: "video_aborted_error",
    defaultMessage: "Video loading was aborted",
  },
  video_decode_error: {
    id: "video_decode_error",
    defaultMessage: "Video decoding failed",
  },
  video_download_error: {
    id: "video_download_error",
    defaultMessage: "Unable to download video.",
  },
  video_format_error: {
    id: "video_format_error",
    defaultMessage: "Video format not supported",
  },
  video_fullscreen_entered: {
    id: "video_fullscreen_entered",
    defaultMessage: "Video entered fullscreen mode. Press F or Escape to exit.",
  },
  video_fullscreen_error: {
    id: "video_fullscreen_error",
    defaultMessage: "Unable to enter fullscreen mode.",
  },
  video_fullscreen_exited: {
    id: "video_fullscreen_exited",
    defaultMessage: "Video exited fullscreen mode.",
  },
  video_load_error: {
    id: "video_load_error",
    defaultMessage: "Failed to load video file. Please try again.",
  },
  video_mute_error: {
    id: "video_mute_error",
    defaultMessage: "Unable to mute/unmute video.",
  },
  video_network_error: {
    id: "video_network_error",
    defaultMessage: "Network error occurred while loading video",
  },
  video_play_error: {
    id: "video_play_error",
    defaultMessage: "Unable to play video. Please check your connection.",
  },
  video_play_item: {
    id: "video_play_item",
    defaultMessage: "Play video: {title}",
  },
  video_player_current_time: {
    id: "video_player_current_time",
    defaultMessage: "Current time",
  },
  video_player_download: {
    id: "video_player_download",
    defaultMessage: "Download video",
  },
  video_player_error_title: {
    id: "video_player_error_title",
    defaultMessage: "Video Error",
  },
  video_player_fullscreen_enter: {
    id: "video_player_fullscreen_enter",
    defaultMessage: "Enter fullscreen",
  },
  video_player_fullscreen_exit: {
    id: "video_player_fullscreen_exit",
    defaultMessage: "Exit fullscreen",
  },
  video_player_loading: {
    id: "video_player_loading",
    defaultMessage: "Loading video...",
  },
  video_player_mute: {
    id: "video_player_mute",
    defaultMessage: "Mute video",
  },
  video_player_pause: {
    id: "video_player_pause",
    defaultMessage: "Pause video",
  },
  video_player_play: {
    id: "video_player_play",
    defaultMessage: "Play video",
  },
  video_player_progress: {
    id: "video_player_progress",
    defaultMessage: "Video progress",
  },
  video_player_retry: {
    id: "video_player_retry",
    defaultMessage: "Retry Video",
  },
  video_player_retry_attempts: {
    id: "video_player_retry_attempts",
    defaultMessage: "Retry ({attempts} attempts left)",
  },
  video_player_total_duration: {
    id: "video_player_total_duration",
    defaultMessage: "Total duration",
  },
  video_player_type_label: {
    id: "video_player_type_label",
    defaultMessage: "VIDEO",
  },
  video_player_unmute: {
    id: "video_player_unmute",
    defaultMessage: "Unmute video",
  },
  video_player_up_next: {
    id: "video_player_up_next",
    defaultMessage: "Up Next",
  },
  video_player_volume_control: {
    id: "video_player_volume_control",
    defaultMessage: "Volume control",
  },
  video_seek_error: {
    id: "video_seek_error",
    defaultMessage: "Unable to seek video position.",
  },
  video_volume_error: {
    id: "video_volume_error",
    defaultMessage: "Unable to adjust volume.",
  },
  cannot_find_target_slot: {
    id: "cannot_find_target_slot",
    defaultMessage: "Cannot find the target time slot. Please try again.",
  },
  cannot_reschedule_occupied_slot: {
    id: "cannot_reschedule_occupied_slot",
    defaultMessage:
      "Cannot reschedule to an occupied time slot. Please choose a free slot.",
  },
  slot_not_available: {
    id: "slot_not_available",
    defaultMessage: "This slot is not available for rescheduling.",
  },
  reschedule_logs: {
    id: "reschedule_logs",
    defaultMessage: "Reschedule Logs",
  },
  close_without_saving: {
    id: "close_without_saving",
    defaultMessage: "Close without saving",
  },
  confirm_close_create_appointment_wizard: {
    id: "confirm_close_create_appointment_wizard",
    defaultMessage:
      "Are you sure you want to close? Your changes will not be saved.",
  },
  rescheduled: {
    id: "rescheduled",
    defaultMessage: "Rescheduled",
  },
  // Add these at the end of the Messages object, before the closing });

  preview_mode_title: {
    id: "preview_mode_title",
    defaultMessage: "Preview Mode - Appointments Not Yet Created",
  },
  preview_mode_description: {
    id: "preview_mode_description",
    defaultMessage:
      'Review the appointment series below. You can reschedule or remove appointments before creating them. Click "Submit" to finalize and create these appointments.',
  },
  appointment_series_preview: {
    id: "appointment_series_preview",
    defaultMessage: "Appointment Series Preview",
  },
  appointments_count: {
    id: "appointments_count",
    defaultMessage: "{count} appointments",
  },
  warnings: {
    id: "warnings",
    defaultMessage: "Warnings",
  },
  date_moved: {
    id: "date_moved",
    defaultMessage: "Date Moved",
  },
  overflow: {
    id: "overflow",
    defaultMessage: "Overflow",
  },
  series_summary: {
    id: "series_summary",
    defaultMessage: "Series Summary",
  },
  total_appointments: {
    id: "total_appointments",
    defaultMessage: "Total",
  },
  first_appointment: {
    id: "first_appointment",
    defaultMessage: "First",
  },
  last_appointment: {
    id: "last_appointment",
    defaultMessage: "Last",
  },
  click_submit_to_create: {
    id: "click_submit_to_create",
    defaultMessage: 'Click "Submit" to create',
  },
  delete_appointment_confirm: {
    id: "delete_appointment_confirm",
    defaultMessage: "Delete appointment {title}, {date}?",
  },
  treatment_regimens: {
    id: "treatment_regimens",
    defaultMessage: "Treatment Regimens",
  },
  select_treatment_regimen: {
    id: "select_treatment_regimen",
    defaultMessage: "Select Treatment Regimen",
  },
  edit_mode: {
    id: "edit_mode",
    defaultMessage: "Edit Mode",
  },
  loading_regimens: {
    id: "loading_regimens",
    defaultMessage: "Loading regimens...",
  },
  choose_treatment_regimen: {
    id: "choose_treatment_regimen",
    defaultMessage: "Choose a treatment regimen...",
  },
  warning_change_regimen: {
    id: "warning_change_regimen",
    defaultMessage:
      "Changing the treatment regimen will require you to reselect appointment slots.",
  },
  please_select_regimen: {
    id: "please_select_regimen",
    defaultMessage: "Please select a treatment regimen",
  },
  reschedule_options: {
    id: "reschedule_options",
    defaultMessage: "Reschedule Options",
  },
  recurring_appointment_info: {
    id: "recurring_appointment_info",
    defaultMessage: "This is a recurring appointment series",
  },
  recurring_appointment_description: {
    id: "recurring_appointment_description",
    defaultMessage:
      "You can choose to reschedule only this appointment or apply the change to all appointments in the series.",
  },
  reschedule_single_only: {
    id: "reschedule_single_only",
    defaultMessage: "Reschedule this appointment only",
  },
  reschedule_single_description: {
    id: "reschedule_single_description",
    defaultMessage: "Only the appointment on {date} will be rescheduled",
  },
  reschedule_entire_series: {
    id: "reschedule_entire_series",
    defaultMessage: "Reschedule entire series",
  },
  reschedule_series_description: {
    id: "reschedule_series_description",
    defaultMessage: "All appointments in this series will be rescheduled",
  },
  number: {
    id: "number",
    defaultMessage: "#",
  },
  warning: {
    id: "warning",
    defaultMessage: "Warning",
  },
  cancellation_reason: {
    id: "cancellation_reason",
    defaultMessage: "Cancellation Reason",
  },
  upload_photo: {
    id: "upload_photo",
    defaultMessage: "Upload Photo",
  },
  click_to_upload_profile_photo: {
    id: "click_to_upload_profile_photo",
    defaultMessage: "Click to upload profile photo",
  },
  profile_photo: {
    id: "profile_photo",
    defaultMessage: "profile photo",
  },
  select_image_to_upload: {
    id: "select_image_to_upload",
    defaultMessage: "Select an image to upload",
  },
  choose: {
    id: "choose",
    defaultMessage: "Choose",
  },
  uploading: {
    id: "uploading",
    defaultMessage: "Uploading...",
  },
  invalid_file_type: {
    id: "invalid_file_type",
    defaultMessage:
      "Invalid file type. Please select a PNG, JPEG, or JPG image.",
  },
  file_too_large: {
    id: "file_too_large",
    defaultMessage: "File is too large. Maximum size is 5MB.",
  },
  photo_uploaded_successfully: {
    id: "photo_uploaded_successfully",
    defaultMessage: "Photo uploaded successfully.",
  },
  upload_failed: {
    id: "upload_failed",
    defaultMessage: "Upload failed. Please try again.",
  },
  reschedule_reason: {
    id: "reschedule_reason",
    defaultMessage: "Reschedule Reason",
  },
  reschedule_reason_placeholder: {
    id: "reschedule_reason_placeholder",
    defaultMessage: "Enter reason for rescheduling...",
  },
  show_recurrence_series_only: {
    id: "show_recurrence_series_only",
    defaultMessage: "Show Recurrence Series Only",
  },
  no_recurrence_schedules_found: {
    id: "no_recurrence_schedules_found",
    defaultMessage: "No recurrence series schedules found",
  },
  ignore_first_appointment_in_series: {
    id: "ignore_first_appointment_in_series",
    defaultMessage: "Ignore first appointment in series",
  },
  recommended_task: {
    id: "recommended_task",
    defaultMessage: "Recommended Task",
  },
  recommended_task_message: {
    id: "recommended_task_message",
    defaultMessage:
      "Based on your responses, we recommend completing this task:",
  },
  start_task: {
    id: "start_task",
    defaultMessage: "Start Task",
  },
  hi_there: {
    id: "hi_there",
    defaultMessage: "Hi there!",
  },
  time_for_daily_checkin: {
    id: "time_for_daily_checkin",
    defaultMessage: "Time for your daily check-in",
  },
  experiencing_symptoms_today: {
    id: "experiencing_symptoms_today",
    defaultMessage: "Are you experiencing any symptoms today?",
  },
  response_helps_care: {
    id: "response_helps_care",
    defaultMessage: "Your response helps us care for you better",
  },
  todays_progress: {
    id: "todays_progress",
    defaultMessage: "Today's Progress",
  },
  tasks_completed_today: {
    id: "tasks_completed_today",
    defaultMessage: "{completed} of {total} tasks",
  },
  unread_updates: {
    id: "unread_updates",
    defaultMessage: "{count} unread",
  },
  treatment_program: {
    id: "treatment_program",
    defaultMessage: "Program",
  },
  day_x: {
    id: "day_x",
    defaultMessage: "Day {day}",
  },
  start_date: {
    id: "start_date",
    defaultMessage: "Start Date",
  },
  apply_filter: {
    id: "apply_filter",
    defaultMessage: "Apply Filter",
  },
  change_dates: {
    id: "change_dates",
    defaultMessage: "Change Dates",
  },
  choose_start_end_dates: {
    id: "choose_start_end_dates",
    defaultMessage: "Choose start and end dates below",
  },
  select_date_range: {
    id: "select_date_range",
    defaultMessage: "Date Range Filter",
  },

  // Entra ID Authentication
  entra_completing_sign_in: {
    id: "entra_completing_sign_in",
    defaultMessage: "Completing sign in...",
  },
  entra_verifying_credentials: {
    id: "entra_verifying_credentials",
    defaultMessage: "Please wait while we verify your credentials",
  },
  entra_sign_in_successful: {
    id: "entra_sign_in_successful",
    defaultMessage: "Sign in successful!",
  },
  entra_redirecting_to_app: {
    id: "entra_redirecting_to_app",
    defaultMessage: "Redirecting you to the application...",
  },
  entra_sign_in_failed: {
    id: "entra_sign_in_failed",
    defaultMessage: "Sign in failed",
  },
  entra_error_occurred: {
    id: "entra_error_occurred",
    defaultMessage: "An error occurred",
  },
  entra_redirecting_to_login: {
    id: "entra_redirecting_to_login",
    defaultMessage: "Redirecting you back to login...",
  },
  entra_login_failed_try_again: {
    id: "entra_login_failed_try_again",
    defaultMessage: "Login failed. Please try again.",
  },
  entra_no_session_id: {
    id: "entra_no_session_id",
    defaultMessage: "No session ID received",
  },
  entra_login_failed_param: {
    id: "entra_login_failed_param",
    defaultMessage: "Login failed: {error}",
  },

  // Entra ID Facility Selection
  entra_session_expired: {
    id: "entra_session_expired",
    defaultMessage: "Session expired. Please log in again.",
  },
  entra_invalid_session: {
    id: "entra_invalid_session",
    defaultMessage: "Invalid session data. Please log in again.",
  },
  entra_please_select_facility: {
    id: "entra_please_select_facility",
    defaultMessage: "Please select a facility",
  },
  entra_failed_select_facility: {
    id: "entra_failed_select_facility",
    defaultMessage: "Failed to select facility. Please try again.",
  },
  entra_session_error: {
    id: "entra_session_error",
    defaultMessage: "Session Error",
  },
  entra_select_your_facility: {
    id: "entra_select_your_facility",
    defaultMessage: "Select Your Facility",
  },
  entra_welcome_user: {
    id: "entra_welcome_user",
    defaultMessage: "Welcome, {user}",
  },
  entra_multiple_facilities_msg: {
    id: "entra_multiple_facilities_msg",
    defaultMessage:
      "You have access to multiple facilities. Please select one to continue.",
  },
  entra_unknown_facility: {
    id: "entra_unknown_facility",
    defaultMessage: "Unknown Facility",
  },
  entra_signing_in: {
    id: "entra_signing_in",
    defaultMessage: "Signing in...",
  },

  // Entra ID Group Mappings
  entra_error_loading_data: {
    id: "entra_error_loading_data",
    defaultMessage: "Error loading data",
  },
  entra_fill_required_fields: {
    id: "entra_fill_required_fields",
    defaultMessage: "Please fill in all required fields",
  },
  entra_mapping_updated: {
    id: "entra_mapping_updated",
    defaultMessage: "Group mapping updated successfully",
  },
  entra_mapping_created: {
    id: "entra_mapping_created",
    defaultMessage: "Group mapping created successfully",
  },
  entra_error_saving_mapping: {
    id: "entra_error_saving_mapping",
    defaultMessage: "Error saving group mapping",
  },
  entra_confirm_delete_mapping: {
    id: "entra_confirm_delete_mapping",
    defaultMessage: "Are you sure you want to delete this mapping?",
  },
  entra_mapping_deleted: {
    id: "entra_mapping_deleted",
    defaultMessage: "Group mapping deleted successfully",
  },
  entra_error_deleting_mapping: {
    id: "entra_error_deleting_mapping",
    defaultMessage: "Error deleting group mapping",
  },
  entra_id_status: {
    id: "entra_id_status",
    defaultMessage: "Entra ID Status",
  },
  entra_total_mappings: {
    id: "entra_total_mappings",
    defaultMessage: "Total Mappings",
  },
  entra_active_mappings: {
    id: "entra_active_mappings",
    defaultMessage: "Active Mappings",
  },
  entra_id_enabled: {
    id: "entra_id_enabled",
    defaultMessage: "Entra ID Enabled",
  },
  entra_allow_password_login: {
    id: "entra_allow_password_login",
    defaultMessage: "Allow Password Login",
  },
  entra_password_login_enabled: {
    id: "entra_password_login_enabled",
    defaultMessage: "Password login enabled for SSO users",
  },
  entra_password_login_disabled: {
    id: "entra_password_login_disabled",
    defaultMessage: "Password login disabled for SSO users",
  },
  entra_edit_group_mapping: {
    id: "entra_edit_group_mapping",
    defaultMessage: "Edit Group Mapping",
  },
  entra_create_group_mapping: {
    id: "entra_create_group_mapping",
    defaultMessage: "Create Group Mapping",
  },
  entra_group_id: {
    id: "entra_group_id",
    defaultMessage: "Entra ID Group ID",
  },
  entra_object_id_hint: {
    id: "entra_object_id_hint",
    defaultMessage: "The Object ID from Azure AD group",
  },
  entra_group_name: {
    id: "entra_group_name",
    defaultMessage: "Entra ID Group Name",
  },
  entra_select_facility: {
    id: "entra_select_facility",
    defaultMessage: "Select a facility",
  },
  entra_current_facility: {
    id: "entra_current_facility",
    defaultMessage: "Current facility",
  },
  entra_mappings_for_facility: {
    id: "entra_mappings_for_facility",
    defaultMessage: "Mappings will be created for your current facility",
  },
  entra_auto_provision: {
    id: "entra_auto_provision",
    defaultMessage: "Auto-provision users",
  },
  entra_auto_provision_hint: {
    id: "entra_auto_provision_hint",
    defaultMessage: "Automatically create Space access when users log in",
  },
  entra_active_hint: {
    id: "entra_active_hint",
    defaultMessage: "Only active mappings are used",
  },
  entra_no_mappings_found: {
    id: "entra_no_mappings_found",
    defaultMessage: "No group mappings found.",
  },
  entra_create_first_mapping_hint: {
    id: "entra_create_first_mapping_hint",
    defaultMessage:
      'Click "Create Mapping" to set up your first Entra ID group mapping.',
  },
  entra_group_name_col: {
    id: "entra_group_name_col",
    defaultMessage: "Group Name",
  },
  entra_auto_provision_col: {
    id: "entra_auto_provision_col",
    defaultMessage: "Auto-Provision",
  },
  entra_inactive: {
    id: "entra_inactive",
    defaultMessage: "Inactive",
  },
  entra_group_mappings_title: {
    id: "entra_group_mappings_title",
    defaultMessage: "Entra ID Group Mappings",
  },
  entra_group_mappings_desc: {
    id: "entra_group_mappings_desc",
    defaultMessage:
      "Manage Microsoft Entra ID security group mappings to facilities and roles",
  },
  entra_create_mapping_btn: {
    id: "entra_create_mapping_btn",
    defaultMessage: "Create Mapping",
  },
  entra_default_care_teams: {
    id: "entra_default_care_teams",
    defaultMessage: "Default CareTeam(s)",
  },
  entra_default_care_teams_hint: {
    id: "entra_default_care_teams_hint",
    defaultMessage:
      "Auto-provisioned staff will be assigned to these CareTeams. Hold Ctrl/Cmd to select multiple.",
  },
  entra_default_role_template: {
    id: "entra_default_role_template",
    defaultMessage: "Default Role Template",
  },
  entra_default_role_template_hint: {
    id: "entra_default_role_template_hint",
    defaultMessage:
      "Applies privileges and visibility settings from a role template to new staff on first login.",
  },
  entra_no_template: {
    id: "entra_no_template",
    defaultMessage: "No template (minimal privileges)",
  },
  entra_no_facility_mappings_title: {
    id: "entra_no_facility_mappings_title",
    defaultMessage: "Microsoft account not linked to a facility",
  },
  entra_no_facility_mappings_msg: {
    id: "entra_no_facility_mappings_msg",
    defaultMessage:
      "Your Microsoft login was successful, but your account is not yet linked to any facility. You can sign in with your password below, or contact your administrator to set up access.",
  },
  facility: {
    id: "facility",
    defaultMessage: "Facility",
  },
  doctor: {
    id: "doctor",
    defaultMessage: "Doctor",
  },
  nurse: {
    id: "nurse",
    defaultMessage: "Nurse",
  },
  general_staff: {
    id: "general_staff",
    defaultMessage: "General Staff",
  },
  mps_admin: {
    id: "mps_admin",
    defaultMessage: "MPS Admin",
  },
  export_pdf: {
    id: "export_pdf",
    defaultMessage: "Export PDF",
  },
  unnamed_medication: {
    id: "unnamed_medication",
    defaultMessage: "Unnamed Medication",
  },
  unknown: {
    id: "unknown",
    defaultMessage: "Unknown",
  },
  dosage_label: {
    id: "dosage_label",
    defaultMessage: "Dosage:",
  },
  prn_label: {
    id: "prn_label",
    defaultMessage: "PRN:",
  },
  as_needed: {
    id: "as_needed",
    defaultMessage: "As needed",
  },
  added_label: {
    id: "added_label",
    defaultMessage: "Added:",
  },
  start_label: {
    id: "start_label",
    defaultMessage: "Start:",
  },
  end_label: {
    id: "end_label",
    defaultMessage: "End:",
  },
  reason_label: {
    id: "reason_label",
    defaultMessage: "Reason:",
  },
  form_label: {
    id: "form_label",
    defaultMessage: "Form:",
  },
  complete_medications_list: {
    id: "complete_medications_list",
    defaultMessage: "Complete Medications List",
  },
  generated_on: {
    id: "generated_on",
    defaultMessage: "Generated on:",
  },
  total_medications: {
    id: "total_medications",
    defaultMessage: "Total medications:",
  },
  active_medications: {
    id: "active_medications",
    defaultMessage: "Active Medications",
  },
  other_medications: {
    id: "other_medications",
    defaultMessage: "Other Medications",
  },
  medication_count: {
    id: "medication_count",
    defaultMessage: "{count, plural, one {# medication} other {# medications}}",
  },
  no_active_medications: {
    id: "no_active_medications",
    defaultMessage: "No active medications found.",
  },
  no_other_medications: {
    id: "no_other_medications",
    defaultMessage: "No other medications found.",
  },
  all_milestones: {
    id: "all_milestones",
    defaultMessage: "All Milestones",
  },
  x_of_y_tasks: {
    id: "x_of_y_tasks",
    defaultMessage: "{completed} of {total} tasks",
  },
  error_no_search_criteria: {
    id: "error_no_search_criteria",
    defaultMessage: "Error: No search criteria specified.",
  },
  error_bulk_action_apply_filters: {
    id: "error_bulk_action_apply_filters",
    defaultMessage:
      "Error: Cannot send to all patients. Please apply search filters first.",
  },
  error_bulk_careplan_no_criteria: {
    id: "error_bulk_careplan_no_criteria",
    defaultMessage:
      "Error: Cannot assign care plan. No search criteria specified.",
  },
  error_invalid_search_apply_filters: {
    id: "error_invalid_search_apply_filters",
    defaultMessage:
      "Error: Invalid search query. Please reload or apply search filters first.",
  },
  articles_in_sections: {
    id: "articles_in_sections",
    defaultMessage:
      "{articleCount} {articleCount, plural, one {article} other {articles}} in {sectionCount} {sectionCount, plural, one {section} other {sections}}",
  },
  article_count: {
    id: "article_count",
    defaultMessage: "{count} {count, plural, one {article} other {articles}}",
  },
  section_count: {
    id: "section_count",
    defaultMessage: "{count} {count, plural, one {section} other {sections}}",
  },
  empty: {
    id: "empty",
    defaultMessage: "Empty",
  },
  otp_logs_title: {
    id: "otp_logs_title",
    defaultMessage: "OTP Logs",
  },
  otp_logs_copy_otp: {
    id: "otp_logs_copy_otp",
    defaultMessage: "Copy OTP",
  },
  otp_logs_view_details: {
    id: "otp_logs_view_details",
    defaultMessage: "View Details",
  },
  otp_logs_view_json: {
    id: "otp_logs_view_json",
    defaultMessage: "View JSON",
  },
  otp_logs_details_title: {
    id: "otp_logs_details_title",
    defaultMessage: "OTP Log Details",
  },
  otp_logs_user: {
    id: "otp_logs_user",
    defaultMessage: "User",
  },
  otp_logs_operation: {
    id: "otp_logs_operation",
    defaultMessage: "Operation",
  },
  otp_logs_otp_code: {
    id: "otp_logs_otp_code",
    defaultMessage: "OTP Code",
  },
  otp_logs_recipient: {
    id: "otp_logs_recipient",
    defaultMessage: "Recipient",
  },
  otp_logs_message: {
    id: "otp_logs_message",
    defaultMessage: "Message",
  },
  otp_logs_facility_id: {
    id: "otp_logs_facility_id",
    defaultMessage: "Facility ID",
  },
  otp_logs_json_title: {
    id: "otp_logs_json_title",
    defaultMessage: "JSON Data",
  },
  otp_logs_no_logs: {
    id: "otp_logs_no_logs",
    defaultMessage: "No OTP logs available.",
  },
  otp_logs_showing_count: {
    id: "otp_logs_showing_count",
    defaultMessage: "Showing {count} OTP logs",
  },
  otp_logs_type: {
    id: "otp_logs_type",
    defaultMessage: "Type",
  },
  content_index_status: {
    id: "content_index_status",
    defaultMessage: "Content Index Status",
  },
  content_index_ready: {
    id: "content_index_ready",
    defaultMessage: "Ready",
  },
  content_index_indexing: {
    id: "content_index_indexing",
    defaultMessage: "Indexing...",
  },
  content_index_error: {
    id: "content_index_error",
    defaultMessage: "Error",
  },
  content_index_not_created: {
    id: "content_index_not_created",
    defaultMessage: "Not Created",
  },
  content_index_items_indexed: {
    id: "content_index_items_indexed",
    defaultMessage: "{count} items indexed",
  },
  content_index_last_indexed: {
    id: "content_index_last_indexed",
    defaultMessage: "Last indexed: {date}",
  },
  content_index_reindex: {
    id: "content_index_reindex",
    defaultMessage: "Reindex",
  },
  content_index_reindex_all: {
    id: "content_index_reindex_all",
    defaultMessage: "Reindex All",
  },
  content_index_reindex_started: {
    id: "content_index_reindex_started",
    defaultMessage: "Reindex has been started.",
  },
  content_index_patient_types_count: {
    id: "content_index_patient_types_count",
    defaultMessage: "{count} patient types",
  },
  content_index_ready_count: {
    id: "content_index_ready_count",
    defaultMessage: "{count} ready",
  },
  content_index_indexing_count: {
    id: "content_index_indexing_count",
    defaultMessage: "{count} indexing",
  },
  content_index_error_count: {
    id: "content_index_error_count",
    defaultMessage: "{count} error",
  },
  content_index_not_created_count: {
    id: "content_index_not_created_count",
    defaultMessage: "{count} not created",
  },
  ambientRecording: {
    id: "ambient_recording",
    defaultMessage: "Ambient Recording",
  },
  startRecording: {
    id: "start_recording",
    defaultMessage: "Start Recording",
  },
  stopRecording: {
    id: "stop_recording",
    defaultMessage: "Stop Recording",
  },
  enhance: {
    id: "enhance",
    defaultMessage: "Enhance",
  },
  enhancing: {
    id: "enhancing",
    defaultMessage: "Enhancing...",
  },
  acceptEnhanced: {
    id: "accept_enhanced",
    defaultMessage: "Accept Enhanced",
  },
  useOriginal: {
    id: "use_original",
    defaultMessage: "Use Original",
  },
  recording: {
    id: "recording",
    defaultMessage: "Recording",
  },
  transcribing: {
    id: "transcribing",
    defaultMessage: "Transcribing...",
  },
  enhancedVersion: {
    id: "enhanced_version",
    defaultMessage: "Enhanced Version",
  },
  originalTranscript: {
    id: "original_transcript",
    defaultMessage: "Original Transcript",
  },
  insertTranscript: {
    id: "insert_transcript",
    defaultMessage: "Insert into Note",
  },
  microphoneAccessRequired: {
    id: "microphone_access_required",
    defaultMessage: "Microphone access is required for ambient recording.",
  },
  speechRecognitionNotSupported: {
    id: "speech_recognition_not_supported",
    defaultMessage: "Speech recognition is not supported in this browser.",
  },
  enhanceWithAI: {
    id: "enhance_with_ai",
    defaultMessage: "Enhance with AI",
  },
  enhancingTranscript: {
    id: "enhancing_transcript",
    defaultMessage: "Enhancing transcript...",
  },
  dismiss: {
    id: "dismiss",
    defaultMessage: "Dismiss",
  },
  keepOriginal: {
    id: "keep_original",
    defaultMessage: "Keep Original",
  },
  continueDictating: {
    id: "continue_dictating",
    defaultMessage: "Continue Dictating",
  },
  enhanceFailed: {
    id: "enhance_failed",
    defaultMessage: "Could not tidy the transcript. Your dictated text is unchanged.",
  },
  editEnhancedHint: {
    id: "edit_enhanced_hint",
    defaultMessage: "You can edit this text before inserting it.",
  },
  cleanedUpDictation: {
    id: "cleaned_up_dictation",
    defaultMessage: "Cleaned up your dictation",
  },
  dictationChangeCount: {
    id: "dictation_change_count",
    defaultMessage: "{count, plural, one {# change} other {# changes}}",
  },
  dictationNoChanges: {
    id: "dictation_no_changes",
    defaultMessage: "No changes",
  },
  showWhatISaid: {
    id: "show_what_i_said",
    defaultMessage: "Show what I said",
  },
  showChanges: {
    id: "show_changes",
    defaultMessage: "Show changes",
  },
  hideChanges: {
    id: "hide_changes",
    defaultMessage: "Hide changes",
  },
  hideWhatISaid: {
    id: "hide_what_i_said",
    defaultMessage: "Hide what I said",
  },
  whatISaid: {
    id: "what_i_said",
    defaultMessage: "What I said",
  },
  useThisText: {
    id: "use_this_text",
    defaultMessage: "Use this",
  },
  keepMyOriginal: {
    id: "keep_my_original",
    defaultMessage: "Keep my original",
  },
  editCleanedText: {
    id: "edit_cleaned_text",
    defaultMessage: "Edit the cleaned up text",
  },
  doneEditingText: {
    id: "done_editing_text",
    defaultMessage: "Done editing",
  },
  addMoreDictation: {
    id: "add_more_dictation",
    defaultMessage: "Add more dictation",
  },
  record: {
    id: "record",
    defaultMessage: "Record",
  },
  stop: {
    id: "stop",
    defaultMessage: "Stop",
  },
  startAmbientRecording: {
    id: "start_ambient_recording",
    defaultMessage: "Start ambient recording",
  },
  your_care_teams: {
    id: "your_care_teams",
    defaultMessage: "Your Care Teams",
  },
  not_member_of_any_care_team: {
    id: "not_member_of_any_care_team",
    defaultMessage: "You are not currently a member of any care team.",
  },
  team_members_count: {
    id: "team_members_count",
    defaultMessage: "{count} {count, plural, one {member} other {members}}",
  },
  your_role: {
    id: "your_role",
    defaultMessage: "Your Role",
  },
  account_info: {
    id: "account_info",
    defaultMessage: "Account Info",
  },
  account_security: {
    id: "account_security",
    defaultMessage: "Account Security",
  },
  last_login: {
    id: "last_login",
    defaultMessage: "Last Login",
  },
  bulk_selection_limit: {
    id: "bulk_selection_limit",
    defaultMessage: "Maximum {limit} tasks at a time",
  },
  consolidated_interactions_report: {
    id: "consolidated_interactions_report",
    defaultMessage: "Consolidated Interactions Report",
  },
  patient_interaction_report: {
    id: "patient_interaction_report",
    defaultMessage: "Patient Interaction Report",
  },
  date_of_birth: {
    id: "date_of_birth",
    defaultMessage: "Date of Birth",
  },
  treatment_start: {
    id: "treatment_start",
    defaultMessage: "Treatment Start",
  },
  treatment_type: {
    id: "treatment_type",
    defaultMessage: "Treatment Type",
  },
  device_label: {
    id: "device_label",
    defaultMessage: "Device Type",
  },
  mask_label: {
    id: "mask_label",
    defaultMessage: "Mask",
  },
  last_mask_issued: {
    id: "last_mask_issued",
    defaultMessage: "Last Mask Issued",
  },
  last_contact_attempted: {
    id: "last_contact_attempted",
    defaultMessage: "Last Contact Attempted",
  },
  hospital_clinic: {
    id: "hospital_clinic",
    defaultMessage: "Hospital / Clinic",
  },
  hospital_internal_ref: {
    id: "hospital_internal_ref",
    defaultMessage: "Hospital Internal Ref",
  },
  interaction_summary: {
    id: "interaction_summary",
    defaultMessage: "Interaction Summary",
  },
  interaction_timeline: {
    id: "interaction_timeline",
    defaultMessage: "Interaction Timeline",
  },
  interaction_detail: {
    id: "interaction_detail",
    defaultMessage: "Interaction Detail",
  },
  product_orders: {
    id: "product_orders",
    defaultMessage: "Product Orders",
  },
  referring_hospital: {
    id: "referring_hospital",
    defaultMessage: "Referring Hospital",
  },
  none_recorded: {
    id: "none_recorded",
    defaultMessage: "None recorded",
  },
  patient_contact_activity: {
    id: "patient_contact_activity",
    defaultMessage: "Patient Contact Activity",
  },
  interaction_types_stacked_subtitle: {
    id: "interaction_types_stacked_subtitle",
    defaultMessage:
      "All interaction types stacked by day across the reporting period",
  },
  orders_equipment_changes: {
    id: "orders_equipment_changes",
    defaultMessage: "Orders & Equipment Changes",
  },
  confidential_patient_record: {
    id: "confidential_patient_record",
    defaultMessage: "Confidential patient record",
  },
  report_generated_date: {
    id: "report_generated_date",
    defaultMessage: "Generated {date}",
  },
  widget_created: {
    id: "widget_created",
    defaultMessage: "Widget has been created.",
  },
  widget_updated: {
    id: "widget_updated",
    defaultMessage: "Widget has been updated.",
  },
  widget_deleted: {
    id: "widget_deleted",
    defaultMessage: "Widget has been deleted.",
  },
  preferences: {
    id: "preferences",
    defaultMessage: "Preferences",
  },
  default_landing_page: {
    id: "default_landing_page",
    defaultMessage: "Default Landing Page",
  },
  notes_expanded_by_default: {
    id: "notes_expanded_by_default",
    defaultMessage: "Notes expanded by default",
  },
  notes_expanded_description: {
    id: "notes_expanded_description",
    defaultMessage: "Show staff notes in expanded view when opening a patient",
  },
  preferences_description: {
    id: "preferences_description",
    defaultMessage: "Personalize your experience. Settings are saved locally.",
  },
  preferences_info_blurb: {
    id: "preferences_info_blurb",
    defaultMessage:
      "Your preferences are saved automatically — no need to click save. They are stored on this device, will persist across logins, and will remain until you clear your browser cache.",
  },
  resume_last_page: {
    id: "resume_last_page",
    defaultMessage: "Resume where I left off",
  },
  resume_last_page_description: {
    id: "resume_last_page_description",
    defaultMessage:
      "On login, return to the last page you were viewing — including the specific patient and tab. Overrides the default landing page.",
  },
  configuration: {
    id: "configuration",
    defaultMessage: "Configuration",
  },
  master_data: {
    id: "master_data",
    defaultMessage: "Master Data",
  },
  terminology: {
    id: "terminology",
    defaultMessage: "Terminology",
  },
  simulator_ongoing: {
    id: "simulator_ongoing",
    defaultMessage: "Ongoing",
  },
  simulator_due: {
    id: "simulator_due",
    defaultMessage: "Due",
  },
  simulator_sent: {
    id: "simulator_sent",
    defaultMessage: "Sent",
  },
  simulator_missed: {
    id: "simulator_missed",
    defaultMessage: "Missed",
  },
  simulator_day_completed: {
    id: "simulator_day_completed",
    defaultMessage: "Completed",
  },
  simulator_legend_title: {
    id: "simulator_legend_title",
    defaultMessage: "Status Legend",
  },
  simulator_legend_completed: {
    id: "simulator_legend_completed",
    defaultMessage: "Patient completed this task",
  },
  simulator_legend_ongoing: {
    id: "simulator_legend_ongoing",
    defaultMessage: "Waiting for patient to complete",
  },
  simulator_legend_fired: {
    id: "simulator_legend_fired",
    defaultMessage:
      "Automatically sent to patient (notification, reminder, message)",
  },
  simulator_legend_missed: {
    id: "simulator_legend_missed",
    defaultMessage: "Past task with no completion record",
  },
  simulator_legend_future: {
    id: "simulator_legend_future",
    defaultMessage: "Scheduled for a future day",
  },
  content_index_status: {
    id: "content_index_status",
    defaultMessage: "Content Index Status",
  },
  content_index_ready: {
    id: "content_index_ready",
    defaultMessage: "Ready",
  },
  content_index_indexing: {
    id: "content_index_indexing",
    defaultMessage: "Indexing...",
  },
  content_index_error: {
    id: "content_index_error",
    defaultMessage: "Error",
  },
  content_index_not_created: {
    id: "content_index_not_created",
    defaultMessage: "Not Created",
  },
  content_index_items_indexed: {
    id: "content_index_items_indexed",
    defaultMessage: "{count} items indexed",
  },
  content_index_last_indexed: {
    id: "content_index_last_indexed",
    defaultMessage: "Last indexed: {date}",
  },
  content_index_reindex: {
    id: "content_index_reindex",
    defaultMessage: "Reindex",
  },
  content_index_reindex_all: {
    id: "content_index_reindex_all",
    defaultMessage: "Reindex All",
  },
  content_index_reindex_started: {
    id: "content_index_reindex_started",
    defaultMessage: "Reindex has been started.",
  },
  test_care_team: {
    id: "test_care_team",
    defaultMessage: "Test Care Team",
  },
  test_care_team_description: {
    id: "test_care_team_description",
    defaultMessage: "Mark as test care team (excluded from reports)",
  },
  billing_report: {
    id: "billing_report",
    defaultMessage: "Usage Summary",
  },
  billing_active_users: {
    id: "billing_active_users",
    defaultMessage: "Active Users",
  },
  billing_invited_users: {
    id: "billing_invited_users",
    defaultMessage: "Invited Users",
  },
  billing_onboarded_users: {
    id: "billing_onboarded_users",
    defaultMessage: "Onboarded Users",
  },
  billing_internal_users: {
    id: "billing_internal_users",
    defaultMessage: "Pre-Invite",
  },
  billing_deleted_users: {
    id: "billing_deleted_users",
    defaultMessage: "Deleted Users",
  },
  billing_new_patients: {
    id: "billing_new_patients",
    defaultMessage: "New Patients",
  },
  billing_new_admitted: {
    id: "billing_new_admitted",
    defaultMessage: "Admitted",
  },
  billing_new_discharged: {
    id: "billing_new_discharged",
    defaultMessage: "Discharged",
  },
  billing_in_treatment: {
    id: "billing_in_treatment",
    defaultMessage: "In Treatment",
  },
  billing_no_care_team: {
    id: "billing_no_care_team",
    defaultMessage: "No Care Team",
  },
  billing_total: {
    id: "billing_total",
    defaultMessage: "Total",
  },
  billing_select_month: {
    id: "billing_select_month",
    defaultMessage: "Select Month",
  },
  billing_load_report: {
    id: "billing_load_report",
    defaultMessage: "Load Report",
  },
  billing_view_current_month: {
    id: "billing_view_current_month",
    defaultMessage: "View Current Month",
  },
  billing_deleted_by_status: {
    id: "billing_deleted_by_status",
    defaultMessage: "Deleted Users by Status",
  },
  billing_status: {
    id: "billing_status",
    defaultMessage: "Status",
  },
  billing_count: {
    id: "billing_count",
    defaultMessage: "Count",
  },
  billing_activity_usage: {
    id: "billing_activity_usage",
    defaultMessage: "Activity & Usage",
  },
  billing_patients_logged_in: {
    id: "billing_patients_logged_in",
    defaultMessage: "Patients Logged In",
  },
  billing_staff_logged_in: {
    id: "billing_staff_logged_in",
    defaultMessage: "Staff Logged In",
  },
  billing_total_sms: {
    id: "billing_total_sms",
    defaultMessage: "SMS Sent",
  },
  billing_total_email: {
    id: "billing_total_email",
    defaultMessage: "Emails Sent",
  },
  billing_total_video: {
    id: "billing_total_video",
    defaultMessage: "Video Seconds",
  },
  billing_survey_submissions: {
    id: "billing_survey_submissions",
    defaultMessage: "Survey Submissions",
  },
  billing_tasks_created: {
    id: "billing_tasks_created",
    defaultMessage: "Tasks Created",
  },
  billing_status_messages: {
    id: "billing_status_messages",
    defaultMessage: "Status Messages",
  },
  billing_staff_notes: {
    id: "billing_staff_notes",
    defaultMessage: "Staff Notes",
  },
  billing_interactions: {
    id: "billing_interactions",
    defaultMessage: "Interactions",
  },
  billing_appts_created: {
    id: "billing_appts_created",
    defaultMessage: "Appointments Created",
  },
  billing_messages_read: {
    id: "billing_messages_read",
    defaultMessage: "Messages Read",
  },
  billing_export_csv: {
    id: "billing_export_csv",
    defaultMessage: "Export CSV",
  },
  billing_export_start: {
    id: "billing_export_start",
    defaultMessage: "Start",
  },
  billing_export_end: {
    id: "billing_export_end",
    defaultMessage: "End",
  },
  billing_monthly_view: {
    id: "billing_monthly_view",
    defaultMessage: "Monthly",
  },
  usage_trends_title: {
    id: "usage_trends_title",
    defaultMessage: "Trends",
  },
  usage_trends_patient_metrics: {
    id: "usage_trends_patient_metrics",
    defaultMessage: "Patient Metrics",
  },
  usage_trends_communication: {
    id: "usage_trends_communication",
    defaultMessage: "Communication",
  },
  usage_trends_engagement: {
    id: "usage_trends_engagement",
    defaultMessage: "Engagement",
  },
  usage_trends_operational: {
    id: "usage_trends_operational",
    defaultMessage: "Operational",
  },
  usage_trends_load: {
    id: "usage_trends_load",
    defaultMessage: "Load Trends",
  },
  usage_trends_loading_month: {
    id: "usage_trends_loading_month",
    defaultMessage: "Loading month {current} of {total}...",
  },
  staff_and_facility_admin: {
    id: "staff_and_facility_admin",
    defaultMessage: "Staff & Facility Admin",
  },
  no_master_data_for_staff: {
    id: "no_master_data_for_staff",
    defaultMessage: "No master data has been shared with you yet.",
  },
  breakfast: {
    id: "breakfast",
    defaultMessage: "Breakfast",
  },
  lunch: {
    id: "lunch",
    defaultMessage: "Lunch",
  },
  dinner: {
    id: "dinner",
    defaultMessage: "Dinner",
  },
  snack: {
    id: "snack",
    defaultMessage: "Snack",
  },
  meal: {
    id: "meal",
    defaultMessage: "Meal",
  },
  meals: {
    id: "meals",
    defaultMessage: "meals",
  },
  tap_for_details: {
    id: "tap_for_details",
    defaultMessage: "Tap for details",
  },
  food_items: {
    id: "food_items",
    defaultMessage: "Food Items",
  },
  additional_nutrients: {
    id: "additional_nutrients",
    defaultMessage: "Additional Nutrients",
  },
  potassium: {
    id: "potassium",
    defaultMessage: "Potassium",
  },
  skip_to_main_content: {
    id: "skip_to_main_content",
    defaultMessage: "Skip to main content",
  },
  ehr_import: {
    id: "ehr_import",
    defaultMessage: "Import from EHR",
  },
  ehr_import_search: {
    id: "ehr_import_search",
    defaultMessage: "Search EHR",
  },
  ehr_import_search_by_mrn: {
    id: "ehr_import_search_by_mrn",
    defaultMessage: "Search by MRN",
  },
  ehr_import_search_by_demographics: {
    id: "ehr_import_search_by_demographics",
    defaultMessage: "Search by Demographics",
  },
  ehr_import_mrn: {
    id: "ehr_import_mrn",
    defaultMessage: "Medical Record Number (MRN)",
  },
  ehr_import_first_name: {
    id: "ehr_import_first_name",
    defaultMessage: "First Name",
  },
  ehr_import_last_name: {
    id: "ehr_import_last_name",
    defaultMessage: "Last Name",
  },
  ehr_import_dob: {
    id: "ehr_import_dob",
    defaultMessage: "Date of Birth",
  },
  ehr_import_phone: {
    id: "ehr_import_phone",
    defaultMessage: "Phone",
  },
  ehr_import_email: {
    id: "ehr_import_email",
    defaultMessage: "Email",
  },
  ehr_import_search_button: {
    id: "ehr_import_search_button",
    defaultMessage: "Search",
  },
  ehr_import_no_results: {
    id: "ehr_import_no_results",
    defaultMessage: "No patients found. Try a different search.",
  },
  ehr_import_select_patient: {
    id: "ehr_import_select_patient",
    defaultMessage: "Select a patient to review",
  },
  ehr_import_review: {
    id: "ehr_import_review",
    defaultMessage: "Review Patient",
  },
  ehr_import_button: {
    id: "ehr_import_button",
    defaultMessage: "Import Patient",
  },
  ehr_import_success: {
    id: "ehr_import_success",
    defaultMessage: "Patient {name} imported successfully",
  },
  ehr_import_error: {
    id: "ehr_import_error",
    defaultMessage: "Failed to import patient. Please try again.",
  },
  ehr_import_searching: {
    id: "ehr_import_searching",
    defaultMessage: "Searching EHR...",
  },
  ehr_import_importing: {
    id: "ehr_import_importing",
    defaultMessage: "Importing patient...",
  },
  ehr_import_back_to_results: {
    id: "ehr_import_back_to_results",
    defaultMessage: "Back to Results",
  },
  ehr_import_back_to_search: {
    id: "ehr_import_back_to_search",
    defaultMessage: "Back to Search",
  },
  ehr_import_gender: {
    id: "ehr_import_gender",
    defaultMessage: "Gender",
  },
  ehr_import_address: {
    id: "ehr_import_address",
    defaultMessage: "Address",
  },
  ehr_import_results_count: {
    id: "ehr_import_results_count",
    defaultMessage: "{count} patient(s) found",
  },
  ehr_import_phone_or_email: {
    id: "ehr_import_phone_or_email",
    defaultMessage: "Phone or Email (optional)",
  },
  ehr_import_assign_to: {
    id: "ehr_import_assign_to",
    defaultMessage: "Assign To",
  },
  ehr_import_care_team: {
    id: "ehr_import_care_team",
    defaultMessage: "Care Team",
  },
  ehr_sync: {
    id: "ehr_sync",
    defaultMessage: "Sync with EHR",
  },
  ehr_sync_title: {
    id: "ehr_sync_title",
    defaultMessage: "Sync Patient with EHR",
  },
  ehr_sync_no_changes: {
    id: "ehr_sync_no_changes",
    defaultMessage: "Patient data is up to date with EHR",
  },
  ehr_sync_accept_ehr: {
    id: "ehr_sync_accept_ehr",
    defaultMessage: "Accept EHR",
  },
  ehr_sync_keep_current: {
    id: "ehr_sync_keep_current",
    defaultMessage: "Keep Current",
  },
  ehr_sync_accept_all_ehr: {
    id: "ehr_sync_accept_all_ehr",
    defaultMessage: "Accept All from EHR",
  },
  ehr_sync_field_mps: {
    id: "ehr_sync_field_mps",
    defaultMessage: "MPS (Current)",
  },
  ehr_sync_field_ehr: {
    id: "ehr_sync_field_ehr",
    defaultMessage: "EHR (EPIC)",
  },
  ehr_sync_field_name: {
    id: "ehr_sync_field_name",
    defaultMessage: "Field",
  },
  ehr_sync_differences_found: {
    id: "ehr_sync_differences_found",
    defaultMessage: "{count} difference(s) found",
  },
  ehr_sync_applying: {
    id: "ehr_sync_applying",
    defaultMessage: "Applying changes...",
  },
  ehr_sync_success: {
    id: "ehr_sync_success",
    defaultMessage: "Patient synced successfully",
  },
  ehr_sync_error: {
    id: "ehr_sync_error",
    defaultMessage: "Sync failed. Please try again.",
  },
  ehr_sync_last_synced: {
    id: "ehr_sync_last_synced",
    defaultMessage: "Synced {time}",
  },
  ehr_sync_never_synced: {
    id: "ehr_sync_never_synced",
    defaultMessage: "Never synced",
  },
  ehr_sync_no_mrn: {
    id: "ehr_sync_no_mrn",
    defaultMessage: "No MRN — cannot sync with EHR",
  },
  terminology_search_placeholder: {
    id: "terminology_search_placeholder",
    defaultMessage: "Search terminology...",
  },
  terminology_no_results: {
    id: "terminology_no_results",
    defaultMessage: "No results found",
  },
  terminology_showing_results: {
    id: "terminology_showing_results",
    defaultMessage: "Showing {shown} of {total} results",
  },
  terminology_server_unavailable: {
    id: "terminology_server_unavailable",
    defaultMessage: "Terminology server unavailable",
  },
  terminology_min_chars: {
    id: "terminology_min_chars",
    defaultMessage: "Type at least {min} characters to search",
  },
  terminology_inactive_code: {
    id: "terminology_inactive_code",
    defaultMessage: "inactive",
  },
  terminology_code_system: {
    id: "terminology_code_system",
    defaultMessage: "Code System",
  },
  terminology_choose_from_terminology: {
    id: "terminology_choose_from_terminology",
    defaultMessage: "Choose from terminology server",
  },
  terminology_link_to_code_system: {
    id: "terminology_link_to_code_system",
    defaultMessage: "Link to Terminology Code System",
  },
  terminology_validate_with_snomed: {
    id: "terminology_validate_with_snomed",
    defaultMessage: "Validate with SNOMED",
  },
  terminology_validate_with_icd10: {
    id: "terminology_validate_with_icd10",
    defaultMessage: "Validate with ICD-10",
  },
  terminology_validate_with_loinc: {
    id: "terminology_validate_with_loinc",
    defaultMessage: "Validate with LOINC",
  },
  terminology_snomed_interpretation: {
    id: "terminology_snomed_interpretation",
    defaultMessage: "SNOMED Interpretation Code",
  },
  terminology_conditions: {
    id: "terminology_conditions",
    defaultMessage: "Conditions",
  },
  terminology_procedures: {
    id: "terminology_procedures",
    defaultMessage: "Procedures",
  },
  terminology_medications: {
    id: "terminology_medications",
    defaultMessage: "Medications",
  },
  terminology_general_snomed: {
    id: "terminology_general_snomed",
    defaultMessage: "General SNOMED",
  },
  terminology_icd10: {
    id: "terminology_icd10",
    defaultMessage: "ICD-10",
  },
  terminology_icd11: {
    id: "terminology_icd11",
    defaultMessage: "ICD-11",
  },
  terminology_loinc: {
    id: "terminology_loinc",
    defaultMessage: "LOINC",
  },
  interpretation: {
    id: "interpretation",
    defaultMessage: "Interpretation",
  },
  governance_review_title: {
    id: "governance_review_title",
    defaultMessage: "Governance Review",
  },
  governance_review_subtitle: {
    id: "governance_review_subtitle",
    defaultMessage: "Generate a review pack of this patient type's configuration for clinical governance sign-off.",
  },
  governance_review_generate: {
    id: "governance_review_generate",
    defaultMessage: "Generate pack",
  },
  governance_review_generating: {
    id: "governance_review_generating",
    defaultMessage: "Generating...",
  },
  governance_review_download: {
    id: "governance_review_download",
    defaultMessage: "Download Excel",
  },
  governance_review_no_packs: {
    id: "governance_review_no_packs",
    defaultMessage: "No review packs yet. Generate the first one.",
  },
  governance_review_version: {
    id: "governance_review_version",
    defaultMessage: "Version",
  },
  governance_review_generated: {
    id: "governance_review_generated",
    defaultMessage: "Generated",
  },
  governance_review_generated_by: {
    id: "governance_review_generated_by",
    defaultMessage: "By",
  },
  governance_review_items: {
    id: "governance_review_items",
    defaultMessage: "Items",
  },
  governance_review_status: {
    id: "governance_review_status",
    defaultMessage: "Status",
  },
  governance_review_domains: {
    id: "governance_review_domains",
    defaultMessage: "Areas to include",
  },
  governance_review_select_patient_type: {
    id: "governance_review_select_patient_type",
    defaultMessage: "Select a patient type to see its review packs.",
  },
  governance_review_cancel: {
    id: "governance_review_cancel",
    defaultMessage: "Cancel",
  },
  governance_review_generate_title: {
    id: "governance_review_generate_title",
    defaultMessage: "Generate review pack",
  },
  governance_review_generate_failed: {
    id: "governance_review_generate_failed",
    defaultMessage: "The pack could not be generated. Try again.",
  },
  governance_domain_CARE_TEAMS: {
    id: "governance_domain_CARE_TEAMS",
    defaultMessage: "Care teams",
  },
  governance_domain_PATIENT_FIELDS: {
    id: "governance_domain_PATIENT_FIELDS",
    defaultMessage: "Patient record fields",
  },
  governance_review_download_pdf: {
    id: "governance_review_download_pdf",
    defaultMessage: "Download PDF",
  },
  governance_review_pdf_title: {
    id: "governance_review_pdf_title",
    defaultMessage: "Download PDF",
  },
  governance_review_pdf_sections: {
    id: "governance_review_pdf_sections",
    defaultMessage: "Choose the sections to include in the PDF",
  },
  governance_review_pdf_all: {
    id: "governance_review_pdf_all",
    defaultMessage: "All sections",
  },
  governance_review_pdf_none: {
    id: "governance_review_pdf_none",
    defaultMessage: "None",
  },
  governance_review_pdf_downloading: {
    id: "governance_review_pdf_downloading",
    defaultMessage: "Preparing PDF…",
  },
  governance_domain_PATIENT_DATA: {
    id: "governance_domain_PATIENT_DATA",
    defaultMessage: "Patient data fields",
  },
  governance_domain_THRESHOLDS: {
    id: "governance_domain_THRESHOLDS",
    defaultMessage: "Clinical thresholds",
  },
  governance_domain_CONSENT: {
    id: "governance_domain_CONSENT",
    defaultMessage: "Consent documents",
  },
  governance_domain_RULES: {
    id: "governance_domain_RULES",
    defaultMessage: "Alert rules",
  },
  governance_domain_TASK_TEMPLATES: {
    id: "governance_domain_TASK_TEMPLATES",
    defaultMessage: "Task routing",
  },
  governance_domain_SURVEYS: {
    id: "governance_domain_SURVEYS",
    defaultMessage: "Surveys",
  },
  governance_domain_CARE_PLANS: {
    id: "governance_domain_CARE_PLANS",
    defaultMessage: "Care plans",
  },
  governance_domain_INFO_PANEL: {
    id: "governance_domain_INFO_PANEL",
    defaultMessage: "Patient info panel",
  },
  governance_domain_CONTENT: {
    id: "governance_domain_CONTENT",
    defaultMessage: "Patient content",
  },
  governance_domain_MESSAGE_TEMPLATES: {
    id: "governance_domain_MESSAGE_TEMPLATES",
    defaultMessage: "Patient messages",
  },
  governance_domain_REMINDERS: {
    id: "governance_domain_REMINDERS",
    defaultMessage: "Clinics and reminders",
  },
  governance_domain_CHOICE_LISTS: {
    id: "governance_domain_CHOICE_LISTS",
    defaultMessage: "Choice lists",
  },
  governance_domain_FACILITY_SETTINGS: {
    id: "governance_domain_FACILITY_SETTINGS",
    defaultMessage: "Facility settings",
  },
  governance_domain_REGIMENS: {
    id: "governance_domain_REGIMENS",
    defaultMessage: "Treatment regimens",
  },
  terminology_status_title: {
    id: "terminology_status_title",
    defaultMessage: "Terminology Server Status",
  },
  terminology_server_online: {
    id: "terminology_server_online",
    defaultMessage: "Online",
  },
  terminology_server_unreachable: {
    id: "terminology_server_unreachable",
    defaultMessage: "Unreachable",
  },
  terminology_server_disabled: {
    id: "terminology_server_disabled",
    defaultMessage: "Disabled",
  },
  obs_set_search_condition: {
    id: "obs_set_search_condition",
    defaultMessage: "Search for a condition",
  },
  obs_set_search_placeholder: {
    id: "obs_set_search_placeholder",
    defaultMessage: "Type a condition name (e.g. Diabetes, Hypertension)...",
  },
  obs_set_searching: {
    id: "obs_set_searching",
    defaultMessage: "Searching for standard observations...",
  },
  obs_set_no_results: {
    id: "obs_set_no_results",
    defaultMessage:
      "No standard observations found for this condition. You can still add observations manually.",
  },
  obs_set_filter_placeholder: {
    id: "obs_set_filter_placeholder",
    defaultMessage: "Filter observations...",
  },
  obs_set_no_filter_match: {
    id: "obs_set_no_filter_match",
    defaultMessage: "No observations match your filter.",
  },
  obs_set_select_all: {
    id: "obs_set_select_all",
    defaultMessage: "Select All",
  },
  obs_set_deselect_all: {
    id: "obs_set_deselect_all",
    defaultMessage: "Deselect All",
  },
  obs_set_selected_count: {
    id: "obs_set_selected_count",
    defaultMessage: "{selected} of {total} selected",
  },
  obs_set_shown_count: {
    id: "obs_set_shown_count",
    defaultMessage: "({count} shown)",
  },
  obs_set_already_configured: {
    id: "obs_set_already_configured",
    defaultMessage: "(Already configured)",
  },
  obs_set_add_selected: {
    id: "obs_set_add_selected",
    defaultMessage: "Add Selected ({count})",
  },
  obs_set_adding: {
    id: "obs_set_adding",
    defaultMessage: "Adding...",
  },
  obs_set_created_partial: {
    id: "obs_set_created_partial",
    defaultMessage: "Created {created} of {total}. Failed: {failed}",
  },
  obs_set_all_failed: {
    id: "obs_set_all_failed",
    defaultMessage:
      "All {count} attributes failed to create. Please try again.",
  },
  obs_set_added_count: {
    id: "obs_set_added_count",
    defaultMessage: "Added {count} observation attribute(s).",
  },
  obs_set_unavailable: {
    id: "obs_set_unavailable",
    defaultMessage: "Terminology service unavailable — try again later",
  },
  pathway_packs_intro: {
    id: "pathway_packs_intro",
    defaultMessage:
      "Pick a disease pathway to add its full set of standard observations in one go.",
  },
  pathway_packs_empty: {
    id: "pathway_packs_empty",
    defaultMessage: "No pathway packs are configured yet.",
  },
  pathway_packs_load_failed: {
    id: "pathway_packs_load_failed",
    defaultMessage: "Could not load pathway packs. Please try again.",
  },
  pathway_packs_observation_singular: {
    id: "pathway_packs_observation_singular",
    defaultMessage: "observation",
  },
  pathway_packs_observation_plural: {
    id: "pathway_packs_observation_plural",
    defaultMessage: "observations",
  },
  pathway_packs_already_configured_count: {
    id: "pathway_packs_already_configured_count",
    defaultMessage: "{count} already configured",
  },
  pathway_packs_already_configured: {
    id: "pathway_packs_already_configured",
    defaultMessage: "(Already configured)",
  },
  pathway_packs_back: {
    id: "pathway_packs_back",
    defaultMessage: "Back to packs",
  },
  pathway_packs_select_all: {
    id: "pathway_packs_select_all",
    defaultMessage: "Select All",
  },
  pathway_packs_deselect_all: {
    id: "pathway_packs_deselect_all",
    defaultMessage: "Deselect All",
  },
  pathway_packs_selected_of: {
    id: "pathway_packs_selected_of",
    defaultMessage: "{selected} of {total} selected",
  },
  pathway_packs_add_selected: {
    id: "pathway_packs_add_selected",
    defaultMessage: "Add Selected ({count})",
  },
  pathway_packs_adding: {
    id: "pathway_packs_adding",
    defaultMessage: "Adding...",
  },
  pathway_packs_partial_failure: {
    id: "pathway_packs_partial_failure",
    defaultMessage: "Created {created} of {total}. Failed: {failed}",
  },
  pathway_packs_all_failed: {
    id: "pathway_packs_all_failed",
    defaultMessage:
      "All {count} attributes failed to create. Please try again.",
  },
  preference_saved: {
    id: "preference_saved",
    defaultMessage: "Preference saved",
  },
  where_used: {
    id: "where_used",
    defaultMessage: "Where Used",
  },
  where_used_title: {
    id: "where_used_title",
    defaultMessage: "Where Used — {title}",
  },
  where_used_references: {
    id: "where_used_references",
    defaultMessage:
      "{count} {count, plural, one {reference} other {references}}",
  },
  where_used_not_used: {
    id: "where_used_not_used",
    defaultMessage: "This attribute is not used anywhere.",
  },
  where_used_error: {
    id: "where_used_error",
    defaultMessage: "Failed to load usage information.",
  },
  where_used_ui_screens: {
    id: "where_used_ui_screens",
    defaultMessage: "UI Screens",
  },
  where_used_surveys: {
    id: "where_used_surveys",
    defaultMessage: "Surveys",
  },
  where_used_task_templates: {
    id: "where_used_task_templates",
    defaultMessage: "Task Templates",
  },
  where_used_care_plan_templates: {
    id: "where_used_care_plan_templates",
    defaultMessage: "Care Plan Templates",
  },
  where_used_comorbidity_templates: {
    id: "where_used_comorbidity_templates",
    defaultMessage: "Comorbidity Templates",
  },
  where_used_rule_maps: {
    id: "where_used_rule_maps",
    defaultMessage: "Rule Maps",
  },
  where_used_quick_actions: {
    id: "where_used_quick_actions",
    defaultMessage: "Quick Actions",
  },
  where_used_appointment_attributes: {
    id: "where_used_appointment_attributes",
    defaultMessage: "Appointment Attributes",
  },
  where_used_episode_of_care: {
    id: "where_used_episode_of_care",
    defaultMessage: "Episode of Care",
  },
  where_used_info_panel: {
    id: "where_used_info_panel",
    defaultMessage: "Info Panel",
  },
  where_used_type_attribute_binding: {
    id: "where_used_type_attribute_binding",
    defaultMessage: "Attribute Binding",
  },
  where_used_type_criteria_to_show: {
    id: "where_used_type_criteria_to_show",
    defaultMessage: "Criteria to Show",
  },
  where_used_type_criteria_to_hide: {
    id: "where_used_type_criteria_to_hide",
    defaultMessage: "Criteria to Hide",
  },
  where_used_type_matching_criteria: {
    id: "where_used_type_matching_criteria",
    defaultMessage: "Matching Criteria",
  },
  where_used_type_mapped_data: {
    id: "where_used_type_mapped_data",
    defaultMessage: "Mapped Data",
  },
  where_used_type_set_ui_attribute: {
    id: "where_used_type_set_ui_attribute",
    defaultMessage: "Set UI Attribute",
  },
  where_used_type_reset_rule: {
    id: "where_used_type_reset_rule",
    defaultMessage: "Reset Rule",
  },
  where_used_type_reset_rules: {
    id: "where_used_type_reset_rules",
    defaultMessage: "Reset Rules",
  },
  where_used_type_attribute_to_update: {
    id: "where_used_type_attribute_to_update",
    defaultMessage: "Attribute to Update",
  },
  where_used_type_appointment_attribute: {
    id: "where_used_type_appointment_attribute",
    defaultMessage: "Appointment Attribute",
  },

  allergies: { id: "allergies", defaultMessage: "Allergies" },
  allergies_uc: { id: "allergies_uc", defaultMessage: "ALLERGIES" },
  add_allergy: { id: "add_allergy", defaultMessage: "Add Allergy" },
  edit_allergy: { id: "edit_allergy", defaultMessage: "Edit Allergy" },
  delete_allergy: { id: "delete_allergy", defaultMessage: "Delete Allergy" },
  delete_allergy_confirm: {
    id: "delete_allergy_confirm",
    defaultMessage: "Are you sure you want to delete this allergy?",
  },
  allergies_empty_state: {
    id: "allergies_empty_state",
    defaultMessage: "No allergies recorded.",
  },
  allergy_unknown_substance: {
    id: "allergy_unknown_substance",
    defaultMessage: "Unknown substance",
  },
  allergy_substance: {
    id: "allergy_substance",
    defaultMessage: "Substance / allergen",
  },
  allergy_substance_required: {
    id: "allergy_substance_required",
    defaultMessage: "Please select an allergen.",
  },
  allergy_criticality_required: {
    id: "allergy_criticality_required",
    defaultMessage: "Please select a criticality.",
  },
  allergy_type: { id: "allergy_type", defaultMessage: "Type" },
  allergy_category: { id: "allergy_category", defaultMessage: "Category" },
  allergy_criticality: {
    id: "allergy_criticality",
    defaultMessage: "Criticality",
  },
  allergy_clinical_status: {
    id: "allergy_clinical_status",
    defaultMessage: "Clinical status",
  },
  allergy_verification_status: {
    id: "allergy_verification_status",
    defaultMessage: "Verification status",
  },
  allergy_notes: { id: "allergy_notes", defaultMessage: "Notes" },
  allergy_reactions: {
    id: "allergy_reactions",
    defaultMessage: "Reactions",
  },
  add_reaction: { id: "add_reaction", defaultMessage: "Add reaction" },
  allergy_reaction_severity: {
    id: "allergy_reaction_severity",
    defaultMessage: "Severity",
  },
  allergy_reaction_description: {
    id: "allergy_reaction_description",
    defaultMessage: "Description",
  },
  allergy_reaction_label: {
    id: "allergy_reaction_label",
    defaultMessage: "Reaction",
  },

  allergy_type_allergy: {
    id: "allergy_type_allergy",
    defaultMessage: "Allergy",
  },
  allergy_type_intolerance: {
    id: "allergy_type_intolerance",
    defaultMessage: "Intolerance",
  },

  allergy_category_food: {
    id: "allergy_category_food",
    defaultMessage: "Food",
  },
  allergy_category_medication: {
    id: "allergy_category_medication",
    defaultMessage: "Medication",
  },
  allergy_category_environment: {
    id: "allergy_category_environment",
    defaultMessage: "Environment",
  },
  allergy_category_biologic: {
    id: "allergy_category_biologic",
    defaultMessage: "Biologic",
  },

  allergy_criticality_low: {
    id: "allergy_criticality_low",
    defaultMessage: "Low",
  },
  allergy_criticality_high: {
    id: "allergy_criticality_high",
    defaultMessage: "High",
  },
  allergy_criticality_unable_to_assess: {
    id: "allergy_criticality_unable_to_assess",
    defaultMessage: "Unable to assess",
  },

  allergy_clinical_active: {
    id: "allergy_clinical_active",
    defaultMessage: "Active",
  },
  allergy_clinical_inactive: {
    id: "allergy_clinical_inactive",
    defaultMessage: "Inactive",
  },
  allergy_clinical_resolved: {
    id: "allergy_clinical_resolved",
    defaultMessage: "Resolved",
  },

  allergy_verification_unconfirmed: {
    id: "allergy_verification_unconfirmed",
    defaultMessage: "Unconfirmed",
  },
  allergy_verification_confirmed: {
    id: "allergy_verification_confirmed",
    defaultMessage: "Confirmed",
  },
  allergy_verification_refuted: {
    id: "allergy_verification_refuted",
    defaultMessage: "Refuted",
  },
  allergy_verification_entered_in_error: {
    id: "allergy_verification_entered_in_error",
    defaultMessage: "Entered in error",
  },

  allergy_severity_mild: {
    id: "allergy_severity_mild",
    defaultMessage: "Mild",
  },
  allergy_severity_moderate: {
    id: "allergy_severity_moderate",
    defaultMessage: "Moderate",
  },
  allergy_severity_severe: {
    id: "allergy_severity_severe",
    defaultMessage: "Severe",
  },

  allergy_added: { id: "allergy_added", defaultMessage: "Allergy added" },
  allergy_updated: {
    id: "allergy_updated",
    defaultMessage: "Allergy updated",
  },
  allergy_deleted: {
    id: "allergy_deleted",
    defaultMessage: "Allergy deleted",
  },
  allergy_save_failed: {
    id: "allergy_save_failed",
    defaultMessage: "Failed to save allergy",
  },

  // ── Management Console (MYP-XXXX) ────────────────────────────────────
  // Console module is en_IE-only for v1; non-en_IE locales fall back to
  // these defaultMessages (Irish English). Full i18n retrofit and
  // additional locales are a v2 follow-up.
  console_app_name: {
    id: "console.app.name",
    defaultMessage: "Management Console",
  },
  console_app_brand: { id: "console.app.brand", defaultMessage: "Console" },
  console_loading: { id: "console.loading", defaultMessage: "Loading…" },
  console_unavailable_title: {
    id: "console.unavailable.title",
    defaultMessage: "Console not available",
  },
  console_unavailable_notDeployed: {
    id: "console.unavailable.notDeployed",
    defaultMessage:
      "The Management Console is not enabled in this environment.",
  },
  console_unavailable_noPrivilege: {
    id: "console.unavailable.noPrivilege",
    defaultMessage:
      "You do not have access to the Management Console. Contact your administrator.",
  },
  console_unavailable_error: {
    id: "console.unavailable.error",
    defaultMessage: "Unable to load the console right now. Please try again.",
  },
  console_placeholder_modulePending: {
    id: "console.placeholder.modulePending",
    defaultMessage:
      'Module is scaffolded but not yet wired. See implementation plan in Confluence (MY space, "New features and Enhancements - 2026").',
  },

  console_status_operational: {
    id: "console.status.operational",
    defaultMessage: "All systems operational",
  },
  console_status_degraded: {
    id: "console.status.degraded",
    defaultMessage: "Degraded performance",
  },
  console_status_down: {
    id: "console.status.down",
    defaultMessage: "Active incident",
  },

  console_nav_section_overview: {
    id: "console.nav.section.overview",
    defaultMessage: "Overview",
  },
  console_nav_section_identity: {
    id: "console.nav.section.identity",
    defaultMessage: "Identity",
  },
  console_nav_section_governance: {
    id: "console.nav.section.governance",
    defaultMessage: "Governance",
  },
  console_nav_section_organisation: {
    id: "console.nav.section.organisation",
    defaultMessage: "Organisation",
  },
  console_nav_section_developer: {
    id: "console.nav.section.developer",
    defaultMessage: "Developer",
  },
  console_nav_section_support: {
    id: "console.nav.section.support",
    defaultMessage: "Support",
  },

  console_nav_dashboard: {
    id: "console.nav.dashboard",
    defaultMessage: "Dashboard",
  },
  console_nav_health: {
    id: "console.nav.health",
    defaultMessage: "System Health",
  },
  console_nav_licence: { id: "console.nav.licence", defaultMessage: "Licence" },
  console_nav_alerts: { id: "console.nav.alerts", defaultMessage: "Alerts" },
  console_nav_users: { id: "console.nav.users", defaultMessage: "Users" },
  console_nav_roles: {
    id: "console.nav.roles",
    defaultMessage: "Roles & Privileges",
  },
  console_nav_entra: { id: "console.nav.entra", defaultMessage: "Entra ID" },
  console_nav_sessions: {
    id: "console.nav.sessions",
    defaultMessage: "Sessions",
  },
  console_nav_audit: { id: "console.nav.audit", defaultMessage: "Audit Log" },
  console_nav_automations: {
    id: "console.nav.automations",
    defaultMessage: "Automations",
  },
  console_nav_facilities: {
    id: "console.nav.facilities",
    defaultMessage: "Facilities",
  },
  console_nav_careteams: {
    id: "console.nav.careteams",
    defaultMessage: "Care Teams",
  },
  console_nav_settings: {
    id: "console.nav.settings",
    defaultMessage: "Settings",
  },
  console_nav_api: { id: "console.nav.api", defaultMessage: "API Keys" },
  console_nav_webhooks: {
    id: "console.nav.webhooks",
    defaultMessage: "Webhooks",
  },
  console_nav_support: { id: "console.nav.support", defaultMessage: "Support" },
  console_nav_onboarding: {
    id: "console.nav.onboarding",
    defaultMessage: "Onboarding",
  },

  console_topbar_search: {
    id: "console.topbar.search",
    defaultMessage: "Search…",
  },
  console_topbar_notifications: {
    id: "console.topbar.notifications",
    defaultMessage: "Notifications",
  },
  console_topbar_help: { id: "console.topbar.help", defaultMessage: "Help" },

  console_action_save: { id: "console.action.save", defaultMessage: "Save" },
  console_action_cancel: {
    id: "console.action.cancel",
    defaultMessage: "Cancel",
  },
  console_action_add: { id: "console.action.add", defaultMessage: "Add" },
  console_action_edit: { id: "console.action.edit", defaultMessage: "Edit" },
  console_action_delete: {
    id: "console.action.delete",
    defaultMessage: "Delete",
  },
  console_action_revoke: {
    id: "console.action.revoke",
    defaultMessage: "Revoke",
  },
  console_action_export: {
    id: "console.action.export",
    defaultMessage: "Export",
  },
  console_action_dismiss: {
    id: "console.action.dismiss",
    defaultMessage: "Dismiss",
  },
  console_action_close: { id: "console.action.close", defaultMessage: "Close" },

  console_empty_noResults: {
    id: "console.empty.noResults",
    defaultMessage: "No results",
  },

  // ── Base Patient Profile Pack — MPS-admin read-only viewer ──────────────
  bppp_title: {
    id: "bppp_title",
    defaultMessage: "Base Patient Profile",
  },
  bppp_subtitle: {
    id: "bppp_subtitle",
    defaultMessage:
      "The IPS-aligned baseline that auto-applies to every new pathway template. Sections and items here flow through to facilities on adoption.",
  },
  bppp_pack_key: {
    id: "bppp_pack_key",
    defaultMessage: "Pack key",
  },
  bppp_section_count: {
    id: "bppp_section_count",
    defaultMessage: "Sections",
  },
  bppp_readonly_banner: {
    id: "bppp_readonly_banner",
    defaultMessage:
      "Read-only view. To change pack contents, edit the seeder, delete the BasePatientProfilePack singleton in Mongo, and restart so the seeder rebuilds.",
  },
  bppp_section_type_demographic: {
    id: "bppp_section_type_demographic",
    defaultMessage: "Demographic",
  },
  bppp_section_type_observations: {
    id: "bppp_section_type_observations",
    defaultMessage: "Observations",
  },
  bppp_section_type_resource_collection: {
    id: "bppp_section_type_resource_collection",
    defaultMessage: "Resource collection",
  },
  bppp_section_type_unknown: {
    id: "bppp_section_type_unknown",
    defaultMessage: "Unknown",
  },
  bppp_valueset_label: {
    id: "bppp_valueset_label",
    defaultMessage: "Value set",
  },
  bppp_empty_payload: {
    id: "bppp_empty_payload",
    defaultMessage: "No items in this section.",
  },
  bppp_load_failed: {
    id: "bppp_load_failed",
    defaultMessage: "Could not load the base patient profile pack.",
  },
  bppp_nav_label: {
    id: "bppp_nav_label",
    defaultMessage: "Base Patient Profile",
  },

  // ── Immunizations FE — patient profile card + add/edit form ─────────────
  immunizations: { id: "immunizations", defaultMessage: "Immunisations" },
  add_immunization: {
    id: "add_immunization",
    defaultMessage: "Add Immunisation",
  },
  edit_immunization: {
    id: "edit_immunization",
    defaultMessage: "Edit Immunisation",
  },
  delete_immunization: {
    id: "delete_immunization",
    defaultMessage: "Delete Immunisation",
  },
  delete_immunization_confirm: {
    id: "delete_immunization_confirm",
    defaultMessage: "Are you sure you want to delete this immunisation record?",
  },
  immunization_added: {
    id: "immunization_added",
    defaultMessage: "Immunisation added",
  },
  immunization_updated: {
    id: "immunization_updated",
    defaultMessage: "Immunisation updated",
  },
  immunization_deleted: {
    id: "immunization_deleted",
    defaultMessage: "Immunisation deleted",
  },
  immunization_save_failed: {
    id: "immunization_save_failed",
    defaultMessage: "Failed to save immunisation",
  },
  immunizations_empty_state: {
    id: "immunizations_empty_state",
    defaultMessage: "No immunisations recorded.",
  },
  immunizations_feature_disabled: {
    id: "immunizations_feature_disabled",
    defaultMessage: "Immunisations are not enabled for this facility.",
  },
  immunization_unknown_vaccine: {
    id: "immunization_unknown_vaccine",
    defaultMessage: "Unknown vaccine",
  },
  immunization_vaccine: {
    id: "immunization_vaccine",
    defaultMessage: "Vaccine",
  },
  immunization_vaccine_required: {
    id: "immunization_vaccine_required",
    defaultMessage: "Please select a vaccine.",
  },
  immunization_administered_label: {
    id: "immunization_administered_label",
    defaultMessage: "Administered",
  },
  immunization_status: { id: "immunization_status", defaultMessage: "Status" },
  immunization_status_completed: {
    id: "immunization_status_completed",
    defaultMessage: "Completed",
  },
  immunization_status_entered_in_error: {
    id: "immunization_status_entered_in_error",
    defaultMessage: "Entered in error",
  },
  immunization_status_not_done: {
    id: "immunization_status_not_done",
    defaultMessage: "Not done",
  },
  immunization_lot_label: {
    id: "immunization_lot_label",
    defaultMessage: "Lot",
  },
  immunization_dose_label: {
    id: "immunization_dose_label",
    defaultMessage: "Dose",
  },
  immunization_dose_number: {
    id: "immunization_dose_number",
    defaultMessage: "Dose number",
  },
  immunization_series_doses: {
    id: "immunization_series_doses",
    defaultMessage: "Series doses",
  },
  immunization_notes: { id: "immunization_notes", defaultMessage: "Notes" },
  immunizations_uc: { id: "immunizations_uc", defaultMessage: "IMMUNISATIONS" },

  // ── Conditions FE — patient profile card + add/edit form ─────────────
  conditions: { id: "conditions", defaultMessage: "Conditions" },
  conditions_uc: { id: "conditions_uc", defaultMessage: "CONDITIONS" },
  add_condition: { id: "add_condition", defaultMessage: "Add Condition" },
  edit_condition: { id: "edit_condition", defaultMessage: "Edit Condition" },
  delete_condition: {
    id: "delete_condition",
    defaultMessage: "Delete Condition",
  },
  delete_condition_confirm: {
    id: "delete_condition_confirm",
    defaultMessage: "Are you sure you want to delete this condition record?",
  },
  condition_added: { id: "condition_added", defaultMessage: "Condition added" },
  condition_updated: {
    id: "condition_updated",
    defaultMessage: "Condition updated",
  },
  condition_deleted: {
    id: "condition_deleted",
    defaultMessage: "Condition deleted",
  },
  condition_save_failed: {
    id: "condition_save_failed",
    defaultMessage: "Failed to save condition",
  },
  conditions_empty_state: {
    id: "conditions_empty_state",
    defaultMessage: "No conditions recorded.",
  },
  conditions_feature_disabled: {
    id: "conditions_feature_disabled",
    defaultMessage: "Conditions are not enabled for this facility.",
  },
  condition_unknown: {
    id: "condition_unknown",
    defaultMessage: "Unknown condition",
  },
  condition_code: { id: "condition_code", defaultMessage: "Condition" },
  condition_code_required: {
    id: "condition_code_required",
    defaultMessage: "Please select a condition.",
  },
  condition_clinical_status: {
    id: "condition_clinical_status",
    defaultMessage: "Clinical status",
  },
  condition_clinical_status_active: {
    id: "condition_clinical_status_active",
    defaultMessage: "Active",
  },
  condition_clinical_status_recurrence: {
    id: "condition_clinical_status_recurrence",
    defaultMessage: "Recurrence",
  },
  condition_clinical_status_relapse: {
    id: "condition_clinical_status_relapse",
    defaultMessage: "Relapse",
  },
  condition_clinical_status_remission: {
    id: "condition_clinical_status_remission",
    defaultMessage: "Remission",
  },
  condition_clinical_status_resolved: {
    id: "condition_clinical_status_resolved",
    defaultMessage: "Resolved",
  },
  condition_clinical_status_inactive: {
    id: "condition_clinical_status_inactive",
    defaultMessage: "Inactive",
  },
  condition_verification_status: {
    id: "condition_verification_status",
    defaultMessage: "Verification",
  },
  condition_verification_unconfirmed: {
    id: "condition_verification_unconfirmed",
    defaultMessage: "Unconfirmed",
  },
  condition_verification_provisional: {
    id: "condition_verification_provisional",
    defaultMessage: "Provisional",
  },
  condition_verification_differential: {
    id: "condition_verification_differential",
    defaultMessage: "Differential",
  },
  condition_verification_confirmed: {
    id: "condition_verification_confirmed",
    defaultMessage: "Confirmed",
  },
  condition_verification_refuted: {
    id: "condition_verification_refuted",
    defaultMessage: "Refuted",
  },
  condition_verification_entered_in_error: {
    id: "condition_verification_entered_in_error",
    defaultMessage: "Entered in error",
  },
  condition_severity: { id: "condition_severity", defaultMessage: "Severity" },
  condition_severity_unset: {
    id: "condition_severity_unset",
    defaultMessage: "—",
  },
  condition_severity_mild: {
    id: "condition_severity_mild",
    defaultMessage: "Mild",
  },
  condition_severity_moderate: {
    id: "condition_severity_moderate",
    defaultMessage: "Moderate",
  },
  condition_severity_severe: {
    id: "condition_severity_severe",
    defaultMessage: "Severe",
  },
  condition_onset_label: {
    id: "condition_onset_label",
    defaultMessage: "Onset",
  },
  condition_abatement_label: {
    id: "condition_abatement_label",
    defaultMessage: "Resolved on",
  },
  condition_notes: { id: "condition_notes", defaultMessage: "Notes" },
  patient_alerts: { id: "patient_alerts", defaultMessage: "Alerts" },
  patient_alert_attribute: {
    id: "patient_alert_attribute",
    defaultMessage: "Attribute",
  },
  patient_alert_value: { id: "patient_alert_value", defaultMessage: "Value" },
  patient_alert_email: { id: "patient_alert_email", defaultMessage: "Email" },
  patient_alert_sms: { id: "patient_alert_sms", defaultMessage: "SMS" },
  patient_alert_push: { id: "patient_alert_push", defaultMessage: "Push" },
  patient_alert_match: {
    id: "patient_alert_match",
    defaultMessage: "Match",
  },
  patient_alert_match_all: {
    id: "patient_alert_match_all",
    defaultMessage: "All conditions",
  },
  patient_alert_match_any: {
    id: "patient_alert_match_any",
    defaultMessage: "Any condition",
  },
  patient_alert_condition: {
    id: "patient_alert_condition",
    defaultMessage: "Condition",
  },
  patient_alert_condition_type: {
    id: "patient_alert_condition_type",
    defaultMessage: "Condition type",
  },
  patient_alert_latest_value: {
    id: "patient_alert_latest_value",
    defaultMessage: "Latest value",
  },
  patient_alert_count_in_window: {
    id: "patient_alert_count_in_window",
    defaultMessage: "Count in window",
  },
  patient_alert_consecutive_count: {
    id: "patient_alert_consecutive_count",
    defaultMessage: "Consecutive count",
  },
  patient_alert_change_from_previous: {
    id: "patient_alert_change_from_previous",
    defaultMessage: "Change from previous",
  },
  patient_alert_missing_in_window: {
    id: "patient_alert_missing_in_window",
    defaultMessage: "Missing in window",
  },
  patient_alert_occurrences: {
    id: "patient_alert_occurrences",
    defaultMessage: "Occurrences",
  },
  patient_alert_window: {
    id: "patient_alert_window",
    defaultMessage: "Window",
  },
  patient_alert_add_condition: {
    id: "patient_alert_add_condition",
    defaultMessage: "Add condition",
  },
  patient_alert_create: {
    id: "patient_alert_create",
    defaultMessage: "Create alert",
  },
  patient_alert_test: { id: "patient_alert_test", defaultMessage: "Test" },
  patient_alert_test_result: {
    id: "patient_alert_test_result",
    defaultMessage: "Test result",
  },
  patient_alert_would_fire: {
    id: "patient_alert_would_fire",
    defaultMessage: "would fire",
  },
  patient_alert_would_not_fire: {
    id: "patient_alert_would_not_fire",
    defaultMessage: "would not fire",
  },
  patient_alert_kind_threshold: {
    id: "patient_alert_kind_threshold",
    defaultMessage: "Threshold",
  },
  patient_alert_kind_threshold_desc: {
    id: "patient_alert_kind_threshold_desc",
    defaultMessage: "A single reading crosses a value",
  },
  patient_alert_kind_repeated: {
    id: "patient_alert_kind_repeated",
    defaultMessage: "Repeated",
  },
  patient_alert_kind_repeated_desc: {
    id: "patient_alert_kind_repeated_desc",
    defaultMessage: "Crosses a value several times in a window",
  },
  patient_alert_kind_streak: {
    id: "patient_alert_kind_streak",
    defaultMessage: "Streak",
  },
  patient_alert_kind_streak_desc: {
    id: "patient_alert_kind_streak_desc",
    defaultMessage: "Crosses a value in consecutive readings",
  },
  patient_alert_kind_change: {
    id: "patient_alert_kind_change",
    defaultMessage: "Sudden change",
  },
  patient_alert_kind_change_desc: {
    id: "patient_alert_kind_change_desc",
    defaultMessage: "A reading changes sharply from the previous one",
  },
  patient_alert_kind_missing: {
    id: "patient_alert_kind_missing",
    defaultMessage: "Missing data",
  },
  patient_alert_kind_missing_desc: {
    id: "patient_alert_kind_missing_desc",
    defaultMessage: "No reading is recorded for a period of time",
  },
  patient_alert_notify_when: {
    id: "patient_alert_notify_when",
    defaultMessage: "Notify me when",
  },
  patient_alert_select_attribute: {
    id: "patient_alert_select_attribute",
    defaultMessage: "Select an attribute…",
  },
  patient_alert_right_now: {
    id: "patient_alert_right_now",
    defaultMessage: "right now",
  },
  patient_alert_at_least: {
    id: "patient_alert_at_least",
    defaultMessage: "at least",
  },
  patient_alert_times_in: {
    id: "patient_alert_times_in",
    defaultMessage: "times in the last",
  },
  patient_alert_for: { id: "patient_alert_for", defaultMessage: "for" },
  patient_alert_readings_in_a_row: {
    id: "patient_alert_readings_in_a_row",
    defaultMessage: "readings in a row",
  },
  patient_alert_change_suffix: {
    id: "patient_alert_change_suffix",
    defaultMessage: "compared to the previous reading",
  },
  patient_alert_no_reading_for: {
    id: "patient_alert_no_reading_for",
    defaultMessage: "has no reading for the last",
  },
  patient_alert_send_via: {
    id: "patient_alert_send_via",
    defaultMessage: "Send via",
  },
  patient_alert_summary: {
    id: "patient_alert_summary",
    defaultMessage: "Summary",
  },
  patient_alert_no_alerts_yet: {
    id: "patient_alert_no_alerts_yet",
    defaultMessage: "No alerts set up for this patient yet",
  },
  patient_alert_active: {
    id: "patient_alert_active",
    defaultMessage: "Active",
  },
  patient_alert_existing: {
    id: "patient_alert_existing",
    defaultMessage: "Existing alerts",
  },
  patient_alert_new: {
    id: "patient_alert_new",
    defaultMessage: "New alert",
  },
  patient_alert_trigger_type: {
    id: "patient_alert_trigger_type",
    defaultMessage: "Trigger type",
  },
  patient_alert_pick_attribute_first: {
    id: "patient_alert_pick_attribute_first",
    defaultMessage: "Pick an attribute to get started.",
  },
  patient_alert_type_single: {
    id: "patient_alert_type_single",
    defaultMessage: "Single reading",
  },
  patient_alert_type_single_desc: {
    id: "patient_alert_type_single_desc",
    defaultMessage: "Fire when one reading crosses a threshold",
  },
  patient_alert_type_trend: {
    id: "patient_alert_type_trend",
    defaultMessage: "Trend over time",
  },
  patient_alert_type_trend_desc: {
    id: "patient_alert_type_trend_desc",
    defaultMessage: "Fire on a pattern of readings or missing data",
  },
  patient_alert_step_type: {
    id: "patient_alert_step_type",
    defaultMessage: "Alert type",
  },
  patient_alert_step_conditions: {
    id: "patient_alert_step_conditions",
    defaultMessage: "Conditions",
  },
  patient_alert_step_delivery: {
    id: "patient_alert_step_delivery",
    defaultMessage: "Delivery",
  },
  patient_alert_add_attribute: {
    id: "patient_alert_add_attribute",
    defaultMessage: "Add attribute",
  },
  patient_alert_match_label: {
    id: "patient_alert_match_label",
    defaultMessage: "Match",
  },
  patient_alert_match_all_short: {
    id: "patient_alert_match_all_short",
    defaultMessage: "All",
  },
  patient_alert_match_any_short: {
    id: "patient_alert_match_any_short",
    defaultMessage: "Any",
  },
  patient_alert_pattern: {
    id: "patient_alert_pattern",
    defaultMessage: "Pattern",
  },
  patient_alert_window_amount_label: {
    id: "patient_alert_window_amount_label",
    defaultMessage: "Within",
  },
  patient_alert_no_attribute_yet: {
    id: "patient_alert_no_attribute_yet",
    defaultMessage: "No attribute selected",
  },
  patient_alert_change_direction: {
    id: "patient_alert_change_direction",
    defaultMessage: "Change",
  },
  patient_alert_change_amount: {
    id: "patient_alert_change_amount",
    defaultMessage: "Amount",
  },
  patient_alert_change_increased: {
    id: "patient_alert_change_increased",
    defaultMessage: "Increased by more than",
  },
  patient_alert_change_decreased: {
    id: "patient_alert_change_decreased",
    defaultMessage: "Decreased by more than",
  },
  patient_alert_kind_repeated_example: {
    id: "patient_alert_kind_repeated_example",
    defaultMessage:
      "e.g. blood pressure exceeds 140 three times in the last 7 days",
  },
  patient_alert_kind_streak_example: {
    id: "patient_alert_kind_streak_example",
    defaultMessage: "e.g. fever stays above 39°C for 3 readings in a row",
  },
  patient_alert_kind_change_example: {
    id: "patient_alert_kind_change_example",
    defaultMessage:
      "e.g. weight drops by more than 2 kg from the previous reading",
  },
  patient_alert_kind_missing_example: {
    id: "patient_alert_kind_missing_example",
    defaultMessage: "e.g. no glucose reading for the last 24 hours",
  },
  patient_alert_non_observation_warning: {
    id: "patient_alert_non_observation_warning",
    defaultMessage:
      "This attribute doesn't support trend alerts. Pick an observation, or switch the alert type to Single.",
  },
  // ── Management Console: Usage Summary ──────────────────────────────────
  usage_summary_title: {
    id: "usage_summary_title",
    defaultMessage: "Service User Stats",
  },
  usage_summary_subtitle: {
    id: "usage_summary_subtitle",
    defaultMessage: "Cross-facility usage",
  },
  usage_summary_data_as_of: {
    id: "usage_summary_data_as_of",
    defaultMessage: "Data as of {timestamp}",
  },
  usage_summary_month_label: {
    id: "usage_summary_month_label",
    defaultMessage: "Month",
  },
  usage_summary_active_users: {
    id: "usage_summary_active_users",
    defaultMessage: "Active users",
  },
  usage_summary_invited_users: {
    id: "usage_summary_invited_users",
    defaultMessage: "Invited users",
  },
  usage_summary_onboarded_users: {
    id: "usage_summary_onboarded_users",
    defaultMessage: "Onboarded users",
  },
  usage_summary_internal_users: {
    id: "usage_summary_internal_users",
    defaultMessage: "Active Internal",
  },
  usage_summary_deleted_users: {
    id: "usage_summary_deleted_users",
    defaultMessage: "Deactivated",
  },
  usage_summary_new_patients_added: {
    id: "usage_summary_new_patients_added",
    defaultMessage: "New patients added",
  },
  usage_summary_admitted: {
    id: "usage_summary_admitted",
    defaultMessage: "Admitted",
  },
  usage_summary_active_staff: {
    id: "usage_summary_active_staff",
    defaultMessage: "Active Staff",
  },
  usage_summary_active_staff_help: {
    id: "usage_summary_active_staff_help",
    defaultMessage:
      "Clinical and administrative staff members who logged in during the month. Staff accounts are separate from patient records and are not included in the Active Patients count.",
  },
  usage_summary_discharged: {
    id: "usage_summary_discharged",
    defaultMessage: "Discharged",
  },
  usage_summary_help_button: {
    id: "usage_summary_help_button",
    defaultMessage: "About these numbers",
  },
  usage_summary_help_close: {
    id: "usage_summary_help_close",
    defaultMessage: "Close",
  },
  usage_summary_help_title: {
    id: "usage_summary_help_title",
    defaultMessage: "About these numbers",
  },
  usage_summary_help_methodology: {
    id: "usage_summary_help_methodology",
    defaultMessage:
      "These terms describe how patient records are categorised on the myPatientSpace platform. Definitions apply consistently across all sites and months. Figures are point-in-time aggregations from the live patient records; subsequent updates (license reconciliation, reclassification, care-team moves) can cause small retrospective adjustments to prior months, typically under 0.1%.",
  },
  usage_summary_help_metrics_intro: {
    id: "usage_summary_help_metrics_intro",
    defaultMessage: "What each metric means",
  },
  usage_summary_active_users_help: {
    id: "usage_summary_active_users_help",
    defaultMessage:
      "Patient records active on the system at any point during the month — created before month-end and not deactivated before month-start. Includes patients deactivated mid-month: they were active for part of it.",
  },
  usage_summary_invited_users_help: {
    id: "usage_summary_invited_users_help",
    defaultMessage:
      "Patients sent an invitation to register but who have not yet completed onboarding, as of end of month.",
  },
  usage_summary_onboarded_users_help: {
    id: "usage_summary_onboarded_users_help",
    defaultMessage:
      "Patients who have accepted their invitation, completed registration, and have live platform access, as of end of month.",
  },
  usage_summary_internal_users_help: {
    id: "usage_summary_internal_users_help",
    defaultMessage:
      "Patient records created on the system but not yet sent an invitation. Used by clinical staff for internal management, scheduling, care planning, notes, AI automation and integrated feeds (labs/appointments). The patient has no direct interaction with the platform at this stage except perhaps via SMS/email.",
  },
  usage_summary_new_patients_added_help: {
    id: "usage_summary_new_patients_added_help",
    defaultMessage:
      "New patient records created during the month. New records enter the system as Active Internal and are counted in Active Patients from that point forward.",
  },
  usage_summary_admitted_help: {
    id: "usage_summary_admitted_help",
    defaultMessage:
      "Patients admitted to a care programme during the month. Used in episodic programmes (Virtual Ward / ESD), not in ongoing chronic-disease or cancer pathways. Other facilities show 0.",
  },
  usage_summary_discharged_help: {
    id: "usage_summary_discharged_help",
    defaultMessage:
      "Patients discharged from a ward during the month. Staff often continue working with patients pre- and post-episode (e.g. six-week reviews). Other facilities show 0.",
  },
  usage_summary_deleted_users_help: {
    id: "usage_summary_deleted_users_help",
    defaultMessage:
      "Patient records deactivated during the month. Each carries a reason: RIP (deceased), Dropout (withdrew or disengaged), Completed (programme/pathway complete), or Deactivated (no reason recorded). Deactivated records are archived and can't be worked on unless manually reactivated.",
  },
  usage_summary_onboarding_rate: {
    id: "usage_summary_onboarding_rate",
    defaultMessage: "Onboarding rate",
  },
  usage_summary_dau: {
    id: "usage_summary_dau",
    defaultMessage: "Daily active patients",
  },
  usage_summary_wau: {
    id: "usage_summary_wau",
    defaultMessage: "Weekly active patients",
  },
  usage_summary_mau: {
    id: "usage_summary_mau",
    defaultMessage: "Monthly active patients",
  },
  usage_summary_staff_dau: {
    id: "usage_summary_staff_dau",
    defaultMessage: "Daily active staff",
  },
  usage_summary_appointments_created: {
    id: "usage_summary_appointments_created",
    defaultMessage: "Appointments created",
  },
  usage_summary_appointments_attended: {
    id: "usage_summary_appointments_attended",
    defaultMessage: "Appointments attended",
  },
  usage_summary_appointments_no_show: {
    id: "usage_summary_appointments_no_show",
    defaultMessage: "No-shows",
  },
  usage_summary_tasks_completed_by_staff: {
    id: "usage_summary_tasks_completed_by_staff",
    defaultMessage: "Tasks completed by staff",
  },
  usage_summary_messages_sent_by_staff: {
    id: "usage_summary_messages_sent_by_staff",
    defaultMessage: "Messages sent by staff",
  },
  usage_summary_messages_sent_by_patient: {
    id: "usage_summary_messages_sent_by_patient",
    defaultMessage: "Messages sent by patients",
  },
  usage_summary_facilities_total: {
    id: "usage_summary_facilities_total",
    defaultMessage: "Facilities",
  },
  usage_summary_facilities_with_activity: {
    id: "usage_summary_facilities_with_activity",
    defaultMessage: "Active",
  },
  usage_summary_facilities_dormant: {
    id: "usage_summary_facilities_dormant",
    defaultMessage: "Dormant",
  },
  usage_summary_facility_table_title: {
    id: "usage_summary_facility_table_title",
    defaultMessage: "Facilities",
  },
  usage_summary_top_appointments: {
    id: "usage_summary_top_appointments",
    defaultMessage: "Top facilities by appointments",
  },
  usage_summary_top_tasks_completed: {
    id: "usage_summary_top_tasks_completed",
    defaultMessage: "Top facilities by tasks completed",
  },
  usage_summary_top_onboarding_rate: {
    id: "usage_summary_top_onboarding_rate",
    defaultMessage: "Top facilities by onboarding rate",
  },
  usage_summary_top_mau: {
    id: "usage_summary_top_mau",
    defaultMessage: "Top facilities by MAU",
  },
  usage_summary_back_to_rollup: {
    id: "usage_summary_back_to_rollup",
    defaultMessage: "← Back to all facilities",
  },

  // ---- Smart Document review surface ----
  doc_report_sections: {
    id: "doc_report_sections",
    defaultMessage: "Report Sections",
  },
  doc_flag_ai_verify: {
    id: "doc_flag_ai_verify",
    defaultMessage: "AI-generated — verify",
  },
  doc_flag_needs_input: {
    id: "doc_flag_needs_input",
    defaultMessage: "Needs your input",
  },
  doc_patient_data: { id: "doc_patient_data", defaultMessage: "Patient Data" },
  doc_survey_responses: {
    id: "doc_survey_responses",
    defaultMessage: "Survey Responses",
  },
  doc_no_attributes_configured: {
    id: "doc_no_attributes_configured",
    defaultMessage: "No attributes configured in this document.",
  },
  doc_no_survey_responses_note: {
    id: "doc_no_survey_responses_note",
    defaultMessage: "No survey responses submitted yet.",
  },
  doc_generated_for: {
    id: "doc_generated_for",
    defaultMessage: "Generated for {name}",
  },
  doc_ai_content_warning: {
    id: "doc_ai_content_warning",
    defaultMessage: "Contains AI content — double-check before saving",
  },
  doc_ai_approve: { id: "doc_ai_approve", defaultMessage: "Approve" },
  doc_ai_approved: { id: "doc_ai_approved", defaultMessage: "Approved" },
  doc_ai_approve_hint: {
    id: "doc_ai_approve_hint",
    defaultMessage: "Confirm you have reviewed this AI-generated section",
  },
  doc_ai_approvals_pending: {
    id: "doc_ai_approvals_pending",
    defaultMessage: "Approve all AI sections to save ({approved}/{total} approved)",
  },
  doc_ai_approve_before_save: {
    id: "doc_ai_approve_before_save",
    defaultMessage:
      "Please review and approve all AI sections before saving — {remaining} still need approval.",
  },
  doc_ai_jump_unapproved: {
    id: "doc_ai_jump_unapproved",
    defaultMessage: "Go to the sections that still need approval",
  },
  doc_attr_show_all: { id: "doc_attr_show_all", defaultMessage: "Show all ({count})" },
  doc_scope_show_all: { id: "doc_scope_show_all", defaultMessage: "Show all" },
  doc_attr_show_section: { id: "doc_attr_show_section", defaultMessage: "This section" },
  doc_attr_all_label: { id: "doc_attr_all_label", defaultMessage: "All data" },
  doc_this_patient: { id: "doc_this_patient", defaultMessage: "this patient" },
  doc_saved: { id: "doc_saved", defaultMessage: "Document saved" },
  doc_save_failed: {
    id: "doc_save_failed",
    defaultMessage: "Failed to save document",
  },
  doc_uploaded: {
    id: "doc_uploaded",
    defaultMessage: "Document uploaded successfully",
  },
  doc_upload_failed: {
    id: "doc_upload_failed",
    defaultMessage: "Failed to upload document",
  },
  doc_version_restored: {
    id: "doc_version_restored",
    defaultMessage: "Version restored",
  },
  doc_version_restore_failed: {
    id: "doc_version_restore_failed",
    defaultMessage: "Failed to restore version",
  },
  doc_no_survey_data: {
    id: "doc_no_survey_data",
    defaultMessage: "No survey data available for this report.",
  },
  doc_no_survey_responses_found: {
    id: "doc_no_survey_responses_found",
    defaultMessage: "No survey responses found.",
  },
  doc_unknown_survey: {
    id: "doc_unknown_survey",
    defaultMessage: "Unknown Survey",
  },

  // ---- Smart Document builder (admin authoring) ----
  doc_builder_title: {
    id: "doc_builder_title",
    defaultMessage: "Document Template",
  },
  doc_builder_subtitle: {
    id: "doc_builder_subtitle",
    defaultMessage: "Document Template Designer · Draft",
  },
  doc_step_cover: { id: "doc_step_cover", defaultMessage: "Cover" },
  doc_cover_page: { id: "doc_cover_page", defaultMessage: "Cover Page" },
  doc_include_cover: {
    id: "doc_include_cover",
    defaultMessage: "Include a cover page",
  },
  doc_subtitle: { id: "doc_subtitle", defaultMessage: "Subtitle" },
  doc_footer_heading: {
    id: "doc_footer_heading",
    defaultMessage: "Footer heading",
  },
  doc_footer_subtext: {
    id: "doc_footer_subtext",
    defaultMessage: "Footer subtext",
  },
  doc_header_footer_images: {
    id: "doc_header_footer_images",
    defaultMessage: "Header & Footer Images",
  },
  doc_header_footer_hint: {
    id: "doc_header_footer_hint",
    defaultMessage:
      "For one-page reports — a banner at the top (and optional footer) instead of a full cover page.",
  },
  doc_header_image: { id: "doc_header_image", defaultMessage: "Header image" },
  doc_footer_image: { id: "doc_footer_image", defaultMessage: "Footer image" },
  doc_upload_image: { id: "doc_upload_image", defaultMessage: "Upload image" },
  doc_cover_title_ph: {
    id: "doc_cover_title_ph",
    defaultMessage: "Cover title",
  },
  doc_cover_empty: {
    id: "doc_cover_empty",
    defaultMessage:
      "No cover page. Enable a cover, or add a header image for one-page reports.",
  },
  doc_search_ph: { id: "doc_search_ph", defaultMessage: "Search…" },
  doc_add_block_hint: {
    id: "doc_add_block_hint",
    defaultMessage: "Add a block from the left to start.",
  },
  doc_select_block_hint: {
    id: "doc_select_block_hint",
    defaultMessage: "Select a block to edit it.",
  },
  doc_selected_block: {
    id: "doc_selected_block",
    defaultMessage: "Selected block",
  },
  doc_heading_text: { id: "doc_heading_text", defaultMessage: "Heading text" },
  doc_section_label: {
    id: "doc_section_label",
    defaultMessage: "Section label",
  },
  doc_edit_in_canvas: {
    id: "doc_edit_in_canvas",
    defaultMessage: "Edit the text directly in the canvas.",
  },
  doc_rendering_preview: {
    id: "doc_rendering_preview",
    defaultMessage: "Rendering preview…",
  },
  doc_preview_doc: {
    id: "doc_preview_doc",
    defaultMessage: "Document preview",
  },
  doc_render_preview: {
    id: "doc_render_preview",
    defaultMessage: "Render preview",
  },
  doc_palette_layout: { id: "doc_palette_layout", defaultMessage: "Layout" },
  doc_palette_clinical: {
    id: "doc_palette_clinical",
    defaultMessage: "Clinical",
  },
  doc_palette_ai: { id: "doc_palette_ai", defaultMessage: "AI" },
  doc_tt_heading: { id: "doc_tt_heading", defaultMessage: "Heading" },
  doc_tt_subheading: { id: "doc_tt_subheading", defaultMessage: "Subheading" },
  doc_tt_normal: { id: "doc_tt_normal", defaultMessage: "Normal text" },
  doc_tt_bold: { id: "doc_tt_bold", defaultMessage: "Bold" },
  doc_tt_italic: { id: "doc_tt_italic", defaultMessage: "Italic" },
  doc_tt_underline: { id: "doc_tt_underline", defaultMessage: "Underline" },
  doc_tt_bullet: { id: "doc_tt_bullet", defaultMessage: "Bullet list" },
  doc_tt_numbered: { id: "doc_tt_numbered", defaultMessage: "Numbered list" },
  doc_tt_quote: { id: "doc_tt_quote", defaultMessage: "Quote" },
  doc_free_text_box: {
    id: "doc_free_text_box",
    defaultMessage: "Free text box",
  },
  doc_no_data_sources: {
    id: "doc_no_data_sources",
    defaultMessage: "No data sources selected",
  },
  doc_all_questions: {
    id: "doc_all_questions",
    defaultMessage: "All questions",
  },
  doc_n_questions: {
    id: "doc_n_questions",
    defaultMessage: "{count} questions",
  },
  doc_untitled_chart: {
    id: "doc_untitled_chart",
    defaultMessage: "Untitled chart",
  },
  doc_no_survey_selected: {
    id: "doc_no_survey_selected",
    defaultMessage: "No survey selected",
  },
  doc_more_count: { id: "doc_more_count", defaultMessage: "+{count} more" },
  doc_ai_section_type: { id: "doc_ai_section_type", defaultMessage: "AI section type" },
  doc_ai_section_name: { id: "doc_ai_section_name", defaultMessage: "Section title" },
  doc_ai_section_name_ph: {
    id: "doc_ai_section_name_ph",
    defaultMessage: "e.g. Cardiovascular Health",
  },
  doc_additional_data: { id: "doc_additional_data", defaultMessage: "Additional data" },
  doc_staff_notes: { id: "doc_staff_notes", defaultMessage: "Staff notes" },
  doc_episodes_of_care: {
    id: "doc_episodes_of_care",
    defaultMessage: "Episodes of care",
  },
  doc_prompt: { id: "doc_prompt", defaultMessage: "Prompt" },
  doc_prompt_ph: {
    id: "doc_prompt_ph",
    defaultMessage: "What should the AI generate from the selected data?",
  },
  doc_chart_type: { id: "doc_chart_type", defaultMessage: "Chart type" },
  doc_chart_auto: {
    id: "doc_chart_auto",
    defaultMessage: "Auto (use survey setting)",
  },
  doc_chart_bar: { id: "doc_chart_bar", defaultMessage: "Bar" },
  doc_chart_line: { id: "doc_chart_line", defaultMessage: "Line" },
  doc_items_optional: {
    id: "doc_items_optional",
    defaultMessage: "Items (optional)",
  },
  doc_all_questions_total: {
    id: "doc_all_questions_total",
    defaultMessage: "All questions (total)",
  },
  doc_select_survey_first: {
    id: "doc_select_survey_first",
    defaultMessage: "Select a survey first",
  },
  doc_items_hint: {
    id: "doc_items_hint",
    defaultMessage:
      "Pick questions to plot separately, or leave blank for the total.",
  },
  doc_select_surveys_ph: {
    id: "doc_select_surveys_ph",
    defaultMessage: "Select surveys…",
  },
  doc_select_attributes_ph: {
    id: "doc_select_attributes_ph",
    defaultMessage: "Select attributes…",
  },
  doc_select_survey_ph: {
    id: "doc_select_survey_ph",
    defaultMessage: "Select a survey…",
  },
  doc_chart_title_ph: {
    id: "doc_chart_title_ph",
    defaultMessage: "Defaults to the survey name",
  },
  doc_add_row: { id: "doc_add_row", defaultMessage: "Add row" },
  doc_add_field: { id: "doc_add_field", defaultMessage: "Add field" },
  doc_add_item: { id: "doc_add_item", defaultMessage: "Add item" },
  doc_add_line: { id: "doc_add_line", defaultMessage: "Add line" },
  doc_sig_no_autofill: {
    id: "doc_sig_no_autofill",
    defaultMessage: "No auto-fill",
  },
  doc_sig_logged_user: {
    id: "doc_sig_logged_user",
    defaultMessage: "Logged-in user",
  },
  doc_sig_current_date: {
    id: "doc_sig_current_date",
    defaultMessage: "Current date",
  },
  doc_ph_measurement: {
    id: "doc_ph_measurement",
    defaultMessage: "Measurement / test name",
  },
  doc_ph_bind_result: {
    id: "doc_ph_bind_result",
    defaultMessage: "Bind result attribute…",
  },
  doc_ph_field_label: {
    id: "doc_ph_field_label",
    defaultMessage: "Field label",
  },
  doc_ph_bind_attr: {
    id: "doc_ph_bind_attr",
    defaultMessage: "Bind attribute…",
  },
  doc_ph_static_value: {
    id: "doc_ph_static_value",
    defaultMessage: "or static value (optional)",
  },
  doc_ph_item_label: { id: "doc_ph_item_label", defaultMessage: "Item label" },
  doc_ticked_default: {
    id: "doc_ticked_default",
    defaultMessage: "Ticked by default",
  },
  doc_ph_sig_line: {
    id: "doc_ph_sig_line",
    defaultMessage: "Line label (e.g. Clinician Signature)",
  },
  doc_hint_reftable: {
    id: "doc_hint_reftable",
    defaultMessage:
      "Bind each result to a patient attribute. The Result and configured Interpretation are pulled from the observation at generation.",
  },
  doc_hint_fieldgrid: {
    id: "doc_hint_fieldgrid",
    defaultMessage:
      "Bind an attribute for live data, type a static value, or leave both blank for a fill-in field completed during review.",
  },
  doc_hint_tickbox: {
    id: "doc_hint_tickbox",
    defaultMessage:
      "A checklist. Items ticked by default render with a check mark.",
  },
  doc_hint_signature: {
    id: "doc_hint_signature",
    defaultMessage:
      "Sign-off lines. Set a line to auto-fill the logged-in user's name or the current date at finalisation.",
  },
  doc_reference_range_table: {
    id: "doc_reference_range_table",
    defaultMessage: "Reference-Range Table",
  },
  doc_field_grid: { id: "doc_field_grid", defaultMessage: "Field Grid" },
  doc_tickbox_list: { id: "doc_tickbox_list", defaultMessage: "Tick-box List" },
  doc_signature: { id: "doc_signature", defaultMessage: "Signature" },
  doc_insert: { id: "doc_insert", defaultMessage: "Insert" },
  doc_block_chapter: { id: "doc_block_chapter", defaultMessage: "Chapter Divider" },
  doc_block_section: { id: "doc_block_section", defaultMessage: "Section Heading" },
  doc_block_free_text: { id: "doc_block_free_text", defaultMessage: "Free Text Section" },
  doc_block_custom_html: { id: "doc_block_custom_html", defaultMessage: "Custom HTML" },
  doc_custom_html_ph: {
    id: "doc_custom_html_ph",
    defaultMessage: "<div style=\"...\">Paste inline-styled HTML here</div>",
  },
  doc_custom_html_hint: {
    id: "doc_custom_html_hint",
    defaultMessage:
      "Rendered exactly as written in the preview, PDF and editor. Use inline styles. Insert a patient value with <span field=\"attribute-name\">Label</span>.",
  },
  doc_ai_section: { id: "doc_ai_section", defaultMessage: "AI Section" },
  doc_survey_chart: { id: "doc_survey_chart", defaultMessage: "Survey Chart" },
  doc_move_up: { id: "doc_move_up", defaultMessage: "Move up" },
  doc_move_down: { id: "doc_move_down", defaultMessage: "Move down" },
  doc_duplicate: { id: "doc_duplicate", defaultMessage: "Duplicate" },
  doc_drag_reorder: {
    id: "doc_drag_reorder",
    defaultMessage: "Drag to reorder",
  },
  doc_image_upload_failed: {
    id: "doc_image_upload_failed",
    defaultMessage: "Image upload failed. Please try again.",
  },
  doc_preview_failed: {
    id: "doc_preview_failed",
    defaultMessage: "Could not generate a preview. Please try again.",
  },
  doc_insert_field: { id: "doc_insert_field", defaultMessage: "Insert field" },
  doc_toggle_sections: {
    id: "doc_toggle_sections",
    defaultMessage: "Toggle sections",
  },
  doc_toggle_patient_data: {
    id: "doc_toggle_patient_data",
    defaultMessage: "Toggle patient data",
  },
  doc_no_attributes_available: {
    id: "doc_no_attributes_available",
    defaultMessage: "No attributes available",
  },
  // Loud chat notifications
  loud_chat_wants_to_chat: {
    id: "loud_chat_wants_to_chat",
    defaultMessage: "wants to chat with you",
  },
  loud_chat_open_now: {
    id: "loud_chat_open_now",
    defaultMessage: "Open chat now",
  },
  loud_chat_snooze: {
    id: "loud_chat_snooze",
    defaultMessage: "Snooze 5 min",
  },
  loud_chat_dismiss: {
    id: "loud_chat_dismiss",
    defaultMessage: "Dismiss",
  },
  loud_chat_role_clinician: {
    id: "loud_chat_role_clinician",
    defaultMessage: "Clinician",
  },
  loud_chat_role_patient: {
    id: "loud_chat_role_patient",
    defaultMessage: "Patient",
  },
  // Chat panel UI (redesign)
  chat_role_clinician: {
    id: "chat_role_clinician",
    defaultMessage: "Clinician",
  },
  chat_role_patient: {
    id: "chat_role_patient",
    defaultMessage: "Patient",
  },
  chat_presence_online: {
    id: "chat_presence_online",
    defaultMessage: "online",
  },
  // FMEA #3 — safety notice
  chat_safety_aria: {
    id: "chat_safety_aria",
    defaultMessage: "Safety notice",
  },
  chat_safety_emergency: {
    id: "chat_safety_emergency",
    defaultMessage:
      "This chat is not monitored for emergencies. If you or someone is in immediate danger, call 999 (or 112 in the EU).",
  },
  chat_safety_response_window: {
    id: "chat_safety_response_window",
    defaultMessage: "Your care team typically responds within one working day.",
  },
  chat_back_to_update: {
    id: "chat_back_to_update",
    defaultMessage: "Back to update",
  },
  chat_you: {
    id: "chat_you",
    defaultMessage: "You",
  },
  chat_typing_indicator: {
    id: "chat_typing_indicator",
    defaultMessage: "{name} is typing…",
  },
  chat_empty_state: {
    id: "chat_empty_state",
    defaultMessage: "No messages yet — start the conversation",
  },
  chat_loading: {
    id: "chat_loading",
    defaultMessage: "Loading conversation…",
  },
  chat_load_error: {
    id: "chat_load_error",
    defaultMessage: "Couldn't load the conversation.",
  },
  chat_retry: {
    id: "chat_retry",
    defaultMessage: "Retry",
  },
  chat_status_sent: {
    id: "chat_status_sent",
    defaultMessage: "Sent",
  },
  chat_status_delivered: {
    id: "chat_status_delivered",
    defaultMessage: "Delivered",
  },
  chat_status_read: {
    id: "chat_status_read",
    defaultMessage: "Read",
  },
  chat_aria_message_from: {
    id: "chat_aria_message_from",
    defaultMessage: "Message from {name} at {time}",
  },
  chat_aria_message_you: {
    id: "chat_aria_message_you",
    defaultMessage: "You at {time}: {content}",
  },
  chat_aria_back: {
    id: "chat_aria_back",
    defaultMessage: "Back to update",
  },
  chat_aria_close: {
    id: "chat_aria_close",
    defaultMessage: "Close chat",
  },
  chat_aria_send: {
    id: "chat_aria_send",
    defaultMessage: "Send message",
  },
  chat_end_conversation: {
    id: "chat_end_conversation",
    defaultMessage: "End conversation",
  },
  chat_create_error: {
    id: "chat_create_error",
    defaultMessage: "Couldn't start the conversation — please try again.",
  },
  chat_voice_input: {
    id: "chat_voice_input",
    defaultMessage: "Voice input",
  },
  chat_voice_listening: {
    id: "chat_voice_listening",
    defaultMessage: "Listening…",
  },
  chat_aria_end_conversation: {
    id: "chat_aria_end_conversation",
    defaultMessage: "End this conversation. The patient will no longer be able to reply.",
  },

  // ===== Webinar Setup Wizard =====
  webinar_create_title: {
    id: "webinar_create_title",
    defaultMessage: "Create Webinar",
  },
  webinar_draft_banner: {
    id: "webinar_draft_banner",
    defaultMessage: "You have an unfinished webinar setup.",
  },
  webinar_resume: { id: "webinar_resume", defaultMessage: "Resume" },
  webinar_discard: { id: "webinar_discard", defaultMessage: "Discard" },
  webinar_prefill_label: {
    id: "webinar_prefill_label",
    defaultMessage: "Start from a previous webinar",
  },
  webinar_prefill_hint: {
    id: "webinar_prefill_hint",
    defaultMessage:
      "Pre-fills the invite, confirmation and reminder messages.",
  },
  webinar_prefill_blank: {
    id: "webinar_prefill_blank",
    defaultMessage: "Blank — start fresh",
  },
  webinar_unsaved_changes_confirm: {
    id: "webinar_unsaved_changes_confirm",
    defaultMessage: "You have unsaved changes. Are you sure you want to leave?",
  },
  webinar_status_starting: {
    id: "webinar_status_starting",
    defaultMessage: "Starting...",
  },
  webinar_status_creating: {
    id: "webinar_status_creating",
    defaultMessage: "Creating...",
  },
  webinar_created: {
    id: "webinar_created",
    defaultMessage: "Webinar created successfully!",
  },
  webinar_create_error: {
    id: "webinar_create_error",
    defaultMessage: "Failed to create webinar: {error}",
  },
  webinar_success_title: {
    id: "webinar_success_title",
    defaultMessage: "Webinar Created Successfully!",
  },
  webinar_create_another: {
    id: "webinar_create_another",
    defaultMessage: "Create Another Webinar",
  },
  webinar_go_to_appointments: {
    id: "webinar_go_to_appointments",
    defaultMessage: "Go to Appointments",
  },
  webinar_delivering_invites: {
    id: "webinar_delivering_invites",
    defaultMessage: "Delivering invitations…",
  },
  webinar_delivery_starting: {
    id: "webinar_delivery_starting",
    defaultMessage: "Starting…",
  },
  webinar_delivery_progress: {
    id: "webinar_delivery_progress",
    defaultMessage: "{processed} of {total} patients",
  },
  webinar_delivery_complete: {
    id: "webinar_delivery_complete",
    defaultMessage: "Delivered to {count} patients",
  },
  webinar_delivery_failed: {
    id: "webinar_delivery_failed",
    defaultMessage: "{count} failed",
  },
  webinar_delivery_background: {
    id: "webinar_delivery_background",
    defaultMessage:
      "Delivery continues in the background — it's safe to leave this page.",
  },
  webinar_delivery_queued: {
    id: "webinar_delivery_queued",
    defaultMessage: "Queued — starts at {time}",
  },
  webinar_delivery_window_wait: {
    id: "webinar_delivery_window_wait",
    defaultMessage: "Waiting for the facility's notification window",
  },

  // Stepper labels
  webinar_step_details: {
    id: "webinar_step_details",
    defaultMessage: "Webinar Details",
  },
  webinar_step_invite: {
    id: "webinar_step_invite",
    defaultMessage: "Invite Message",
  },
  webinar_step_confirmation: {
    id: "webinar_step_confirmation",
    defaultMessage: "Confirmation & Reminders",
  },
  webinar_step_audience: {
    id: "webinar_step_audience",
    defaultMessage: "Audience",
  },
  webinar_step_review: {
    id: "webinar_step_review",
    defaultMessage: "Review & Create",
  },

  // Navigation
  webinar_create_button: {
    id: "webinar_create_button",
    defaultMessage: "Create Webinar",
  },

  // Merge buttons
  webinar_insert_date: {
    id: "webinar_insert_date",
    defaultMessage: "Insert Date",
  },
  webinar_insert_time: {
    id: "webinar_insert_time",
    defaultMessage: "Insert Time",
  },
  webinar_insert_meeting_link: {
    id: "webinar_insert_meeting_link",
    defaultMessage: "Insert Meeting Link",
  },
  webinar_set_date_first: {
    id: "webinar_set_date_first",
    defaultMessage: "Set the date in Step 1 first",
  },
  webinar_set_time_first: {
    id: "webinar_set_time_first",
    defaultMessage: "Set the time in Step 1 first",
  },
  webinar_link_placeholder_tooltip: {
    id: "webinar_link_placeholder_tooltip",
    defaultMessage:
      "Inserts a placeholder — the actual video link will be inserted when the message is sent to the patient",
  },
  webinar_enter_link_first: {
    id: "webinar_enter_link_first",
    defaultMessage: "Enter a meeting link in Step 1 first",
  },
  webinar_choose_platform_first: {
    id: "webinar_choose_platform_first",
    defaultMessage: "Choose a video platform in Step 1 first",
  },

  // Embedded patient filter
  webinar_loading_filters: {
    id: "webinar_loading_filters",
    defaultMessage: "Loading filters...",
  },

  // Details step
  webinar_details_subtitle: {
    id: "webinar_details_subtitle",
    defaultMessage:
      "Set up the basic information for your webinar. These details will be auto-inserted into all messages.",
  },
  webinar_schedule: { id: "webinar_schedule", defaultMessage: "Schedule" },
  webinar_schedule_new: {
    id: "webinar_schedule_new",
    defaultMessage: "New schedule",
  },
  webinar_schedule_new_desc: {
    id: "webinar_schedule_new_desc",
    defaultMessage: "Create a new schedule for this webinar",
  },
  webinar_schedule_existing: {
    id: "webinar_schedule_existing",
    defaultMessage: "Use existing schedule",
  },
  webinar_schedule_existing_desc: {
    id: "webinar_schedule_existing_desc",
    defaultMessage: "Add this webinar to an existing schedule",
  },
  webinar_schedule_select: {
    id: "webinar_schedule_select",
    defaultMessage: "Select a schedule",
  },
  webinar_schedule_none: {
    id: "webinar_schedule_none",
    defaultMessage: "No existing schedules",
  },
  webinar_patient_type: { id: "webinar_patient_type", defaultMessage: "Patient Type" },
  webinar_name: { id: "webinar_name", defaultMessage: "Webinar Name" },
  webinar_name_placeholder: {
    id: "webinar_name_placeholder",
    defaultMessage: "e.g. Patient Education Webinar — March 2026",
  },
  webinar_start_time: {
    id: "webinar_start_time",
    defaultMessage: "Start Time",
  },
  webinar_end_time: { id: "webinar_end_time", defaultMessage: "End Time" },
  webinar_time_hh: { id: "webinar_time_hh", defaultMessage: "HH" },
  webinar_time_mm: { id: "webinar_time_mm", defaultMessage: "MM" },
  webinar_video_platform: {
    id: "webinar_video_platform",
    defaultMessage: "Video Platform",
  },
  webinar_provider_room_auto: {
    id: "webinar_provider_room_auto",
    defaultMessage: "Video room created automatically",
  },
  webinar_external_link: {
    id: "webinar_external_link",
    defaultMessage: "External Link",
  },
  webinar_external_link_desc: {
    id: "webinar_external_link_desc",
    defaultMessage: "Zoom, Teams, or any meeting URL",
  },
  webinar_mps_video_info: {
    id: "webinar_mps_video_info",
    defaultMessage:
      "A {provider} room will be created when you submit. The join link will be included in all messages automatically.",
  },
  webinar_meeting_link: {
    id: "webinar_meeting_link",
    defaultMessage: "Meeting Link",
  },
  webinar_meeting_link_placeholder: {
    id: "webinar_meeting_link_placeholder",
    defaultMessage: "https://zoom.us/j/... or any meeting URL",
  },
  webinar_max_participants: {
    id: "webinar_max_participants",
    defaultMessage: "Max Participants",
  },
  webinar_max_participants_hint: {
    id: "webinar_max_participants_hint",
    defaultMessage: "{provider} supports up to {count} participants per room",
  },
  webinar_speakers: { id: "webinar_speakers", defaultMessage: "Speakers" },

  // Invite Message step
  webinar_invite_subtitle: {
    id: "webinar_invite_subtitle",
    defaultMessage:
      "Compose the invitation patients will receive. The Register button will be automatically linked to this webinar.",
  },
  webinar_invite_info: {
    id: "webinar_invite_info",
    defaultMessage:
      "Patients receive the video link in the confirmation message after they click Register.",
  },
  webinar_email_invitation: {
    id: "webinar_email_invitation",
    defaultMessage: "Email Invitation",
  },
  webinar_email_subject: {
    id: "webinar_email_subject",
    defaultMessage: "Email Subject",
  },
  webinar_email_subject_placeholder: {
    id: "webinar_email_subject_placeholder",
    defaultMessage: "e.g. You're Invited: Patient Education Webinar",
  },
  webinar_email_body: {
    id: "webinar_email_body",
    defaultMessage: "Email Body",
  },
  webinar_email_body_placeholder: {
    id: "webinar_email_body_placeholder",
    defaultMessage: "Write your invitation email here...",
  },
  webinar_sms_message: {
    id: "webinar_sms_message",
    defaultMessage: "SMS Message",
  },
  webinar_sms_text: { id: "webinar_sms_text", defaultMessage: "SMS Text" },
  webinar_sms_char_count: {
    id: "webinar_sms_char_count",
    defaultMessage: "{count} / 160",
  },
  webinar_sms_invite_placeholder: {
    id: "webinar_sms_invite_placeholder",
    defaultMessage: "Short SMS invitation...",
  },
  webinar_status_message: {
    id: "webinar_status_message",
    defaultMessage: "Status Message",
  },
  webinar_push_notification: {
    id: "webinar_push_notification",
    defaultMessage: "Push Notification",
  },
  webinar_action_buttons: {
    id: "webinar_action_buttons",
    defaultMessage: "Action Buttons",
  },
  webinar_register_for_webinar: {
    id: "webinar_register_for_webinar",
    defaultMessage: "Register for Webinar",
  },
  webinar_auto_linked: {
    id: "webinar_auto_linked",
    defaultMessage: "Auto-linked to this webinar",
  },
  webinar_actions_info: {
    id: "webinar_actions_info",
    defaultMessage:
      "Configure the action buttons patients see on the invite. Each included action is created for this webinar.",
  },
  webinar_action_button_label: {
    id: "webinar_action_button_label",
    defaultMessage: "Button label",
  },
  webinar_action_help_text: {
    id: "webinar_action_help_text",
    defaultMessage: "Help text",
  },
  webinar_action_confirmation: {
    id: "webinar_action_confirmation",
    defaultMessage: "Confirmation message",
  },
  webinar_action_attribute: {
    id: "webinar_action_attribute",
    defaultMessage: "Observation / attribute to record",
  },
  webinar_action_icon: {
    id: "webinar_action_icon",
    defaultMessage: "Icon",
  },
  webinar_in_app_message: {
    id: "webinar_in_app_message",
    defaultMessage: "In-app message",
  },
  webinar_in_app_actions_note: {
    id: "webinar_in_app_actions_note",
    defaultMessage:
      "This message and its action buttons appear in the patient's app only — not in the email or SMS.",
  },
  webinar_action_register_auto: {
    id: "webinar_action_register_auto",
    defaultMessage: "Automatically linked to this webinar's appointment",
  },
  webinar_err_action_attribute_required: {
    id: "webinar_err_action_attribute_required",
    defaultMessage: "Choose an attribute for this action",
  },
  webinar_actions_question: {
    id: "webinar_actions_question",
    defaultMessage: "What actions do you want to include?",
  },
  webinar_action_cloned_badge: {
    id: "webinar_action_cloned_badge",
    defaultMessage: "Cloned for this webinar",
  },
  webinar_action_reused_badge: {
    id: "webinar_action_reused_badge",
    defaultMessage: "Reused as configured",
  },
  webinar_action_register: {
    id: "webinar_action_register",
    defaultMessage: "Register",
  },
  webinar_action_register_hint: {
    id: "webinar_action_register_hint",
    defaultMessage: "Registers the patient for this webinar.",
  },
  webinar_action_dont_register: {
    id: "webinar_action_dont_register",
    defaultMessage: "Don't Register",
  },
  webinar_action_dont_register_hint: {
    id: "webinar_action_dont_register_hint",
    defaultMessage: "Records that the patient is not interested this time.",
  },
  webinar_action_unsubscribe: {
    id: "webinar_action_unsubscribe",
    defaultMessage: "Unsubscribe",
  },
  webinar_action_unsubscribe_hint: {
    id: "webinar_action_unsubscribe_hint",
    defaultMessage: "Opts the patient out of all future webinar notifications.",
  },
  webinar_action_select_placeholder: {
    id: "webinar_action_select_placeholder",
    defaultMessage: "Select an action…",
  },
  webinar_action_none_configured: {
    id: "webinar_action_none_configured",
    defaultMessage: "No matching actions configured",
  },

  // Confirmation & Reminders step
  webinar_confirmation_subtitle: {
    id: "webinar_confirmation_subtitle",
    defaultMessage:
      "Configure the messages patients receive after registering and before the event.",
  },
  webinar_registration_confirmation: {
    id: "webinar_registration_confirmation",
    defaultMessage: "Registration Confirmation",
  },
  webinar_sent_immediately: {
    id: "webinar_sent_immediately",
    defaultMessage: "Sent immediately on registration",
  },
  webinar_confirmation_subject_placeholder: {
    id: "webinar_confirmation_subject_placeholder",
    defaultMessage: "e.g. Registration Confirmed — Patient Education Webinar",
  },
  webinar_confirmation_body_placeholder: {
    id: "webinar_confirmation_body_placeholder",
    defaultMessage: "Thank you for registering...",
  },
  webinar_sms_confirmation: {
    id: "webinar_sms_confirmation",
    defaultMessage: "SMS Confirmation",
  },
  webinar_sms_confirmation_placeholder: {
    id: "webinar_sms_confirmation_placeholder",
    defaultMessage: "Short SMS confirmation...",
  },
  webinar_reminders_count: {
    id: "webinar_reminders_count",
    defaultMessage: "Reminders ({count})",
  },
  webinar_add_reminder: {
    id: "webinar_add_reminder",
    defaultMessage: "Add Reminder",
  },
  webinar_reminder_n: {
    id: "webinar_reminder_n",
    defaultMessage: "Reminder {number}",
  },
  webinar_when_to_send: {
    id: "webinar_when_to_send",
    defaultMessage: "When to send",
  },
  webinar_reminder_subject_placeholder: {
    id: "webinar_reminder_subject_placeholder",
    defaultMessage: "e.g. Reminder: Webinar Tomorrow",
  },
  webinar_reminder_body_placeholder: {
    id: "webinar_reminder_body_placeholder",
    defaultMessage: "Include video link details here...",
  },
  webinar_reminder_sms_placeholder: {
    id: "webinar_reminder_sms_placeholder",
    defaultMessage: "Short SMS reminder...",
  },

  // Reminder timing options
  webinar_timing_1_hour: {
    id: "webinar_timing_1_hour",
    defaultMessage: "1 hour before",
  },
  webinar_timing_2_hours: {
    id: "webinar_timing_2_hours",
    defaultMessage: "2 hours before",
  },
  webinar_timing_3_hours: {
    id: "webinar_timing_3_hours",
    defaultMessage: "3 hours before",
  },
  webinar_timing_6_hours: {
    id: "webinar_timing_6_hours",
    defaultMessage: "6 hours before",
  },
  webinar_timing_12_hours: {
    id: "webinar_timing_12_hours",
    defaultMessage: "12 hours before",
  },
  webinar_timing_24_hours: {
    id: "webinar_timing_24_hours",
    defaultMessage: "24 hours before",
  },
  webinar_timing_2_days: {
    id: "webinar_timing_2_days",
    defaultMessage: "2 days before",
  },
  webinar_timing_3_days: {
    id: "webinar_timing_3_days",
    defaultMessage: "3 days before",
  },
  webinar_timing_1_week: {
    id: "webinar_timing_1_week",
    defaultMessage: "1 week before",
  },
  webinar_timing_minutes_before: {
    id: "webinar_timing_minutes_before",
    defaultMessage: "{minutes} minutes before",
  },

  // Audience step
  webinar_audience_subtitle: {
    id: "webinar_audience_subtitle",
    defaultMessage:
      "Choose which patients will receive the webinar invitation.",
  },
  webinar_all_patients: {
    id: "webinar_all_patients",
    defaultMessage: "All Patients",
  },
  webinar_all_patients: { id: "webinar_all_patients", defaultMessage: "All Patients" },
  webinar_all_type_patients: {
    id: "webinar_all_type_patients",
    defaultMessage: "All {type} Patients",
  },
  webinar_all_type_will_receive: {
    id: "webinar_all_type_will_receive",
    defaultMessage: "All active {type} patients will receive this invitation",
  },
  webinar_all_patients_desc: {
    id: "webinar_all_patients_desc",
    defaultMessage: "Send to all active patients via channel broadcast.",
  },
  webinar_filtered_patients: {
    id: "webinar_filtered_patients",
    defaultMessage: "Filtered Patients",
  },
  webinar_filtered_patients_desc: {
    id: "webinar_filtered_patients_desc",
    defaultMessage: "Target a specific cohort using patient filters.",
  },
  webinar_patients_will_receive: {
    id: "webinar_patients_will_receive",
    defaultMessage: "{count} patients will receive this invitation",
  },
  webinar_all_active_will_receive: {
    id: "webinar_all_active_will_receive",
    defaultMessage: "All active patients will receive this invitation",
  },
  webinar_search_above: {
    id: "webinar_search_above",
    defaultMessage: "Search patients above to see results",
  },
  webinar_showing_x_of_y: {
    id: "webinar_showing_x_of_y",
    defaultMessage: "Showing {shown} of {total} patients",
  },

  // Review step
  webinar_review_subtitle: {
    id: "webinar_review_subtitle",
    defaultMessage:
      "Review all settings before creating the webinar. Click Edit to modify any section.",
  },
  webinar_review_selected: {
    id: "webinar_review_selected",
    defaultMessage: "Selected",
  },
  webinar_mps_video_auto: {
    id: "webinar_mps_video_auto",
    defaultMessage: "MPS Video (auto-created on submit)",
  },
  webinar_confirmation_email_subject: {
    id: "webinar_confirmation_email_subject",
    defaultMessage: "Confirmation Email Subject",
  },
  webinar_confirmation_email_body: {
    id: "webinar_confirmation_email_body",
    defaultMessage: "Confirmation Email Body",
  },
  webinar_confirmation_sms: {
    id: "webinar_confirmation_sms",
    defaultMessage: "Confirmation SMS",
  },
  webinar_confirmation_status_message: {
    id: "webinar_confirmation_status_message",
    defaultMessage: "Confirmation Status Message",
  },
  webinar_confirmation_push_notification: {
    id: "webinar_confirmation_push_notification",
    defaultMessage: "Confirmation Push Notification",
  },
  webinar_reminder_timing_line: {
    id: "webinar_reminder_timing_line",
    defaultMessage: "Reminder {number}: {timing}",
  },
  webinar_target: { id: "webinar_target", defaultMessage: "Target" },
  webinar_target_all: {
    id: "webinar_target_all",
    defaultMessage: "All active patients",
  },
  webinar_target_filtered: {
    id: "webinar_target_filtered",
    defaultMessage: "Filtered patients",
  },
  webinar_status_library: {
    id: "webinar_status_library",
    defaultMessage: "Library: {name}",
  },
  webinar_status_survey: {
    id: "webinar_status_survey",
    defaultMessage: "Survey: {name}",
  },
  webinar_status_consent: {
    id: "webinar_status_consent",
    defaultMessage: "Consent: {name}",
  },
  webinar_status_configured: {
    id: "webinar_status_configured",
    defaultMessage: "Configured",
  },
  webinar_speaker_fallback: {
    id: "webinar_speaker_fallback",
    defaultMessage: "Staff member",
  },

  // Validation errors
  webinar_err_patient_type_required: {
    id: "webinar_err_patient_type_required",
    defaultMessage: "Patient type is required",
  },
  webinar_err_name_required: {
    id: "webinar_err_name_required",
    defaultMessage: "Webinar name is required",
  },
  webinar_err_date_required: {
    id: "webinar_err_date_required",
    defaultMessage: "Date is required",
  },
  webinar_err_date_future: {
    id: "webinar_err_date_future",
    defaultMessage: "Date must be in the future",
  },
  webinar_err_start_time_required: {
    id: "webinar_err_start_time_required",
    defaultMessage: "Start time is required",
  },
  webinar_err_end_time_required: {
    id: "webinar_err_end_time_required",
    defaultMessage: "End time is required",
  },
  webinar_err_end_after_start: {
    id: "webinar_err_end_after_start",
    defaultMessage: "End time must be after start time",
  },
  webinar_err_min_participants: {
    id: "webinar_err_min_participants",
    defaultMessage: "Must be at least 1",
  },
  webinar_err_link_required: {
    id: "webinar_err_link_required",
    defaultMessage: "Meeting link is required",
  },
  webinar_err_schedule_required: {
    id: "webinar_err_schedule_required",
    defaultMessage: "Select a schedule",
  },
  webinar_err_link_invalid: {
    id: "webinar_err_link_invalid",
    defaultMessage: "Must be a valid URL",
  },
  webinar_err_speaker_required: {
    id: "webinar_err_speaker_required",
    defaultMessage: "At least one speaker is required",
  },
  webinar_err_email_subject_required: {
    id: "webinar_err_email_subject_required",
    defaultMessage: "Email subject is required",
  },
  webinar_err_status_required: {
    id: "webinar_err_status_required",
    defaultMessage: "Add a status message — this is how patients receive the invite",
  },
  webinar_err_email_body_required: {
    id: "webinar_err_email_body_required",
    defaultMessage: "Email body is required",
  },
  webinar_err_confirmation_subject_required: {
    id: "webinar_err_confirmation_subject_required",
    defaultMessage: "Confirmation email subject is required",
  },
  webinar_err_confirmation_body_required: {
    id: "webinar_err_confirmation_body_required",
    defaultMessage: "Confirmation email body is required",
  },
  carevw_tab_label: {
    id: "carevw_tab_label",
    defaultMessage: "Virtual Ward Analytics",
  },
  carevw_title: {
    id: "carevw_title",
    defaultMessage: "CARE Virtual Ward",
  },
  carevw_generated_at: {
    id: "carevw_generated_at",
    defaultMessage: "Data as of {timestamp}",
  },
  carevw_loading: {
    id: "carevw_loading",
    defaultMessage: "Loading CARE Virtual Ward analytics…",
  },
  carevw_error: {
    id: "carevw_error",
    defaultMessage: "Unable to load CARE Virtual Ward analytics. Please try again shortly.",
  },
  carevw_empty: {
    id: "carevw_empty",
    defaultMessage: "No CARE Virtual Ward data is available for this facility yet.",
  },
  carevw_metric_admissions: {
    id: "carevw_metric_admissions",
    defaultMessage: "Admissions",
  },
  carevw_metric_distinct_patients: {
    id: "carevw_metric_distinct_patients",
    defaultMessage: "Distinct Patients",
  },
  carevw_metric_distinct_patients_unavailable: {
    id: "carevw_metric_distinct_patients_unavailable",
    defaultMessage: "Not yet available",
  },
  carevw_metric_bed_days_saved: {
    id: "carevw_metric_bed_days_saved",
    defaultMessage: "Bed Days Saved",
  },
  carevw_metric_total_admissions: {
    id: "carevw_metric_total_admissions",
    defaultMessage: "Total Admissions",
  },
  carevw_chart_title: {
    id: "carevw_chart_title",
    defaultMessage: "Weekly Admissions vs Discharges",
  },
  carevw_chart_legend_admissions: {
    id: "carevw_chart_legend_admissions",
    defaultMessage: "Admissions",
  },
  carevw_chart_legend_discharges: {
    id: "carevw_chart_legend_discharges",
    defaultMessage: "Discharges",
  },
  carevw_grid_title: {
    id: "carevw_grid_title",
    defaultMessage: "Weekly Info",
  },
  carevw_col_week_start: {
    id: "carevw_col_week_start",
    defaultMessage: "Week Start",
  },
  carevw_col_week_end: {
    id: "carevw_col_week_end",
    defaultMessage: "Week End",
  },
  carevw_col_admissions: {
    id: "carevw_col_admissions",
    defaultMessage: "Admissions",
  },
  carevw_col_discharges: {
    id: "carevw_col_discharges",
    defaultMessage: "Discharges",
  },
  carevw_col_discharges_projected_note: {
    id: "carevw_col_discharges_projected_note",
    defaultMessage: "{count} projected",
  },
  carevw_col_rescue_scripts: {
    id: "carevw_col_rescue_scripts",
    defaultMessage: "Initiate Rescue Script",
  },
  carevw_col_patient_count: {
    id: "carevw_col_patient_count",
    defaultMessage: "Patient Count",
  },
  carevw_col_occupancy_pct: {
    id: "carevw_col_occupancy_pct",
    defaultMessage: "Occupancy %",
  },
  carevw_col_max_patients: {
    id: "carevw_col_max_patients",
    defaultMessage: "Max Patients",
  },
  carevw_col_max_occupancy_pct: {
    id: "carevw_col_max_occupancy_pct",
    defaultMessage: "Max Occupancy %",
  },
  carevw_col_on_ward: {
    id: "carevw_col_on_ward",
    defaultMessage: "On Ward This Week",
  },
  carevw_col_avg_los: {
    id: "carevw_col_avg_los",
    defaultMessage: "Cumulative Avg LOS (days)",
  },
  carevw_period_label: { id: "carevw_period_label", defaultMessage: "Period" },
  carevw_period_12w: { id: "carevw_period_12w", defaultMessage: "Last 12 weeks" },
  carevw_period_6m: { id: "carevw_period_6m", defaultMessage: "Last 6 months" },
  carevw_period_12m: { id: "carevw_period_12m", defaultMessage: "Last 12 months" },
  carevw_period_all: { id: "carevw_period_all", defaultMessage: "All time" },
  carevw_filter_dimension_month: { id: "carevw_filter_dimension_month", defaultMessage: "Month" },
  carevw_filter_chip_label: {
    id: "carevw_filter_chip_label",
    defaultMessage: "{dimension}: {value}",
  },
  carevw_filter_remove_aria: {
    id: "carevw_filter_remove_aria",
    defaultMessage: "Remove {label} filter",
  },
  carevw_filter_clear_all: { id: "carevw_filter_clear_all", defaultMessage: "Clear all" },
  carevw_grid_filter_hint: {
    id: "carevw_grid_filter_hint",
    defaultMessage: "Click a week to filter by month",
  },
  carevw_metric_scope_all_time: {
    id: "carevw_metric_scope_all_time",
    defaultMessage: "All-time figure",
  },
  carevw_empty_filtered: {
    id: "carevw_empty_filtered",
    defaultMessage: "No data matches the selected period and filters.",
  },
  carevw_chart_click_hint: {
    id: "carevw_chart_click_hint",
    defaultMessage: "Click a bar to filter the dashboard",
  },
  carevw_filter_dimension_referred_by: {
    id: "carevw_filter_dimension_referred_by",
    defaultMessage: "Referred by",
  },
  carevw_filter_dimension_encounter_type: {
    id: "carevw_filter_dimension_encounter_type",
    defaultMessage: "Encounter type",
  },
  carevw_bds_chart_desc: {
    id: "carevw_bds_chart_desc",
    defaultMessage: "Monthly bed days saved from rescue scripts for the selected period, with a cumulative running total.",
  },
  carevw_bds_legend_monthly: {
    id: "carevw_bds_legend_monthly",
    defaultMessage: "Monthly Bed Days Saved",
  },
  carevw_bds_legend_cumulative: {
    id: "carevw_bds_legend_cumulative",
    defaultMessage: "Cumulative Bed Days Saved",
  },
  carevw_bds_bar_aria: {
    id: "carevw_bds_bar_aria",
    defaultMessage: "{month}: {value} bed days saved",
  },
  carevw_bds_cumulative_aria: {
    id: "carevw_bds_cumulative_aria",
    defaultMessage: "{month}: {value} cumulative bed days saved",
  },
  carevw_referred_by_title: {
    id: "carevw_referred_by_title",
    defaultMessage: "Referred By",
  },
  carevw_referred_by_desc: {
    id: "carevw_referred_by_desc",
    defaultMessage: "Ranked referral sources for the selected period, showing referral count and percentage of period referrals.",
  },
  carevw_referred_by_bar_aria: {
    id: "carevw_referred_by_bar_aria",
    defaultMessage: "{source}: {count} referrals, {pct}% of period",
  },
  carevw_referred_by_value_label: {
    id: "carevw_referred_by_value_label",
    defaultMessage: "{count} ({pct}%)",
  },
  carevw_flow_title: {
    id: "carevw_flow_title",
    defaultMessage: "Admissions vs Discharges",
  },
  carevw_flow_desc: {
    id: "carevw_flow_desc",
    defaultMessage: "Admissions and discharges for the selected period, at weekly or monthly grain depending on the period length, with the net change in ward population running through zero.",
  },
  carevw_flow_legend_net: {
    id: "carevw_flow_legend_net",
    defaultMessage: "Net Change",
  },
  carevw_flow_bar_aria: {
    id: "carevw_flow_bar_aria",
    defaultMessage: "{period} — {series}: {value}",
  },
  carevw_flow_net_aria: {
    id: "carevw_flow_net_aria",
    defaultMessage: "{period}: net change {value}",
  },
  galwayvw_tab_label: {
    id: "galwayvw_tab_label",
    defaultMessage: "Galway COPD",
  },
  galwayvw_title: {
    id: "galwayvw_title",
    defaultMessage: "Galway COPD Virtual Ward",
  },
  galwayvw_table_demographics: {
    id: "galwayvw_table_demographics",
    defaultMessage: "Demographics",
  },
  galwayvw_table_assessments: {
    id: "galwayvw_table_assessments",
    defaultMessage: "Assessments",
  },
  galwayvw_table_length_of_stay: {
    id: "galwayvw_table_length_of_stay",
    defaultMessage: "Length of Stay",
  },
  galwayvw_table_cohorts: {
    id: "galwayvw_table_cohorts",
    defaultMessage: "Cohorts",
  },
  galwayvw_col_study_id: {
    id: "galwayvw_col_study_id",
    defaultMessage: "Study ID",
  },
  galwayvw_col_date_of_birth: {
    id: "galwayvw_col_date_of_birth",
    defaultMessage: "Date Of Birth",
  },
  galwayvw_col_gender: {
    id: "galwayvw_col_gender",
    defaultMessage: "Gender",
  },
  galwayvw_col_admission_date: {
    id: "galwayvw_col_admission_date",
    defaultMessage: "Admission Date",
  },
  galwayvw_col_discharge_date: {
    id: "galwayvw_col_discharge_date",
    defaultMessage: "Discharge Date",
  },
  galwayvw_col_length_of_stay: {
    id: "galwayvw_col_length_of_stay",
    defaultMessage: "Length of stay",
  },
  galwayvw_discharge_projected: {
    id: "galwayvw_discharge_projected",
    defaultMessage: "projected",
  },
  galwayvw_metric_distinct_patients: {
    id: "galwayvw_metric_distinct_patients",
    defaultMessage: "Patients through the service",
  },
  galwayvw_metric_legacy_note: {
    id: "galwayvw_metric_legacy_note",
    defaultMessage: "Power BI reported {count} (distinct discharge dates)",
  },
  galwayvw_metric_avg_los: {
    id: "galwayvw_metric_avg_los",
    defaultMessage: "Average length of stay",
  },
  galwayvw_metric_readmissions_within_30: {
    id: "galwayvw_metric_readmissions_within_30",
    defaultMessage: "Readmissions < 30 days",
  },
  galwayvw_metric_readmissions_after_30: {
    id: "galwayvw_metric_readmissions_after_30",
    defaultMessage: "Readmissions > 30 days",
  },
  galwayvw_metric_days_unit: {
    id: "galwayvw_metric_days_unit",
    defaultMessage: "days",
  },
  galwayvw_chart_admissions_title: {
    id: "galwayvw_chart_admissions_title",
    defaultMessage: "Admissions vs Discharges",
  },
  galwayvw_chart_admissions_desc: {
    id: "galwayvw_chart_admissions_desc",
    defaultMessage: "Weekly admissions against weekly discharges.",
  },
  galwayvw_chart_on_ward_title: {
    id: "galwayvw_chart_on_ward_title",
    defaultMessage: "Patients on Ward",
  },
  galwayvw_chart_on_ward_desc: {
    id: "galwayvw_chart_on_ward_desc",
    defaultMessage: "Daily count of patients on the ward.",
  },
  galwayvw_chart_cohorts_title: {
    id: "galwayvw_chart_cohorts_title",
    defaultMessage: "Cohorts",
  },
  galwayvw_chart_cohorts_desc: {
    id: "galwayvw_chart_cohorts_desc",
    defaultMessage: "Patients per study cohort.",
  },
  galwayvw_chart_diagnosis_title: {
    id: "galwayvw_chart_diagnosis_title",
    defaultMessage: "Admission Diagnosis",
  },
  galwayvw_chart_diagnosis_desc: {
    id: "galwayvw_chart_diagnosis_desc",
    defaultMessage: "Patients per admission diagnosis.",
  },
  galwayvw_chart_rationale_title: {
    id: "galwayvw_chart_rationale_title",
    defaultMessage: "Rationale for RVW",
  },
  galwayvw_chart_rationale_desc: {
    id: "galwayvw_chart_rationale_desc",
    defaultMessage: "Patients per rationale for referral to the virtual ward.",
  },
  galwayvw_empty: {
    id: "galwayvw_empty",
    defaultMessage: "No Galway virtual ward data available yet.",
  },
  galwayvw_failed: {
    id: "galwayvw_failed",
    defaultMessage: "Galway virtual ward data could not be loaded.",
  },
  carevw_bed_occupancy_title: {
    id: "carevw_bed_occupancy_title",
    defaultMessage: "Bed Occupancy",
  },
  carevw_bed_occupancy_desc: {
    id: "carevw_bed_occupancy_desc",
    defaultMessage: "Patients on the ward per period against ward bed capacity, restoring the Power BI Bed Occupancy view.",
  },
  carevw_bed_occupancy_bar_aria: {
    id: "carevw_bed_occupancy_bar_aria",
    defaultMessage: "{period}: {value} patients on ward, {pct}% peak occupancy",
  },
  carevw_rescue_title: {
    id: "carevw_rescue_title",
    defaultMessage: "Rescue Scripts",
  },
  carevw_rescue_desc: {
    id: "carevw_rescue_desc",
    defaultMessage: "Monthly rescue scripts initiated for the selected period, with a cumulative running total.",
  },
  carevw_rescue_legend_monthly: {
    id: "carevw_rescue_legend_monthly",
    defaultMessage: "Monthly Rescue Scripts",
  },
  carevw_rescue_legend_cumulative: {
    id: "carevw_rescue_legend_cumulative",
    defaultMessage: "Cumulative Rescue Scripts",
  },
  carevw_rescue_bar_aria: {
    id: "carevw_rescue_bar_aria",
    defaultMessage: "{month}: {value} rescue scripts",
  },
  carevw_rescue_cumulative_aria: {
    id: "carevw_rescue_cumulative_aria",
    defaultMessage: "{month}: {value} cumulative rescue scripts",
  },
  carevw_encounters_title: {
    id: "carevw_encounters_title",
    defaultMessage: "Encounters",
  },
  carevw_encounters_desc: {
    id: "carevw_encounters_desc",
    defaultMessage: "Encounters by type for the selected period, at weekly or monthly grain depending on the period length. Toggle to view the mix as a percentage of each period's total.",
  },
  carevw_encounters_toggle_absolute: {
    id: "carevw_encounters_toggle_absolute",
    defaultMessage: "Count",
  },
  carevw_encounters_toggle_percent: {
    id: "carevw_encounters_toggle_percent",
    defaultMessage: "% of period",
  },
  carevw_encounters_toggle_group_aria: {
    id: "carevw_encounters_toggle_group_aria",
    defaultMessage: "Encounters view",
  },
  carevw_encounters_segment_aria: {
    id: "carevw_encounters_segment_aria",
    defaultMessage: "{period}, {type}: {value}",
  },
  carevw_encounters_legend_aria: {
    id: "carevw_encounters_legend_aria",
    defaultMessage: "Filter to {type} encounters",
  },
  carevw_totals_title: {
    id: "carevw_totals_title",
    defaultMessage: "Encounter Totals",
  },
  carevw_totals_scope_badge: {
    id: "carevw_totals_scope_badge",
    defaultMessage: "All time",
  },
  carevw_totals_group_aria: {
    id: "carevw_totals_group_aria",
    defaultMessage: "Encounter totals, all time — not affected by the selected period",
  },
  carevw_totals_cell_aria: {
    id: "carevw_totals_cell_aria",
    defaultMessage: "{type}, all time: {count}, {percent}% of total encounters",
  },
  carevw_totals_cell_percent: {
    id: "carevw_totals_cell_percent",
    defaultMessage: "{percent}%",
  },
  carevw_totals_click_hint: {
    id: "carevw_totals_click_hint",
    defaultMessage: "Click a tile to filter the dashboard by that encounter type. Click the tile again to clear the filter.",
  },
  carevw_table_nav_aria: {
    id: "carevw_table_nav_aria",
    defaultMessage: "Select table",
  },
  carevw_table_referral_source: {
    id: "carevw_table_referral_source",
    defaultMessage: "Referral Source",
  },
  carevw_table_tasks: {
    id: "carevw_table_tasks",
    defaultMessage: "Tasks",
  },
  carevw_table_monthly: {
    id: "carevw_table_monthly",
    defaultMessage: "Monthly",
  },
  carevw_table_excel: {
    id: "carevw_table_excel",
    defaultMessage: "Excel",
  },
  carevw_table_weekly_info_desc: {
    id: "carevw_table_weekly_info_desc",
    defaultMessage: "Weekly admissions, discharges, occupancy and rescue script figures for the selected period.",
  },
  carevw_table_referral_source_desc: {
    id: "carevw_table_referral_source_desc",
    defaultMessage: "Weekly referral source counts and percentages for the selected period.",
  },
  carevw_table_tasks_desc: {
    id: "carevw_table_tasks_desc",
    defaultMessage: "Weekly encounter counts by type for the selected period.",
  },
  carevw_table_monthly_desc: {
    id: "carevw_table_monthly_desc",
    defaultMessage: "Monthly encounter counts by type, rolled up from weekly data, for the selected period.",
  },
  carevw_table_their_report: {
    id: "carevw_table_their_report",
    defaultMessage: "Their Report",
  },
  carevw_table_their_report_desc: {
    id: "carevw_table_their_report_desc",
    defaultMessage: "HSE's Their Report figures, reproduced with HSE's original question wording, all time.",
  },
  carevw_table_ucopd: {
    id: "carevw_table_ucopd",
    defaultMessage: "UCOPD Outcomes",
  },
  carevw_table_ucopd_desc: {
    id: "carevw_table_ucopd_desc",
    defaultMessage: "UCOPD outcome flags aggregated by month, all time.",
  },
  carevw_col_month: {
    id: "carevw_col_month",
    defaultMessage: "Month",
  },
  carevw_csv_download: {
    id: "carevw_csv_download",
    defaultMessage: "Download CSV",
  },
  carevw_print_button: {
    id: "carevw_print_button",
    defaultMessage: "Print / Save as PDF",
  },
  carevw_print_period: {
    id: "carevw_print_period",
    defaultMessage: "Period: {period}",
  },
  carevw_month_nav_title: {
    id: "carevw_month_nav_title",
    defaultMessage: "Browse by month",
  },
  carevw_month_nav_group_aria: {
    id: "carevw_month_nav_group_aria",
    defaultMessage: "Month navigator — click a month to filter the dashboard to it",
  },
  carevw_month_nav_tile_aria: {
    id: "carevw_month_nav_tile_aria",
    defaultMessage: "{month} {year}",
  },
  carevw_month_nav_clear: {
    id: "carevw_month_nav_clear",
    defaultMessage: "Clear month",
  },
  carevw_month_nav_hint: {
    id: "carevw_month_nav_hint",
    defaultMessage: "Click a month to filter the dashboard to it, overriding the period buttons above. Click the same month again, or Clear month, to return to the selected period.",
  },
  carevw_insights_tab_label: {
    id: "carevw_insights_tab_label",
    defaultMessage: "Clinical Insights",
  },
  carevw_insights_title: {
    id: "carevw_insights_title",
    defaultMessage: "CARE Virtual Ward — Clinical Insights",
  },
  carevw_insights_loading: {
    id: "carevw_insights_loading",
    defaultMessage: "Loading clinical insights…",
  },
  carevw_insights_error: {
    id: "carevw_insights_error",
    defaultMessage: "Unable to load clinical insights. Please try again shortly.",
  },
  carevw_insights_empty: {
    id: "carevw_insights_empty",
    defaultMessage: "No CARE Virtual Ward clinical data is available for this facility yet.",
  },
  carevw_insights_cohort_tile_label: {
    id: "carevw_insights_cohort_tile_label",
    defaultMessage: "Patients in cohort",
  },
  carevw_insights_low_coverage_note: {
    id: "carevw_insights_low_coverage_note",
    defaultMessage: "Coverage is low ({n} patients) — treat this figure as indicative only.",
  },
  carevw_insights_care_bundle_title: {
    id: "carevw_insights_care_bundle_title",
    defaultMessage: "Care Bundle Compliance",
  },
  carevw_insights_care_bundle_desc: {
    id: "carevw_insights_care_bundle_desc",
    defaultMessage:
      "Per-element completion of the six-point COPD care bundle across the cohort, including how many patients have an unknown or unrecorded status for each element.",
  },
  carevw_insights_legend_complete: {
    id: "carevw_insights_legend_complete",
    defaultMessage: "Complete (Yes)",
  },
  carevw_insights_legend_incomplete: {
    id: "carevw_insights_legend_incomplete",
    defaultMessage: "Incomplete (No)",
  },
  carevw_insights_legend_unknown: {
    id: "carevw_insights_legend_unknown",
    defaultMessage: "Unknown / not recorded",
  },
  carevw_insights_care_bundle_unknown_note: {
    id: "carevw_insights_care_bundle_unknown_note",
    defaultMessage:
      "Unknown includes both missing data and ambiguous answers — it is not the same as incomplete, and is shown separately so it cannot be mistaken for non-compliance.",
  },
  carevw_insights_care_bundle_row_label: {
    id: "carevw_insights_care_bundle_row_label",
    defaultMessage: "n = {total}",
  },
  carevw_insights_care_bundle_bar_aria: {
    id: "carevw_insights_care_bundle_bar_aria",
    defaultMessage: "{label}: {complete} complete, {incomplete} incomplete, {unknown} unknown, out of {total}",
  },
  carevw_insights_engagement_title: {
    id: "carevw_insights_engagement_title",
    defaultMessage: "Device & Self-Assessment Engagement",
  },
  carevw_insights_engagement_desc: {
    id: "carevw_insights_engagement_desc",
    defaultMessage:
      "Days since each engagement signal was last recorded, bucketed across currently admitted patients only — discharged patients are excluded.",
  },
  carevw_insights_engagement_coverage_note: {
    id: "carevw_insights_engagement_coverage_note",
    defaultMessage: "n = {total} currently admitted patients (discharged patients are excluded from this chart).",
  },
  carevw_insights_gone_quiet_label: {
    id: "carevw_insights_gone_quiet_label",
    defaultMessage: "Gone quiet (no signal in {thresholdDays}+ days)",
  },
  carevw_insights_gone_quiet_value: {
    id: "carevw_insights_gone_quiet_value",
    defaultMessage: "{count} of {admittedTotal}",
  },
  carevw_insights_engagement_field_corsano_used: {
    id: "carevw_insights_engagement_field_corsano_used",
    defaultMessage: "Corsano device last used",
  },
  carevw_insights_engagement_field_corsano_synced: {
    id: "carevw_insights_engagement_field_corsano_synced",
    defaultMessage: "Corsano data last synced",
  },
  carevw_insights_engagement_field_self_assessment: {
    id: "carevw_insights_engagement_field_self_assessment",
    defaultMessage: "Self-assessment last submitted",
  },
  carevw_insights_bucket_0_1: {
    id: "carevw_insights_bucket_0_1",
    defaultMessage: "0–1 days",
  },
  carevw_insights_bucket_2_3: {
    id: "carevw_insights_bucket_2_3",
    defaultMessage: "2–3 days",
  },
  carevw_insights_bucket_4_7: {
    id: "carevw_insights_bucket_4_7",
    defaultMessage: "4–7 days",
  },
  carevw_insights_bucket_8_plus: {
    id: "carevw_insights_bucket_8_plus",
    defaultMessage: "8+ days",
  },
  carevw_insights_bucket_never: {
    id: "carevw_insights_bucket_never",
    defaultMessage: "Never",
  },
  carevw_insights_engagement_bar_aria: {
    id: "carevw_insights_engagement_bar_aria",
    defaultMessage: "{field}, {bucket}: {count} patients",
  },
  carevw_insights_oxygenation_title: {
    id: "carevw_insights_oxygenation_title",
    defaultMessage: "Oxygenation — Nadir vs Average",
  },
  carevw_insights_oxygenation_desc: {
    id: "carevw_insights_oxygenation_desc",
    defaultMessage:
      "Distribution of daily SpO2 minimum and average readings, and how many patients have a nadir below {nadirThreshold}% despite an average at or above {averageThreshold}%.",
  },
  carevw_insights_oxygenation_headline_label: {
    id: "carevw_insights_oxygenation_headline_label",
    defaultMessage: "Nadir below {nadirThreshold}% despite average ≥{averageThreshold}%",
  },
  carevw_insights_oxygenation_headline_note: {
    id: "carevw_insights_oxygenation_headline_note",
    defaultMessage: "The average alone would hide this desaturation.",
  },
  carevw_insights_oxygenation_headline_value: {
    id: "carevw_insights_oxygenation_headline_value",
    defaultMessage: "{count} of {denominator}",
  },
  carevw_insights_legend_average: {
    id: "carevw_insights_legend_average",
    defaultMessage: "Average",
  },
  carevw_insights_legend_minimum: {
    id: "carevw_insights_legend_minimum",
    defaultMessage: "Minimum",
  },
  carevw_insights_oxygenation_bar_aria: {
    id: "carevw_insights_oxygenation_bar_aria",
    defaultMessage: "SpO2 {bucket}%, {series}: {count} readings",
  },
  carevw_insights_oxygenation_coverage_note: {
    id: "carevw_insights_oxygenation_coverage_note",
    defaultMessage: "n = {patientsWithData} of {total} patients contributed daily SpO2 readings ({dailyReadings} readings pooled)",
  },
  carevw_insights_symptom_diary_title: {
    id: "carevw_insights_symptom_diary_title",
    defaultMessage: "Symptom Diary Over Time",
  },
  carevw_insights_symptom_diary_desc: {
    id: "carevw_insights_symptom_diary_desc",
    defaultMessage: "Daily self-reported breathing, cough, sputum colour and rescue-medication use across the cohort.",
  },
  carevw_insights_symptom_diary_coverage_note: {
    id: "carevw_insights_symptom_diary_coverage_note",
    defaultMessage: "n = {patientsWithData} of {total} patients contributed a symptom diary entry ({totalResponses} responses)",
  },
  carevw_insights_symptom_breathing_title: {
    id: "carevw_insights_symptom_breathing_title",
    defaultMessage: "Breathlessness",
  },
  carevw_insights_symptom_cough_title: {
    id: "carevw_insights_symptom_cough_title",
    defaultMessage: "Cough",
  },
  carevw_insights_symptom_phlegm_title: {
    id: "carevw_insights_symptom_phlegm_title",
    defaultMessage: "Sputum colour",
  },
  carevw_insights_symptom_rescue_title: {
    id: "carevw_insights_symptom_rescue_title",
    defaultMessage: "Rescue medication use",
  },
  carevw_insights_symptom_item_n: {
    id: "carevw_insights_symptom_item_n",
    defaultMessage: "n = {n} responses",
  },
  carevw_insights_symptom_bar_aria: {
    id: "carevw_insights_symptom_bar_aria",
    defaultMessage: "{day}, {category}: {count}",
  },
  carevw_insights_symptom_other_category: {
    id: "carevw_insights_symptom_other_category",
    defaultMessage: "Other / unrecognised",
  },
  traffic_light_nights: {
    id: "traffic_light_nights",
    defaultMessage: "Nights",
  },
  traffic_light_tiers: {
    id: "traffic_light_tiers",
    defaultMessage: "Tiers",
  },
  traffic_light_adherence: {
    id: "traffic_light_adherence",
    defaultMessage: "Adherence",
  },
  traffic_light_showing_recent: {
    id: "traffic_light_showing_recent",
    defaultMessage: "Showing the most recent {count} of {total}",
  },
  traffic_light_tier_green: {
    id: "traffic_light_tier_green",
    defaultMessage: "Green",
  },
  traffic_light_tier_orange: {
    id: "traffic_light_tier_orange",
    defaultMessage: "Orange",
  },
  traffic_light_tier_red: {
    id: "traffic_light_tier_red",
    defaultMessage: "Red",
  },
  traffic_light_tier_unknown: {
    id: "traffic_light_tier_unknown",
    defaultMessage: "Not scored",
  },
  traffic_light_current_tier: {
    id: "traffic_light_current_tier",
    defaultMessage: "Current tier",
  },
  traffic_light_adherence_score: {
    id: "traffic_light_adherence_score",
    defaultMessage: "Adherence score",
  },
  traffic_light_nights_met: {
    id: "traffic_light_nights_met",
    defaultMessage: "Nights met",
  },
  traffic_light_nights_with_data: {
    id: "traffic_light_nights_with_data",
    defaultMessage: "Nights with data",
  },
  traffic_light_monitoring_window: {
    id: "traffic_light_monitoring_window",
    defaultMessage: "Monitoring window",
  },
  traffic_light_last_data_date: {
    id: "traffic_light_last_data_date",
    defaultMessage: "Last data received",
  },
  traffic_light_run_date: {
    id: "traffic_light_run_date",
    defaultMessage: "Scoring run",
  },
  traffic_light_tier: {
    id: "traffic_light_tier",
    defaultMessage: "Tier",
  },
  traffic_light_previous_tier: {
    id: "traffic_light_previous_tier",
    defaultMessage: "Previous tier",
  },
  traffic_light_transition: {
    id: "traffic_light_transition",
    defaultMessage: "Tier changed",
  },
  traffic_light_config_version: {
    id: "traffic_light_config_version",
    defaultMessage: "Config version",
  },
  traffic_light_no_data_flag: {
    id: "traffic_light_no_data_flag",
    defaultMessage: "No data in window",
  },
  traffic_light_tier_history: {
    id: "traffic_light_tier_history",
    defaultMessage: "Tier history",
  },
  traffic_light_no_tiers: {
    id: "traffic_light_no_tiers",
    defaultMessage: "This patient has no tier snapshots yet.",
  },
  traffic_light_no_nights: {
    id: "traffic_light_no_nights",
    defaultMessage: "This patient has no nightly sleep data yet.",
  },
  traffic_light_no_nights_in_range: {
    id: "traffic_light_no_nights_in_range",
    defaultMessage: "No nightly sleep data in the selected dates.",
  },
  traffic_light_no_tiers_in_range: {
    id: "traffic_light_no_tiers_in_range",
    defaultMessage: "No scoring runs in the selected dates.",
  },
  traffic_light_night_date: {
    id: "traffic_light_night_date",
    defaultMessage: "Night",
  },
  traffic_light_usage_hours: {
    id: "traffic_light_usage_hours",
    defaultMessage: "Usage hours",
  },
  traffic_light_met_threshold: {
    id: "traffic_light_met_threshold",
    defaultMessage: "Met threshold",
  },
  traffic_light_below_threshold: {
    id: "traffic_light_below_threshold",
    defaultMessage: "Below threshold",
  },
  traffic_light_mask_leak: {
    id: "traffic_light_mask_leak",
    defaultMessage: "Mask leak",
  },
  traffic_light_ahi: {
    id: "traffic_light_ahi",
    defaultMessage: "AHI",
  },
  traffic_light_cai: {
    id: "traffic_light_cai",
    defaultMessage: "CAI",
  },
  traffic_light_sleep_score: {
    id: "traffic_light_sleep_score",
    defaultMessage: "Sleep score",
  },
  traffic_light_usage_chart_title: {
    id: "traffic_light_usage_chart_title",
    defaultMessage: "Usage hours, last {count} nights",
  },
  traffic_light_nights_recorded: {
    id: "traffic_light_nights_recorded",
    defaultMessage: "{count} nights recorded",
  },
  traffic_light_snapshots_recorded: {
    id: "traffic_light_snapshots_recorded",
    defaultMessage: "{count} scoring runs recorded",
  },
  traffic_light_load_error: {
    id: "traffic_light_load_error",
    defaultMessage: "We could not load this data. Please try again.",
  },
  traffic_light_page_of: {
    id: "traffic_light_page_of",
    defaultMessage: "Page {page} of {totalPages}",
  },
  traffic_light_newer: {
    id: "traffic_light_newer",
    defaultMessage: "Newer",
  },
  traffic_light_older: {
    id: "traffic_light_older",
    defaultMessage: "Older",
  },
  device_definitions: {
    id: "device_definitions",
    defaultMessage: "Device Definitions",
  },
  add_device_definition: {
    id: "add_device_definition",
    defaultMessage: "Add Device Definition",
  },
  edit_device_definition: {
    id: "edit_device_definition",
    defaultMessage: "Edit Device Definition",
  },
  remove_device_definition: {
    id: "remove_device_definition",
    defaultMessage: "Remove Device Definition",
  },
  remove_device_definition_confirm: {
    id: "remove_device_definition_confirm",
    defaultMessage: 'Are you sure you want to remove "{name}"?',
  },
  device_name: {
    id: "device_name",
    defaultMessage: "Device Name",
  },
  device_image: {
    id: "device_image",
    defaultMessage: "Device Image",
  },
  manufacturer: {
    id: "manufacturer",
    defaultMessage: "Manufacturer",
  },
  owner: {
    id: "owner",
    defaultMessage: "Owner",
  },
  model_number: {
    id: "model_number",
    defaultMessage: "Model Number",
  },
  external_integration_type: {
    id: "external_integration_type",
    defaultMessage: "External Integration Type",
  },
  no_device_definitions: {
    id: "no_device_definitions",
    defaultMessage: "No device definitions found.",
  },
  device_definitions_showing_count: {
    id: "device_definitions_showing_count",
    defaultMessage: "Showing {count} device definitions",
  },
  search_device_definitions: {
    id: "search_device_definitions",
    defaultMessage: "Search by name, manufacturer or model",
  },
  device_name_required: {
    id: "device_name_required",
    defaultMessage: "Device name is required.",
  },
  device_definition_saved: {
    id: "device_definition_saved",
    defaultMessage: "Device definition has been saved.",
  },
  device_definition_removed: {
    id: "device_definition_removed",
    defaultMessage: "Device definition has been removed.",
  },
  device_definitions_load_error: {
    id: "device_definitions_load_error",
    defaultMessage: "Could not load device definitions.",
  },
  device_definition_save_error: {
    id: "device_definition_save_error",
    defaultMessage: "Could not save the device definition.",
  },
  device_definition_remove_error: {
    id: "device_definition_remove_error",
    defaultMessage: "Could not remove the device definition.",
  },
  add_device: {
    id: "add_device",
    defaultMessage: "Add Device",
  },
  edit_device: {
    id: "edit_device",
    defaultMessage: "Edit Device",
  },
  remove_device: {
    id: "remove_device",
    defaultMessage: "Remove Device",
  },
  remove_device_confirm: {
    id: "remove_device_confirm",
    defaultMessage: 'Are you sure you want to remove device "{name}"?',
  },
  no_devices_found: {
    id: "no_devices_found",
    defaultMessage: "No devices found.",
  },
  devices_showing_count: {
    id: "devices_showing_count",
    defaultMessage: "Showing {count} devices",
  },
  search_devices: {
    id: "search_devices",
    defaultMessage: "Search serial, device, patient, status, location or owner",
  },
  device_required: {
    id: "device_required",
    defaultMessage: "Device is required.",
  },
  serial_number_required: {
    id: "serial_number_required",
    defaultMessage: "Serial number is required.",
  },
  device_saved: {
    id: "device_saved",
    defaultMessage: "Device has been saved.",
  },
  device_removed: {
    id: "device_removed",
    defaultMessage: "Device has been removed.",
  },
  devices_load_error: {
    id: "devices_load_error",
    defaultMessage: "Could not load devices.",
  },
  device_save_error: {
    id: "device_save_error",
    defaultMessage: "Could not save the device.",
  },
  device_remove_error: {
    id: "device_remove_error",
    defaultMessage: "Could not remove the device.",
  },
  not_assigned: {
    id: "not_assigned",
    defaultMessage: "Not assigned",
  },
  version: {
    id: "version",
    defaultMessage: "Version",
  },
  mobile_device_identifier: {
    id: "mobile_device_identifier",
    defaultMessage: "IMEI / MAC",
  },
  manufacture_date: {
    id: "manufacture_date",
    defaultMessage: "Manufacture Date",
  },
  expiration_date: {
    id: "expiration_date",
    defaultMessage: "Expiration Date",
  },
  device_status: {
    id: "device_status",
    defaultMessage: "Device Status",
  },
  device_status_in_stock: {
    id: "device_status_in_stock",
    defaultMessage: "In Stock",
  },
  device_status_allocated: {
    id: "device_status_allocated",
    defaultMessage: "Allocated",
  },
  device_status_despatched: {
    id: "device_status_despatched",
    defaultMessage: "Despatched",
  },
  device_status_in_use: {
    id: "device_status_in_use",
    defaultMessage: "In Use",
  },
  device_status_returned: {
    id: "device_status_returned",
    defaultMessage: "Returned",
  },
  device_status_decontamination: {
    id: "device_status_decontamination",
    defaultMessage: "Decontamination",
  },
  device_status_refurb_qa: {
    id: "device_status_refurb_qa",
    defaultMessage: "Refurb QA",
  },
  device_status_retired: {
    id: "device_status_retired",
    defaultMessage: "Retired",
  },
  device_status_lost: {
    id: "device_status_lost",
    defaultMessage: "Lost",
  },
  location: {
    id: "location",
    defaultMessage: "Location",
  },
  device_kit: {
    id: "device_kit",
    defaultMessage: "Device Kit",
  },
  assign_to_patient: {
    id: "assign_to_patient",
    defaultMessage: "Assign to patient",
  },
  unassign: {
    id: "unassign",
    defaultMessage: "Unassign",
  },
  unassign_device_confirm: {
    id: "unassign_device_confirm",
    defaultMessage: "Remove {name} from {patient}?",
  },
  device_assigned: {
    id: "device_assigned",
    defaultMessage: "Device assigned",
  },
  device_unassigned: {
    id: "device_unassigned",
    defaultMessage: "Device unassigned",
  },
  device_assign_error: {
    id: "device_assign_error",
    defaultMessage: "Could not update the device assignment",
  },
  stock: {
    id: "stock",
    defaultMessage: "Stock",
  },
  kits: {
    id: "kits",
    defaultMessage: "Kits",
  },
  kit: {
    id: "kit",
    defaultMessage: "Kit",
  },
  devices_in_kit: {
    id: "devices_in_kit",
    defaultMessage: "Devices in this kit",
  },
  add_device_to_kit: {
    id: "add_device_to_kit",
    defaultMessage: "Add device",
  },
  remove_from_kit: {
    id: "remove_from_kit",
    defaultMessage: "Remove from kit",
  },
  kit_empty: {
    id: "kit_empty",
    defaultMessage: "No devices in this kit yet.",
  },
  device_added_to_kit: {
    id: "device_added_to_kit",
    defaultMessage: "Device added to the kit",
  },
  device_removed_from_kit: {
    id: "device_removed_from_kit",
    defaultMessage: "Device removed from the kit",
  },
  no_devices_available_to_add: {
    id: "no_devices_available_to_add",
    defaultMessage: "No devices available to add.",
  },
  select_device: {
    id: "select_device",
    defaultMessage: "Select Device",
  },
  kit_type: {
    id: "kit_type",
    defaultMessage: "Kit Type",
  },
  add_kit: {
    id: "add_kit",
    defaultMessage: "Add Kit",
  },
  edit_kit: {
    id: "edit_kit",
    defaultMessage: "Edit Kit",
  },
  remove_kit: {
    id: "remove_kit",
    defaultMessage: "Remove Kit",
  },
  remove_kit_confirm: {
    id: "remove_kit_confirm",
    defaultMessage: 'Are you sure you want to remove kit "{name}"?',
  },
  no_kits_found: {
    id: "no_kits_found",
    defaultMessage: "No kits found.",
  },
  kits_showing_count: {
    id: "kits_showing_count",
    defaultMessage: "Showing {count} kits",
  },
  search_kits: {
    id: "search_kits",
    defaultMessage: "Search serial, kit, patient, status, location or owner",
  },
  sort_a_z: {
    id: "sort_a_z",
    defaultMessage: "A → Z",
  },
  sort_z_a: {
    id: "sort_z_a",
    defaultMessage: "Z → A",
  },
  sort_earliest_first: {
    id: "sort_earliest_first",
    defaultMessage: "Earliest first",
  },
  sort_latest_first: {
    id: "sort_latest_first",
    defaultMessage: "Latest first",
  },
  sort_lifecycle: {
    id: "sort_lifecycle",
    defaultMessage: "Lifecycle order",
  },
  sort_lifecycle_reverse: {
    id: "sort_lifecycle_reverse",
    defaultMessage: "Reverse lifecycle",
  },
  expires: {
    id: "expires",
    defaultMessage: "Expires",
  },
  manufactured_on: {
    id: "manufactured_on",
    defaultMessage: "Mfg {date}",
  },
  location_owner: {
    id: "location_owner",
    defaultMessage: "Location / Owner",
  },
  identifiers: {
    id: "identifiers",
    defaultMessage: "Identifiers",
  },
  patient_location_owner: {
    id: "patient_location_owner",
    defaultMessage: "Patient / Location / Owner",
  },
  channel_type: {
    id: "channel_type",
    defaultMessage: "Channel type",
  },
  public_url_channel: {
    id: "public_url_channel",
    defaultMessage: "Public URL Channel",
  },
  public_link_login_failed: {
    id: "public_link_login_failed",
    defaultMessage: "This link could not sign you in. Please try again later.",
  },
  no_channels_yet: {
    id: "no_channels_yet",
    defaultMessage: "No channels yet",
  },
  channel_created: {
    id: "channel_created",
    defaultMessage: "Channel created",
  },
  public_channel_link_hint: {
    id: "public_channel_link_hint",
    defaultMessage: "Anyone with this link can open this channel.",
  },
  channel_delete_error: {
    id: "channel_delete_error",
    defaultMessage:
      "Error while deleting channel {name}. Please try again later",
  },
  clinic_export_excel: {
    id: "clinic_export_excel",
    defaultMessage: "Export Excel",
  },
  clinic_export_excel_fields_hint: {
    id: "clinic_export_excel_fields_hint",
    defaultMessage:
      "Choose the columns to include in the Excel file. Tick \"Writing space\" to add a blank column beside a field for handwritten notes.",
  },
  clinic_export_roomy: {
    id: "clinic_export_roomy",
    defaultMessage: "Roomy rows for handwritten notes",
  },
  clinic_export_roomy_hint: {
    id: "clinic_export_roomy_hint",
    defaultMessage:
      "Wide columns and tall rows, set to print in landscape on one page wide.",
  },
  appt_scope_oncology: {
    id: "appt_scope_oncology",
    defaultMessage: "Oncology",
  },
  appt_scope_haematology: {
    id: "appt_scope_haematology",
    defaultMessage: "Haematology",
  },
  appt_all_time: {
    id: "appt_all_time",
    defaultMessage: "All time",
  },
  appt_all_schedules: {
    id: "appt_all_schedules",
    defaultMessage: "All schedules",
  },
  appt_months_selected: {
    id: "appt_months_selected",
    defaultMessage: "{count} months selected",
  },
  appt_by_cancer_type: {
    id: "appt_by_cancer_type",
    defaultMessage: "Appointments by cancer type",
  },
  appt_by_treatment_type: {
    id: "appt_by_treatment_type",
    defaultMessage: "Appointments by treatment type",
  },
  appt_cancer_type_note: {
    id: "appt_cancer_type_note",
    defaultMessage: "Counts appointments, not patients. Cancer type is taken from the patient record, and is recorded for {pct}% of the appointments in this selection.",
  },
  appt_treatment_type_note: {
    id: "appt_treatment_type_note",
    defaultMessage: "Counts appointments. Treatment type is taken from the appointment record.",
  },
  appt_data_preparing: {
    id: "appt_data_preparing",
    defaultMessage: "Appointment data is being prepared. It refreshes each night at 3am.",
  },
  appt_booked_ahead: {
    id: "appt_booked_ahead",
    defaultMessage: "Booked ahead",
  },
  appt_new_treatments: {
    id: "appt_new_treatments",
    defaultMessage: "New Treatments",
  },
  appt_clinical_trials: {
    id: "appt_clinical_trials",
    defaultMessage: "Clinical Trials",
  },
  appt_reschedules: {
    id: "appt_reschedules",
    defaultMessage: "Reschedules",
  },
  appt_did_not_attend: {
    id: "appt_did_not_attend",
    defaultMessage: "Did Not Attend",
  },
  appt_screenings: {
    id: "appt_screenings",
    defaultMessage: "Screenings",
  },
  appt_consultants: {
    id: "appt_consultants",
    defaultMessage: "Consultants",
  },
  appt_chair_distribution: {
    id: "appt_chair_distribution",
    defaultMessage: "Chair Distribution",
  },
  appt_monthly_trend: {
    id: "appt_monthly_trend",
    defaultMessage: "Monthly Activity Trend",
  },
  appt_summary_line: {
    id: "appt_summary_line",
    defaultMessage: "{appts} appointments across {schedules} schedules, for {patients} individual patients, since {since}",
  },
  appt_scope_all: {
    id: "appt_scope_all",
    defaultMessage: "All",
  },
  appt_cancelled: {
    id: "appt_cancelled",
    defaultMessage: "Cancelled",
  },
  appt_schedules_selected: {
    id: "appt_schedules_selected",
    defaultMessage: "{count} schedules selected",
  },
  appt_measure_appointments: {
    id: "appt_measure_appointments",
    defaultMessage: "All Appointments",
  },
  appt_measure_patients: {
    id: "appt_measure_patients",
    defaultMessage: "Unique Patients",
  },
  appt_summary_line_patients: {
    id: "appt_summary_line_patients",
    defaultMessage: "{appts} unique patients across {schedules} schedules, since {since}",
  },
  appt_exclude_cancelled: {
    id: "appt_exclude_cancelled",
    defaultMessage: "Exclude cancelled",
  },
  appt_excluding_cancelled: {
    id: "appt_excluding_cancelled",
    defaultMessage: "excluding cancelled",
  },
  appt_archived_patients: {
    id: "appt_archived_patients",
    defaultMessage: "Archived Patients",
  },
  appt_patient_status: {
    id: "appt_patient_status",
    defaultMessage: "Patient status",
  },
  appt_patient_status_note: {
    id: "appt_patient_status_note",
    defaultMessage: "Counts patients, not appointments, and shows their status today rather than when it changed.",
  },
  appt_unit_appointments: {
    id: "appt_unit_appointments",
    defaultMessage: "appointments",
  },
  appt_unit_patients: {
    id: "appt_unit_patients",
    defaultMessage: "unique patients",
  },
  appt_patients_screened: {
    id: "appt_patients_screened",
    defaultMessage: "Patients Screened",
  },
  appt_screening_note_events: {
    id: "appt_screening_note_events",
    defaultMessage: "Counts screening events. An appointment is screened before treatment, so this tracks appointments rather than people.",
  },
  appt_screening_note_patients: {
    id: "appt_screening_note_patients",
    defaultMessage: "Counts distinct patients screened. Someone with both a negative and a positive result appears in each row but is counted once in the total.",
  },
  appt_chairs_note_events: {
    id: "appt_chairs_note_events",
    defaultMessage: "Counts appointments in each chair.",
  },
  appt_chairs_note_patients: {
    id: "appt_chairs_note_patients",
    defaultMessage: "Counts distinct patients who used each chair.",
  },
  appt_tab_heatmap: {
    id: "appt_tab_heatmap",
    defaultMessage: "Heatmap",
  },
  appt_tab_flow: {
    id: "appt_tab_flow",
    defaultMessage: "Patient Flow",
  },
  appt_flow_entry: {
    id: "appt_flow_entry",
    defaultMessage: "Entry",
  },
  appt_flow_stream: {
    id: "appt_flow_stream",
    defaultMessage: "Clinic",
  },
  appt_flow_exit: {
    id: "appt_flow_exit",
    defaultMessage: "Where they are now",
  },
  appt_entry_new: {
    id: "appt_entry_new",
    // "New to the clinic" read as new to the hospital, but the bare word "New" then
    // collided with the New Treatments tile directly above the diagram and the two were
    // read as the same number. They are not: this band counts people attending for the
    // first time, the tile counts people starting a treatment.
    defaultMessage: "New patients",
  },
  appt_open_in_my_clinics: {
    id: "appt_open_in_my_clinics",
    defaultMessage: "Click to open this day in My Clinics",
  },
  appt_csv_label: {
    id: "appt_csv_label",
    defaultMessage: "CSV",
  },
  appt_csv_download_title: {
    id: "appt_csv_download_title",
    defaultMessage: "Download CSV",
  },
  appt_flow_filter_to_this: {
    id: "appt_flow_filter_to_this",
    defaultMessage: "Filter to this",
  },
  appt_flow_filter_hint: {
    id: "appt_flow_filter_hint",
    defaultMessage:
      "Highlighting traces a band inside the whole picture. Filter to this narrows every chart and tile to it.",
  },
  appt_entry_continuing: {
    id: "appt_entry_continuing",
    defaultMessage: "Continuing",
  },
  appt_exit_active: {
    id: "appt_exit_active",
    defaultMessage: "Still attending",
  },
  appt_exit_completed: {
    id: "appt_exit_completed",
    defaultMessage: "Completed treatment",
  },
  appt_exit_gone: {
    id: "appt_exit_gone",
    defaultMessage: "No longer attending",
  },
  appt_flow_overlap_note: {
    id: "appt_flow_overlap_note",
    defaultMessage: "Band width is distinct patients. {overlap} of {total} patients attend more than one clinic, so the clinic figures add to more than the total — that overlap is the double counting, shown rather than hidden.",
  },
  appt_flow_entry_hint: {
    id: "appt_flow_entry_hint",
    defaultMessage: "Select one or more months on the Heatmap tab to see how many patients are new to each clinic in that period.",
  },
  appt_flow_truncation_note: {
    id: "appt_flow_truncation_note",
    defaultMessage: "New patients counts people whose first appointment anywhere in the service falls inside the selected months. It is not the New Treatments tile, which counts people starting a treatment: a patient of five years starting a new regimen is Continuing here and a new treatment there. Records begin in {month}, so a patient whose history starts earlier cannot be distinguished from a genuine new start in that first month.",
  },
  appt_flow_band_note: {
    id: "appt_flow_band_note",
    defaultMessage: "A band is sized by its clinic totals so the ribbons meet it, but the figure beside it is distinct patients. Someone attending two clinics contributes to both ribbons and is counted once in the figure.",
  },
  appt_flow_clear_trace: {
    id: "appt_flow_clear_trace",
    defaultMessage: "Clear highlight",
  },
  appt_clear_chart_filters: {
    id: "appt_clear_chart_filters",
    defaultMessage: "Clear chart filters",
  },
  appt_filters_applied: {
    id: "appt_filters_applied",
    defaultMessage: "Filters:",
  },
  appt_clear_all_filters: {
    id: "appt_clear_all_filters",
    defaultMessage: "Clear all",
  },
  appt_chip_remove: {
    id: "appt_chip_remove",
    defaultMessage: "Remove this filter",
  },
  appt_consultants_note: {
    id: "appt_consultants_note",
    defaultMessage: "The consultant named on the patient record, counted per appointment. Where a patient has no consultant recorded they are left out rather than shown as unknown.",
  },
  appt_trend_note: {
    id: "appt_trend_note",
    defaultMessage: "Monthly totals for the current filter. The solid line is history; the dashed part is appointments already booked into future months, which will keep filling up.",
  },
  appt_tiles_all_time: {
    id: "appt_tiles_all_time",
    defaultMessage: "All time",
  },
  appt_tiles_all_time_note: {
    id: "appt_tiles_all_time_note",
    defaultMessage: "The whole facility. These figures do not react to a month or schedule selection, so there is always a fixed point to compare against.",
  },
  appt_tiles_selection_note: {
    id: "appt_tiles_selection_note",
    defaultMessage: "The current selection only. Every figure here reacts to the months, schedules and chart filters you have applied.",
  },
  appt_demand_heading: {
    id: "appt_demand_heading",
    defaultMessage: "Demand on the service",
  },
  appt_demand_note: {
    id: "appt_demand_note",
    defaultMessage: "Growth, depth of engagement, and how much of the work patients do themselves. Figures follow the speciality, cancelled and chart filters, so the case can be made for the whole service or for one part of it.",
  },
  appt_demand_year_so_far: {
    id: "appt_demand_year_so_far",
    defaultMessage: "appointments in {year}, in {months} months. All of {priorYear} was {prior}.",
  },
  appt_demand_self_service: {
    id: "appt_demand_self_service",
    defaultMessage: "of pre-treatment screenings are completed by the patient, not by staff — {count} of them.",
  },
  appt_demand_sustained: {
    id: "appt_demand_sustained",
    defaultMessage: "of patients have been with the service for seven months or more.",
  },
  appt_demand_forward: {
    id: "appt_demand_forward",
    defaultMessage: "appointments already booked for future months, for {patients} patients.",
  },
  appt_demand_growth: {
    id: "appt_demand_growth",
    defaultMessage: "Appointments and patients by year",
  },
  appt_demand_growth_note: {
    id: "appt_demand_growth_note",
    defaultMessage: "Bars are appointments on the left axis; the line is distinct patients on the right. The current year is hatched because it is a part year — it is never scaled up to a full-year estimate.",
  },
  appt_demand_retention: {
    id: "appt_demand_retention",
    defaultMessage: "How long patients stay with the service",
  },
  appt_demand_retention_note: {
    id: "appt_demand_retention_note",
    defaultMessage: "Months from a patient\u2019s first appointment to their most recent one. It shows whether contact is one-off or sustained.",
  },
  appt_demand_col_year: {
    id: "appt_demand_col_year",
    defaultMessage: "Year",
  },
  appt_demand_col_new: {
    id: "appt_demand_col_new",
    defaultMessage: "New patients",
  },
  appt_demand_col_per_patient: {
    id: "appt_demand_col_per_patient",
    defaultMessage: "Appointments per patient",
  },
  appt_demand_partial: {
    id: "appt_demand_partial",
    defaultMessage: "({months} months so far)",
  },
  appt_retention_1: {
    id: "appt_retention_1",
    defaultMessage: "One month only",
  },
  appt_retention_2_6: {
    id: "appt_retention_2_6",
    defaultMessage: "Two to six months",
  },
  appt_retention_7_12: {
    id: "appt_retention_7_12",
    defaultMessage: "Seven to twelve months",
  },
  appt_retention_12plus: {
    id: "appt_retention_12plus",
    defaultMessage: "More than a year",
  },
  appt_cancer_type_note_patients: {
    id: "appt_cancer_type_note_patients",
    defaultMessage: "Counts distinct patients, not appointments. Cancer type is taken from the patient record, and is recorded for {pct}% of the appointments in this selection.",
  },
  appt_treatment_type_note_patients: {
    id: "appt_treatment_type_note_patients",
    defaultMessage: "Counts distinct patients. Treatment type is taken from the appointment record.",
  },
  appt_by_cancer_type_patients: {
    id: "appt_by_cancer_type_patients",
    defaultMessage: "Patients by cancer type",
  },
  appt_by_treatment_type_patients: {
    id: "appt_by_treatment_type_patients",
    defaultMessage: "Patients by treatment type",
  },
  appt_tiles_events_note: {
    id: "appt_tiles_events_note",
    defaultMessage: "Clinical Trials, Reschedules, Cancelled and Did Not Attend count appointments in the appointments measure, and distinct patients in the unique-patients measure. New Treatments always counts distinct patients: the NewTreatment flag marks the start of a treatment, but it is often applied to every appointment in the series, so the appointment count measures data entry rather than treatments started.",
  },
  appt_addon_label: {
    id: "appt_addon_label",
    defaultMessage: "Treatment add-on",
  },
  appt_addon_none: {
    id: "appt_addon_none",
    defaultMessage: "No add-on",
  },
  appt_addon_timing: {
    id: "appt_addon_timing",
    defaultMessage: "{pre} min before, {post} min after",
  },
  appt_addon_before: {
    id: "appt_addon_before",
    defaultMessage: "Before treatment",
  },
  appt_addon_after: {
    id: "appt_addon_after",
    defaultMessage: "After treatment",
  },
  appt_addon_day_total: {
    id: "appt_addon_day_total",
    defaultMessage: "+ {title} ({timing}) = {total}",
  },
  fa_addon_options: {
    id: "fa_addon_options",
    defaultMessage: "Add-on options",
  },
  fa_addon_title: {
    id: "fa_addon_title",
    defaultMessage: "Option title",
  },
  fa_addon_pre_mins: {
    id: "fa_addon_pre_mins",
    defaultMessage: "Minutes before",
  },
  fa_addon_post_mins: {
    id: "fa_addon_post_mins",
    defaultMessage: "Minutes after",
  },
  fa_addon_add: {
    id: "fa_addon_add",
    defaultMessage: "Add option",
  },
  fa_addon_none_yet: {
    id: "fa_addon_none_yet",
    defaultMessage: "No add-ons yet.",
  },
  holidays_add_known: {
    id: "holidays_add_known",
    defaultMessage: "Add known holidays",
  },
  holidays_lookup_needs_countries: {
    id: "holidays_lookup_needs_countries",
    defaultMessage: "Set Countries Supported first",
  },
  holidays_lookup_modal_title: {
    id: "holidays_lookup_modal_title",
    defaultMessage: "Add known holidays",
  },
  holidays_lookup_countries_label: {
    id: "holidays_lookup_countries_label",
    defaultMessage: "Countries",
  },
  holidays_lookup_years_label: {
    id: "holidays_lookup_years_label",
    defaultMessage: "Years",
  },
  holidays_lookup_fetch_button: {
    id: "holidays_lookup_fetch_button",
    defaultMessage: "Find holidays",
  },
  holidays_lookup_preview_hint: {
    id: "holidays_lookup_preview_hint",
    defaultMessage: "Review the list before adding. Untick anything that is wrong for this facility.",
  },
  holidays_lookup_already_exists: {
    id: "holidays_lookup_already_exists",
    defaultMessage: "Already configured",
  },
  holidays_lookup_select_all: {
    id: "holidays_lookup_select_all",
    defaultMessage: "Select all",
  },
  holidays_lookup_unsupported: {
    id: "holidays_lookup_unsupported",
    defaultMessage: "No public holidays are available for: {countries}. Add these manually.",
  },
  holidays_lookup_no_new: {
    id: "holidays_lookup_no_new",
    defaultMessage: "All holidays found are already configured.",
  },
  holidays_lookup_add_button: {
    id: "holidays_lookup_add_button",
    defaultMessage: "Add {count} selected",
  },
  holidays_lookup_back_button: {
    id: "holidays_lookup_back_button",
    defaultMessage: "Back",
  },
  holidays_lookup_cancel_button: {
    id: "holidays_lookup_cancel_button",
    defaultMessage: "Cancel",
  },
  holidays_lookup_toast_added: {
    id: "holidays_lookup_toast_added",
    defaultMessage: "Added {added} holidays. Save the facility to keep them.",
  },
  holidays_lookup_toast_error: {
    id: "holidays_lookup_toast_error",
    defaultMessage: "Couldn't fetch holidays — please try again.",
  },
  holidays_col_holiday: {
    id: "holidays_col_holiday",
    defaultMessage: "Holiday",
  },
  holidays_list_label: {
    id: "holidays_list_label",
    defaultMessage: "Facility holidays",
  },
  holidays_none: {
    id: "holidays_none",
    defaultMessage: "No holidays configured.",
  },
  holidays_show_list: {
    id: "holidays_show_list",
    defaultMessage: "Show {count} holidays",
  },
  holidays_hide_list: {
    id: "holidays_hide_list",
    defaultMessage: "Hide holidays",
  },
  holidays_next: {
    id: "holidays_next",
    defaultMessage: "Next: {date}",
  },
  holidays_attribution_label: {
    id: "holidays_attribution_label",
    defaultMessage: "Holiday data source:",
  },
});

export default Messages;
